export default {
	AL: {
		state: 'Alabama',
		stateNickname: 'Yellowhammer State',
		welcome: `
			<p>Alabama is nicknamed the Yellowhammer State, the Cotton State, and the Heart of Dixie and is the 24th largest state in the country with a population of more than 4.9 million people. Alabama is known for its iron and steel natural resources, sweet tea, Southern hospitality, and football.</p>
			<p>The state's major industries include information technology, chemicals, automotive, aerospace, and forestry. Because 70 percent of the state is covered in forests and because it's rich in iron ore, limestone, and coal, Alabama is known for its timber and it makes sense that the Yellowhammer state is the largest supplier of steel pipe and cast-iron products.</p>
			<p>Some of the top attractions in Alabama include Gulf State Park, Cheaha State Park, the U.S. Space & Rocket Center, Oak Mountain State Park, the Birmingham Civil Rights Institute, the McWane Science Center, Mobile Bay, and the Frank Lloyd Wright Rosenbaum House Museum.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
			<p>Alabama has seen a recent surge in self-storage development activity, due in part to net positive population growth throughout the state creating more demand for the product. Developers did not keep up with demand for self-storage space in the wake of the last recession, leading to a scarcity of supply and rising storage rates. This trend is playing out nationwide and in the great state of Alabama as well. Now self-storage developers have been building new facilities in top Alabama destination to tap into the pent up demand.</p>
			`,
			facts: [
				{
					fact: 'Alabama is home to more than 1,002 self-storage facilities',
					highlight: '1,002',
				},
				{
					fact: 'Alabama facilities offer more than 30,065,572 million square feet of storage space combined.',
					highlight: '30,065,572',
				},
				{
					fact: "Alabama has 6.29 square feet of storage space for every man, woman, and child. That's more than the national average of 5.4 square feet per person.",
					highlight: '6.29',
				},
				{
					fact: 'Average price of a self-storage unit in Alabama: ',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Birmingham',
				price: '0',
			},
			{
				city: 'Tuscaloosa',
				price: '0',
			},
			{
				city: 'Mobile',
				price: '0',
			},
			{
				city: 'Huntsville',
				price: '0',
			},
			{
				city: 'Montgomery',
				price: '0',
			},
			{
				city: 'Dothan',
				price: '0',
			},
			{
				city: 'Auburn',
				price: '0',
			},
			{
				city: 'Gulf Shores',
				price: '0',
			},
			{
				city: 'Decatur',
				price: '0',
			},
			{
				city: 'Hoover',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>Considering a move to Alabama, but not quite convinced yet? Take a look at our top 10 reasons to love the Heart of Dixie.</p>',
			reasons: [
				"A low cost of living. Compared to most states, Alabama has a very low cost of living. So if you move to the Yellowhammer State, you'll have more cash to splurge on the things you really want.",
				'Friendly folks. Southern hospitality makes people really friendly in Alabama  - friendly enough to strike up a random conversation during your daily commute or while standing in line at the grocery store.',
				'Scenic beaches. Alabama has plenty of beaches for when you want to work on your tan or just have a fun-filled day at the beach with the family. Check out Gulf Shores Main Public Beach, Cotton Bayou Beach, Dauphin Island Public Beach, or West End Beach.',
				'Gorgeous state parks. Alabama is home to several state parks that make it easy to enjoy outdoor activities like hiking, biking, and swimming, including Oak Mountain State Park, Cheaha State Park, and Gulf State Park.',
				"Football is king. Similar to states like Louisiana and Texas, football is king in Alabama, especially if you're talking about the famous rivalry between college football teams the Auburn Tigers and the Alabama Crimson Tide.",
				"Laid back lifestyle. If you're looking for the crawling country pace, you'll find it in Alabama. The people in Alabama have a very laid back way of life so you'll fit right in if that's your kind of living.",
				"Big city living. In Alabama, you can have the best of both worlds - big city living or the slow crawl of country life. Larger cities like Birmingham can provide the big city living you're craving.",
				"The sweet tea. If you're a fan of sweet tea, you'll love the sweetness factor in Alabama. Much like other southern states, in Alabama, you'll get the perfect blend complete with a Mason jar to drink it out of if you know where to go.",
				'Great higher education. Alabama is home to four Tier 1 universities, including The University of Alabama (UA), the University of Alabama at Birmingham (UAB), Auburn University (AU), and the University of Alabama in Huntsville (UAH).',
				"Delicious southern food. Can't get enough of delicious southern cuisine? Alabama can give you your fill of classic southern staples like fried chicken, black-eyed peas, collard greens, mashed potatoes, cornbread, and a sweet potato pie for dessert.",
			],
		},
		movingTo: {
			// static content
			copy: "<p>Alabama has a population of 4.9 million people and ranks as the 24th most populous state in the US. Between 2018 and 2019, Alabama's population grew by 0.21 percent. According to a 2018 Atlas Van Lines' Migration Patterns study, more people are moving into Alabama than out and it's among the top 10 states in the US for inbound moves. People are moving for the great weather and the low cost of living.</p>",
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Alabama's GDP was $221.7 billion was of 2018, according to the Federal Reserve Bank of St. Louis. The state's unemployment rate was 3 percent as of September 2019.</p>
				<p>Below is a breakdown of the largest sectors of the Alabama economy by real value GDP added:</p>
			`,
			breakdown: [
				{
					sector: 'Manufacturing',
					value: '$34.01 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$31.37 billion',
				},
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$29.81 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$20.41 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$16.27 billion',
				},
			],
			bottomLine:
				"<p>Alabama is looking at a job growth rate of 1.2 percent and is expected to add about 25,000 new jobs through 2020. Construction is a huge growth area for the state and the automotive industry is also growing with 4,000 new jobs expected to be added throughout 2021 thanks to building plans for new plants. Furthermore, Amazon is expected to create 1,500 new jobs in a Birmingham fulfillment center. Alabama has a cost of living score of 88.6, which means it's cheaper than the national average. Housing costs are also significantly lower than the national average.</p>",
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Encompass Health ',
					employees: '29,298',
				},
				{
					employer: 'Regions Bank',
					employees: '22,126',
				},
				{
					employer: 'The University of Alabama at Birmingham',
					employees: '11,300',
				},
				{
					employer: 'Civil Air Patrol',
					employees: '10,500',
				},
				{
					employer: 'BBVA Compass',
					employees: '10,336',
				},
			],
		},
		placesToLive: {
			// static content
			copy: '<p>Alabama covers roughly 52,419 square miles and has diverse landscapes, ranging from beaches to mountains to forests. The three largest cities include Birmingham, Montgomery, and Mobile.</p>',
			cities: [
				{
					city: 'Birmingham',
					copy: "<p>Birmingham is Alabama's largest city and has a population of more than 210,099 people. Due to its rapid growth, Birmingham was nicknamed Magic City and offers plenty for residents and visitors alike to enjoy, including Oak Mountain State Park, Birmingham Botanical Gardens, the Birmingham Zoo, Vulcan Park and Museum, and Alabama Adventure & Splash Adventure.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '9 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$120,000',
						},
						{
							item: 'Average rent',
							value: '$1,001 per month',
						},
						{
							item: 'Average apartment size',
							value: '987 square feet',
						},
					],
				},
				{
					city: 'Montgomery',
					copy: '<p>Montgomery is the second-largest city in Alabama with a population of more than 197,337 people. It also happens to be the capital of Alabama and what would the capital city be without an array of sights to see and activities to enjoy? The city has so much to offer, including the Montgomery Zoo & Mann Wildlife Learning Center, the Alabama Safari Park, Riverfront Park, Blount Cultural Park, and the Museum of Alabama.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '8 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$85,300',
						},
						{
							item: 'Average rent',
							value: '$1,466 per month',
						},
					],
				},
				{
					city: 'Mobile',
					copy: '<p>Mobile is the third-largest city in Alabama and more than 191,437 people call it home. It was named one of the best cities to live in the US by National Geographic mostly likely because of the range of activities, the restaurant and bar life, the architecture, and the array of museums and other attractions, such as the Mobile Carnival Museum, Dauphin Street, the History Museum of Mobile, the GulfQuest National Maritime Museum of the Gulf of Mexico, and Battleship USS Alabama.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '7 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$121,100',
						},
						{
							item: 'Average rent',
							value: '820 per month',
						},
						{
							item: 'Average apartment size',
							value: '925 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: "Driver's license info",
				copy: "New residents of Alabama are required to transfer their out-of-state driver's license to the state at an ALEA office. You'll need your social security card and one item from the primary list of documentations mentioned via the link below. You'll also have to pay a $5 transfer fee and $36.25 for the license itself.",
				link: 'https://www.alea.gov/dps/driver-license/document-requirements-and-fees',
			},
			{
				title: 'Vehicle registration info',
				copy: "To register an out-of-state vehicle in Alabama, bring your original vehicle title and the current tag registration from your previous state. The owner is required to come in and provide the vehicle inspection within 30 days of moving to the state with their new Alabama driver's license, and a valid insurance card. If your vehicle is leased or financed, you'll also need to contact the lien-holder or leasing company and request the title documents be sent to the Alabama DMV.",
				link: 'https://www.support.revenue.alabama.gov/hc/en-us/articles/115006309308-What-are-the-prerequisites-for-registering-a-vehicle-in-Alabama-',
			},
			{
				title: 'Voter registration info',
				copy: 'To register to vote in Alabama, download the State of Alabama Mail-In Voter registration from the link below. Then, print it out, fill it out, and mail it in to your local board of registrars. Anyone registering to vote has to send in a mailed application with their original signature to the Board of Registrars in the county they live in.',
				link: 'https://www.sos.alabama.gov/alabama-votes/voter/register-to-vote',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/alabama-population/',
			'https://www.coolkidfacts.com/alabama-facts/',
			'https://kids.nationalgeographic.com/explore/states/alabama/',
			'https://www.planetware.com/tourist-attractions/alabama-usal.htm',
			'https://www.onlyinyourstate.com/alabama/reasons-why-people-are-moving-to-alabama/',
			'https://www.coastalliving.com/travel/gulf-coast/best-beaches-alabama',
			'https://www.al.com/business/2018/01/more_people_moving_into_alabam.html',
			'https://www.al.com/news/2019/04/census-most-of-alabamas-counties-are-losing-people.html',
			'https://fred.stlouisfed.org/series/ALNGSP',
			'https://www2.labor.alabama.gov/LAUS/',
			'https://www.statista.com/statistics/1064673/alabama-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-alabama/',
			'https://www.kiplinger.com/slideshow/business/T019-S010-kiplinger-economic-outlook-for-all-50-states-2020/index.html',
			'https://www.bestplaces.net/cost_of_living/state/alabama',
			'https://www.coastalliving.com/travel/travel-mobile-alabama',
			'https://www.tripadvisor.com/Attractions-g30709-Activities-Mobile_Alabama.html',
			'https://www.alea.gov/dps/driver-license/document-requirements-and-fees',
			'https://www.support.revenue.alabama.gov/hc/en-us/articles/115006309308-What-are-the-prerequisites-for-registering-a-vehicle-in-Alabama-',
			'https://www.sos.alabama.gov/alabama-votes/voter/register-to-vote',
			'https://www.payscale.com/cost-of-living-calculator/Alabama-Birmingham',
			'https://www.zillow.com/birmingham-al/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/al/birmingham/',
			'https://www.payscale.com/cost-of-living-calculator/Alabama-Montgomery',
			'https://www.zillow.com/montgomery-al/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/al/montgomery/',
			'https://www.payscale.com/cost-of-living-calculator/Alabama-Mobile',
			'https://www.zillow.com/mobile-al/home-values/',
		],
	},
	AK: {
		state: 'Alaska',
		stateNickname: 'Last Frontier',
		welcome: `
			<p>Alaska truly lives up to its nickname of The Last Frontier. The vast wilderness of America's largest state draws adventurers and those that seek a more rustic lifestyle amid the snow. Rich in natural resources from fisheries to oil, Alaska is an important strategic resource for the United States. Living in remote parts of Alaska can often be challenging, and enduring winters test even the most hardened. However more than half of the state's population lives in and around Anchorage, the state's biggest city. In Anchorage, residents can enjoy living in an increasingly diverse community with all the cultural and entertainment amenities you could hope for.</p>
			<p>Are you ready to start a new life outside of the lower 48? Keep reading to learn all you need to know to prepare for a move to Alaska.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
			<p>Self-storage is a hot commodity in Alaska as exiting inventory per capita lags behind the national average. The Alaska self-storage sector offers 4.64 square feet of storage space per capita, which is well below the national average of 5.4 square feet per person. This suggests that the Alaskan self-storage is undersupplied, which means availability may be limited and prices may be elevated in some markets. A trend of self-storage development has recently taken place nationwide, with Alaska seeing some new investment in self-storage facilities as a result.</p>
			<p>Here's some data points that illustrate just how big self-storage is in Alaska:</p>
			`,
			facts: [
				{
					fact: 'Alaska is home to more than 101 self-storage facilities.',
					highlight: '101',
				},
				{
					fact: 'Alaska self-storage facilities provide more than 3,171,433 square feet of storage space.',
					highlight: '3,171,433',
				},
				{
					fact: 'Alaska has 4.64 square feet of self-storage space for every person in the state.',
					highlight: '4.64',
				},
				{
					fact: 'Average price of a self-storage unit in Alaska:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Anchorage',
				price: '0',
			},
			{
				city: 'Juneau',
				price: '0',
			},
			{
				city: 'Homer',
				price: '0',
			},
			{
				city: 'Fairbanks',
				price: '0',
			},
			{
				city: 'Wasilla',
				price: '0',
			},
			{
				city: 'Ketchikan',
				price: '0',
			},
			{
				city: 'Sitka',
				price: '0',
			},
			{
				city: 'Nome',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>Moving to Alaska is a huge decision. If you are thinking about moving to Alaska, you might want to see if any of the reasons below appeal to you first.</p>',
			reasons: [
				"Get that money. Yes, it's true. Alaska really will pay you to live there. Full-time residents are eligible to receive an annual royalty from the state's Permanent Fund Dividend, which is funded by the state's oil production.",
				"The Northern Lights will blow your mind. Living in Alaska you'll have a chance to witness the aurora borealis, a phenomenon most likely to be seen from Fairbanks and north of the Arctic Circle between September and late April.",
				"You're ready to hit your highest peak. Spend some time in Denali National Park, where you can witness, and perhaps even climb, North America's highest mountaintop.",
				"The State Fair is kind of a big deal. Every year around Labor Day, Alaskans from all over the state descend upon around Palmer for the Alaska State Fair. You'll go for the amazing fried foods, touring bands, and to reconnect with far flung friends. ",
				'Small town life appeals to you. While half of Alaskans live near Anchorage, most of the other half depend on the community and resources provided by tight knit small towns. ',
				"You're a Salmon fanatic. Head over to Kenai for one of the best places to go and catch giant salmon.",
				"You can really get lost. Many people come to Alaska's remote areas come to start a new life, or be as far away as they can from other people. The state is the most sparsely populated in the union, which means you can truly disappear, if that's what you want.",
				'No sales or income tax. There is no sales tax or income tax in Alaska, which is a boon for many residents. Be forewarned that property taxes are higher as a result.',
				"You love to explore. Alaska might be desolate, but if that's your thing you'll never run out of things to do. From the former gold mine found at Treadwell Ruins, to the Kennicott ghost town to abandoned military installations--Alaska is full of interesting remnants of the past worth discovering.",
				"More room for activities. Speaking of exploring, there are so many outdoor activities to enjoy in Alaska that you'll quickly want to adapt to the cold weather. Whether its skiing, snowboarding, snowmobiling or dog sledding--you'll spend plenty of time in the great outdoors.",
			],
		},
		movingTo: {
			// static content
			copy: "<p>Alaska is the biggest state at 663,267 square miles. That's about three times the state of Texas. It is also the third least populated state with around 735,720 people. Alaska saw a slight decline in population from 2018 to 2019, less than a quarter of a percent drop. While growth may have stalled last year, the state is estimated to have grown more than three percent since 2010. Alaska is a land of extreme cold and an abnormal daylight calendar due to its proximity to the North Pole. If those aren't deal breakers for you, then you might just be ready for the Last Frontier.</p>",
		},
		economicOutlook: {
			// static content
			copy: `
				<p>The Alaskan economy is driven by energy, fisheries, and tourism. It has the 48th lowest GDP in the country at $55 billion. But don't let that statistic fool you, the state has the fourth highest GDP per capita, at $63,971 per head. Alaska residents are among the richest in the country, ranked seventeenth in 2018 in terms of average personal income for residents of $73,000 annually. Alaska has a high unemployment rate relative to the rest of the nation, at 6.2 percent as of September 2019.</p>
				<p>Below, you'll find a breakdown of Alaska' largest sectors by share of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Minerals (mostly oil)',
					value: '24 percent',
				},
				{
					sector: 'Government',
					value: '19 percent',
				},
				{
					sector: 'Financial Activities',
					value: '11 percent',
				},
				{
					sector: 'Transportation and Warehousing',
					value: '10 percent',
				},
				{
					sector: 'Professional and Business Services',
					value: '7 percent',
				},
			],
			bottomLine:
				"<p>Alabama is looking at a job growth rate of 1.2 percent and is expected to add about 25,000 new jobs through 2020. Construction is a huge growth area for the state and the automotive industry is also growing with 4,000 new jobs expected to be added throughout 2021 thanks to building plans for new plants. Furthermore, Amazon is expected to create 1,500 new jobs in a Birmingham fulfillment center. Alabama has a cost of living score of 88.6, which means it's cheaper than the national average. Housing costs are also significantly lower than the national average.</p>",
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Fort Wainwright Credit Union in Wainwright  ',
					employees: '7,500',
				},
				{
					employer: 'Bristol Bay Native in Anchorage',
					employees: '4,869',
				},
				{
					employer: 'Chugach Alaska in Anchorage',
					employees: '4,822',
				},
				{
					employer: 'Afognak Native in Kodiak',
					employees: '4,450',
				},
				{
					employer: 'Anchorage School District in Anchorage',
					employees: '10,336',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Living in Alaska can get kind of lonely, for some thatº's why they like it. For others at least there are a few towns and cities that can provide community and things to do.</p>
				<p>Here is a quick look at the state's three most populous places to live:</p>
			`,
			cities: [
				{
					city: 'Anchorage',
					copy: "<p>The city of Anchorage is actually pretty decently sized, with 291,538 residents making up the populations of Alaska's largest city. More than 40 percent of Alaskans live in Anchorage, which gives you a good idea how sparsely populated the rest of the state is. Settled around a railroad camp around 1914, Anchorage developed on the back of its thriving industry. It is also a key refueling stop for cargo planes embarking to and from the United States to other locations around the world.  Anchorage residents have a median income of $78,121, much higher than the national average of $53,482.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '28 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$318,000',
						},
						{
							item: 'Average rent',
							value: '$1025/month',
						},
						{
							item: 'Average apartment size',
							value: '697 square feet',
						},
					],
				},
				{
					city: 'Fairbanks',
					copy: "<p>Fairbanks is a home rule city and is the largest city in Alaska's Interior region with more than 31,000 people. Fairbanks is also the northernmost metropolitan statistical area in the United States, located less than 200 miles from the Arctic Circle.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '22 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$385,000',
						},
						{
							item: 'Average rent',
							value: '$1,105/month',
						},
					],
				},
				{
					city: 'Juneau',
					copy: "<p>Juneau, capital of Alaska, also has just over 31,000 people. Despite being connected to the mainland, the city isn't connected to the rest of the state by road and can only be accessed by air and sea. You'll have to take your car on the ferry to drive in and out.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '33 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$223,875',
						},
						{
							item: 'Average rent',
							value: '$1,244/month',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Alaska must get a new license within 90 days of first driving in the state. To get an Alaska license you'll need to surrender your old license, pass a written knowledge exam, pass a substance abuse awareness test, take a vision test, and provide proof of name, DOB, new address and social security number.",
				link: 'https://doa.alaska.gov/dmv/akol/new2ak.htm',
			},
			{
				title: 'Vehicle registration',
				copy: 'You must register your out-of-state vehicle within 10 days of moving to Alaska if you are moving or taking a job in the state. Non-residents can operate a vehicle for 60 days before they are required to register the vehicle in Alaska.',
				link: 'https://doa.alaska.gov/dmv/reg/require.htm',
			},
			{
				title: 'Voter Registration',
				copy: 'In Alaska the deadline to register to vote is 30 days before the election. Registration can be mailed or submitted online, or register in person at a local Division of Elections office, the DMV or before a qualified registration official or agency.',
				link: 'https://ballotpedia.org/Alaska_elections,_2020',
			},
		],
		sources: [
			// static content
			'https://doa.alaska.gov/dmv/reg/require.htm',
			'https://en.wikipedia.org/wiki/Anchorage,_Alaska#Economy',
			'https://www.bestplaces.net/economy/city/alaska/anchorage',
			'https://www.payscale.com/cost-of-living-calculator/Alaska-Fairbanks',
			'https://www.rentcafe.com/average-rent-market-trends/us/ak/anchorage/',
			'https://en.wikipedia.org/wiki/Fairbanks,_Alaska',
			'https://www.zillow.com/fairbanks-ak/home-values/',
			'https://www.rentjungle.com/average-rent-in-fairbanks-ak-rent-trends/',
			'https://en.wikipedia.org/wiki/Juneau,_Alaska',
			'https://www.commerce.alaska.gov/web/Portals/6/pub/2011_Alaska_Economic_Performance_Report.pdf',
			'https://live.laborstats.alaska.gov/labforce/',
			'https://en.wikipedia.org/wiki/Economy_of_Alaska',
			'https://en.wikipedia.org/wiki/List_of_U.S._states_by_GDP_per_capita',
			'https://www.movoto.com/blog/opinions/moving-to-alaska/',
			'https://smartasset.com/mortgage/15-things-to-know-before-moving-to-alaska',
			'https://worldpopulationreview.com/states/',
			'https://en.wikipedia.org/wiki/Alaska_Permanent_Fund',
			'https://www.travelandleisure.com/trip-ideas/nature-travel/alaska-when-to-see-northern-lights',
			'https://www.nps.gov/dena/index.htm',
			'https://traveltips.usatoday.com/time-salmon-fishing-alaska-17657.html',
			'https://www.atlasobscura.com/things-to-do/alaska/places',
			'https://en.wikipedia.org/wiki/Anchorage,_Alaska',
			'https://en.wikipedia.org/wiki/Alaska',
		],
	},
	AZ: {
		state: 'Arizona',
		stateNickname: 'Grand Canyon State',
		welcome: `
			<p>Arizona, also known as the Copper State, or the Grand Canyon State, is the 14th largest state in the country, with a population of more than 7.2 million people. One-fourth of the state is made up of forests, which includes 11.2 million acres of National Forests. Even though it's usually known for deserts, the state has over 3,900 mountain peaks and summits. It's bordered by Nevada, New Mexico, California, Utah, Colorado, and Mexico.</p>
			<p>Arizona's major industries include tourism, mining, manufacturing, and agriculture. The state produces silver and gold, but it produces the most copper of any kind of metal and does it more than any other state in the US.</p>
			<p>Arizona gets sunshine for 85 percent of the year, meaning plenty of opportunities for outdoor activities and events, like swimming, white water rafting, hiking, camping, parks, and water and amusement parks. Some of the state's top attractions include The Grand Canyon, Sedona, the Hoover Dam, Monument Valley, Saguaro National Park, and Havasu Falls.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Arizona has been one of the hottest markets for self-storage, and we aren't talking about the desert. With more and more people moving to the state, demand for self-storage continues to drive new development of storage facilities in Arizona. A lull in construction after the recession led to pent up demand from consumers looking for storage space. A new wave of construction seeks to capture that demand by building new facilities and even converting vacant retail stores into storage buildings. This trend is taking place throughout Arizona's population centers and across the United States. Arizona self-storage has gotten a boost from the growing number of retirees relocating to the state from California and beyond.</p>
				<p>Below is an overview of the current state of the Arizona self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Arizona is home to about 918 self-storage facilities.',
					highlight: '918',
				},
				{
					fact: 'Arizona self-storage facilities cover 41,687,324 square feet of storage space.',
					highlight: '41,687,324',
				},
				{
					fact: 'Arizona storage facilities offer 6.22 square feet of storage per person, which is higher than the national average of 5.4 square feet per person.',
					highlight: '6.22',
				},
				{
					fact: 'Average price of a self-storage unit in Arizona:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Phoenix',
				price: '0',
			},
			{
				city: 'Tempe',
				price: '0',
			},
			{
				city: 'Tucson',
				price: '0',
			},
			{
				city: 'Scottsdale',
				price: '0',
			},
			{
				city: 'Mesa',
				price: '0',
			},
			{
				city: 'Sedona',
				price: '0',
			},
			{
				city: 'Chandler',
				price: '0',
			},
			{
				city: 'Flagstaff',
				price: '0',
			},
			{
				city: 'Yuma',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>Considering a move to Arizona like so many people do each year? Our top 10 reasons to move to the Copper State might help sway you in the right direction.</p>',
			reasons: [
				'The Grand Canyon. Arizona is home to one of the Seven Natural Wonders of the World, the Grand Canyon. Moving here means you can visit anytime you want and take in this natural beauty in all its amazement.',
				"Stronger wine. That's right. In Arizona, the wine has higher alcohol content. Mainly because the state grows 30 varieties of grapes and they're all made a little stronger than those you'd normally find outside the state.",
				"White water rafting on the Colorado River. If you're an adrenaline junkie with a love of water, you can't go wrong white water rafting on the Colorado River. Moving to Arizona means you'll be that much closer to the action.",
				"The birthplace of the chimichanga. The Chimichanga was invented in Arizona and you can get one in a variety of ways, including deep-fried and topped with cheese. Living here means you'll be in close proximity to this delicious treat pretty much all the time.",
				"Warm weather. What's the first thing you think about when you hear Arizona? Sizzling heat, right? Well, that's exactly what you'll find if you move out here. It can get as hot as 120 degrees in the summertime so make sure to find plenty of ways to stay cool.",
				"Skiing in Flagstaff. What a lot of people don't know is that Arizona is not just an arid desert that stays warm all year long. In fact, some areas of Arizona (like Flagstaff) get pretty cold - cold enough to go skiing. If you love the snow, you might not necessarily have to give it up to live in Arizona.",
				'The stone forest. The Petrified Forest National Park is covered in fossilized trees, some of which date back as far as 225 million years. Need we say more?',
				"The sunsets. Arizona has some of the most gorgeous sunsets in the country. If you're a hopeless romantic, you can easily grab a blanket and your sweetheart and kick back to watch the amazing array of colors in the Arizona sky just before dinner.",
				"Outdoor events and entertainment. Since the weather is so nice so much of the year, Arizona has tons of outdoor events and entertainment for visitors and residents alike to enjoy. From open-air festivals to outdoor restaurants, you'll be able to enjoy doing pretty much everything outside when the weather permits.",
				"The Food scene. Aside from chimichangas, Arizona has plenty to offer in terms of types of restaurants and dishes. From Moroccan food and Thai food to Mexican food and American food, you'll get your fill of diverse, delectable dishes.",
			],
		},
		movingTo: {
			// static content
			copy: "<p>Arizona is the 14th largest state by population and the sixth-largest state in terms of area, with a population of roughly 7.2 million people. From 2018 to 2019, the population grew by 1.44 percent. According to Bloomberg, 200 new people moved to Arizona daily between 2017 and 2018. Arizona's 2017 inbound population movement was the highest among all US states, according to a study by North American Moving Services (NAMS).  And a large number of those people moving into the state were from California. Some of the reasons people are choosing to move to Arizona include the state's low tax rates and lower cost of living.</p>",
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Arizona had a GDP of $346 billion in 2018, according to the Federal Reserve Bank of St. Louis. If Arizona were a country, it would have a GDP similar to Israel's nearly $300 billion GDP.</p>
				<p>Below is a breakdown of the state's largest sectors by real value GDP added</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$63.65 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$36.68 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$36 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$30.94 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$28.51 billion',
				},
			],
			bottomLine: `
				<p>Arizona's economy grew at a pretty solid pace during the first half of 2019 and the state added 37,000 jobs as of August 2019. Arizona is expected to add 165,000 new jobs by 2020 and the state economy is expected to be among the best in the nation, according to Forbes.</p>
				<p>Arizona has a cost of living score of 112.4, which means it's somewhat more expensive to live in Arizona than the US as a whole. On the plus side, there are several cities within the state that have a cost of living lower than the national average, including Phoenix and Tucson.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Pet Smart',
					employees: '53,000',
				},
				{
					employer: 'Circle K',
					employees: '35,733',
				},
				{
					employer: 'Republic Services',
					employees: '33,000',
				},
				{
					employer: 'ON Semiconductor',
					employees: '32,000',
				},
				{
					employer: 'Freeport-McMoRan',
					employees: '30,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Arizona is roughly 113,998 square miles and is home to 15 counties, several public forests, parklands, state trusts, and Native American reservations. Its three biggest cities include Phoenix, Tucson, and Mesa.</p>
			`,
			cities: [
				{
					city: 'Phoenix',
					copy: '<p>Phoenix is the capital of Arizona and the largest city in the state, with a population of more than 1.7 million people. Phoenix boasts natural beauty and plenty to do outdoors, including golf courses, spas, museums, restaurants, theaters, shopping, and cultural attractions.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '5 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$246,400',
						},
						{
							item: 'Average rent',
							value: '$1,085 per month',
						},
						{
							item: 'Average apartment size',
							value: '800 square feet',
						},
					],
				},
				{
					city: 'Tucson',
					copy: '<p>Tucson is the second-largest city in Arizona and has a population of more than 537,500 people. Tucson has a flourishing visual and performing arts scene and plenty of museums and art galleries. Tucson offers the best of both worlds: in the summer you can go hiking in the mountains and in the winter you can hit the slopes of Mt. Lemon.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '6 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$194,100',
						},
						{
							item: 'Average rent',
							value: '$879 per month',
						},
						{
							item: 'Average apartment size',
							value: '757 square feet',
						},
					],
				},
				{
					city: 'Mesa',
					copy: "<p>Mesa is Arizona's third-largest city with a population of 503,619 people. It's known for its universities, including Arizona State University. But it also has tons of activities and events including zoos, golf, museums, old west towns, three lakes, two rivers, and attractions like the Tonto National Forest, the Arizona Museum of Natural History, the Mesa Arts Center, Papago Park, Usery Mountain Regional Park, and the Commemorative Air Force Museum.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '7 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$255,600',
						},
						{
							item: 'Average rent',
							value: '$1,058 per month',
						},
						{
							item: 'Average apartment size',
							value: '815 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info',
				copy: "New residents of Arizona must obtain a new driver's license at an MVD office and the state recommends getting the Arizona Travel ID that has the gold star in the top right-hand corner. You can apply for an Arizona driver's license online. You can also go to a privately operated business contracted with MVD for driver's license services.  For more info, visit:",
				link: 'https://azdot.gov/motor-vehicles/new-az/obtaining-driver-license',
			},
			{
				title: 'Vehicle registration',
				copy: "To apply for an Arizona title and registration for your vehicle, you have to visit an MVD Office or Authorized Third Party provider to complete an application. That has to be done within 15 days of purchase of your new vehicle (if applicable). If you're bringing your car from out-of-state, you have to register it as soon as you become a resident of the state of Arizona. For more info, visit:",
				link: 'https://azdot.gov/motor-vehicles/new-az/applying-title-and-registration',
			},
			{
				title: 'Voter Registration',
				copy: "In Arizona, you can submit a voter registration application at the same time you apply for your new Arizona driver's license. To register to vote, fill out a voter registration application online. Your application has to be filled out and received by the county recorder at least 29 days before the election in order for you to be eligible to vote. For more info, visit:",
				link: 'https://azdot.gov/motor-vehicles/driver-services/driver-license-information/voter-registration',
			},
		],
		sources: [
			// static content
			'https://www.foodnetwork.com/restaurants/packages/best-food-in-america/photos/what-to-eat-in-arizona',
			'https://www.onlyinyourstate.com/arizona/az-iconic-foods/',
			'https://www.coolkidfacts.com/arizona-facts/',
			'https://www.buzzfeed.com/sebastiana2/36-reasons-why-arizona-is-the-best-state-1yiw',
			'https://www.zippia.com/advice/largest-companies-in-arizona/',
			'https://worldpopulationreview.com/states/arizona-population/cities/',
			'https://azdot.gov/motor-vehicles/driver-services/driver-license-information/voter-registration',
			'https://azdot.gov/motor-vehicles/new-az/applying-title-and-registration',
			'https://worldpopulationreview.com/states/arizona-population/',
			'https://www.tripadvisor.com/Attractions-g28924-Activities-Arizona.html',
			'https://www.bizjournals.com/phoenix/news/2019/09/04/heres-how-many-people-are-moving-to-phoenix-on-a.html',
			'https://www.ozy.com/fast-forward/why-people-are-flocking-from-california-to-arizona/90804/',
			'https://fred.stlouisfed.org/series/AZNGSP',
			'https://patch.com/arizona/phoenix/everyone-u-s-moving-maricopa-county',
			'https://www.usatoday.com/story/money/2019/04/17/how-gdp-of-us-states-compares-to-countries-around-the-world/39295197/',
			'https://www.statista.com/statistics/1064748/arizona-real-gdp-by-industry/',
			'https://www.comerica.com/insights/economic-commentary/august-2019-arizona-economic-outlook.html',
			'https://azgovernor.gov/governor/news/2019/02/forecast-arizona-add-more-165000-new-jobs-2020',
			'https://www.forbes.com/places/az/',
			'https://www.bestplaces.net/cost_of_living/state/arizona',
			'https://www.visitarizona.com/cities/phoenix-and-central/phoenix',
			'https://www.visitarizona.com/cities/tucson-and-southern/tucson',
			'https://www.visitarizona.com/cities/phoenix-and-central/mesa',
			'https://www.tripadvisor.com/Attractions-g31281-Activities-Mesa_Arizona.html',
			'https://kids.nationalgeographic.com/explore/states/arizona/',
			'https://www.payscale.com/cost-of-living-calculator/Arizona-Phoenix',
			'https://www.zillow.com/phoenix-az/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/az/phoenix/',
			'https://www.payscale.com/cost-of-living-calculator/Arizona-Tucson',
			'https://www.zillow.com/tucson-az/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/az/tucson-city/',
			'https://www.payscale.com/cost-of-living-calculator/Arizona-Mesa',
			'https://www.zillow.com/mesa-az/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/az/mesa/',
		],
	},
	AR: {
		state: 'Arkansas',
		stateNickname: 'Natural State',
		welcome: `
			<p>From the Ozark mountains to the rice patties of the delta, Arkansas is a state full of variety–and not just when it comes to geological features. The state is home to big business, arts and culture, outdoor adventure, elite college sports and so much more.</p>
			<p>Much like in neighboring Mississippi, the Arkansas delta region is home to vibrant mix of musical tradition that includes blues, gospel, R&B, and rockabilly that gave birth to musicians such as Howlin' Wolf, Johnny Cash, Albert King, Levon Helm, Al Green, Sister Rosetta Tharpe and many more. Arkansas is also home to Wal-Mart, the world's largest retailer, but also many more giant businesses including ABF Freight System, J.B. Hunt, Dillard's, Murphy Oil and Tyson Foods. </p>
			<p>Thinking about calling Arkansas home? Keep reading to learn more about the Natural State and all that it has to offer.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Arkansas self-storage industry has recently benefitted from a nationwide wave of self-storage construction activity taking place across the nation. Now some of that new construction has made its way to Arkansas. Self-storage operators are attracted to fast growing markets, making some Arkansas cities and towns an attractive target for expansion. New facilities are being built around the state, in addition to the redevelopment of vacant strip mall big box stores into self-storage units.</p>
				<p>Below are some statistics that provide an overview of the self-storage industry in Arkansas:</p>
			`,
			facts: [
				{
					fact: 'Arkansas is home to an estimated 688 self-storage facilities.',
					highlight: '688',
				},
				{
					fact: 'Arkansas self-storage facilities cover 20,909,575 square feet of storage space.',
					highlight: '20,909,575',
				},
				{
					fact: 'Arkansas storage facilities offer 7.16 square feet of storage per person, which is higher than the national average of 5.4 square feet per person.',
					highlight: '7.16',
				},
				{
					fact: 'Average price of a self-storage unit in Arkansas:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Little Rock',
				price: '0',
			},
			{
				city: 'Bentonville',
				price: '0',
			},
			{
				city: 'Fayetteville',
				price: '0',
			},
			{
				city: 'Fort Smith',
				price: '0',
			},
			{
				city: 'Hot Springs',
				price: '0',
			},
			{
				city: 'Jonesboro',
				price: '0',
			},
			{
				city: 'Rogers',
				price: '0',
			},
			{
				city: 'Conway',
				price: '0',
			},
			{
				city: 'Springdale',
				price: '0',
			},
			{
				city: 'Pine Bluff',
				price: '0',
			},
			{
				city: 'Eureka Springs',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>If you are moving to Arkansas you have a lot to look forward to. The state has a lot to offer in terms of culture, climate, jobs and more. Keep reading to find out more about all the things that make Arkansas an amazing place to live.</p>',
			reasons: [
				'Explore the Ozarks. The Ozarks is an incredible region of mountains and lakes full of outdoor recreation possibilities, or just good country living.',
				'You can afford it. Arkansas has a 15 percent lower cost of living than the rest of the country.',
				'Soak in Hot Springs. Head to Hot Springs to enjoy, well, hot springs. The spa town is home to a number of developed and natural thermal springs that provide a warm respite from the outside world.',
				"Razorback pride. Fandom for the University of Arkansas' Razorbacks sports teams is pervasive throughout the state. If you aren't a fan now, you will be.",
				"Arts and culture are our bread and butter. Arkansas is rife with performing arts centers, museums and galleries thanks in big part to the fortunes of the Waltons; the Walmart founding family has invested millions into the region's arts and culture over the years and continues to do so.",
				"Property taxes are way low. Arkansas has the 10th lowest property tax rates in the country, which has help fuel the state's fast growing housing industry.",
				"Finders keepers. Arkansas is home to the only diamond mine in the world that is open to the public. If you're lucky enough to find a diamond while prospecting it is yours to keep.",
				'Keep it folky. Mountain View is a small town in the Ozarks that is known as the Folk Music Capital of the World. It hosts the annual Arkansas Folk Festival, and several other folk music performances including a weekly free show on the courthouse steps.',
				"Little Rock rocks. You'll find plenty to do in the state's biggest city and its capital including: the Arkansas Arts Center, Bill Clinton's presidential library, the General Douglas MacArthur military museum and many more.",
				'We got good weather. Arkansas low key has one of the most comfortable climates in the Lower 48. The state has four distinct seasons: a temperate spring, a hot summer, a dry fall, and mild winter.',
			],
		},
		movingTo: {
			// static content
			copy: "<p>Arkansas has a growing population, thanks to many new residents moving from out of state for its low cost of living, high quality of life, thriving business environment and opportunities in the arts. The state grew 3.6 percent between 2010 and 2018. With an estimated three million people, Arkansas is ranked 34th in population for the United States. Little Rock is the state's most populous city with nearly 200,000 citizens. Residents go by several different acceptable demonyms: Arkansan, Arkansawyer or Arkanite.</p>",
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Arkansas has a GDP of $132.4 billion, ranked about 35th nationally. The state is home to several Fortune 500 corporations, including global retail giant Walmart. However, the median household income is $45,869 per year, which is significantly less than the national average of more than $60,000 a year. The good news is the state has a very low cost of living and also a low cost of doing business, which is both attracting new residents and businesses alike. The state of Arkansas has a low unemployment rate of 3.5 percent, as of November 2019.</p>
				<p>Here is a break down of Arkansas' largest sectors by GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Manufacturing',
					value: '$19.5 million',
				},
				{
					sector: 'Government and government enterprises',
					value: '$16.7 million',
				},
				{
					sector: 'Real estate and rental and leasing',
					value: '$13.9 million',
				},
				{
					sector: 'Healthcare and social assistance',
					value: '$11.7 million',
				},
				{
					sector: 'Wholesale trade',
					value: '$10.2 million',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Walmart in Bentonville',
					employees: '2,300,00',
				},
				{
					employer: 'Tyson Foods in Springdale',
					employees: '114,000',
				},
				{
					employer: 'Dillard’s in Little Rock',
					employees: '30,800',
				},
				{
					employer: 'Sam’s Club in Bentonville',
					employees: '27,940',
				},
				{
					employer: 'J.B. Hunt Transport Services in Lowell',
					employees: '22,190',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Arkansas spans more than 53,000 square miles, the 29th largest state in the country. It is divided in several distinct regions: the Ozarks, the Arkansas Valley, the Ouachita Mountains, the Gulf Coastal Plain, and the Mississippi River Delta. Little Rock is located in the center of the state at the nexus of these various regions. Each region has its own cultural differences and traditions that you should know about when selecting a place to move. Below are just a few of the places you might consider living when you arrive in Arkansas.</p>
			`,
			cities: [
				{
					city: 'Little Rock',
					copy: '<p>The cultured capital of Arkansas has a metro region population of more than 700,000 residents. Residents of the city are known as Little Rockers. The city is actually named for a little rock, a stone outcropping in the Arkansas River that travelers used as a landmark. Attempts to name the settlement Arkopolis in the 1820s were unsuccessful.  Today the city is home to several museums, theaters, cultural institutions, large state employers, and much more.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '4 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$167,000',
						},
						{
							item: 'Average rent',
							value: '$793 per month',
						},
						{
							item: 'Average apartment size',
							value: '883 square feet',
						},
					],
				},
				{
					city: 'Fort Smith',
					copy: "<p>Located in northwest Arkansas near the Oklahoma border, Fort Smith is the second most populous city in Arkansas. The city is known for its thriving music scene and large number of manufacturing jobs. The city was established as a frontier military camp in 1817 and became a starting point for settlers making their way further west. The city is also home to the new United States Marshals Service National Museum, thanks to the city's federal law enforcement roots. </p>",
					facts: [
						{
							item: 'Cost of living',
							value: '15 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$126,000',
						},
						{
							item: 'Average rent',
							value: '$524 per month',
						},
					],
				},
				{
					city: 'Fayetteville',
					copy: '<p>Fayetteville is home to the University of Arkansas, making this college town in the heart of the Ozarks important to Razorbacks everywhere. Known as the Athens of the Ozarks, this small refined city has a population of more than 86,000 and more than 500,000 residents living in the surrounding metro area. Families and retirees are flocking to Fayetteville which was recognized in 2016 by U.S. News as the third best place to live in America.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '11 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$219,000',
						},
						{
							item: 'Average rent',
							value: '$744 per month',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Arkansas must obtain a valid Arkansas driver's license within 30 days of establishing residency by going to a local revenue office. No exams are required if you can present an out-of-state license that is not more than 31 days expired.",
				link: 'https://www.dfa.arkansas.gov/services/category/vehicles/',
			},
			{
				title: 'Vehicle registration',
				copy: 'New Arkansas residents must register their vehicle within 30 days of moving. You will need the following documents to do so: current registration, title, proof of Arkansas insurance, application, bill of sale, VIN inspection report and registration fees. For more details check out the Arkansas Department of Finance and Administration.',
				link: 'https://www.dfa.arkansas.gov/services/category/vehicles/',
			},
			{
				title: 'Voter Registration',
				copy: "In Arkansas, you must register to vote 30 days before the election. To register you will need to provide a driver's license number and the last four digits of your social security number. If you don't have a license yet you must also submit a valid photo id and a current bill or check with your name and address on it. You can register to vote in Arkansas here:",
				link: 'https://www.sos.arkansas.gov/elections/voter-information/voter-registration-information',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/',
			'https://en.wikipedia.org/wiki/Arkansas_Delta',
			'https://en.wikipedia.org/wiki/Walmart',
			'https://en.wikipedia.org/wiki/List_of_Arkansas_companies',
			'https://listwithclever.com/real-estate-blog/moving-to-arkansas/',
			'https://wallethub.com/edu/states-with-the-highest-and-lowest-property-taxes/11585/',
			'https://en.wikipedia.org/wiki/Hot_Springs,_Arkansas#Natural_springs',
			'https://www.arkansasedc.com/why-arkansas/life-in-the-natural-state/detail/cost-of-living',
			'https://en.wikipedia.org/wiki/Arkansas_Arts_Center',
			'https://www.waltonfamilyfoundation.org/our-work/home-region/northwest-arkansas',
			'https://www.50states.com/facts/arkansas.htm',
			'https://www.atlasobscura.com/places/crater-of-diamonds',
			'https://en.wikipedia.org/wiki/Mountain_View,_Arkansas',
			'https://en.wikipedia.org/wiki/Fayetteville,_Arkansas',
			'https://en.wikipedia.org/wiki/Little_Rock,_Arkansas',
			'https://careerinfonet.org/oview6.asp?soccode=&id=&nodeid=12&stfips=05&from=State',
			'https://apps.bea.gov/itable/iTable.cfm?ReqID=70&step=1#reqid=70&step=1&isuri=1',
			'https://www.zippia.com/advice/largest-companies-in-arkansas/',
			'https://www.payscale.com/cost-of-living-calculator/Arkansas-Little-Rock',
			'https://www.zillow.com/little-rock-ar/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ar/little-rock/',
			'https://www.rentjungle.com/average-rent-in-fort-smith-rent-trends/',
		],
	},
	CA: {
		state: 'California',
		stateNickname: 'Golden State',
		welcome: `
			<p>From the tops of the redwood forests to the bottom of Death Valley, California is a truly majestic place. Ever since the Gold Rush, many have answered the call of destiny to travel here and make California their home. Some seek opportunities and fortunes, while other come to live out their dreams.</p>
			<p>California continues to be a powerful magnet for the most talented, creative and brilliant minds, which drive the booming entertainment and tech industries of the state. In fact, California is the fifth largest economy in the world, making it an attractive destination if you are looking to make a move.</p>
			<p>Who knows? Perhaps you will be the next California resident to make it big. But whether you are looking to settle down and relax or pursue your next big career move, California has something to offer every lifestyle. It is no surprise then, that so many people are moving here.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Whether people are moving in to the state or moving out, many of them will need to rent a self-storage space to facilitate their move. According to our internal research, about 60 percent of self-storage users are in the process of moving. California has a thriving self-storage industry, which benefits from high income households, limited supply of available storage space and high barriers to entry that prevent new competitors from entering the market easily.</p>
				<p>Here are some more fast facts about self-storage in California you might now know</p>
			`,
			facts: [
				{
					fact: 'California is home to more than 3,500 self-storage facilities',
					highlight: '3,500',
				},
				{
					fact: 'California facilities offer more than 213.3 million square feet of storage space combined.',
					highlight: '213.3',
				},
				{
					fact: "California has 5.53 square feet of storage space for every man, woman, and child. That's on par with the national average of 5.4 square feet per person.",
					highlight: '5.53',
				},
				{
					fact: 'Average price of a self-storage unit: ',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Los Angeles',
				price: '0',
			},
			{
				city: 'San Diego',
				price: '0',
			},
			{
				city: 'San Francisco',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>If you are wondering if California is right for you, consider the following points:</p>',
			reasons: [
				'There is beautiful weather all year-round with a winter average of 63 degrees.',
				'Get outdoors. Cali is home to the best national parks including Yosemite, Joshua Tree and the Redwood National Forest.',
				'If you work in the technology sector, Silicon Valley is calling you.',
				'Property taxes are below the national average!',
				'An education. You (or your children) can go to community college for free.',
				'With more than 3,400 miles of coastline, you are never too far from the beach.',
				'California is considered the most diverse state in the country, so you can enjoy contact with many cultures different from your own.',
				'Along with being a multicultural state, California is home to some of the best restaurants in the world representing a variety of global cuisine like no other place in the world.',
				'You might live longer: Californians have an average life expectancy of 80.9 years, making it the third ranked state in the nation for longevity. ',
				'Are you a pro sports fan? California has 16 professional sports teams, more than any other state.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>California is the most populous state in the country with an estimated 39.7 million residents in 2019. While the state remains the most populous nation in the country, California’s rate of population growth is at its lowest point in its recorded history. The overall population of California is expected to grow just 0.48 percent from the previous year. There are two primary reasons that population growth in California is slowing down: declining birthrates and residents moving to other states.</p>
				<p>Soaring housing costs and rising taxes are the chief drivers behind the continual exodus of Californians to other nearby states like Texas, Arizona and Nevada. While Californians are leaving the state in greater numbers than ever before, the current trend has been ongoing for the last thirty years with the dot-com bust and Great Recession as the primary catalysts.</p>
				<p>Due to the large numbers of people leaving the state, net migration is actually negative in California. About 38,000 more people moved out of the state than people that moved in, according to the latest census estimates. That calculation includes immigrants to California from other countries, who continue to move to the state in large numbers. But for the last two years, immigrant arrivals have not outnumbered California-born residents who are moving away. In 2018, California saw net migration of nearly 118,000 immigrants, compared to a net migration of -156,000 native residents departing the state.</p>
				<p>While more folks are indeed leaving California than ever before, the state remains an attractive draw for thousands of people from the United States and abroad. Whether it’s the draw of the tech sector, the allure of the entertainment industry or simply the state’s majestic beauty, California still has a lot going for it.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>As previously stated, California has the biggest economy of all 50 states. If California was a country, it would be the 5th largest economy in the world with a GDP of $3 trillion. California is home to a healthy job market. As of September 2019, California has an unemployment rate of 4 percent, slightly higher than the United States as a whole at 3.5 percent.</p>
				<p>The economic outlook for the future of California is strong. The state created 347,000 jobs in 2018. According to economist Mark Schniepp, some employers may find it challenging to fill open positions, which is expected to lead to increased wages and salaries in the California job market going forward.</p>
				<p>While there is a big difference between living in a major city or a small town, the overall cost of living in California is one of the most expensive in the country—second only to Hawaii.</p>
				<p>Below is a breakdown of California’s largest sectors by share of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate rental and leasing',
					value: '22 percent',
				},
				{
					sector: 'Professional and business services',
					value: '13 percent',
				},
				{
					sector: 'Government and government enterprises',
					value: '12 percent',
				},
				{
					sector: 'Information',
					value: '9 percent',
				},
				{
					sector: 'Educational services, health care and social assistance',
					value: '7 percent',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Los Angeles International Airport',
					employees: '45,000',
				},
				{
					employer: '32nd St Naval Station (San Diego)',
					employees: '42,951',
				},
				{
					employer: 'UCLA Health System (Los Angeles)',
					employees: '35,543',
				},
				{
					employer: 'University of Southern California (Los Angeles)',
					employees: '30,000',
				},
				{
					employer: 'Walt Disney Parks and Resorts (Anaheim)',
					employees: '28,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Deserts, mountains, beaches, forests, big cities, small towns and everything in between—The Golden State has got it all. California spans an area of 155,779 square miles, making it the third largest state in the country.</p>
			`,
			cities: [
				{
					city: 'Los Angeles',
					copy: '<p>With more than 13 million people in the metro area, Los Angeles is the second biggest city in the country. The entertainment industry is front and center, but L.A. is so much more–including being a haven for culinary pursuits and a launching pad for high-tech startups.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '43 percent higher than national average',
						},
						{
							item: 'Median home price',
							value: '$788,384',
						},
						{
							item: 'Average rent',
							value: '$2,384/month',
						},
						{
							item: 'Average apartment size',
							value: '786 square feet',
						},
					],
				},
				{
					city: 'San Diego',
					copy: '<p>You’ll live your life to the fullest in California’s second biggest city. Packed with universities and colleges, funky neighborhoods, and miles of beaches (with seals!), San Diego is a haven from the spotlights of L.A. and the tech buzz of San Francisco.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '44 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$817,185',
						},
						{
							item: 'Average rent',
							value: '$2,137/month',
						},
						{
							item: 'Average apartment size',
							value: '828 square feet',
						},
					],
				},
				{
					city: 'San Francisco',
					copy: '<p>San Francisco might grab headlines for being one of the most expensive housing markets in the country, but one visit to the City by the Bay and you’ll see why. A bastion of history, culture and tech, San Francisco is an amazing place to live—if you can find a way to afford it.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '80 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$1,146,835',
						},
						{
							item: 'Average rent',
							value: '$3,612/month',
						},
						{
							item: 'Average apartment size',
							value: '789 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents of California are required to get a new license within 10 days of establishing residence. You will need to take a knowledge test and a driving test. You will also have to have your fingerprint scanned and photograph taken. A $35 fee will be charged.',
				link: 'https://www.dmv.ca.gov/portal/dmv/detail/dl/dl_info#two500',
			},
			{
				title: 'Vehicle registration',
				copy: 'To register your out-of-state vehicle after moving to California, you will need an Application for Title or Registration, proof of ownership, a Verification of Vehicle form and applicable fees. For a complete breakdown see the California DMV.',
				link: 'https://www.dmv.ca.gov/portal/dmv/detail/pubs/brochures/howto/htvr09',
			},
			{
				title: 'Voter Registration',
				copy: 'The deadline to register to vote in California is by midnight on the 15th calendar day prior to Election Day. You may register to vote in California here.',
				link: 'https://registertovote.ca.gov/',
			},
		],
		sources: [
			// static content
			'https://www.census.gov/quickfacts/CA',
			'https://www.latimes.com/local/lanow/la-me-ln-population-growth-20190501-story.html',
			'https://qz.com/1599150/californias-population-could-start-shrinking-very-soon/',
			'https://www.salary.com/research/cost-of-living/ca',
			'https://www.payscale.com/cost-of-living-calculator/California-Los-Angeles',
			'https://www.rentcafe.com/average-rent-market-trends/us/ca/los-angeles/',
		],
	},
	CO: {
		state: 'Colorado',
		stateNickname: 'Centennial State',
		welcome: `
			<p>In 1876, Colorado was the 38th state admitted. Coincidentally, the centennial of the Declaration of Independence was that same year, which earned Colorado the nickname the “Centennial State.” With some of the tallest mountains in the country, it’s a popular destination for those who love to ski and snowboard, specifically in Vail and Aspen. It’s not only the Rocky Mountains attracting people; the Great Plains and desert regions are vividly stunning, as well. Colorado is one of the “Four Corners” states, bordered by Wyoming, Nebraska, Kansas, Oklahoma, New Mexico, and Utah.</p>
			<p>Surprisingly enough, Colorado isn’t one massive blizzard year-round. Instead, with a range of 22 ℉ to 89 ℉ temperatures throughout the year, the weather is mostly dry, sunny, and comfortable with the occasional snowstorm. However, the locals claim that the snow is usually power-like and melts away by noon. Coloradans are well-known for leading a highly active and healthy lifestyle, even with the legalization of marijuana in the state in 2012. </p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The self-storage industry has been booming nationwide, and Colorado has been one of the hottest markets for self-storage development. Denver has seen as a surge in activity, as have other markets in Colorado that are popular with retirees. A lack of new development in the preceding years precipitated the current building frenzy. Storage development usually follows behind the development of new residential space, as its users typically are in the midst of a move from one location to another. Developers continue to pursue ground up development, as well as the conversion of vacant big box stores like Sears and Kmart into self-storage facilities. Development is expected to wane in the coming years, but Colorado is expected to remain one of the strongest markets for self-storage in the nation.</p>
			`,
			facts: [
				{
					fact: 'Colorado is home to about 892 self-storage facilities.',
					highlight: '892',
				},
				{
					fact: 'Colorado self-storage facilities cover 36,099,642 square feet of storage space.',
					highlight: '36,099,642',
				},
				{
					fact: 'Colorado storage facilities offer 6.82 square feet of storage per person, which is more than the national average of 5.4 square feet per person.',
					highlight: '6.82',
				},
				{
					fact: 'Average price of a self-storage unit in Colorado:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Denver',
				price: '0',
			},
			{
				city: 'Boulder',
				price: '0',
			},
			{
				city: 'Colorado Springs',
				price: '0',
			},
			{
				city: 'Fort Collins',
				price: '0',
			},
			{
				city: 'Aurora',
				price: '0',
			},
			{
				city: 'Pueblo',
				price: '0',
			},
			{
				city: 'Grand Junction',
				price: '0',
			},
			{
				city: 'Aspen ',
				price: '0',
			},
			{
				city: 'Lakewood',
				price: '0',
			},
			{
				city: 'Loveland',
				price: '0',
			},
			{
				city: 'Durango',
				price: '0',
			},
			{
				city: 'Vail',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>If you are wondering if California is right for you, consider the following points:</p>',
			reasons: [
				'Breathtaking views. Few places on earth are as diverse and stunning as the landscape in Colorado. From the mountains to the desert dunes to the prairie lands, it’s easy to reconnect with nature here.',
				'Adventure. If Colorado offers one thing, it provides a deeply-rooted sense of adventure. With numerous outdoor activities, a shortage of new ventures doesn’t exist with the residents here. Plus, with Colorado’s diverse geography, few individuals repeat the same adventure twice.',
				'City living. If you’re someone who enjoys getting in touch with nature one minute, then ordering a warm, frothy coffee the next minute, Colorado is for you. With such a small separation between the great outdoors and city living, Coloradans get the best of both worlds simultaneously.',
				'Legalization. Since 2012, marijuana has been legal in Colorado. Of course, this particular legalization didn’t come without rules and regulations. Still, it’s one reason for Colorado’s recent population boom.',
				"Job opportunities. The job market in Colorado is promising, offering both skilled and unskilled positions to its residents. Since the mid-90s, job growth has never been more secure and consistent. Also, nearly 7% of workers telecommute, so sitting in a dreary office isn't always reality here.",
				'Personal wellness. It’s widespread that Coloradans live a healthier and more active lifestyle than most others around the U.S. With so much opportunity for outdoor fun and adventure, it only makes sense, after all.',
				'Comfortable weather. Most people assume that Colorado is all ice and cold, but it’s far more than its snowy peaks. The summers hover in the 80s, and the winters don’t often dip below freezing. Plus, it’s sunny and dry most of the time, which is excellent mood-boosting weather.',
				'It’s a skiers utopia. With the vast amount of snow-covered mountains, Colorado is a skier’s dream destination. Aspen, Vail, Breckenridge, and other cities provide dozens of skiing resorts as well as perfectly crisp slopes.',
				'The craft beer. Colorado has such a rich brewing history that its residents have made brewery hopping a lifestyle. From the famous Coors brand to local favorites, such as Ipse Dixit and Gratitude Five, beer lovers are sure to find an enjoyable beverage.',
				'For the dogs. Some places are more welcoming to our four-legged friends than others, and Colorado undoubtedly qualifies as a dog-friendly environment. Many establishments also welcome pooches inside their buildings, too. Plus, most residents enjoy the company of their dogs while adventuring in Colorado outdoors.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>As the 21st most populous state, Colorado’s population is 5.77 million. According to the U.S. Census Bureau, the population of Colorado grew by 1.32% from 2018 to 2019. Unsurprisingly, Colorado’s growth rate is the seventh fastest in the nation. Plenty of individuals are discovering the state’s natural beauty and a thriving economy. Colorado does have a higher cost of living in some parts, but despite the price tag, more people are moving here versus moving away. Also, those heading to Colorado tend to be in their twenties and at a rate of about 60,000 to 75,000 per year.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>From county to county, Colorado’s economy is thriving, landing the state GDP at $384.4 billion. Plus, the unemployment rate is 2.7%, according to the Bureau of Labor Statistics, which is below the national average of 3.6% as of October 2019. Although growth was slower than in 2018, the job market and average incomes display positive trends, which will likely remain unchanged in the coming years. Because the state highly depends on its natural resources, Colorado is trying to diversify its economy more.</p>
				<p>Colorado’s overall economy continues to grow, though the expansion is limited in some industries. Mainly this trend is occurring because throngs of unskilled workers are relocating to Colorado but are unable to fill positions requiring skilled professionals. Even with economic holdups in some parts of the state, Colorado’s forecast is healthy and secure.</p>
				<p>As one of the most beautiful states in which to live, Colorado is perfect for anyone who loves nature and adventure. However, because of its recent popularity, some parts of the state are undoubtedly more affordable than others. The overall cost of living is slightly higher than the national average, though Colorado has notoriously inexpensive utilities.</p>
				<p>The following is a breakdown of Colorado’s largest sectors by real value added of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental and leasing',
					value: '$61.4 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$51.15 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$37.97 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance ',
					value: '$24.12 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$23.54 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Denver International Airport',
					employees: '35,000',
				},
				{
					employer: 'Lockheed Martin Space Systems',
					employees: '14,000',
				},
				{
					employer: 'University of Colorado-Boulder',
					employees: '13,300',
				},
				{
					employer: 'HealthONE Corporation',
					employees: '11,050',
				},
				{
					employer: 'Centura Health',
					employees: '8,310',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>In all of Colorado’s 104,194 square miles of outdoor wonder, several cities make for optimal places to call home. Although the population boom in Colorado has created an uptick in the cost of living, it’s still the perfect destination for outdoor enthusiasts. Plus, it has tons more to offer, no matter if you’re surrounded by the Rocky Mountains or the Great Plains!</p>
			`,
			cities: [
				{
					city: 'Denver',
					copy: '<p>In the Wild West days, Denver was founded as a mining hub. Because of its 5,279-foot elevation, it’s nicknamed the “Mile High City.” Although Denver is not officially a mountain town, many of its 2,798,684 residents are avid skiers and outdoor enthusiasts. U.S. News ranked Denver as its #2 best places to live based on the quality of life and job market.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '12% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$424,300',
						},
						{
							item: 'Average rent',
							value: '$1,673/month',
						},
						{
							item: 'Average apartment size',
							value: '841 square feet',
						},
					],
				},
				{
					city: 'Colorado Springs',
					copy: '<p>With a population of 698,595, Colorado Springs falls into line after Denver as the #3 best places to live according to U.S. News. With a low cost of living and a low unemployment rate, this city has much to offer. Whether it’s hiking, biking, or climbing around the city, Colorado Springs is an excellent place for adventurers. Plus, the weather is typically optimal for outdoor activities.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '6% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$299,200',
						},
						{
							item: 'Average rent',
							value: '$1,190/month',
						},
						{
							item: 'Average apartment size',
							value: '840 square feet',
						},
					],
				},
				{
					city: 'Aurora',
					copy: '<p>Aurora has been nicknamed the “Gateway to the Rockies,” and is also considered the most active city in the U.S. Many of its 374,144 residents live a healthy and active lifestyle. The city is a retail paradise and features a vibrant arts culture, too.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '5% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$329,900',
						},
						{
							item: 'Average rent',
							value: '$1,359/month',
						},
						{
							item: 'Average apartment size',
							value: '842 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'After officially becoming a Colorado resident, you must transfer your driver’s license. If you’ve never held a Colorado license before, you can start the application process online. However, you’ll need to finish up in person at a Colorado driver’s license office. Documents you will need are a valid out-of-state driver’s license, identification documents, proof of Social Security number, two proofs of Colorado residency, proof of U.S. citizenship, and the application fee. Colorado waives the testing requirements when your previous license is still valid from your former state of residency. Though an expired license over a year calls for you to fulfill testing requirements.',
				link: 'https://www.colorado.gov/pacific/dmv/new-colorado-0#New%20Resident%20with%20a%20Valid%20License%2016%20Years%20of%20Age%20or%20Older:',
			},
			{
				title: 'Vehicle registration',
				copy: 'Colorado requires you to register your vehicle within 90 days of becoming a Colorado resident. If your vehicle was registered in another state, Colorado requires the Verification of Vehicle Identification Number form. However, you can’t fill the form out yourself. It must be completed by an auto dealer, a law enforcement officer, or a licensed Colorado emissions testing station.',
				link: 'https://www.colorado.gov/pacific/dmv/new-colorado-0#Vehicle%20Title',
			},
			{
				title: 'Voter Registration',
				copy: 'All Colorado driver’s license offices can help you register to vote in this state. You can also register online.',
				link: 'https://www.sos.state.co.us/voter/pages/pub/home.xhtml',
			},
		],
		sources: [
			// static content
			'https://www.westword.com/restaurants/colorados-best-craft-beers-of-2018-11074154',
			'https://www.uncovercolorado.com/moving-to-colorado/',
			'https://livability.com/co/real-estate/8-reasons-to-move-to-colorado',
			'https://moving.tips/city-guides/reasons-to-move-to-colorado/',
			'https://www.westword.com/marijuana/colorado-legalized-cannabis-seven-years-ago-now-people-can-finally-consume-it-11363287',
			'https://weatherspark.com/y/3709/Average-Weather-in-Denver-Colorado-United-States-Year-Round',
			'https://www.coloradovirtuallibrary.org/resource-sharing/state-pubs-blog/whos-moving-into-and-out-of-colorado/',
			'https://worldpopulationreview.com/states/colorado-population/',
			'https://smartasset.com/mortgage/the-cost-of-living-in-colorado',
			'https://data.bls.gov/timeseries/LNS14000000',
			'https://www.metrodenver.org/research-reports/economic-forecasts/2019-economic-forecast/',
			'https://choosecolorado.com/doing-business/major-employers/',
			'https://www.careerinfonet.org/oview6.asp?printer=true&stfips=08',
			'https://www.bellpolicy.org/2019/01/02/colorado-economic-trends/',
			'https://www.denverpost.com/2019/05/14/us-news-colorado-top-economy/',
			'https://www.statista.com/statistics/594399/colorado-real-gdp-by-industry/',
			'https://www.bls.gov/eag/eag.co.htm',
			'https://www.usgovernmentspending.com/compare_state_spending_2019bZ0a',
			'https://livability.com/co/aurora/real-estate/8-reasons-to-move-to-aurora-colorado',
			'https://realestate.usnews.com/places/colorado/colorado-springs',
			'https://realestate.usnews.com/places/colorado/denver',
			'https://www.rentcafe.com/average-rent-market-trends/us/co/aurora/',
			'https://www.rentcafe.com/average-rent-market-trends/us/co/colorado-springs/',
			'https://www.rentcafe.com/average-rent-market-trends/us/co/denver/',
			'https://www.zillow.com/aurora-co/home-values/',
			'https://www.zillow.com/colorado-springs-co/home-values/',
			'https://www.zillow.com/denver-co/home-values/',
			'https://www.payscale.com/research/US/Location=Aurora-CO/Salary',
			'https://www.payscale.com/cost-of-living-calculator/Colorado-Colorado-Springs',
			'https://www.payscale.com/research/US/Location=Denver-CO/Salary',
			'https://www.usnews.com/news/best-states/colorado',
			'https://www.colorado-demographics.com/cities_by_population',
			'https://www.colorado.gov/pacific/dmv/new-colorado-0#New%20Resident%20with%20a%20Valid%20License%2016%20Years%20of%20Age%20or%20Older:',
			'https://www.colorado.gov/pacific/sites/default/files/DR2698.pdf',
			'https://www.colorado.gov/pacific/dmv/new-colorado-0#Vehicle%20Title',
		],
	},
	CT: {
		state: 'Connecticut',
		stateNickname: 'Nutmeg State',
		welcome: `
			<p>Although it’s one of the smallest states in the nation, there’s no shortage of sights to see and things to do in beautiful Connecticut. Nestled on the southern end of New England, Connecticut boasts a wide array of attractions for visitors of varied ages and interests.</p>
			<p>Of course, while Connecticut is one of the most popular states to visit, the appeal and allure of this quaint state also brings people from across the country who want to make it their permanent residence. And can you blame them? Connecticut has consistently been one of the highest ranked states in the entire nation when it comes to “Human Development Index,” which is a statistic that takes education, per capita income, and life expectancy into consideration. In other words, those who live in Connecticut are among the most intelligent, well-off, and longest living in the country. That’s a triple-threat that’s hard to top.</p>
			<p>Whether you’re a foodie looking forward to Connecticut’s incredible seafood scene, a history buff looking to dive into the state’s rich history, or a nature lover looking to get lost in the natural beauty of the state, there’s a number of great reasons to become a proud New Englander and settle in Connecticut.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Self-storage construction in Connecticut has been on the roll for the last several years thanks to a wave of development and investment in the product that is taking place nationwide. What's behind the boom in storage? After the last recession, development of new storage facilities ground to a halt. That caused the existing inventory of storage across the country to reach record high levels of occupancy and empowering operators to raise rates. As the economy recovered, developers have once again set out to develop self-storage—attracted to the high occupancies and returns enjoyed by operators in the business. As part of the trend, Connecticut has seen a resurgence in self-storage development, particularly in towns and cities where people are moving to in the largest numbers.</p>
			`,
			facts: [
				{
					fact: 'Connecticut is home to about 328 self-storage facilities.',
					highlight: '328',
				},
				{
					fact: 'Connecticut self-storage facilities cover 11,751,914 square feet of storage space.',
					highlight: '11,751,914',
				},
				{
					fact: 'Connecticut storage facilities offer 3.34 square feet of storage per person, which is lower than the national rate of 5.4 square feet per person.',
					highlight: '3.34',
				},
				{
					fact: 'Average price of a self-storage unit in Connecticut:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'New Haven',
				price: '0',
			},
			{
				city: 'Bridgeport',
				price: '0',
			},
			{
				city: 'Hartford',
				price: '0',
			},
			{
				city: 'Stamford',
				price: '0',
			},
			{
				city: 'Milford',
				price: '0',
			},
			{
				city: 'Norwalk',
				price: '0',
			},
			{
				city: 'Waterbury',
				price: '0',
			},
			{
				city: 'Stratford',
				price: '0',
			},
			{
				city: 'New London',
				price: '0',
			},
			{
				city: 'Trumbull',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: `
				<p>If you're thinking about making the move to Connecticut but still need a little more convincing, below are some of the most appealing and alluring facts about this great state. Whether you’re relocating to Connecticut for work or choosing to settle here to raise a family, you’re sure to find plenty to make the move worthwhile.</p>
			`,
			reasons: [
				'Incredible history. Originally inhabited by Native Americans and first settled by the Dutch in the 1620s, Connecticut would go on to be one of the nation’s original 13 colonies. Connecticut played a significant role in the Revolutionary War, and in 1788, it became the fifth state to join the United States. With so much history and a wealth of museums that chronicle it, history buffs will feel right at home in Connecticut.',
				'Mouth-watering food. As a part of New England, Connecticut is home to some incredible seafood. Whether you fancy crabs, lobsters, mussels, or clams, you can get it all in Connecticut. And while New England is mostly known for its super seafood, the hamburger was born in Connecticut, too – and some of the best burgers in the country are still found there today.',
				'Close-knit communities. In Connecticut, tight-knit communities are the norm. There’s a great sense of camaraderie among residents, and your new neighbors will become close friends quite quickly. Connecticut is known for being a laid-back, family-friendly state that welcomes new residents with open arms. You’ll fit in like a native New Englander in no time!',
				'Quality higher education. There are over 40 colleges and universities in Connecticut, and just shy of 130,000 students are currently enrolled in Connecticut as they pursue their degrees. Whether you want to pursue that master’s degree or you’re looking for a place to live with plenty of educational opportunities for your kids, Connecticut has a school for everyone. World-famous Yale University is the most well-known Connecticut college, with the University of Connecticut being a popular choice as well.',
				'Championship sports teams. OK, fine – the New England Patriots don’t actually play in Connecticut. But Connecticut residents proudly cheer the Pats on every Sunday. After all, they’re the New England Patriots, and they’ve won six Super Bowls – that’s one Super Bowl for each of the six states that comprise New England!',
				'Proximity to the Big Apple. While Connecticut has plenty of great cities of its own, one of the luxuries that Connecticut residents enjoy is the state’s proximity to New York City. Connecticut residents get to enjoy the best of both worlds: the beautiful, rural landscapes of their beloved state, with one of the world’s most famous and happening cities just a short drive or train ride away. In fact, many Connecticut residents move from New York, but still work in the Big Apple and commute there each day.',
				'Thrill-seeker central. Connecticut is home to Lake Compounce, the longest continuously operated amusement park in the United States. It opened in 1846 and it’s known for its award-winning wooden roller coasters. Of course, Lake Compounce isn’t the only theme park in Connecticut. The state is home to countless amusement parks and attractions for thrill-seekers.',
				'Land of lakes. Connecticut is jam-packed with countless serene lakes and breathtaking waterfalls. Whether you’re a nature lover or just someone who appreciates a picturesque scene that looks fit for a postcard, Connecticut provides plenty of breathtaking views to sit back and enjoy.',
				'Wonderful weather. Connecticut’s climate offers the best of both worlds. January is the state’s coldest month, with average high temperatures in the low-30s. That means winters are chilly enough for significant snowfall and all of the fun activities that come with it (the state is home to a number of great ski resorts), while summers are warm enough to frolic on the beach and enjoy the balmy temperatures. July is the state’s warmest month, with average highs in the mid-80s.',
				'Bountiful beaches. Speaking of beaches…because Connecticut is home to a number of coastal towns, there’s no shortage of gorgeous and relaxing beaches in the state. If you enjoy having your toes in the sand and a cool ocean breeze on your skin as you bask in the sun, you’ll surely find a spot to settle into in Connecticut.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>According to the United States Census Bureau, Connecticut is the 29th most-populated state in the country, with 3,572,665 estimated residents as of 2019. However, because the state is only 110 miles from east to west and 70 miles from north to south, Connecticut ranks 4th in national population density.</p>
				<p>Although Connecticut is home for many thriving industries and appealing attractions, from 2010 to 2018, it was one of only three states in the country to see a net population loss. According to a National Movers Survey, the leading reasons that residents have left Connecticut are job related (accounting for 34 percent of moves out of Connecticut) and retirement-related (accounting for 30 percent of moves).</p>
				<p>The fact that the population in Connecticut is trending downward means there’s more room and more opportunity for you!</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Connecticut has a state GDP (gross domestic product) of $268.47 billion, which represents 1.34% of the country’s GDP and ranks Connecticut as the 23rd largest state economy in the nation.</p>
				<p>Below, you'll find a breakdown of Connecticut’s largest sectors of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, and real estate',
					value: '27.3% of Connecticut’s GDP',
				},
				{
					sector: 'Transportation, trade, and utilities',
					value: '15% of Connecticut’s GDP',
				},
				{
					sector: 'Professional and business services',
					value: '12.4% of Connecticut’s GDP',
				},
				{
					sector: 'Manufacturing',
					value: '11% of Connecticut’s GDP',
				},
				{
					sector: 'Healthcare and education',
					value: '10.4% of Connecticut’s GDP',
				},
			],
		},
		largestEmployers: {
			// static content
			copy: `
				<p>Connecticut is home to 14 employers on the Fortune 500 list. Its largest 5 employers are listed below, with each institution employing over 5,000 individuals.</p>
			`,
			employers: [
				{
					employer: 'Yale-New Haven Hospital',
				},
				{
					employer: 'Yale University',
				},
				{
					employer: 'Sikorsky Aircraft Corporation',
				},
				{
					employer: 'Pratt & Whitney',
				},
				{
					employer: 'General Dynamics Electric Boat',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>While Connecticut is only 5,543 square miles, it has a number of sizable cities for those looking for a city lifestyle. Here is a quick look at the state's three largest cities:</p>
			`,
			cities: [
				{
					city: 'Bridgeport',
					copy: '<p>Bridgeport is home to 144,229 Connecticut residents, according to Census data, and it’s one of the most visited cities in the state. This seaport city is known for its welcoming aura and family-friendly atmosphere.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '4 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$189,250',
						},
						{
							item: 'Average rent',
							value: '$1,095/month',
						},
						{
							item: 'Average apartment size',
							value: '707 square feet',
						},
					],
				},
				{
					city: 'New Haven',
					copy: '<p>New Haven is Connecticut’s second-largest city, with an estimated population of 129,779. Known as the “Cultural Capital of Connecticut” due to its wealth of museums, theaters, and music venues, New Haven is an attractive option for singles and families alike. That culture comes at a price, though, as New Haven is one of the more expensive areas of the state to live in.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '23 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$189,900',
						},
						{
							item: 'Average rent',
							value: '$1,733/month',
						},
						{
							item: 'Average apartment size',
							value: '773 square feet',
						},
					],
				},
				{
					city: 'Hartford',
					copy: '<p>The capital city of Connecticut, Hartford had a population of 124,775 as of the latest United States Census. It’s also one of the state’s oldest and most historic cities, with a number of historical landmarks and claims to fame, including being the home of Mark Twain, who once called the city one of the most beautiful towns he ever had the fortune to see.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '17 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$149,900',
						},
						{
							item: 'Average rent',
							value: '$1,209/month',
						},
						{
							item: 'Average apartment size',
							value: '798 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents of Connecticut have 30 days to transfer their out-of-state license to Connecticut. Any driver applying for a Connecticut license must have a license from another state that was valid within the past 2 years. Applicants must also pass a vision test before their new Connecticut license will be issued. There is an application fee of $40 and a license fee of $72.',
				link: 'https://portal.ct.gov/DMV/Licenses/Licenses/Applying-for-a-License/Drivers-License--New-Resident-Requirements',
			},
			{
				title: 'Vehicle registration',
				copy: 'You must register your out-of-state vehicle within 60 days of moving to Connecticut. You’ll first need an emissions test (or a VIN check, if your vehicle was manufactured after 2015) before you can register.  Then, make sure to have your identification, proof of insurance, completed registration form (H-13B), and proof of ownership in addition to your emission inspection report or VIN report. There is an $80 registration fee, a $7 plate fee, a $10 administrative fee, a $10 “Clean Air Act” fee, and a $10 “Passport to the Parks” fee with each registration of a passenger vehicle.',
				link: 'https://portal.ct.gov/DMV/Registration/Requirements-to-Transfer-Your-Out-of-State-Registered-Vehicle',
			},
			{
				title: 'Voter Registration',
				copy: 'Voter registration deadlines vary in Connecticut based on the particular election you intend to vote in, but the state now offers Election Day Registration, which allows voters to register on-the-spot when they go to vote in-person.',
				link: 'https://portal.ct.gov/SOTS/Election-Services/Voter-Information/Voter-Registration-Information',
			},
		],
		sources: [
			// static content
			'https://portal.ct.gov/',
			'https://www.ctvisit.com/',
			'https://hdr.undp.org/en/content/human-development-index-hdi',
			'https://www.movoto.com/guide/ct/moving-to-connecticut/',
			'https://www.usnews.com/news/best-states/connecticut',
			'https://www.collegesimply.com/colleges/connecticut/',
			'https://www.census.gov/library/visualizations/2018/comm/population-change-2010-2018.html',
			'https://yankeeinstitute.org/2019/01/03/connecticut-ranks-3rd-in-country-for-people-moving-out/',
			'https://www.bea.gov/system/files/2019-11/qgdpstate1119.pdf',
			'https://portal.ct.gov/ChooseCT/Why-CT/Key-Employers-in-Connecticut',
			'https://www1.ctdol.state.ct.us/lmi/EmpSearchTopList.asp',
			'https://www.bestplaces.net/cost_of_living/state/connecticut',
			'https://www.courant.com/business/hc-biz-connecticut-economy-20190725-yd7x6vtribfknc5ecaobrjuouu-story.html',
			'https://portal.ct.gov/-/media/OPM/Budget/2020_2021_Biennial_Budget/Economic-Report-of-the-Governor-FY-2020---FY-2021.pdf?la=en',
			'https://state.1keydata.com/states-by-size.php',
			'https://www.payscale.com/cost-of-living-calculator/state/Connecticut?',
			'https://www.rentcafe.com/average-rent-market-trends/us/ct',
			'https://www.zillow.com/hartford-ct/home-values/',
			'https://www.zillow.com/bridgeport-ct/home-values/',
			'https://www.zillow.com/new-haven-ct/home-values/',
		],
	},
	DC: {
		state: 'District of Columbia',
		stateNickname: 'The District',
		isDC: true,
	},
	DE: {
		state: 'Delaware',
		stateNickname: 'First State',
		welcome: `
			<p>Small but mighty Delaware is nestled in the heart of the East Coast and makes up part of the Mid-Atlantic Region. It's biggest city, Wilmington, is located just over 30 miles from Philadelphia. Delaware is known as the First State, because it was the first former colony to ratify a constitution. The state is also known for its friendly business environment, sandy Atlantic beaches, having its own slice of Amish Country, and world class entertainment.</p>
			<p>Delaware's incorporation laws makes it an easy place to do business, that's why more than two-thirds of Fortune 500 companies are Delaware corporations–even if their headquarters are located elsewhere. Many Delawareans also work elsewhere, many of whom commute one to three hours to jobs in Pennsylvania, Maryland, Virginia, Washington D.C., and even as far as New York City. That's because Delaware's low cost of living, idyllic surroundings, and close to proximity to hot East Coast job markets makes it an ideal place for many folks to move and start a new life.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Delaware has seen a boomlet in self-storage development, thanks to a national trend of record-high levels of self-storage construction that has been taking place over the last several years. While parts of Delaware have grown by leaps and bounds, self-storage developers weren't keeping up with demand in the wake of the last recession. Now they are playing catch up, building new facilities and converting vacant retail stores wherever they can reach a growing population segment. Delaware's location on the I-95 corridor, tourist attractions, and growing population make it a promising market for self-storage operators to pursue.</p>
				<p>Here's some fast facts about the state of the Delaware's self-storage industry:</p>
			`,
			facts: [
				{
					fact: 'Delaware is home to about 110 self-storage facilities.',
					highlight: '110',
				},
				{
					fact: 'Delaware self-storage facilities cover 934,695 square feet of storage space.',
					highlight: '934,695',
				},
				{
					fact: 'Delaware storage facilities offer 4.52 square feet of storage per person, which is less than the national average of 5.4 square feet per person.',
					highlight: '4.52',
				},
				{
					fact: 'Average price of a self-storage unit in Delaware:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Wilmington',
				price: '0',
			},
			{
				city: 'Dover',
				price: '0',
			},
			{
				city: 'Rehoboth Beach',
				price: '0',
			},
			{
				city: 'Newark',
				price: '0',
			},
			{
				city: 'Lewes',
				price: '0',
			},
			{
				city: 'New Castle',
				price: '0',
			},
			{
				city: 'Milford',
				price: '0',
			},
			{
				city: 'Seaford',
				price: '0',
			},
			{
				city: 'Smyrna',
				price: '0',
			},
			{
				city: 'Camden',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: `
				<p>If you're thinking about making the move to Connecticut but still need a little more convincing, below are some of the most appealing and alluring facts about this great state. Whether you’re relocating to Connecticut for work or choosing to settle here to raise a family, you’re sure to find plenty to make the move worthwhile.</p>
			`,
			reasons: [
				'Right by the beach! Delaware might not be the first place that comes to mind when you think of awesome beaches, but sure enough they are there. While the beaches get swamped by tourists in the summer--especially popular Rehoboth Beach, locals can enjoy close proximity to the shore all year long.',
				"No sales tax. Delaware levies no sales tax on purchases, which makes Delaware a shopping destination for folks from other states. It also means all of the country's best retailers are located here to take advantage of the popularity.",
				"Amish country. You though the Amish were just in Pennsylvania and Ohio? Think again. The Dover area is home to around 1,000 Amish. You'll see horse drawn buggies everywhere and you'll enjoy eating their delicious traditional foods.",
				'Affordable housing. One reason new home buyers are flocking to Delaware is that they can afford to buy a house here. With a median home value of $236,300, the American dream is well within reach.',
				'Welcome to Delmarva country. Most of the state is located in the Delmarva Peninsula, so named after the three states that occupy it: Delaware, Maryland and Virginia. The Peninsula is formed by the Chesapeake Bay, Delaware River, Delaware Bay and the Atlantic Ocean. The area has its own distinct culture and way of life that you have to experience to believe.',
				'Woo sports! Delaware may not have any major league sports franchises, but locals nuts for the minor league basketball, baseball, soccer and rugby teams. With Philadelphia arenas a short drive away and Dover bringing NASCAR and other races throughout the year, Delaware is actually a sports-lovers dream.',
				"It's steeped in history. Delaware was one of the first colonies and still features plenty of architectural sites and museums. From the Roosevelt Inlet Shipwreck to the expansive French gardens of the Versailles-inspired Nemours Estate to historic Fort Delaware, the state might be small but its big on roadside attractions.",
				"Let the music come to you. Delaware doesn't always attract the biggest headlining acts as they book dates in the state's more populous neighbors. But every June the Firefly Music Festival brings some of the world's biggest performers to Dover for three days of music--and its not to be missed!",
				'Wilmington is a real gem. Although it is one of the smallest cities to be the most populous city in a state, there is still lots to see and explore in this historic city like the Clifford Brown Jazz Festival, the Delaware Art Museum, the Wilmington Riverwalk, and The Queen music venue.',
				"Come for the home prices, stay for the popcorn. Fenwick Island, DE-based Fisher's Popcorn is known around the world for creating some of the most addicting caramel corn in existence. One taste of the boardwalk confection and you'll never get enough.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Covering just 1,982 square miles, Delaware is the second smallest state in the country and is home to under a million people. While it may come in near the bottom of area and population rankings, the state is the sixth most densely populated state in the country with around 500 people per square mile. Delaware is full of small towns to discover, each with their own character and flair.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Delaware has a stable economy and home to several thriving sectors. The state has an estimated total GDP of more than $72 billion, and it is one of the country's fastest growing states by GDP. The median income for Delaware residents is $62,852 a year. The state also has a low unemployment rate of just 3.5 percent.</p>
				<p>Here is a breakdown of Delaware's biggest economic sectors by percent share of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance and insurance',
					value: '16.8 percent',
				},
				{
					sector: 'Real estate and rental and leasing',
					value: '8.2 percent',
				},
				{
					sector: 'Government and government enterprises',
					value: '5.5 percent',
				},
				{
					sector: 'Healthcare and social assistance',
					value: '4.3 percent',
				},
				{
					sector: 'Manufacturing',
					value: '3.7 percent',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'DuPont (Wilmington)',
					employees: '46,000',
				},
				{
					employer: 'Integrity Staffing Solutions (Newark)',
					employees: '26,000',
				},
				{
					employer: 'W. L. Gore & Associates (Newark)',
					employees: '9,500',
				},
				{
					employer: 'Swissport Holding Inc (Wilmington)',
					employees: ' 9,140',
				},
				{
					employer: 'University of Delaware (Newark)',
					employees: '9,010',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>While Delaware is only 1,954 square miles, there are quite a few places to leave. Everything is just really close to each other! Much of the state is actually rural, with small towns scattered about. It's less than an hour drive between populous Wilmington to the north to the state capital of Dover to the south. The state is divided into North and South, with much of NorDel considered an extension of the Philadelphia suburbs, while SoDel is known for its country living and beach town tourism.</p>
				<p>Here a few of the top spots in Delaware to move to:</p>
			`,
			cities: [
				{
					city: 'Wilmington',
					copy: "<p>Founded on the same site as the New World's first Swedish settlement, Wilmington is now the biggest city in the state. The city is known as the Corporate Capital because of the number of corporations that legally incorporated in the city. Its low cost of living compared to other East Coast cities make it a place to live for some people who don't mind commuting an hour or more a day for higher paying jobs.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '7.7 percent higher than national average',
						},
						{
							item: 'Median home price',
							value: '$189,000',
						},
						{
							item: 'Average rent',
							value: '$1,168/month',
						},
						{
							item: 'Average apartment size',
							value: '864 square feet',
						},
					],
				},
				{
					city: 'Dover',
					copy: "<p>Dover is the state capital, with a population of 37,538 residents. It's location in the middle of the state and the low cost of living has led to increased population growth over the last few years.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '2 percent higher than national average',
						},
						{
							item: 'Median home price',
							value: '$207,000',
						},
						{
							item: 'Average rent',
							value: '$1,022/month',
						},
					],
				},
				{
					city: 'Newark',
					copy: "<p>Newark, DE is just 12 miles west of Wilmington and is the state's third largest city, with a population of 33,673 residents. Newark is home to the University of Delaware, which makes this college town an excellent place to live and work.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '10 percent higher than national average',
						},
						{
							item: 'Median home price',
							value: '$233,700',
						},
						{
							item: 'Average rent',
							value: '$1,234/month',
						},
						{
							item: 'Average apartment size',
							value: '896 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "You must get a Delaware driver's license within 60 days of becoming a resident of the state.",
			},
			{
				title: 'Vehicle registration',
				copy: 'You also must register your vehicle in state within 60 days. To do this you must be able to show proof of insurance and completion of a state inspection.',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Delaware, you must be a citizen of the United States aged 18 years or older. Qualified members of the public have until before the fourth Saturday before any Primary or General Election in which to register. The deadline to vote in the 2020 General Election is October 10, 2020. Uniformed service members and other residents living overseas have a little more time to register, until October 19, 2020.',
			},
		],
		sources: [
			// static content
			'https://elections.delaware.gov/calendar/2020ElectionCalendar.pdf',
			'https://www.yourmechanic.com/article/how-to-register-a-car-in-delaware',
			'https://www.zillow.com/dover-de/home-values/',
			'https://www.salaryexpert.com/cost-of-living/united-states/delaware/newark',
			'https://www.payscale.com/research/US/Location=Wilmington-DE/Salary',
			'https://apps.bea.gov/iTable/iTable.cfm?reqid=70&step=1&isuri=1&acrdn=2#reqid=70&step=1&isuri=1&acrdn=2',
			'https://delawarebusinessnow.com/2018/03/delaware-leads-nation-in-gross-domestic-product-growth/',
			'https://www.zippia.com/advice/largest-companies-in-delaware/',
			'https://datausa.io/profile/geo/delaware#economy',
			'https://www.usnews.com/news/best-states/delaware',
			'https://www.delawareonline.com/story/news/2016/03/11/90-minutes-work-mega-commuting-takes-hold-delaware/80821770/',
			'https://amishamerica.com/delaware-amish/',
			'https://en.wikipedia.org/wiki/List_of_Delaware_companies',
			'https://en.wikipedia.org/wiki/Delaware#Colonial_Delaware',
			'https://www.theodysseyonline.com/delaware-state-divided',
		],
	},
	FL: {
		state: 'Florida',
		stateNickname: 'Sunshine State',
		welcome: `
			<p>Known for its beaches, theme parks, and plant and animal wildlife, Florida is one of the most popular tourist destinations in the country. With a population of more than 21 million people, Florida is the third most populous state in the country.</p>
			<p>The Sunshine State's major industries are tourism, manufacturing, agriculture, information technology, and aerospace. Florida is mostly a flat plane and doesn't reach more than 100 feet above sea level. The state has about 1,300 miles of coastline and near-perfect weather year-round. With top attractions like Busch Gardens, LEGOLAND, Disneyland, and Sea World, Florida attracts millions of visitors each year. And as of late, more and more people are flocking to the state for several reasons—one is warmer weather.</p>
			<p>If you're considering moving to Florida, below you will find a few things to consider before making the move.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Over the last few years Florida has seen a surge in new self-storage construction as developers rushed to meet the storage demands of a growing population. A temporary pause in activity took place after the Great Recession, creating pent up demand for self-storage space. That has led to the current building boom in storage. The trend has taken place nationwide, but Florida is among the states that has experienced the biggest uptick in new self-storage projects.</p>
				<p>Below are some statistics that provide an overview of the self-storage industry in Florida:</p>
			`,
			facts: [
				{
					fact: 'Florida is home to an estimated 2,602 self-storage facilities.',
					highlight: '2,602',
				},
				{
					fact: 'Florida self-storage facilities cover 124,569,554 square feet of storage space.',
					highlight: '124,569,554',
				},
				{
					fact: 'Florida storage facilities offer 6.29 square feet of storage per person, which is higher than the national average of 5.4 square feet per person.',
					highlight: '6.29',
				},
				{
					fact: 'Average price of a self-storage unit in Florida:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Jacksonville',
				price: '0',
			},
			{
				city: 'Miami',
				price: '0',
			},
			{
				city: 'Tampa Springs',
				price: '0',
			},
			{
				city: 'Orlando Collins',
				price: '0',
			},
			{
				city: 'St. Petersburg',
				price: '0',
			},
			{
				city: 'Hialeah',
				price: '0',
			},
			{
				city: 'Port St. Lucie Junction',
				price: '0',
			},
			{
				city: 'Tallahassee ',
				price: '0',
			},
			{
				city: 'Cape Coral',
				price: '0',
			},
			{
				city: 'Fort Lauderdale',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>As one of the top travel destinations in the world, Florida receives more than 90 million visitors each year. But here are a few reasons you should consider staying for good.</p>',
			reasons: [
				'Walt Disney World. Florida is probably best known for one of its greatest attractions -- Walt Disney World, the happiest place on earth. Walt Disney World gets more than 45,000 visitors a day - and up to 100,000 on its busiest days.',
				"Outdoor events and festivals. Because Florida has such great weather all the time, there are always outdoor events and festivals happening. From arts and craft shows and music concerts to car shows and polo matches, there's a little something for everyone. They've also got farmers' markets, sand-sculpting contests, chalk festivals, and more.",
				"Seemingly endless beaches. In Florida, you're never too far from the ocean no matter where you are. With 1,300 miles of coastline, you can hit the beach almost any time you want to. Because who doesn't love the beach?",
				"The golf courses. If you're a golf enthusiast and you just can't get enough green, you'll love Florida because it has more golf courses than any other state in the country and it's also home to the World Golf Hall of Fame and Museum in St. Augustine. Not to mention the dozens of golf tournaments going on all the time.",
				'Gators and crocs. Florida is the only place you can go and see both crocodiles and alligators living together in the Florida Everglades.',
				"The Daytona 500 International Speedway. If you're a fan of car racing, you'll love Florida because The Daytona 500, also known as The Great American Race, is located in Daytona Beach. Move there and you'll have the chance to see the action up close and personal.",
				"No state income tax. One great thing about living in Florida is that there's no state income tax, meaning you get to keep more of your money in your pocket. Instead of collecting income tax, the state gets revenue from the millions of tourists that visit the state each year.",
				"Great weather all year round. If you're running from your last cold winter and never looking back, you'll appreciate Florida for its warm temperatures. The average high is 79.5 degrees and the average low for the state is 55.7 degrees. The average temperature is about 67.6 degrees year-round.",
				"Sports. If you're a sports fan, you'll do well in Florida because it's home to several sports teams, including basketball, football, baseball, and hockey teams. The following teams call Florida home: Miami Heat, Jacksonville Jaguars, Tampa Bay Buccaneers, Florida Panthers, Tampa Rays, Orlando Magic, and the Miami Dolphins.",
				"Endless entertainment options. Florida has plenty to offer even the pickiest of travelers. From amusement parks, nature trails, and state parks to theme parks, beaches and bars, you'll never run out of things to do. Not to mention the nearly perfect year-round weather makes it easy to enjoy outdoor activities like kayaking, surfing, jet skiing, boating, biking, and paddle boarding.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Florida is the third-largest state in the country with more than 21.6 million people. Its major cities include Tallahassee, Jacksonville, Orlando, Tampa, Fort Lauderdale, St. Petersburg, Miami, and Hialeah. Florida has more than 1,300 miles of coastline that includes mangrove swamps, seagrass beds, estuaries, and coral reefs. It's also got plenty of freshwater lakes, streams, rivers, and springs that house a range of aquatic life.</p>
				<p>These and the previously mentioned reasons are probably why more than 300,000 people are moving to Florida every year. The state is expected to reach more than 22 million residents by 2022. On April 1, 2018, Florida had a population of 20.84 million and on April 1, 2019, that number had increased to 21.2 million people. In most cases, people were moving to Florida for lower taxes and better weather.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>If Florida were a country, it would have the 17th largest GDP in the world with an economic output of more than $1 trillion in 2018, according to Biz Journals. After the most recent recession, Florida's job market recovered and the state expects to see continued salary growth and increased retail spending. Florida's economy is also expected to outperform the national forecast for four straight years, according to economist Sean Snaith in the latest Florida & Metro Forecast from the UCF Institute for Economic Competitiveness.</p>
				<p>The economic outlook for Florida is positive for the next few years. Florida is expected to see tremendous growth and a boost in the state's revenue. The state saw a 2.5 percent growth -- or 221,200 jobs since August 2018.  Florida has a cost of living index of 110.9, which is higher than the national average. However, with no state income tax, you'll keep more of your hard-earned money. Florida has a recent unemployment rate of 3.2 percent as of September 2019, which is somewhat lower than the national average of 3.5 percent (as of September 2019)</p>
				<p>Below you'll find a breakdown of Florida's largest sectors by real value added of GDP in billions:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$195.25 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$124.2 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$97.3 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$90.24 billion',
				},
				{
					sector: 'Retail trade',
					value: '$72.58 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Walt Disney World Resort',
					employees: '74,200',
				},
				{
					employer: 'AdventHealth',
					employees: '28,959',
				},
				{
					employer: 'Universal Orlando Resort',
					employees: '25,000',
				},
				{
					employer: 'Orange County Public Schools',
					employees: '24,629',
				},
				{
					employer: 'University of Central Florida',
					employees: '9,476',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Florida is 65,755 square miles with 663 miles of beaches. It is home to an amazing array of wildlife including black bears, sea turtles, dolphins, armadillos, snakes, and the Florida panther. It's also home to famous attractions like The Kennedy Space Center, the Everglades National Park, the Daytona 500 International Speedway, and Duval Street in Key West. If you're looking to head to Florida, check out a run down of the major cities below.</p>
			`,
			cities: [
				{
					city: 'Jacksonville',
					copy: '<p>Jacksonville is the largest city in Florida and in the continental US. The city offers plenty to do including two national parks, 400 city parks, several beaches & waterways, animal attractions, museums, gardens, and arboretums. Some of the most popular activities include swimming, kayaking, sunbathing, surfing, fishing, and boating.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '5 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$179,300',
						},
						{
							item: 'Average rent',
							value: '$1,095 per month',
						},
						{
							item: 'Average apartment size',
							value: '969 square feet',
						},
					],
				},
				{
					city: 'Miami',
					copy: "<p>With a population of more than 490,000 people, Miami is the second-largest city in Florida and has plenty of beaches, parks, resorts, and museums. The city is not only a vital seaport city for trade both nationally and internationally, but it's also a tourism center.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '14 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$326,200',
						},
						{
							item: 'Average rent',
							value: '$2,017 per month',
						},
						{
							item: 'Average apartment size',
							value: '835 square feet',
						},
					],
				},
				{
					city: 'Tampa',
					copy: '<p>Tampa is the third-largest city in Florida with a population of more than 400,000 people. Some of the top companies in the area include food processing and packaging, medical and health technologies, aerospace and aviation, agriculture, tourism, financial firms, technology, and electronics manufacturing companies.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '5 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$200,100',
						},
						{
							item: 'Average rent',
							value: '$1,321 per month',
						},
						{
							item: 'Average apartment size',
							value: '924 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Florida have to obtain a valid Florida driver's license within 30 days of moving there. You must also get insurance from a Florida insurance agent that's licensed to sell insurance in Florida if you want to get the title and registration for your vehicle.",
				link: 'https://www.colorado.gov/pacific/dmv/new-colorado-0#New%20Resident%20with%20a%20Valid%20License%2016%20Years%20of%20Age%20or%20Older:',
			},
			{
				title: 'Vehicle registration',
				copy: "All new Florida residents have to obtain Florida insurance within 10 days of officially moving into the state. To register an out-of-state vehicle in Florida, you'll need to pay the $225 Initial Registration Fee (a fee paid when the owner doesn't have a license plate or record of a license plate registered in their name in the state of Florida. You must appear in person at a local service center and bring proof of identity, proof of Florida insurance, and a completed Application for Certificate of Title With/Without Registration (HSMV form 82040).",
				link: 'https://www.flhsmv.gov/motor-vehicles-tags-titles/license-plates-registration/motor-vehicle-registrations/',
			},
			{
				title: 'Voter Registration',
				copy: "In Florida, you can apply for voter registration at the same time you apply for your driver's license. The deadline to register to vote in Florida is [date] for the November 5, 2019 election. You can register to vote in Florida here:",
				link: 'https://dos.myflorida.com/elections/for-voters/voter-registration/register-to-vote-or-update-your-information/',
			},
		],
		sources: [
			// static content
			'https://www.payscale.com/cost-of-living-calculator/Florida-Miami',
			'https://www.zillow.com/miami-fl/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/fl/miami-beach/',
			'https://worldpopulationreview.com/states/florida-population/cities/',
			'https://smartasset.com/mortgage/15-things-to-know-before-moving-to-florida',
			'https://www.coolkidfacts.com/florida-facts/',
			'https://www.usclimatedata.com/climate/florida/united-states/3179',
			'https://business.ucf.edu/florida-metro-forecast-robust-state-economy-remain-ahead-u-s-outlook/',
			'https://www.bizjournals.com/jacksonville/news/2018/07/16/florida-gdp-hits-1-trillion-mark-for-2018-largely.html',
			'https://www.landscope.org/florida/natural_geography/',
			'https://www.democratandchronicle.com/story/news/politics/albany/2019/04/29/new-yorkers-fleeing-florida-more-than-any-other-state/3616563002/',
			'https://www.bls.gov/cps/cps_htgm.htm',
			'https://www.bizjournals.com/orlando/subscriber-only/2018/07/06/largest-employers.html',
			'https://www.payscale.com/cost-of-living-calculator/Florida-Tampa',
			'https://www.zillow.com/tampa-fl/home-values/',
			'https://www.payscale.com/cost-of-living-calculator/Florida-Jacksonville',
			'https://www.zillow.com/jacksonville-fl/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/fl/jacksonville/',
			'https://www.visitjacksonville.com/things-to-do/outdoors/',
			'https://www.flhsmv.gov/new-resident/',
			'https://worldpopulationreview.com/states/florida-population/',
			'https://www.statista.com/statistics/304903/florida-real-gdp-by-industry/',
			'https://www.planetware.com/tourist-attractions/florida-usfl.htm',
			'https://kids.nationalgeographic.com/explore/states/florida/',
			'https://www.stateofflorida.com/facts.aspx',
			'https://www.orlandosentinel.com/business/os-bz-florida-gdp-1-trillion-20180713-story.html',
			'https://www.bestplaces.net/cost_of_living/state/florida',
			'https://www.floridajobs.org/workforce-statistics/workforce-statistics-data-releases/latest-statistics',
			'https://www.stateofflorida.com/moving-to-florida.aspx',
		],
	},
	GA: {
		state: 'Georgia',
		stateNickname: 'Peach State',
		welcome: `
			<p>Georgia is the 8th largest state in the US, with a population of 10.6 million people. Nestled in the southeastern region of the country, Georgia is bordered by North Carolina, Tennessee, Alabama, South Carolina, and Florida. While Northern Georgia is mountainous, the central region is filled with rolling hills and the southern region is essentially a flat coastal plain. The Blue Ridge Mountains call Northern Georgia home and the two largest rivers of central Georgia, the Oconee and the Ocmulgee flow together to form the Altamaha.</p>
			<p>Georgia is home to about 18 Fortune 500 Companies, including Coca Cola, Delta Air Lines, Home Depot, UPS, and Aflac, among others. Some of the state's major industries include agriculture (cotton, cattle, calves, chicken eggs, and peanuts), manufacturing, mining, fishing, and services. Georgia manufactures processed foods and drinks and textiles like carpeting, yarn, and synthetic fabrics, and tire cord.</p>
			<p>There's plenty to do if you decide to make the move to the Peach State, including attractions like the World of Coca-Cola, Rock City Gardens, the Georgia Aquarium, Centennial Olympic Park, and LEGOLAND Discovery Center. Atlanta is the cultural hub of Georgia and offers plenty in terms of entertainment, events, food, and fun. Georgia's also got more than 50 state parks and tons of beaches so if you're considering a permanent move to the Peach State, you won't be disappointed.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>As Georgia grows, so does the need for new self-storage facilities. Over the last few years developers have rushed to the market to develop new storage properties. A lack of construction following the last recession led to a shortage of storage space that was not sufficient to meet the demands of a growing population. That has created tremendous opportunity for self-storage developers to build more rentable storage space in Georgia, which is an essential product for people moving or in the midst of other life transitions.</p>
				<p>Below are some statistics that provide an overview of the self-storage industry in Georgia:</p>
			`,
			facts: [
				{
					fact: 'Georgia is home to an estimated 1,502 self-storage facilities.',
					highlight: '1,502',
				},
				{
					fact: 'Georgia self-storage facilities cover 58,391,886 square feet of storage space.',
					highlight: '58,391,886',
				},
				{
					fact: 'Georgia storage facilities offer 5.82 square feet of storage per person, which is close to the national average of 5.4 square feet per person.',
					highlight: '5.82',
				},
				{
					fact: 'Average price of a self-storage unit in Georgia:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Atlanta',
				price: '0',
			},
			{
				city: 'Augusta',
				price: '0',
			},
			{
				city: 'Columbus',
				price: '0',
			},
			{
				city: 'Athens',
				price: '0',
			},
			{
				city: 'Savannah',
				price: '0',
			},
			{
				city: 'Macon',
				price: '0',
			},
			{
				city: 'Marietta',
				price: '0',
			},
			{
				city: 'Alpharetta',
				price: '0',
			},
			{
				city: 'Valdosta',
				price: '0',
			},
			{
				city: 'Lawrenceville',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Georgia has a lot to offer both visitors and residents alike, so if you're considering Georgia for your new home state, these reasons might just sway you to put down some roots in the Peach State.</p>",
			reasons: [
				"Good vibes only. If you're considering moving to the great state of Georgia, you'll love the southern hospitality sprinkled with a little southern charm. Savannah was listed as one of the 10 friendliest cities in the country by Conde Nast.",
				"Warm weather. Not a fan of winter weather? You'll love the Peach State because it's warm pretty much all year round. Even in January, temperatures only get as low as 52 degrees. The average temperature is around 62 degrees.",
				"Atlanta. Need we say more? Atlanta is a booming city filled with opportunities for both work and play. If you're looking for a big-city atmosphere, then ATL might just work for you.",
				"Fresh produce. Georgia has a large amount of farmland and natural beauty so it's no wonder the state produces a lot of...well, produce. If you love shopping for fresh fruits and veggies at your local farmer's market, you'll love their peaches and boiled peanuts come summertime.",
				"Great educational institutions. Georgia is home to some of the best educational institutions in the country. It has some of the best high schools in the country, which includes schools in Gwinnett County, Johns Creek, and Alpharetta. But it's also got top-notch higher education institutions so if you ever want to go back to school, you've got some great options.",
				"Affordable housing. While housing might be similar to New York and LA in Atlanta, there are plenty of Georgia cities that offer affordable housing, whether you're renting or buying. Not to mention, Athens, Columbus, and Augusta are amazing cities offering pretty high salaries.",
				"Easy access to traveling opportunities. Atlanta is home to one of the busiest international airports, which means if you live in Georgia you'll have access to the best flights that leave right from your home state.",
				"Sports fanatics' dream. Georgia is home to several sports teams, including the Hawks, the Falcons, the Gladiators, and the Bulldogs. The state is also known as one of the birthplaces of NASCAR and there are more than 20 racetracks throughout the state.",
				"The cuisine. Moving to Georgia means you'll have access to some of the most delectable cuisine known to man - southern food. From their barbecue and cornbread to their fried chicken and peach cobbler, you'll be sure to get your fill of delicious southern food. Let's not forget about their signature sweet tea that goes with pretty much any savory meal.",
				"An abundance of natural beauty. Georgia's got an amazingly large amount of natural beauty, from its plentiful trees and sprawling greenery to its natural lakes and mountains. Any nature lover would feel right at home exploring the sweeping landscapes of Georgia.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Georgia has a population of 10.6 million people and ranks as the 8th largest state in terms of population. From 2018 to 2019, Georgia's population increased by 1.03 percent. Overall, more people are moving to Georgia than from it. Those that are moving into the state came for a variety of reasons, including lifestyle, health, new job, retirement, family, and lifestyle. Some of the reasons people left are some of the same reasons.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Georgia's state GDP is $510 billion, which is almost as much as Belgium's at $524 billion. The unemployment rate is 3.6 in Georgia as of August 2019, according to the Bureau of Labor Statistics. Overall, Georgia's economy is moving in the right direction in the coming years.</p>
				<p>Below is a breakdown of Georgia's largest sectors by real value added GDP</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$195.25 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$124.2 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$97.3 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$90.24 billion',
				},
				{
					sector: 'Retail trade',
					value: '$72.58 billion',
				},
			],
			bottomLine: `
				<p>Georgia is expected to move towards a slow recovery with a decrease in unemployment and an increase in annual GDP through 2020. Georgia has a cost of living score of 100.3, meaning it's somewhat more expensive than the US as a whole, although not by much. However, that doesn't mean Georgia can't offer affordable living. Cities like Duluth, Newnan, Gainesville, Warner Robins, and Smyrna are all affordable cities in Georgia.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'The Home Depot',
					employees: '406,000',
				},
				{
					employer: 'UPS',
					employees: '335,520',
				},
				{
					employer: 'Randstad USA',
					employees: '125,000',
				},
				{
					employer: 'The Coca-Cola Company',
					employees: '100,300',
				},
				{
					employer: 'Hansen Beverage',
					employees: '100,300',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>The state of Georgia is 59,425 square miles and within that area lies plenty of places to call your new home. Among the largest cities in Georgia are Atlanta, Augusta, and Columbus, which you learn more about below.</p>
			`,
			cities: [
				{
					city: 'Atlanta',
					copy: "<p>Atlanta is the largest city in Georgia with a population of 501,178 people. Known as ATL in some circles, the city is the 38th most populous city in the US. It's also the major commercial and cultural hub of Georgia. ATL has tons to offer both visitors and residents, including the Atlanta Botanical Garden, the Georgia Aquarium, Piedmont Park, LEGOLAND Discovery Center, and the World of Coca-Cola.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '1 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$261,100',
						},
						{
							item: 'Average rent',
							value: '$1,485 per month',
						},
						{
							item: 'Average apartment size',
							value: '978 square feet',
						},
					],
				},
				{
					city: 'Augusta',
					copy: '<p>Augusta is the second-largest city in Georgia and has roughly 197,000 residents living inside the city limits. The city is best known for hosting one of the four major PGA golf tournaments called The Masters. But Augusta has much more to offer than hitting a hole in one, including the Augusta Museum of History, the Phinizy Swamp Nature Park, and plenty of other parks, concerts, shows, events, spas, and restaurants.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '13 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$129,900',
						},
						{
							item: 'Average rent',
							value: '$846 per month',
						},
						{
							item: 'Average apartment size',
							value: '921 square feet',
						},
					],
				},
				{
					city: 'Columbus',
					copy: "<p>Nestled along the Chattahoochee River, Columbus is the third most populous city in Georgia and has a population of about 194,000 people. The city covers roughly 220 square miles and is a key tourist destination, with so many attractions like the Coca-Cola Space Science Center, the Columbus Aquatic Center, the Chattahoochee RiverWalk, the Columbus Botanical Garden, the Columbus Museum, and Sherlock's Murder Mystery Dinner Theatre.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '11 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$95,000',
						},
						{
							item: 'Average rent',
							value: '$947 per month',
						},
						{
							item: 'Average apartment size',
							value: '885 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Georgia must apply for a new license within 30 days of moving to the state. You'll need to visit the nearest Department of Driver Services (DDS) Customer Service Center. Bring with you your current license, proof of your social security number, two proofs of your Georgia residency (like a utility bill or bank statement), and proof of your identity (like a birth certificate or passport). For more info, visit:",
				link: 'https://georgia.gov/popular-topic/moving-georgia',
			},
			{
				title: 'Vehicle registration',
				copy: "To register and title your vehicle in Georgia for the first time, you'll need to visit a Department of Driver Services office to transfer your driver's license first. Once you get your temporary driver's license, you can go to the County Tax Commissioner's Office and register and title your vehicle. You'll have to fill out an application for a title and license plate, present proof of insurance, and pay for your registration and title, and pay a one-time Title Ad Valorem Tax via cash, check, or money order. For more info, visit:",
				link: 'https://georgia.gov/popular-topic/moving-georgia',
			},
			{
				title: 'Voter Registration',
				copy: 'To register to vote in the state of Georgia, you have to be a US citizen or a legal resident of the country, be 18 years or older at the time you vote, and you must be free of any convicted felonies. You can register to vote online at the link below or you can download a voter registration application, fill it out, sign it and mail it in. For more info, visit:',
				link: 'https://sos.ga.gov/index.php/elections/register_to_vote',
			},
		],
		sources: [
			// static content
			'https://vacationidea.com/georgia/largest-cities-in-georgia.html',
			'https://worldpopulationreview.com/states/georgia-population/cities/',
			'https://patch.com/georgia/atlanta/people-are-moving-georgia-heres-why',
			'https://www.usatoday.com/story/money/2019/04/17/how-gdp-of-us-states-compares-to-countries-around-the-world/39295197/',
			'https://www.homesnacks.net/30-things-need-know-georgia-move-128264/',
			'https://www.tripadvisor.com/Attractions-g28931-Activities-Georgia.html',
			'https://www.city-data.com/states/Georgia-Topography.html',
			'https://www.bls.gov/cps/cps_htgm.htm',
			'https://www.statista.com/statistics/304946/georgia-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-georgia/',
			'https://www.bestplaces.net/cost_of_living/state/georgia',
			'https://sos.ga.gov/index.php/elections/register_to_vote',
			'https://ftnnews.com/other-news/36138-5-reasons-to-move-to-georgia',
			'https://www.payscale.com/cost-of-living-calculator/Georgia-Atlanta',
			'https://www.zillow.com/atlanta-ga/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ga/atlanta/',
			'https://www.payscale.com/cost-of-living-calculator/Georgia-Augusta',
			'https://www.zillow.com/augusta-ga/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ga/augusta/',
			'https://www.payscale.com/cost-of-living-calculator/Georgia-Columbus',
			'https://www.zillow.com/columbus-ga/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/oh/columbus/',
			'https://fred.stlouisfed.org/series/OHNGSP',
			'https://www.whitmirecustomhomes.com/top-8-reasons-to-move-to-georgia',
			'https://www.tripadvisor.com/Attractions-g60898-Activities-Atlanta_Georgia.html',
			'https://www.tripadvisor.com/Attractions-g29212-Activities-Augusta_Georgia.html',
			'https://visitcolumbusga.com/visit/things-to-do/',
			'https://patch.com/georgia/atlanta/these-georgia-companies-make-2019-list',
			'https://www.onlyinyourstate.com/georgia/reasons-to-move-to-georgia/',
			'https://livability.com/ga/real-estate/9-reasons-to-move-to-georgia',
		],
	},
	HI: {
		state: 'Hawaii',
		stateNickname: 'Aloha State',
		welcome: `
			<p>Why do people spend a fortune to live on a pack of volcanoes in the middle of the sea? Because it’s paradise on earth.</p>
			<p>Hawaii residents are laid back and nice, the nature is unparalleled, and there are more jobs than you may expect. There are enough outdoor activities in Hawaii to last you a lifetime. Honolulu is a bustling, economic powerhouse that links the Western hemisphere to the East. It’s easy to get away from the hustle and bustle of the city by visiting any number of the hundreds of public beaches the state has to offer.</p>
			<p>People looking to slow their pace and constantly be surrounded by natural beauty will find the perfect home in Hawaii. Does that sound like you?</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
			Hawaii's self-storage industry is unique in that the number of suitable sites are fairly limited. This creates great demand for storage facilities created by new residents, in-state movers, and part-timers. Hawaii has one of the lowest ratios of square feet of storage space per capita in the nation–2.86 square feet per resident. Compare that to the national average of 5.4 square feet per capita and it's easy to see why storage prices in Hawaii tend to trend higher. A nationwide surge in self-storage development has led to some recently built storage facilities in Hawaii, which could potentially have a cooling effect on prices in this greatly undersupplied market.
			`,
			facts: [
				{
					fact: 'Hawaii is home to an estimated 85 self-storage facilities.',
					highlight: '85',
				},
				{
					fact: 'Hawaii self-storage facilities cover 4,036,700 square feet of storage space.',
					highlight: '4,036,700',
				},
				{
					fact: 'Hawaii storage facilities offer 2.86 square feet of storage per person, which is lower than the national average of 5.4 square feet per person.',
					highlight: '2.86',
				},
				{
					fact: 'Average price of a self-storage unit in Hawaii:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Honolulu',
				price: '0',
			},
			{
				city: 'Hilo',
				price: '0',
			},
			{
				city: 'Kailua-Kona',
				price: '0',
			},
			{
				city: 'Lahaina',
				price: '0',
			},
			{
				city: 'Kapolei',
				price: '0',
			},
			{
				city: 'Kahulei',
				price: '0',
			},
			{
				city: 'Pearl City',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			reasons: [
				'Amazing Weather. If you plan on moving to Hawaii, you will be able to get rid of your bulky winter wardrobe once and for all. Winter highs in the Islands of Aloha usually hover around 83°F, and overnight winter lows are typically in the mid 60s. The city of Honolulu receives around 270 days of sunshine a year and a rainbow is almost guaranteed after a rain shower. That is something to think about while you are shoveling the snow off your driveway.',
				'Best beaches. Hawaii has over 750 miles of coastline, giving it the title of the 4th longest coastline in the U.S. There are hundreds of pristine beaches where visitors can take part in all types of water activities including: swimming, surfing, snorkeling, volleyball, parasailing and people watching. All beaches in The Aloha State are public, so you don’t need anybody’s permission to enter. It is recommended to get to the beach early, before the east to west trade winds pick up.',
				'Spirit of Aloha. Aloha is generally understood to be the Hawaiian word for hello and goodbye, but the meaning actually goes deeper. The word aloha roughly translates to “the breath of life”, and represents the general attitude of locals. That attitude is one of kindness, generosity, understanding, harmony with nature, respect, admiration and an overall easy going, chill vibe.',
				'Ecological exposure. The Hawaiian islands are one of a kind when it comes to the biodiversity of its plants and animals. The islands are a bird watchers paradise and a botanists heaven. Over 150 different types of environment exist in Hawaii, each with their own type of ecosystem and unique flora and fauna.',
				'Everything is tasty. Food lovers in Hawaii will have plenty of flavor stimulators to pick from. From pineapples and tropical fruits, macadamia nuts, coffee and amazingly fresh seafood, residents of the island nation get the pick of the litter. Hawaii produces one-third of the world’s supply of pineapples, and it is the only state in the nation that grows coffee. The volcanic soil on the islands is said to impart an intense depth of flavor to anything grown in it.',
				'Hermit or social butterfly. There’s a wide range of population density in Hawaii. You could easily seclude yourself on an isolated island, only going into public once every few months to pick up supplies. Alternatively, you could go out every-night in Honolulu or Waikiki, spreading the aloha spirit and crushing Mai Tais like Don Draper on a sabbatical.',
				'Abundant beauty.  Living on a volcano in the middle of the sea can certainly change your outlook on life. Being constantly surrounded by picturesque beaches, lush mountains and exotic plants can make you take a step back and really be thankful for the existence of such a paradise.',
				'Volcanoes. Hawaii is home to five active volcanoes. Kilauea is the world’s most active volcano, and it is located on Hawaii’s big island. Mauna Loa, Mauna Kea, and Hualalai are all active volcanoes on the big island. Loihi is currently erupting underwater, and one day the cooled magma will help form a new Hawaiian island. The islands are home to dozens of dormant and extinct volcanoes that offer up great exploration opportunities for professionals and amateur volcano enthusiasts alike.',
				'No venomous snakes! People with ophidiophobia will be happy to know that the island contains no species of venomous snakes. Hawaii takes its snake population very seriously. Authorities recently imported four sterile male brown tree snakes solely for the purpose of training a team of dogs how to accurately sniff them out. If the invasive brown tree snake ever made it to Hawaii accidentally by way of shipped goods, it could create devastating effects on the island’s native bird population',
				'Minimalist lifestyle. Hawaii’s cost of living is higher than the national average because it is a literal paradise and everything you might want to buy has to travel extremely far to get there. In response to the high cost of living, many residents create a minimalist lifestyle. Downsizing your life, and spending more time outdoors is the general par for the course for new residents. You don’t need to live in a big, fancy house if you spend most of your time outside. Trade in your gym membership for a surfboard, eat inexpensive, local foods, and trade in your car for a scooter. Minimizing your life if the first step on the path of achieving the Aloha spirit.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>The population in Hawaii as of 2019 is 1,416,589, giving it the population rank of 41st in the nation. Hawaii is home to many diverse cultures including Pacific Islanders, Japanese, and Chinese peoples–and of course Hawaiians, which is a demonym that belongs to the aboriginal Polynesian people that originally inhabited the island and their descendants.  Hawaii resident is the preferred term used to refer to anyone that lives in the state.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>In 2018, Hawaii’s Real Gross Domestic Product was $80.8 billion, ranking it the 33rd best GDP in the nation.  In the past 10 years, Hawaii has increased its Real GDP by $9 billion. Tourism is a major contributor to the state’s economy. Tourists will find themselves paying duty tax and hotel tax to the state. Hawaii is a major trade hub between the east and west. It lies 2390 miles southwest of California, and 3850 miles east of Japan. As of September 2019, Hawaii’s unemployment rate is at 2.7 percent.</p>
				<p>Below is a breakdown of Hawaii’s Real GDP by sector:</p>
			`,
			breakdown: [
				{
					sector: 'Real Estate / Rental and Leasing',
					value: '$16.5 billion',
				},
				{
					sector: 'Federal Government (civilian)',
					value: '$15.9 billion',
				},
				{
					sector: 'Arts, Entertainment and Recreation',
					value: '$7.4 billion',
				},
				{
					sector: 'Accommodations (Hotels, Resorts, etc)',
					value: '$6.5 billion',
				},
				{
					sector: 'Retail',
					value: '$5.9 billion',
				},
			],
			bottomLine: `
				<p>Georgia is expected to move towards a slow recovery with a decrease in unemployment and an increase in annual GDP through 2020. Georgia has a cost of living score of 100.3, meaning it's somewhat more expensive than the US as a whole, although not by much. However, that doesn't mean Georgia can't offer affordable living. Cities like Duluth, Newnan, Gainesville, Warner Robins, and Smyrna are all affordable cities in Georgia.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'The Queen’s Medical Center',
					employees: '7,499',
				},
				{
					employer: 'Hawaii Pacific Health',
					employees: '6,621',
				},
				{
					employer: 'Hawaiian Airlines',
					employees: '6,356',
				},
				{
					employer: 'Hawaii State Teachers Association',
					employees: '4,667',
				},
				{
					employer: 'State of Hawaii',
					employees: '4,160',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Located 2,000 southwest of the mainland United States, the Hawaiian archipelago is the only state in the US that is comprised totally of islands. The eight main islands contain 10,931 square miles of total area, and 41% of that total area is water. The average elevation on the islands is 3,030 ft, and the highest point is 13,976 feet at Mauna Kea, a volcano on the Big Island.</p>
			`,
			cities: [
				{
					city: 'Honolulu',
					copy: '<p>Honolulu is the most populated city in Hawaii with 395,397 residents. Located on the island of O’ahu, it has been the capital of Hawaii since 1845. It is the second safest city in the United States.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '88% higher than national average',
						},
						{
							item: 'Median home price',
							value: '$661,300',
						},
						{
							item: 'Average rent',
							value: '$1,734',
						},
						{
							item: 'Average apartment size',
							value: '561 square feet',
						},
					],
				},
				{
					city: 'Pearl City',
					copy: '<p>Pearl City is the second largest city in Hawaii with 47,700 residents. It is located along the north shore of Pearl Harbor.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '75% higher than national average',
						},
						{
							item: 'Median home price',
							value: '$718,900',
						},
					],
				},
				{
					city: 'Hilo',
					copy: '<p>Hilo is the third largest city in Hawaii with 43,200 permanent residents. On the big island, the name means to twist in Polynesian, because the cove twists back from the rest of the island.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '46% higher than national average',
						},
						{
							item: 'Median home price',
							value: '$348,200',
						},
						{
							item: 'Average rent',
							value: '$1,466',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'You will be required to acquire an official State of Hawaii drivers license once you establish residency on the island. Visit the nearest DMV and bring along your current proof of identity and two proofs of Hawaiian residency. Once you fill out the proper application, paper work, and you pay the proper fees, your new ID will be mailed to you within six to eight weeks.',
			},
			{
				title: 'Vehicle registration',
				copy: 'Rules for vehicle registration differ depending on what island you live on. If you move to Honolulu and have your vehicle shipped from the US mainland, you will need to present your vehicles title, bill of lading (shipping document for your vehicle), current registration and Hawaii vehicle inspection document. After the proper forms are filled out and fees are paid, you can get your Hawaiian registration stickers and license plate.',
			},
			{
				title: 'Voter Registration',
				copy: 'Once you have your Hawaiian drivers license, you will be eligible to obtain voter status in your new state. Have your driver’s license and social security number ready and go to this site to fill out your voter registration form.',
			},
		],
		sources: [
			// static content
			'https://datausa.io/profile/geo/east-honolulu-hi/',
			'https://worldpopulationreview.com/us-cities/honolulu-population/',
			'https://www.payscale.com/cost-of-living-calculator/Hawaii-Honolulu',
			'https://www.rentcafe.com/average-rent-market-trends/us/hi/hilo/',
			'https://www.rentcafe.com/average-rent-market-trends/us/hi/honolulu/',
			'https://www.zillow.com/pearl-city-hi/home-values/',
			'https://www.zillow.com/hilo-hi/home-values/https://www.zillow.com/honolulu-hi/home-values/',
			'https://www.payscale.com/research/US/Location=Hilo-HI',
			'https://worldpopulationreview.com/states/hawaii-population/',
			'https://united-states.reaproject.org/data-tables/gsp-a900n/tools/150000/',
			'https://en.wikipedia.org/wiki/Hawaii',
			'https://en.wikipedia.org/wiki/Honolulu',
			'https://en.wikipedia.org/wiki/Hilo,_Hawaii',
			'https://en.wikipedia.org/wiki/Pearl_City,_Hawaii',
			'https://www.honolulu.gov/faqs/118-site-csd-cat/faq-driver-s-license-cat/19823-how-do-i-transfer-my-valid-out-of-state-licens',
			'https://portal.ehawaii.gov/residents/newcomers-guide/registering-your-vehicle/',
			'https://www.honolulu.gov/cms-csd-menu/site-csd-sitearticles/6441-vehicle-registration-information.html',
			'https://olvr.hawaii.gov/https://www.bls.gov/eag/eag.hi.htm',
			'https://united-states.reaproject.org/data-tables/gsp-a900n/tools/150000/',
			'https://www.zippia.com/advice/largest-companies-in-hawaii/',
			'https://www.50states.com/facts/hawaii.htm',
			'https://www.livinginhawaii.com/50-reasons-to-move-to-hawaii/',
			'https://www.currentresults.com/Weather/Hawaii/annual-days-of-sunshine.php',
			'https://www.hawaiigaga.com/hawaii-best-beaches.aspx',
			'https://www.to-hawaii.com/aloha.php',
			'https://www.sutori.com/story/history-of-hawaii-s-ecology–YxjBE5QjdzrQqMgcTNSJJdLn',
			'https://www.zipline.com/blog/active-volcanoes-hawaiian-islands/',
			'https://www.hawaiinewsnow.com/2018/12/10/hawaii-just-purposely-imported-brown-tree-snakes-heres-why/',
		],
	},
	ID: {
		state: 'Idaho',
		stateNickname: 'Gem State',
		welcome: `
			<p>Idaho, nicknamed the Gem State, has more than 1.7 million people that call it home. Located in the northwest, Idaho is known for its scenic mountain ranges, potatoes, protected wilderness, and outdoor recreation areas (like the Boise River).</p>
			<p>Idaho's major industries include tourism, healthcare, agriculture, manufacturing, and food and beverage manufacturing. The state also produces 72 types of gemstones, including rubies and diamonds.</p>
			<p>Some of the major attractions include the Craters of the Moon National Monument and Preserve, Shoshone Falls Park, Oregon Trail, Silverwood Theme Park, and Silver Mountain.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Idaho self-storage industry consists of about 436 self-storage facilities spread throughout the state. The number has been rising lately thanks to an increase in self-storage development that is occurring nationwide. Idaho currently has a surplus of self-storage supply, in fact the state has the highest ratio of self-storage per person at a rate of 10.76 square feet per capita. That's nearly double the national average of 5.4 square feet per capita. Still, opportunities exist for new storage facilities as operators seek to cater to tourists and new residents moving to Idaho from out of state.</p>
			`,
			facts: [
				{
					fact: 'Idaho is home to more than 436 self-storage facilities',
					highlight: '436',
				},
				{
					fact: 'Idaho facilities offer more than 17,546,608 million square feet of storage space combined.',
					highlight: '17,546,608',
				},
				{
					fact: 'Idaho has 10.76 square feet of storage space for every man, woman, and child, the highest per capita rate in the country.',
					highlight: '10.76',
				},
				{
					fact: 'Average price of a self-storage unit in Idaho:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Boise',
				price: '0',
			},
			{
				city: "Coeur d'Alene",
				price: '0',
			},
			{
				city: 'Idaho Falls',
				price: '0',
			},
			{
				city: 'Twin Falls',
				price: '0',
			},
			{
				city: 'Nampa',
				price: '0',
			},
			{
				city: 'Meridan',
				price: '0',
			},
			{
				city: 'Pocatello',
				price: '0',
			},
			{
				city: 'Lewiston',
				price: '0',
			},
			{
				city: 'Caldwell',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Thinking of moving to the Gem State, but not really sure if you'll fit in? Check out our top 10 reasons to move to Idaho.</p>",
			reasons: [
				"Fisherman's delight. Idaho is well known for its trout fishing so if you make the move, you'll have ample opportunities to go fishing in trout streams like the South Fork of the Snake River and Henry's Fork of the Snake River.",
				'Affordable living. Idaho is also known for its low cost of living, making it affordable for anyone considering a move from a more expensive state like New York or California.',
				"Experience every season. Idaho's weather fluctuates with ice-cold winters and sizzling summers. So if you want a place where you can experience all of the seasons in one place, Idaho's got it.",
				"High homeownership rates. Idaho has the 12th highest homeownership rate in the country, according to Census data. That means you'll definitely have your fair shot if that's your goal.",
				"Outdoor activities. Idaho makes participating in outdoor recreation easy and it's a favorite for kayakers and whitewater rafters. In the winter, it's a skier's paradise.",
				'Live music festivals. Idaho is home to several music festivals for a range of music fans, including the Treefort Music Festival, the Mountain Home Music Festival, and the Festival at Sandpoint, to name a few.',
				"Low crime rate. Idaho's got one of the lowest crime rates in the whole country so you can be more confident about your safety here.",
				"Close proximity to Yellowstone. Yellowstone's Western Gateway is only about 20 miles from Island Park, Idaho so you'll have direct access to this amazing natural beauty any time.",
				"Light traffic. Idaho is among those states that enjoy incredibly light traffic most of the time, especially compared to other places. During rush hour, you're looking at a 30-40 minute commute at the most.",
				"Craft beer heaven. In Idaho, you'll find a local brewery within close proximity no matter where you are in the state.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Idaho has a population of 1.79 million people and ranks as the 40th largest state by population. Between 2018 and 2019, Idaho's population increased by 2.05 percent. Roughly 80,000 people moved to Idaho in 2018, according to Idaho News. Tons of priced-out Californians are moving to Idaho because of the low cost of living and the more favorable housing prices.</p>
				<p>Idaho is expected to see continued job growth through 2020, although slower than 2019. It's expected to see a 1.8 percent job growth rate and add roughly 13,600 new jobs in the year 2020. Idaho has a cost of living score of 100.2, meaning it's slightly more expensive to live in the Gem state than the US as a whole. But some cities provide a lower cost of living than the national average.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Idaho's GDP for 2018 was approximately $69.89 billion, while unemployment is around 2.9 percent as of September 2019.</p>
				<p>Below is a breakdown of the top five sectors in Idaho by GDP of real value added:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$11.6',
				},
				{
					sector: 'Government and government enterprises',
					value: '$8.68',
				},
				{
					sector: 'Manufacturing ',
					value: '$8.61',
				},
				{
					sector: 'Professional and business services',
					value: '$7.43',
				},
				{
					sector: 'Educational services, healthcare, and social assistance',
					value: '$6.25 ',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Albertsons',
					employees: '273,000',
				},
				{
					employer: 'Micron Technology',
					employees: '31,400',
				},
				{
					employer: 'State of Idaho',
					employees: '26,100',
				},
				{
					employer: "St. Luke's Health",
					employees: '12,825',
				},
				{
					employer: 'WinCo Foods',
					employees: '12,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Idaho covers roughly 83,642 square miles and the state is made up of 44 counties. The three largest cities are Boise City, Meridian, and Nampa.</p>
			`,
			cities: [
				{
					city: 'Boise',
					copy: "<p>Boise City is the largest city in Idaho, with a population of about 231,773. It's also the capital and the 99th largest city in the US by population. The city is filled with things to do and see, including museums, restaurants, spas, concerts, shows, nightlife, parks, tours, water sports, and shopping.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '8 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$307,500',
						},
						{
							item: 'Average rent',
							value: '$1,186 per month',
						},
						{
							item: 'Average apartment size',
							value: '881 square feet',
						},
					],
				},
				{
					city: 'Meridian',
					copy: "<p>Meridian is the second-largest city in Idaho with a population of 107,989 people. It's the fastest-growing city in Idaho and for good reason. Meridian can keep you entertained with activities and attractions like Roaring Springs Water Park, Wahooz Family Fun Zone, Settlers Park, Meridian Speedway, and Julius K. Kleiner Memorial Park.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '2 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$325,300',
						},
						{
							item: 'Average rent',
							value: '$1,224 per month',
						},
						{
							item: 'Average apartment size',
							value: '995 square feet',
						},
					],
				},
				{
					city: 'Nampa',
					copy: "<p>Nampa, the third-largest city in Idaho, has a population of roughly 96,332 people. It's the largest city in Canyon County and provides plenty for residents to do all year round, including Warhawk Air Museum, Lake Lowell, Deer Flat National Wildlife Refuge, Wilson Springs Ponds, and Sawtooth Winery.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '13 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$242,500',
						},
						{
							item: 'Average rent',
							value: '$1,035 per month',
						},
						{
							item: 'Average apartment size',
							value: '1,036 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Idaho have 90 days to transfer their existing license to an Idaho driver's license. If you have a commercial driver's license (CDL), however, you'll only 30 days to transfer your out-of-state license. For more info, visit:",
				link: 'https://itd.idaho.gov/itddmv/?target=Drivers-License-ID-Cards',
			},
			{
				title: 'Vehicle registration',
				copy: "If you're going to be a permanent resident of Idaho (meaning you'll live there at least 90 days continually), you'll need to register your out-of-state vehicle with the Idaho DMV. Depending on the county you live in, you might also have to have your vehicle inspected prior to registration. For more info, visit:",
				link: 'https://www.idaho.gov/about-idaho/moving/',
			},
			{
				title: 'Voter Registration',
				copy: "To register to vote in Idaho, you'll need to print out an application, fill it out, sign it and hand it or mail it in to the county clerk, who acts as the chief registration official of their county. For more info, visit:",
				link: 'https://idahovotes.gov/voting/',
			},
		],
		sources: [
			// static content
			'https://idahovotes.gov/voting/',
			'https://itd.idaho.gov/itddmv/?target=Drivers-License-ID-Cards',
			'https://itd.idaho.gov/itddmv/',
			'https://www.idaho.gov/about-idaho/moving/',
			'https://worldpopulationreview.com/states/idaho-population/cities/',
			'https://www.coolkidfacts.com/idaho-facts/',
			'https://kids.nationalgeographic.com/explore/states/idaho/',
			'https://www.statista.com/statistics/1064884/idaho-real-gdp-by-industry/',
			'https://www.statista.com/statistics/187861/gdp-of-the-us-federal-state-of-idaho-since-1997/',
			'https://labor.idaho.gov/dnn/Businesses/Unemployment-Tax/Unemployment-Tax-Rates',
			'https://www.zippia.com/advice/largest-companies-in-idaho/',
			'https://www.kiplinger.com/slideshow/business/T019-S010-kiplinger-economic-outlook-for-all-50-states-2020/index.html',
			'https://www.bestplaces.net/cost_of_living/state/idaho',
			'https://worldpopulationreview.com/states/idaho-population/',
			'https://www.businessinsider.com/californians-priced-out-move-to-idaho-2018-10',
			'https://idahonews.com/news/local/nearly-80000-people-moved-to-idaho-in-2018-heres-where-they-came-from',
			'https://smartasset.com/mortgage/15-things-to-know-before-moving-to-idaho',
			'https://www.onlyinyourstate.com/idaho/reasons-to-move-to-id/',
			'https://www.tripadvisor.com/Attractions-g35394-Activities-Boise_Idaho.html',
			'https://www.tripadvisor.com/Attractions-g35531-Activities-Meridian_Idaho.html',
			'https://www.tripadvisor.com/Attractions-g35546-Activities-Nampa_Idaho.html',
			'https://www.payscale.com/cost-of-living-calculator/Idaho-Boise',
			'https://www.zillow.com/boise-id/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/id/ada-county/boise-city/',
			'https://www.areavibes.com/meridian-id/cost-of-living/',
			'https://www.zillow.com/meridian-id/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/id/meridian/',
			'https://www.areavibes.com/nampa-id/cost-of-living/',
			'https://www.zillow.com/nampa-id/home-values/',
		],
	},
	IL: {
		state: 'Illinois',
		stateNickname: 'Land of Lincoln',
		welcome: `
			<p>Illinois is the 25th largest state in the country by area, but it's the sixth most populous with a population of more than 12.7 million people. Known for its agriculture, architecture, culture, and art, Illinois has plenty to offer. While it's mostly a flat plane, Illinois boasts some of the most diverse regions and beautiful landscapes in the country, from its wetlands and hills to its farmlands and forests.</p>
			<p>Chicago's major industries include manufacturing, service, mining, and agriculture. Some major manufacturing companies and well-regarded universities call the Chicago area home, including the University of Illinois and the University of Chicago, both ranked among the top universities in the world.</p>
			<p>While Chicago may be pricier than the country as a whole in terms of cost of living, the state of Illinois has plenty of cities with a favorable cost of living, including Carbondale, Marion, and Herrin. But more than that, Illinois offers plenty to do in terms of outdoor activities when the weather permits, including theme parks, water skiing, wine country, golf getaways, hiking, botanic gardens, biking, museums, theaters, snow skiing, antique shopping, and professional and college sports.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Buoyed by Chicago and the surrounding suburbs, the self-storage industry in Illinois is one strongest in the country. Chicago was one of the first cities to experience the ongoing self-storage development boom, which is taking place all over the country and elsewhere throughout the Land of Lincoln. Funding for new development became scarce after the last recession, leading to a shortage of storage space for consumers and record-high rental rates. Within the last half decade the storage industry has been undergoing a major expansion to meet the demands of movers and businesses around the nation. With more space available, rates for self-storage have moderated and it has become easier for users to find space near them.</p>
				<p>Below is an overview of the current state of the Illinois self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Illinois is home to about 1,558 self-storage facilities.',
					highlight: '1,558',
				},
				{
					fact: 'Illinois self-storage facilities cover 55,641,378 square feet of storage space.',
					highlight: '55,641,378',
				},
				{
					fact: 'Illinois storage facilities offer 4.35 square feet of storage per person, which is lower than the national average of 5.4 square feet per person.',
					highlight: '4.35',
				},
				{
					fact: 'Average price of a self-storage unit in Illinois:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Chicago',
				price: '0',
			},
			{
				city: 'Peoria',
				price: '0',
			},
			{
				city: 'Rockford',
				price: '0',
			},
			{
				city: 'Aurora',
				price: '0',
			},
			{
				city: 'Champaign',
				price: '0',
			},
			{
				city: 'Joliet',
				price: '0',
			},
			{
				city: 'Naperville',
				price: '0',
			},
			{
				city: 'Elgin',
				price: '0',
			},
			{
				city: 'Evanston',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you've been considering a move to the Prairie state, here are a few things that might help you decide.</p>",
			reasons: [
				'The Windy City. Chicago is home to some of the best nightlife, food, art, and entertainment in the state, which is why people of all demographics flock to the Windy City every year, either to visit or to stay.',
				'Great cost of living. While the Chicagoland area might be more expensive than the US average, Central Illinois is sprinkled with small cities and towns that make living affordable.',
				"A place for sweets. Not only was the ice cream sundae named here, but Illinois is also home to the first Dairy Queen. So you'll be sure to find plenty of sweets to satisfy your sweet tooth.",
				"Home of the World's Largest Bakery. Speaking of sweet treats, the Nabisco factory is located in Chicago and is the world's largest bakery at 1,800,000 square feet. So if you love cookies, Illinois is where you want to be.",
				"You can drive your car through the post office. That's right. The Chicago Post Office on 433 West Van Buren is the only postal office in the world that you can literally drive your car through. Talk about convenience.",
				"The Lincoln Park Zoo. This Chicago zoo is one of only three major free zoos in the county and the nation's oldest public zoo. Taking the family to see the animals won's cost you a dime.",
				"Da Bears! But legendary sports teams don's end there with the Chicago White Sox, the Chicago Blackhawks, the Chicago Bulls, and the Chicago Fire playing to win.",
				"St. Patrick's Day green river. The Chicago River is one of the only rivers in the world that flows backward and every year on St. Patrick's Day, the residents dye it green!",
				"Books galore. If you's a book nerd, you'll love the fact that the Chicago Public Library houses more than 2 million books! Happy reading!",
				"Natural beauty. Calling all nature lovers! Starved Rock State Park is one of the state's most beautiful destinations with 18 canyons. Lake Michigan is also in Illinois, providing plenty of opportunities to enjoy an array of outdoor activities.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Also known as the Corn State, Illinois has a population of more than 12.7 million people as of 2019, according to World Population Review. It's the 26th largest state and the sixth most populous in the country.</p>
				<p>From 2017 to 2018, Illinois' population declined, losing an estimated 45,116 residents, according to the Census Bureau. Every day, 313 people leave Illinois, mostly affluent millennials, according to Illinois Policy. The number one reason people seem to be leaving is taxation. The state recently passed 20 new or increased tax and fee hikes when they passed a $40 billion spending bill and $45 billion infrastructure bill.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Agriculture is one of the most important parts of Illinois' economy and it's the country's largest producer of pumpkins and its second-largest producer of corn. The state's GDP is $864 million as of 2018 and Illinois had an unemployment rate of 4 percent as of August 2019, according to the Bureau of Labor Statistics.</p>
				<p>Here are the top five sectors by GDP of real value added:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$161.72 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$71.13 billion',
				},
				{
					sector: 'Manufacturing ',
					value: '$98.41 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$109.47 billion',
				},
				{
					sector: 'Educational services, healthcare, and social assistance',
					value: '$66.61 billion',
				},
			],
			bottomLine: `
				<p>Throughout 2019, Illinois saw far more growth than expected. However, forecasters predict that a potential economic slowdown is on the way as the state prepares to pass a budget for 2020.</p>
				<p>Illinois has a cost of living index score of 101.5, meaning it's more expensive than the US average. However, certain cities in the state boast a lower cost of living than the national average, such as Rockford, which has a cost of living 10 percent lower than the national average. That means while some cities might be a bit out of your price range, you can still take comfort in knowing there are cities you can afford to move to in Illinois.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: "McDonald's",
					employees: '375,000',
				},
				{
					employer: 'Walgreens',
					employees: '253,400',
				},
				{
					employer: 'Sears Holdings',
					employees: '140,000',
				},
				{
					employer: 'Caterpillar',
					employees: '95,400',
				},
				{
					employer: 'United Airlines',
					employees: '90,600',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Illinois is roughly 57,914 square miles with a population density of 230 people per square mile. Most of Illinois' population is located in the North East in the Chicago Metro area. The three largest cities include Chicago, Aurora, and Rockford.</p>
			`,
			cities: [
				{
					city: 'Chicago',
					copy: "<p>Chicago is the largest city in Illinois with a population of about 2.7 million people, but it's also the largest city in the entire Midwest. The Windy City is well known as an industrial metropolis and as a city of exports thanks to the International Port of Chicago. Nestled on the shores of Lake Michigan, Chicago has plenty to offer in terms of outdoor entertainment, including lake-front museums, state parks, concerts, waterparks, and more.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '23 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$227,300',
						},
						{
							item: 'Average rent',
							value: '$2,007 per month',
						},
						{
							item: 'Average apartment size',
							value: '749 square feet',
						},
					],
				},
				{
					city: 'Aurora',
					copy: "<p>Aurora is the state's second-largest city and has a population of about 199,602 people. The city served as the location for a few Hollywood movies including Wayne's World and Public Enemies. The city has experienced amazing growth in the last few decades and has plenty to offer in terms of activities and entertainment.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '4 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$184,600',
						},
						{
							item: 'Average rent',
							value: '$1,332 per month',
						},
						{
							item: 'Average apartment size',
							value: '904 square feet',
						},
					],
				},
				{
					city: 'Rockford',
					copy: '<p>Rockford is the third most populous city in the state of Illinois with a population of 152,871 residents. Located on the banks of the Rock River, Rockford is in Northern Illinois between Chicago and Galena.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '10 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$88,300',
						},
						{
							item: 'Average rent',
							value: '$1,467',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Illinois are legally allowed to use their valid driver's license from out-of-state or out-of-country for 90 days. But after that period, you'll have to get an Illinois driver's license or ID card if you want to become a legal resident of Illinois. To get a new driver's license, you have to visit a Secretary of State facility to turn in your out-of-state license. You'll also have to pass a vision screening test and a written exam. In some cases, you might be asked to take a driving exam. Bring your ID with you when you go so they can verify your personal information, such as your name, date of birth, social security number, your proof of residency, and your signature. For more information, visit:",
				link: 'https://www.cyberdriveillinois.com/departments/drivers/home.html',
			},
			{
				title: 'Vehicle registration',
				copy: "Once you move to Illinois, you'll have 30 days to apply for an Illinois title and registration, as long as your car is already properly registered in another state. To register your vehicle, you have to visit a Secretary of State facility. You'll need a few documents to register your vehicle, including your lease-purchase agreement (if applicable), your out-of-state registrations that show the vehicle was registered in another state, your out-of-state title, the Manufacturer's Certificate of Origin, and the bill of sale. For more information, visit:",
				link: 'https://www.cyberdriveillinois.com/departments/vehicles/title_and_registration/home.html',
			},
			{
				title: 'Voter Registration',
				copy: "When you apply for your Illinois driver's license, you'll be asked if you'd like to register to vote. In order to register to vote in Illinois, you have to be a U.S. citizen and at least 17 years old on the date of the Primary Election. You also have to be 18 by the time the General or Consolidated Election begins. You'll be required to attest, under penalty of perjury, that you meet the qualifications to register to vote and give your electronic signature. For more information on registering to vote in Illinois, visit:",
				link: 'https://www.cyberdriveillinois.com/departments/drivers/motorvoter.html',
			},
		],
		sources: [
			// static content
			'https://fred.stlouisfed.org/series/ILNGSP',
			'https://www.bls.gov/cps/cps_htgm.htm',
			'https://www.statista.com/statistics/304912/illinois-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-illinois/',
			'https://www.payscale.com/cost-of-living-calculator/Illinois-Chicago',
			'https://www.zillow.com/chicago-il/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/il/chicago/',
			'https://www.payscale.com/cost-of-living-calculator/Illinois-Aurora',
			'https://www.rentcafe.com/average-rent-market-trends/us/il/aurora/',
			'https://www.zillow.com/aurora-il/home-values/',
			'https://www.payscale.com/cost-of-living-calculator/Illinois-Rockford',
			'https://www.zillow.com/rockford-il/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/il/rockford/',
			'https://www.cyberdriveillinois.com/departments/vehicles/title_and_registration/home.html',
			'https://www.cyberdriveillinois.com/departments/vehicles/title_and_registration/home.html',
			'https://www.cyberdriveillinois.com/departments/drivers/motorvoter.htmlhttps://www.cyberdriveillinois.com/publications/pdf_publications/vsd271.pdf',
			'https://www.huffpost.com/entry/25-fun-facts-about-illino_b_5076872',
			'https://mentalfloss.com/article/59043/15-things-you-might-not-know-about-illinois',
			'https://www.50states.com/facts/illinois.htm',
			'https://www.coolkidfacts.com/illinois-facts/',
			'https://justfunfacts.com/interesting-facts-about-illinois/',
			'https://www.news-gazette.com/news/state-agency-illinois-better-than-expected-growth-in-as-good/article_25369d80-46d2-5cdb-9532-58674236416a.html',
			'https://www.chicagotribune.com/news/ct-met-census-illinois-population-20181219-story.html',
			'https://www.google.com/url?sa=i&source=images&cd=&cad=rja&uact=8&ved=0ahUKEwjP3cPj-5LlAhWhTt8KHXjABlwQMwhSKAIwAg&url=https%3A%2F%2Fwww.azquotes.com%2Fquote%2F1263760&psig=AOvVaw2pXgzyrRXbGmuSNvBLjrKD&ust=1570840706679395&ictx=3&uact=3',
			'https://www.governing.com/topics/finance/sl-illinois-sees-population-decline.html',
		],
	},
	IN: {
		state: 'Indiana',
		stateNickname: 'Hoosier State',
		welcome: `
			<p>Indiana is synonymous with both “the heartland” and the world’s oldest annual automobile race–the Indianapolis 500. This midwestern state spans 36,418 miles of mostly flat plains in the north and central parts of the state, with a vastly different hill and forest country to the south.</p>
			<p>The state is nicknamed the “Hoosier State” for reasons that are not entirely clear. Possible origins include Hoosier being an old pioneer greeting, or last name of a man who hired Indiana residents to work on the Ohio Falls canal in the 1820s. The origins of the state’s official motto, “The Crossroads of America” are much more clear. Several major interstate highways that connect to the rest of the United States meet in the Hoosier State. However you choose to refer to Indiana, it’s a state that embodies Americana. And actually, Hoosier isn't just a nickname anymore. Since 2016, it is the official demonym for a resident of Indiana, according to the U.S. General Publishing Office.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Self-storage development has been taking off across the country as more investors are looking to bet on self-storage. More facilities are being built to meet demand, which is generated by things like people moving, small businesses, or retirees downsizing their belongings. Until a few years ago, self-storage development was at a standstill. Many storage spaces had waiting lists as the industry achieved record levels of occupancy. As a result of the lack of supply they were able to raise rates. Attracted to the high yields generated by storage facilities operating in this environment, developers and operators set out to expand their operations. At the same time more funding sources have become available to them as the broader economy expands. That has ueled the latest trend in self-storage development that is sweeping the nation. Indiana is no exception as it continues to grow its population at a steady clip.</p>
				<p>Below is an overview of the current state of the Indiana self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Indiana is home to about 1,144 self-storage facilities.',
					highlight: '1,144',
				},
				{
					fact: 'Indiana self-storage facilities cover 35,148,061 square feet of storage space.',
					highlight: '35,148,061',
				},
				{
					fact: 'Indiana storage facilities offer 5.35 square feet of storage per person, which is close to the national average of 5.4 square feet per person.',
					highlight: '5.35',
				},
				{
					fact: 'Average price of a self-storage unit in Indiana:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [],
		reasonsToMove: {
			// static content
			copy: "<p>If you're thinking about making the move, but aren't sure if Indiana is the right place for you, consider the following:</p>",
			reasons: [
				'Indiana loves sports. There is an affinity between rural America and sports, especially football, and this extends to even the big cities in Indiana. College football and basketball are popular all over the state, as are the Indianapolis Colts and Indiana Pacers.',
				'500 laps = 200 miles. But in Indiana, the sport of automobile racing may be king. The Indianapolis 500 is one of the big three global auto races, the others being the Le Mans and the Monaco Grand Prix. The first race started in 1911, and continues on in Speedway, Indiana each May.',
				'Limestone is the state’s bedrock. The country’s highest quality limestone, known as Salem limestone, is found in Indiana’s “Stone Belt” in the south-central region of the state. The limestone industry began in 1827, and the stone’s beauty can be seen all over the country, including on the exterior cladding of the Empire State Building in New York City.',
				'Indiana’s stunning Dunes area on Lake Michigan. Some may be unfamiliar with America’s northern coast, found at the Great Lakes. Indiana Dune National Park offers sandy beaches, trails, forests, and views of the Chicago skyline in the distance.',
				'Farming is a pretty big deal. There is a reason so many trucks and other vehicles pass through the Crossroads of America — the corn, grain, dairy, and other produced in America’s breadbasket.  There are an estimated 94,000 farmers in Indiana, cultivating over 15 million acres of farmland each year.',
				'All that farming means good eats. Like many destinations in the United States, Indiana has some of its own unique culinary dishes. The most “Hoosier” dish of them all, however is the pork tenderloin sandwich — or “Hoosier sandwich” — that involves a crispy pounded pork cutlet bigger than your plate between a burger bun.',
				'Indiana is an educational crossroads, too. The state is home to such renowned colleges and universities as Ball State University, Purdue, University of Notre Dame, and over sixty other institutions.',
				'Deep roots of industry and manufacturing. Like other Midwest states, the heartland of Indiana also a connection to manufacturing. Indiana industry, however, steers toward advanced manufacturing, such as the design, testing and production work in Indianapolis’s Eli Lilly and Co.',
				'A defense industry hub. Skilled advanced manufacturing also plays a role in the state’s history as a center of the defense industry. Indiana is home to employers that manufacture satellite components, military vehicles, aircraft electronic controls, and more.',
				'Presidential history. Indiana is famous for being where President Lincoln was raised, but it was also home to Benjamin Harrison. And, we’ve had six Hoosier Vice Presidents, from Schuyler Colfax in 1869 to Mike Pence in 2019.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>As the Crossroads of America, full of educational opportunities, history, and natural beauties, Indiana is today witnessing population growth. With almost 6.7 million residents, Indiana is the 17th most populous state in the country. Indiana has seen consistent population growth. The population growth rate is .33%, which is 29th in the nation. This is modest when compared with southern or western states, but it outpaces much of the rest of the midwest.</p>
				<p>Most of this growth is in the suburban area surrounding the state’s two largest cities: Indianapolis and Fort Wayne.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Indiana’s gross domestic product (GDP) is roughly $368 billion, making it the 19th largest state economy in the nation. This figure represents a steady increase over the past decade, consistent with the sustained growth experienced in most of the country. Indiana employment numbers are on the rise, too, with its payroll growth ranking 13th in the country.</p>
				<p>Growth in Indiana is likely related to the state’s ranking as the 10th most favorable in the country on the Tax Foundation’s State Business Tax Climate Index. When compared to its Midwest neighbors, Indiana shines as a location for sustained business activity.</p>
				<p>Indiana’s employment opportunities span manufacturing, education, health care, and more. Of course, like many other states in the country, manufacturing in Indiana has slowed over the years as businesses have become more globalized, especially in the low to mid-skilled factories. But the Hoosier state still leads the country in manufacturing employment. The focus, however, is not on low skill manufacturing, but on product creation and research and development. For those looking to move to the Hoosier State, it means innovation is alive and well today and in the future.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Cummins',
					employees: '55,400',
				},
				{
					employer: 'Anthem',
					employees: '53,000',
				},
				{
					employer: 'Eli Lilly and Company',
					employees: '41,975',
				},
				{
					employer: 'Indiana University',
					employees: '30,000',
				},
				{
					employer: 'Purdue University',
					employees: '20,250',
				},
				{
					employer: 'Zimmer Biomet',
					employees: '18,500',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>If you look at a map of Indiana, you’ll see that the roughly triangle shaped state runs from the southern shore of Lake Michigan in the north, to the meeting of Illinois and Kentucky to the south. The major population centers also follow this vertical path, with Fort Wayne in the north, Indianapolis at the state’s center, and Evansville in the south.</p>
				<p>Here’s a quick look at the state’s three largest cities:</p>
			`,
			cities: [
				{
					city: 'Indianapolis',
					copy: '<p>The economic, cultural, and educational center of Indiana is also its geographic center. Indianapolis, the state capital, has a population of 872,680. It is the 17th most populous city in the United States, and also boasts 2 million residents in the greater Indianapolis metropolitan area. Employers in the city include University of Indiana Health, Eli Lilly and Company, and Community Health.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '8 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$174,000',
						},
						{
							item: 'Average rent',
							value: '$878/month',
						},
						{
							item: 'Average apartment size',
							value: '880 square feet',
						},
					],
				},
				{
					city: 'Fort Wayne',
					copy: '<p>In the state’s northeast, Fort Wayne is a city with a history that stretches back to the end of the 18th century. Established as a U.S. Army fort, today Fort Wayne is home to 267,633 residents. As a northeastern city, it is part of the rust belt, with major employers including General Motors and Parkview Health Systems.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '12 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$169,000',
						},
						{
							item: 'Average rent',
							value: '$783/month',
						},
						{
							item: 'Average apartment size',
							value: '885 square feet',
						},
					],
				},
				{
					city: 'Evansville',
					copy: '<p>The next largest city in Indiana is Evansville, located in the southern portion of the state, with 119,000 residents. Big employers in Evansville include Toyota Motors, Deaconess Health Systems, Whirlpool Corp, Mead Johnson, and the University of Southern Indiana.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '11 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$139,000',
						},
						{
							item: 'Average rent',
							value: '$829/month',
						},
						{
							item: 'Average apartment size',
							value: '900 square feet.',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents who possess a driver’s license from another state must obtain an Indiana license within 60 days of establishing residency.',
				link: 'https://www.in.gov/bmv/2558.htm',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents of Indiana must also register their vehicles within 60 days of becoming a Hoosier.',
				link: 'https://www.in.gov/bmv/2558.htm',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Indiana, you must be a citizen of the United States, be 18 years of age or older on or before the date of the next election, and must be a resident of the state.',
				link: 'https://indianavoters.in.gov/',
			},
		],
		sources: [
			// static content
			'https://igws.indiana.edu/Surficial/Landscapes#gsc.tab=0',
			'https://www.in.gov/isda/3555.htm',
			'https://www.govinfo.gov/app/details/GPO-STYLEMANUAL-2016',
			'https://www.visitbloomington.com/limestone/',
			'https://igws.indiana.edu/MineralResources/Limestone',
			'https://www.nps.gov/indu/index.htm',
			'https://www.indystar.com/story/money/2016/03/18/indianas-manufacturing-history-also-key-states-economic-future/81540742/',
			'https://www.southbendtribune.com/news/local/history/a-look-back-six-u-s-vice-presidents-called-indiana/article_30d4e0e8-4061-5105-b5a3-a42ae1e511ed.html',
			'https://indianapublicmedia.org/news/indy-suburbs-fastest-growing-cities-towns-indiana-148275/',
			'https://www.ibrc.indiana.edu/ibr/2018/outlook/indiana.html',
			'https://www.zippia.com/advice/largest-companies-in-indiana/',
			'https://www.zillow.com/indianapolis-in/home-values/',
			'https://www.rentjungle.com/average-rent-in-evansville-rent-trends/',
			'https://www.in.gov/bmv/2558.htm',
		],
	},
	IA: {
		state: 'Iowa',
		stateNickname: 'Hawkeye State',
		welcome: `
			<p>As more people look to the middle of the country to find a new home, Iowa has shown true promise as an amazing place to live. Beautiful meadows, hills, fields, and lush forests make this state an ideal playground for nature enthusiasts and those seeking a more rural lifestyle. All four seasons await those who are looking to escape climates that are too hot or cold for their comfort. </p>
			<p>Iowans welcome with open arms those who are looking to relocate for a better quality of life. The metro areas including Des Moines and Cedar Rapids are growing rapidly and jobs are being created at a fast rate as well. People looking to escape high cost of city living in urban areas are finding Iowa to be a nice place to call home.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Self-storage development has been surging from coast-to-coast, the heartland included. Iowa has seen an uptick in self-storage development, along with the rest of the country. In fact, construction spending on self-storage facilities is at record levels as self-storage companies seek to capture excess demand in markets of all sizes across the nation. Many self-storage developers are investing in new building new sites in Iowa, renovating and expanding existing facilities, as well as turning closed down big-box stores into state-of-the-art self-storage facilities. </p>
				<p>Below is an overview of the current state of the Iowa self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Iowa is home to about 547 self-storage facilities.',
					highlight: '547',
				},
				{
					fact: 'Iowa self-storage facilities cover 13,473,893 square feet of storage space.',
					highlight: '13,473,893',
				},
				{
					fact: 'Iowa storage facilities offer 4.34 square feet of storage per person, which is less than the national average of 5.4 square feet per person.',
					highlight: '4.34',
				},
				{
					fact: 'Average price of a self-storage unit in Iowa:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Des Moines',
				price: '0',
			},
			{
				city: 'Cedar Rapids',
				price: '0',
			},
			{
				city: 'Davenport',
				price: '0',
			},
			{
				city: 'Sioux City',
				price: '0',
			},
			{
				city: 'Iowa City',
				price: '0',
			},
			{
				city: 'Waterloo',
				price: '0',
			},
			{
				city: 'Dubuque',
				price: '0',
			},
			{
				city: 'Council Bluffs',
				price: '0',
			},
			{
				city: 'Ames',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>If you are planning on making a move soon, here is a list of reasons why you might want to consider Iowa:</p>',
			reasons: [
				'Iowa State Fair. This annual event in Des Moines is full of rides, games, food and fun for the whole family! Be sure to check out the tradition of the Butter Cow Sculpture. Since 1911, five different sculptors have gotten the honor of making the Butter Cow. The sculptors have also done companion sculptures for the Butter Cow including the Peanuts gang, John Wayne and Snow White and the Seven Dwarves to name a few.',
				'Nature. If you are a nature lover, Iowa has some gems for you. From grand lakes to caves and dense forests, there is plenty of fresh air, hiking, and spelunking to go around.',
				'Grotto of the Redemption. In West Bend, Iowa, Father Paul Daubberstein made a shrine of shells, rocks, and fossils to make up what is believed to be the largest grotto in the world. More than 100,000 people visit the grotto each year.',
				'If you build it, they will come. The popular baseball movie, Field of Dreams, was filmed at a house in Dyersville, Iowa. The house is open for tours and comes complete with a retail shop and has an option to rent out the whole house if you want to reenact the movie yourself.',
				'Organic farms. Iowa is 5th in the nation for the amount of organic farms it has. In 2016 there were 732 organic farms in Iowa and that trend is gaining momentum. Iowans certainly do care about their local, seasonal, and organic produce.',
				'Low cost of living. Iowa’s cost of living is well below the national average mostly due to the existence of quality, inexpensive housing. With the median home price currently sitting at $144,000, it’s easy to see why people want to make Iowa their new home.',
				'Safety. If you are looking for a place to live that gives you peace of mind when it comes to safety, you will be thrilled to learn that Iowa is the 6th safest state to live in the United States.',
				'Friendly folks. What they say about Midwestern hospitality is certainly true. Iowans are known for kind smiles and welcoming strangers with open arms.',
				'Business is good. Iowa has been listed as one of the best states in the nation to start a business. Low costs associated with taxes, utilities, and real estate makes the state perfect for the aspiring entrepreneur or business person looking to cut costs by moving location.',
				'Location. Iowa is bordered shares borders with Wisconsin, Illinois, Missouri, Nebraska, South Dakota and Minnesota. The centralized Midwestern location allows for quicker business travel and gives residents plenty of options for weekend trips.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Iowa had a population growth rate of 0.38% in 2019 and now has an estimated population of 3.17 million. That makes the state the 31st largest in terms of population. Iowa’s population is projected to grow to 3.32 million by 2030. Many entrepreneurs are moving to Iowa because the cost of starting a business there is below the national average. From 2000-2008, urban centers had a population increase of 8.5%, while the more rural communities had a loss of 4.2%.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Iowa has a diverse job market with the GDP reaching $157 billion in 2016. That accounts for .97% of the National GDP, setting its place as the 30th largest in the US. The unemployment rate is currently sitting at 2.5%, which is down one full percent from 2015.</p>
				<p>Below is a breakdown of Iowa's largest sectors by real value GDP added:</p>
			`,
			breakdown: [
				{
					sector: 'Manufacturing',
					value: '$32.9 billion',
				},
				{
					sector: 'Government',
					value: '$20.1 billion',
				},
				{
					sector: 'Real estate, rental and leasing',
					value: '$17.9 billion',
				},
				{
					sector: 'Finance and insurance',
					value: '$19.9 billion',
				},
				{
					sector: 'Agriculture, forestry, fishing and hunting',
					value: '$9.3 billion',
				},
			],
			bottomLine: `
				<p>Business showed signs of growth in 2018 by adding 11,200 jobs to the payroll. The manufacturing industry continues to show signs of strong growth, especially amongst the durable goods sector which accounts for big ticket items such as heavy machinery. BestPlaces.net rated Iowa’s overall cost of living at 89.5 out of 100, which means it has a lower cost of living than the national average.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Hy-Vee (Midwest Supermarket Chain)',
					employees: '85,000',
				},
				{
					employer: 'Casey’s General Stores',
					employees: '25,463',
				},
				{
					employer: 'Rockwell Collins',
					employees: '19,000',
				},
				{
					employer: 'Principal Financial Group',
					employees: '14,854',
				},
				{
					employer: 'University of Iowa',
					employees: '10,920',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Iowa rests in the middle of the nation and takes up a space of 56,273 square miles. The state stretches 200 miles wide and 310 miles long. It is the only state whose borders to the east and west are marked by rivers. The mighty Mississippi lays to the East, and the Big Sioux and Missouri Rivers lay to the West. The land is made up of green rolling hills and rich farmland.</p>
			`,
			cities: [
				{
					city: 'Des Moines',
					copy: '<p>The capital of Iowa is the most populated city in the state with an estimated 207,510 residents. It Is the 91st most populated metro area in the nation. Des Moines is home to many insurance company headquarters and financial institutions. The city gets its name from the Des Moines River, which means River of the Monks in French.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '10% lower than national average',
						},
						{
							item: 'Median home price',
							value: '$144,900',
						},
						{
							item: 'Average rent',
							value: '$657 per month',
						},
						{
							item: 'Average apartment size',
							value: '761 square feet',
						},
					],
				},
				{
					city: 'Cedar Rapids',
					copy: '<p>Cedar Rapids is the second most populous city in Iowa. The population is more than 128,429 and it is the county seat of Linn County. Cedar Rapids is home to the Mother Mosque of America, which is the oldest mosque in North America.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3% lower than national average',
						},
						{
							item: 'Median home price',
							value: '$132,600',
						},
						{
							item: 'Average rent',
							value: '$657 per month',
						},
					],
				},
				{
					city: 'Davenport',
					copy: '<p>Davenport is the third largest city in Iowa with 102,157 residents. The city is located on the Mississippi river, halfway between Des Moines and Chicago. The city is home to a large manufacturing industry that supports over 7,000 jobs.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3% lower than national average',
						},
						{
							item: 'Median home price',
							value: '$131,300',
						},
						{
							item: 'Average rent',
							value: '$905 per month',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'In order to get an Iowa driver’s license, you need to show proof of identity. A previous ID card along with a birth certificate, social security card and two pieces of mail showing your new Iowa address should suffice. After you pass a vision test and pay the fees, you will be able to receive your Iowa license.',
				link: 'https://iowadot.gov/mvd/driverslicense',
			},
			{
				title: 'Vehicle registration',
				copy: 'Within 30 days of moving to Iowa, you must register your vehicle with your county’s treasurer’s office. You will need to bring your ownership document with you and fill out the proper application for an Iowa certificate. Contact your county treasurer’s office for more info.',
				link: 'https://www.iowatreasurers.org/maphome.php',
			},
			{
				title: 'Voter Registration',
				copy: 'Once you get your driver’s license or Iowa Id number, you will be able to register to vote online. Once you submit your online registration, they will send you your voter ID card in the mail.',
				link: 'https://sos.iowa.gov/elections/pdf/voteapp.pdf',
			},
		],
		sources: [
			// static content
			'https://www.worldatlas.com/articles/the-biggest-cities-in-iowa.html',
			'https://www.zillow.com/des-moines-ia/home-values/',
			'https://www.payscale.com/cost-of-living-calculator/Iowa-Des-Moines',
			'https://www.rentcafe.com/average-rent-market-trends/us/ia/des-moines/',
			'https://en.wikipedia.org/wiki/Des_Moines,_Iowa',
			'https://www.payscale.com/cost-of-living-calculator/Iowa-Cedar-Rapids',
			'https://www.zillow.com/cedar-rapids-ia/home-values/',
			'https://www.rentjungle.com/average-rent-in-cedar-rapids-rent-trends/',
			'https://en.wikipedia.org/wiki/Davenport,_Iowa',
			'https://www.payscale.com/cost-of-living-calculator/Iowa-Davenport',
			'https://www.zillow.com/davenport-ia/home-values/',
			'https://iowadot.gov/mvd/driverslicense/MM935_NewToIowaFAQ.pdf',
			'https://www.rentjungle.com/average-rent-in-davenport-rent-trends/',
			'https://iowadot.gov/mvd/vehicleregistration/registering-a-vehicle',
			'https://iowadot.gov/mvd/driverslicense/new-iowa-residents',
			'https://sos.iowa.gov/elections/voterinformation/voterregistration.html',
			'https://www.deptofnumbers.com/gdp/iowa/',
			'https://www.bls.gov/eag/eag.ia.htm',
			'https://www.zippia.com/advice/largest-companies-in-iowa/',
			'https://worldpopulationreview.com/states/iowa-population/',
			'https://www.onlyinyourstate.com/iowa/10-reasons-move-to-ia/',
			'https://en.wikipedia.org/wiki/Grotto_of_the_Redemptionhttps://www.bestplaces.net/cost_of_living/state/iowa',
			'https://www.iowastatefair.org/about/butter-cow/',
			'https://www.iowadnr.gov/Places-to-Go/State-Parks/Iowa-State-Parks',
			'https://www.iowaworkforcedevelopment.gov/sites/search.iowaworkforcedevelopment.gov/files/documents/2018/iowaworkforceandtheeconomy_2019.pdf',
			'https://www.iowadatacenter.org/quickfacts',
		],
	},
	KS: {
		state: 'Kansas',
		stateNickname: 'Sunflower State',
		welcome: `
			<p>Head for the heartland and make a new home in Kansas. The Sunflower State lives up to its name as an agricultural powerhouse thanks to its rolling plans its known for–but Kansas is so much more. From vibrant small towns and even a slice of big city life in Wichita, this state offers a little something for everyone.</p>
			<p>With a foundation of solid Midwestern values, Kansas' reputation as an excellent place to raise family is growing. Considering its low cost of living, affordable home prices, proximity to top-rated educational institution and outdoor recreation it is surprising more people aren't choosing to call Kansas home. As for whatever is calling you, we think you may be on to something. Keep reading to learn more about moving to Kansas and see if its the right place for you.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Kansas has seen more self-storage development in recent years thanks to a wave of self-storage construction that has swept across the country. New development has been made possible by capital investment and financing flowing into the sector. A lack of new construction after the recession led to a shortage of self-storage space relative to population growth and natural demand for the product. That's created an opportunity in markets across the country to develop new self-storage facilities, and Kansas has proved to be no exception.</p>
				<p>Below are some statistics that provide an overview of the self-storage industry in Kansas:</p>
			`,
			facts: [
				{
					fact: 'Kansas is home to an estimated 560 self-storage facilities.',
					highlight: '560',
				},
				{
					fact: 'Kansas self-storage facilities cover 14,933,823 square feet of storage space.',
					highlight: '14,933,823',
				},
				{
					fact: 'Kansas storage facilities offer 5.18 square feet of storage per person, which is about on par to the national average of 5.4 square feet per person.',
					highlight: '5.18',
				},
				{
					fact: 'Average price of a self-storage unit in Kansas:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Wichita',
				price: '0',
			},
			{
				city: 'Topeka',
				price: '0',
			},
			{
				city: 'Overland Park',
				price: '0',
			},
			{
				city: 'Lawrence',
				price: '0',
			},
			{
				city: 'Kansas City',
				price: '0',
			},
			{
				city: 'Lenexa',
				price: '0',
			},
			{
				city: 'Manhattan',
				price: '0',
			},
			{
				city: 'Olathe',
				price: '0',
			},
			{
				city: 'Salina',
				price: '0',
			},
			{
				city: 'Dodge City',
				price: '0',
			},
			{
				city: 'Shawnee',
				price: '0',
			},
			{
				city: 'Garden City',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Looking for the heart of America? You'll find it in Kansas. Located in northern Kansas near the Nebraska border, Smith County is home to the geographic center of the lower 48 states. If that isn't enough of a reason to move to Kansas, see if any of the reasons below strike your fancy.</p>",
			reasons: [
				'A trifecta of pro sports. While there are no pro teams in Kansas, just across the eastern border is Kansas City, Missouri.  That city is home to three major pro sports teams: the Kansas City Chiefs football team, the Kansas City Royals baseball team, and the Sporting Kansas City pro soccer team.',
				"Everything is fresh from the farm. Kansas is located smack dab in America's heartland, which means fresh farmed food abounds. The best produce can be found at farmers' markets through out the state.",
				"The Midwest is friendlier. The people of Kansas are some of the nicest folks you'll ever meet. If you're looking for a place to make friends easily, then you are headed to the right place.",
				'Cost of living you can afford. Kansas has one of the lowest cost of living rates in the country, about 21 percent less than the national average. That makes it more affordable to buy a house, raise a family and retire!',
				"A rivalry like no other.  It's true Kansas doesn't have any major league teams of its own, but we do have the Kansas State University Wildcats and the University of Kansas Jayhawks. Both NCAA teams are major rivals in the Big 12 Conference, providing epic games all year long.",
				"Wichita means business. The state's largest city is a business and industrial hub for the Midwest. With a specialty in aeronautical engineering, the state is a major draw for those seeking high paying technical jobs.",
				'Home on the range. With only 34.9 people per square mile, Kansas is 40th in terms of population density. That means those seeking peace and quiet can find it here.',
				"Kansas keeps it weird. You'll soon grow accustomed to Kansas' quirky side once you get a chance to visit roadside attractions such as the World's Largest Collection of Smallest Versions of Largest Things, Truckhenge, The Giant Van Gogh Painting, and the Wizard of Oz Museum. And those are just the tip of the iceberg of all the strange museums and other oddities you'll encounter as a full-time resident.",
				"Outdoor fun. Kansas isn't all flat plains. The eastern third of the state is full of heavily forested rocky hill formations and other varied terrain. That provides plenty of opportunities for hunting, hiking, camping and other activities.",
				"Take a dip in the Big Pool. The Big Pool in Garden City, KS is as big as a football field and holds more than two million gallons of water. It's considered largest outdoor concrete public pool in the world! Get there while you can, as it may close in the future due to lack of funds to conduct expensive repairs.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Kansas is the 35th most populous state, with about 2.9 million people residing here. The population has grown modestly over the last few years, growing about 1.8 percent since 2010. The state covers more than 81,800 square miles making it the 13th largest in the nation. That means those who are seeking some peace and quiet can find it in Kansas, with a population density that is about half that of the United States' average overall. </p>
				<p>Within Kansas a phenomenon known as rural flight has contributed to the growth of the state's metropolitan cities. At the same time rural populations are shrinking and many small towns are fading away. If you are looking to become a Kansan, you'll have to decide if you want to live in the country or in one of its growing urban centers.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Kansas has a GDP of $172.5 billion, which is growing at an annual rate of 2.2 percent.  The state is home to some major corporations, including Sprint, AMC Theaters, and Koch Industries.  However, the median household income of $55,477 per year, which is a bit less than the national average of more than $60,000 a year. The good news is the state has a very low cost of living and also a low cost of doing business, which is both attracting new residents and businesses alike. The state of Kansas has a low unemployment rate of 3.2 percent, as of September 2019.</p>
				<p>These are the largest economic sectors in Kansas by GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Manufacturing',
					value: '$27.6 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$22.5 billion',
				},
				{
					sector: 'Real estate and rental and leasing',
					value: '$21 billion',
				},
				{
					sector: 'Healthcare and social assistance',
					value: '$13 billion',
				},
				{
					sector: 'Wholesale trade',
					value: '$11.3 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Spirit AeroSystems in Wichita',
					employees: '12,000',
				},
				{
					employer: 'Sprint Corporation in Overland Park',
					employees: '7,600',
				},
				{
					employer: 'Textron Aviation in Wichita',
					employees: '6,812',
				},
				{
					employer: 'General Motors in Kansas City',
					employees: '4,000',
				},
				{
					employer: 'Bombardier Aerospace in Wichita',
					employees: '3,500',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Kansas is the 15th largest state in the Union, covering more than 82,000 square miles. Contrary to popular belief, Kansas is not completely flat. The western two-thirds of the state are part of the Central Great Plains of the United States, but the eastern third is covered in hills and forests. The state itself is divided in a few different regions including the western High Plains region, the north central Smoky Hills, the Arkansas River Valley and the Red Hills in the south central part of the state, the Flint Hills and Osage Cuestas to the east, and the Glaciated Region in the northeast corner of the state.  However most people live in one of three following cities:</p>
			`,
			cities: [
				{
					city: 'Wichita',
					copy: "<p>With nearly 390,000 people, Wichita is the most populous city in Kansas, the 10th largest city in the Midwest, and the 51st largest city in the United States. The city is known as the Air Capital of the World, named for its long history and current place in aviation manufacturing. Also contributing to the city's sky high bonafides is nearby McConnell Air Force Base and the Wichita Dwight D. Eisenhower National Airport.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '8 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$170,000',
						},
						{
							item: 'Average rent',
							value: '$657 per month',
						},
						{
							item: 'Average apartment size',
							value: '792 square feet',
						},
					],
				},
				{
					city: 'Kansas City',
					copy: "<p>Don't confuse Kansas City, Kansas with Kansas City, Missouri. KCK, as locals call it, is the second largest city in Kansas with 150,000 residents. The city is located right next to the state line where Kansas City, MO is located. Unlike its larger neighbor to the east. KCK has a casino and NASCAR race track. Plus it has the best views of downtown KC-MO!</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '16 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$129,000',
						},
						{
							item: 'Average rent',
							value: '$1,069 per month',
						},
					],
				},
				{
					city: 'Topeka',
					copy: '<p>Topeka is the capital city of Kansas, and its third most populous with about 125,000 residents. The name is derived from a Kansa-Osage phrase that roughly translates to "a good place to dig for potatoes."  The city was founded in the 1850s as a ferry stop across the Kansas River as settlers made their way westward along the Oregon Trail. Today, Topeka is also known for its arts and culture institutions such as the Topeka Symphony Orchestra, Kansas Museum of History, and the Combat Air Museum.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: 'value',
						},
						{
							item: 'Median home price',
							value: 'value',
						},
						{
							item: 'Average rent',
							value: 'value',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Kansas need to get a Kansas driver's license within 90 days of establishing residency in the state. Apply for a Kansas license here.",
				link: 'https://www.ksrevenue.org/dovobtainingdl.html',
			},
			{
				title: 'Vehicle registration',
				copy: 'New Kansas residents also must register their vehicle within 90 days of becoming a Kansas resident.',
				link: 'https://www.ksrevenue.org/dovtitle.html',
			},
			{
				title: 'Voter Registration',
				copy: 'In Kansas, you must register three weeks (21 days) before Election Day. Register to vote in Kansas here.',
				link: 'https://sos.kansas.gov/elections/registration-voting/',
			},
		],
		sources: [
			// static content
			'https://www.kgs.ku.edu/Physio/physio.html',
			'https://en.wikipedia.org/wiki/Kansas',
			'https://worldpopulationreview.com/states/',
			'https://wichitaliberty.org/economics/kansas-gdp-2019-q2/',
			'https://en.wikipedia.org/wiki/Topeka,_Kansas',
			'https://en.wikipedia.org/wiki/Kansas#Topography',
			'https://en.wikipedia.org/wiki/Wichita,_Kansas#History',
			'https://www.kgs.ku.edu/Physio/physio.html',
			'https://homesteadontherange.com/2013/08/14/glaciated-region/',
			'https://en.wikipedia.org/wiki/Kansas_City,_Kansas',
			'https://www.payscale.com/cost-of-living-calculator/Kansas-Wichita',
			'https://www.zillow.com/wichita-ks/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ks/wichita/',
			'https://www.areavibes.com/kansas+city-ks/cost-of-living/',
			'https://www.payscale.com/cost-of-living-calculator/Kansas-Topeka',
			'https://www.zillow.com/topela-ks/home-values/',
			'https://www.rentjungle.com/average-rent-in-kansas-city-mo-rent-trends/',
			'https://www.rentjungle.com/average-rent-in-topeka-rent-trends/',
		],
	},
	KY: {
		state: 'Kentucky',
		stateNickname: 'Bluegrass State',
		welcome: `
			<p>Even those who’ve never set foot in the Bluegrass State probably know about two of Kentucky’s claims to fame: bourbon and horse racing. Those who live in the state know that, while 95 percent of the world’s bourbon supply flows through the state and the Kentucky Derby is widely considered the holy grail of U.S. horse racing, there’s much more to Kentucky.</p>
			<p>Kentucky is one of several states in America that has a broad identity due to its geography. According to the U.S. Census Bureau, Kentucky is considered part of the South. But, if you are viewing the state from the deep south — say Mississippi or Alabama — it’s part of the Midwest, or maybe even the North. Culturally, however, Kentucky resonates with Southern living, with its barbecue and laid-back, friendly vibe.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Kentucky has a growing population, which means it is an ideal market for self-storage developers. Self-storage construction has been ramping up to record high levels over the last few years, and that has resulted in more facilities being developed nationwide–Kentucky included. Developers have expanded the number of available self-storage units in the state by building new facilities from the ground up, as well as by renovating former retail big box stores. The increase in development has had a positive effect for consumers. By increasing supply, the monthly rental rates for storage has been on a downward trend.</p>
			`,
			facts: [
				{
					fact: 'Kentucky is home to more than 631 self-storage facilities',
					highlight: '631',
				},
				{
					fact: 'Kentucky facilities offer more than 18.4 million square feet of storage space combined.',
					highlight: '18,400,000',
				},
				{
					fact: "Kentucky has 4.21 square feet of storage space for every man, woman, and child. That's less than the national average of 5.4 square feet per capita.",
					highlight: '4.21',
				},
				{
					fact: 'Average price of a self-storage unit in Kentucky:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Lexington',
				price: '0',
			},
			{
				city: 'Lousiville',
				price: '0',
			},
			{
				city: 'Bowling Green',
				price: '0',
			},
			{
				city: 'Frankfort',
				price: '0',
			},
			{
				city: 'Paducah',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're thinking about making the move, but aren't sure if Kentucky is the right place for you, consider the following:</p>",
			reasons: [
				'The Kentucky Derby. Held the first Saturday of every May at Churchill Downs in Louisville, this 1¼ mile race features $2 million in prize money that attracts the best horses, trainers, and jockeys in the nation. The event, which is part of the Triple Crown of horse racing, also attracts visitors who like to play the horses and revel in Derby style. The whole state gets excited for this event, which is often referred to as the most exciting two minutes in sports.',
				"Bourbon. All those Derby partiers get thirsty, and the drink of choice is the Mint Julep. And, the main ingredient of this quintessential Kentucky cocktail is bourbon.  The state has 68 distilleries devoted to producing bourbon, and many say it's the ideal combination of climate, conditions, and naturally limestone-rich water that makes the spirit so unique. Kentucky bourbon is tasty served on its own, but to make the Derby day drink, mix it with sugar, water, ice, and fresh mint.",
				'Kentucky barbecue. When many people think about barbecue, pork, beef, or chicken often come to mind. Kentucky has plenty of these meat options to offer but adds mutton as its unique barbecue meat. Mutton is the name for older sheep, and its use in Kentucky barbecue followed a wool production boom in the early 1800s. The meat has a deeply rich flavor, but can be chewy and gamey when cooked quickly. Low and slow barbecue and an acidic sauce combine for a barbecue experience like no other.',
				'The Hot Brown. Kentucky cuisine has more to offer than regional barbecue. One of the most famous culinary creations in the Bluegrass State is the Hot Brown, an open-faced turkey and bacon sandwich that is covered in Mornay cheese sauce and broiled crisp. It’s been a popular dish for a century, but it’s hard to find it on any restaurant menus outside of Kentucky.',
				'Bluegrass. Now, you may be wondering why Kentucky is referred to as the Bluegrass State. The term is not a direct reference to the style of music, but a nod to a particular type of grass found in Kentucky. This grass is not blue, but early settlers to the area thought it had a peculiar blue-green tint in the sun. Bluegrass music is an American roots music genre that originated in Kentucky in the 1940s.',
				'Friendly faces. Another name for Kentucky could be the Friendly State, as its residents are well-known for being polite. Kentucky’s laid back vibe has also helped make it a retirement-friendly state, but the low taxes and deductions of seniors have helped, too.',
				'Fort Knox. This army post south of Louisville contains the United States Bullion Depository, which houses much of the nation’s gold reserves — valued at over $6 billion. It is an interesting fact about Kentucky but is not a tourist destination, as the gold depository is one of the most secure facilities in the world, and visitors are not permitted.',
				'Cumberland Falls. Dubbed the “Niagara of the South,” Cumberland Falls is a 60-foot tall waterfall on the Cumberland River. It’s a breathtaking piece of nature, deep inside a vast area filled with outdoor activities for residents and tourists alike. It’s also one of the few places in the world where people can witness a moonbow — which is like a rainbow but is formed from the reflection of moonlight on water droplets misted from the falls.',
				'Rock climbing. Kentucky is also known for its sandstone mountains and cliffs. Actually, these rock formations are the top edges of the Cumberland Plateau. This sandstone is the preferred climbing surface for rock climbing enthusiasts. Popular climbing spots include the Red River Gorge, Morehead, and the Rockcastle River watershed.',
				'The Wildcats.  The University of Kentucky’s men’s basketball team, the Wildcats, has the most victories in NCAA Division I. So, the team is a big deal in Kentucky and throughout neighboring states as well.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Kentucky is the 37th largest state by size, covering approximately 39,732 square miles. It ranks as the 26th largest state by population, with an estimated 4.5 million residents. This combination means that Kentucky is comfortably populated, so you have a lot of room in the Bluegrass State, but not so much that you’ll get lonely.</p>
				<p>Kentucky has shown modest population growth from 2018 to 2019 of .35%. The rural areas of the state have experienced a net loss in population, while some of the more urban areas are seeing continued growth.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Kentucky’s gross domestic product (GDP) is roughly $173 billion, a 4.38% increase over the past five years. This makes Kentucky the 29th largest state economy in the nation. Growth is steady, but the per capita GDP of $38,985 is considerably lower than the US average of $50,577.</p>
				<p>The unemployment rate in Kentucky was recently 4.4%, which is slightly higher than the national average of 3.6%. Over the period from December 2015 to August 2019, Kentucky added about 50,000 non-farming jobs. That figure is also proportionately lower than the national average but is better than neighboring Ohio and West Virginia.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'UPS',
				},
				{
					employer: 'Ford Motor Company',
				},
				{
					employer: 'GE Appliances',
				},
				{
					employer: 'Norton Healthcare',
				},
				{
					employer: 'Humana Inc.',
				},
				{
					employer: 'Yum! Brands',
				},
				{
					employer: 'LG&E and KU Energy',
				},
				{
					employer: 'Tyson Foods',
				},
				{
					employer: 'Kroger Co.',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Most of the state’s economic activity is in Louisville and the northern tier of the state, as much of the eastern side of the state is rural Appalachia. But, the central part of the state includes a major metropolitan area at Lexington, and Bowling Green on the south also is a thriving community.</p>
				<p>Here’s a quick look at the state’s three largest cities:</p>
			`,
			cities: [
				{
					city: 'Louisville',
					copy: '<p>Louisville has a population of 620,000, which is a huge number compared to other cities in the state. The state only has one other metropolitan area with more than 100,000 residents. The average salary in the city is $60,000, which is roughly on par with the national average. The biggest employers include Humana, Inc., General Electric, University of Louisville, and UPS.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '8 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$164,500',
						},
						{
							item: 'Average rent',
							value: '$977',
						},
						{
							item: 'Average apartment size',
							value: '931 square feet',
						},
					],
				},
				{
					city: 'Lexington',
					copy: '<p>Located about 80 miles southeast of Louisville is Kentucky’s second most populous city, Lexington. The city of 321,000 residents, like its larger neighbor, has a strong connection to horse farms and thoroughbred racetracks. It is also home to the Kentucky Horse Park, with the International Museum of the Horse. But, the economy in Lexington goes beyond the equestrian. Major employers include the University of Kentucky, Lockheed Martin Corp., and Lexmark.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '4 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$186,500',
						},
						{
							item: 'Average rent',
							value: '$916',
						},
						{
							item: 'Average apartment size',
							value: '899 square feet',
						},
					],
				},
				{
					city: 'Bowling Green',
					copy: '<p>Bowling Green is in southern Kentucky, closer to Nashville, Tennessee, than it is to Louisville.  This city, with approximately 60,000 residents, has seen the population grow in recent years. It is, however, mostly considered a growing retirement destination due to a lower cost of living and laid back lifestyle. Employment opportunities are primarily in the healthcare field, with the largest employers, including the Medical Center at Bowling Green, Graves Gilbert Clinic, and Greenville Regional Hospital.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '8 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$185,800',
						},
						{
							item: 'Average rent',
							value: '$823',
						},
						{
							item: 'Average apartment size',
							value: '882 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents who possess a driver’s license from another state must obtain a Kentucky license within 30 days of establishing residency. If your license is valid in your previous state, there are no testing requirements.',
				link: 'https://drive.ky.gov/driver-licensing/Pages/Drivers-License-and-ID-Card.aspx',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents of Kentucky must register their vehicle within 45 days of moving to Kentucky.',
				link: 'https://transportation.ky.gov/Organizational-Resources/Forms/TC%2096-182.pdf',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Kentucky, you must be a citizen of the United States, be 18 years of age or older on or before the date of the next election, and must be a resident of the state.',
				link: 'https://elect.ky.gov/registertovote/Pages/default.aspx',
			},
		],
		sources: [
			// static content
			'https://kybourbon.com/bourbon_culture-2/key_bourbon_facts/',
			'https://www.foodrepublic.com/2012/03/13/a-year-of-barbecue-kentucky-mutton/',
			'https://www.usmoneyreserve.com/blog/how-much-gold-is-in-fort-knox-fun-fort-knox-facts/',
			'https://www.treasury.gov/about/education/Pages/fort-knox.aspx',
			'https://home.army.mil/knox/index.php/about/visitor-information',
			'https://smartasset.com/retirement/kentucky-retirement-taxes',
			'https://inside.fei.org/news/bluegrass-isn%E2%80%99t-blue-it',
			'https://www.kentuckytourism.com/ky-taste/culinary-trails/western-kentucky-bbq/',
			'https://www.theringer.com/pop-culture/2017/8/21/16169944/sorry-your-state-is-not-southern-south-package',
			'https://www.americasbestracing.net/the-sport/2019-top-five-horse-racing-events-us',
			'https://parks.ky.gov/parks/resortparks/cumberland-falls/',
			'https://www.mountainproject.com/area/105868674/kentucky',
			'https://worldpopulationreview.com/states/kentucky-population/',
			'https://www.deptofnumbers.com/gdp/kentucky/',
			'https://www.courier-journal.com/story/news/politics/elections/kentucky/2019/10/31/kentucky-election-fact-checking-bevin-beshear-job-growth/2498546001/',
			'https://www.payscale.com/research/US/Location=Louisville-KY/Salary',
			'https://www.payscale.com/research/US/Location=Bowling-Green-KY/Salary',
		],
	},
	LA: {
		state: 'Louisiana',
		stateNickname: 'Pelican State',
		welcome: `
			<p>Louisiana, also known as The Pelican State, is the 25th most populous state in the US with a population of more than 4.6 million people. Located in the southeastern part of the country, Louisiana is essentially a blend of different cultures like African, French, French-Canadian, and modern American. The state is famous for the Mardi Gras festival, the Creole and Cajun culture, jazz music, and the unique and delectable food.</p>
			<p>Louisiana's major industries include natural gas, agriculture, oil, commercial fishing, and chemicals. The state is the country's biggest producer of salt and it's the nation's second-largest seafood supplier of crawfish, oysters, fish, crabs, and shrimp.</p>
			<p>Louisiana is filled with state parks and wartime exhibits, but some of the top attractions in The Pelican State include the French Quarter, the Louisiana Purchase Gardens and Zoo, the National WWII Museum, Bourbon Street, Jackson Square, Oak Alley Plantation, Audubon Aquarium of the Americas, Mardi Gras World, and City Park.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Louisiana self-storage industry is letting the good times roll as more investment pours into the sector than ever before. A nationwide trend of self-storage development as been ongoing for the last several years, which has led storage operators and developers to build new facilities throughout the state wherever they can find a suitable site. This includes the conversion of vacant retail strip center stores and other derelict properties into storage facilities.</p>
			`,
			facts: [
				{
					fact: 'Louisiana is home to more than 947 self-storage facilities',
					highlight: '947',
				},
				{
					fact: 'Louisiana facilities offer more than 30,507,046 million square feet of storage space combined.',
					highlight: '30,507,046',
				},
				{
					fact: "Louisiana has 6.58 square feet of storage space for every man, woman, and child. That's more than the national average of 5.4 square feet per person.",
					highlight: '6.58',
				},
				{
					fact: 'Average price of a self-storage unit in Louisiana:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'New Orleans',
				price: '0',
			},
			{
				city: 'Baton Rouge',
				price: '0',
			},
			{
				city: 'Lafayette',
				price: '0',
			},
			{
				city: 'Shreveport',
				price: '0',
			},
			{
				city: 'Bossier City',
				price: '0',
			},
			{
				city: 'Lake Charles',
				price: '0',
			},
			{
				city: 'Metairie',
				price: '0',
			},
			{
				city: 'Slidell',
				price: '0',
			},
			{
				city: 'Kenner',
				price: '0',
			},
			{
				city: 'Alexandria',
				price: '0',
			},
			{
				city: 'Gonzales',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Thinking about moving to the Pelican State, but aren't sure if it would be a good fit for you? Check out our top 10 reasons to move to Louisiana to help you make the right decision.</p>",
			reasons: [
				"The Big Easy. New Orleans provides a number of entertainment options, including the famous French Quarter and Bourbon Street, award-winning restaurants, swamp and ghost tours, museums, zoos, dinner cruises, and more. There's no shortage of fun and entertaining things to do in New Orleans.",
				"Mardi Gras. If you're thinking of moving to Louisiana, you'll be able to enjoy the Mardi Gras festival right in your own backyard every February. Enjoy the great food and live music and other related festivities when you go.",
				"Festivals for everything. In New Orleans, you'll find a festival to celebrate almost everything. You can look forward to festivals like the Louisiana Shrimp & Petroleum Festival in Morgan City, the New Orleans Jazz & Heritage Festival, Shreveport's Red River Revel, and the Ponchatoula Strawberry Festival, among others.",
				"The people. Let's face it. People in New Orleans know how to celebrate and who doesn't want to be close to all of that excitement all year round? Living in Louisiana means being invited to your new friend's crawfish boil or a weekend festival that's everything you thought it would be and more.",
				"Foodie friendly. The Pelican State is a melting pot of culinary cuisine. Expect the very best when you move to Louisiana, with dishes like gumbo, crawfish, red beans and rice, jambalaya, and shrimp étouffée being served all over town. You'll get a ton of Creole and Cajun offerings, including some of the most delectable pastries like beignets, King Cakes, and pralines.",
				"Great for football fans. While New Orleans is home to the NBA Pelicans, it's probably already been agreed upon by everyone you'll ever know from Louisiana (or any southern state for that matter) that football is king. New Orleans residents are devout Saints fans and you'll likely become one too if you move here.",
				"Great live music. Louisiana's rich musical heritage encompasses a variety of different sounds, including Cajun, blues, jazz, rock 'n' roll, and Zydeco. The New Orleans Jazz & Heritage Festival attracts the biggest names in all genres of music during April and early May.",
				"Riverboat gambling. Ever been gambling on a riverboat? Our guess is you probably haven't, but moving to Louisiana means you'll definitely get the chance. Casinos and riverboat gambling are pretty prominent throughout the city of Shreveport.",
				'Great for bike riding. Looking to get your daily exercise in? Bike riding is a great way to do it, especially through the gorgeous national parks, like Lincoln Parish Park, Kisatchie National Forest, or Hodges Gardens State Park.',
				"Great educational institutions. If you're thinking of going back to school or have children entering college sometime soon, Louisiana is a great place to get an education. It has a large selection of top-rated colleges and universities to choose from sprinkled all throughout the state, including Louisiana State University (Baton Rouge), Tulane and University of New Orleans.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Louisiana has a population of more than 4.6 million people and ranks as the 25th largest state in the country by population. Between 2018 and 2019, Louisiana's population decreased by 0.16 percent. According to Business Report, Louisiana's population shrunk at the 7th fastest rate in the country. The main reason people seem to be leaving is a lack of jobs since Hurricane Katrina. Despite the booming US economy, Louisiana hasn't seen nearly as much growth as the country as a whole. However, that means that there's plenty of room for Louisiana to bounce back and for new residents to benefit as a result.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>In 2018, Louisiana had a GDP of $255.5 billion. The state's unemployment rate is 4.3 percent as of September 2019.</p>
				<p>Below is a breakdown of the top five sectors in Louisiana by real value added GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Manufacturing',
					value: '$47.71 billion',
				},
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$31.37 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$24.29 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$20.23 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$19.89 billion',
				},
			],
			bottomLine: `
				<p>Louisiana is expected to add 53,800 jobs through 2020 and 2021 (mostly in New Orleans and Lafayette) and the tariff issue with China is expected to be resolved before the 2020 national elections, which will give the national economy a boost. Also, an end to the lull in industrial construction will bring new jobs to the New Orleans metro area. A few construction projects starting up soon could help improve things even more for the state. Federal regulators have okayed construction on the Calcasieu Pass LNG export facility and TransCameron Pipeline, which will create about 1,500 temp jobs during the season and 130 permanent jobs.</p>
				<p>Louisiana has a cost of living score of 95.5, meaning it's cheaper to live in the state than it is to live in the US as a whole. Also, the cost of groceries, health, and housing are also below the national average.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'CenturyLink',
					employees: '39,800',
				},
				{
					employer: 'Ochsner Health System',
					employees: '19,000',
				},
				{
					employer: 'Odyssea Marine',
					employees: '17,000',
				},
				{
					employer: 'Amedisys',
					employees: '16,000',
				},
				{
					employer: 'Entergy',
					employees: '13,513',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Louisiana is roughly 52,271 square miles and is home to more than 4.6 million people. The largest three cities include New Orleans, Baton Rouge, and Shreveport.</p>
			`,
			cities: [
				{
					city: 'New Orleans',
					copy: '<p>New Orleans, also known as "The Big Easy," is the largest city in Louisiana with a population of 396,766 people. New Orleans has a lot to offer, including the French Quarter, Bourbon Street, the National WWII Museum, Garden District, Jackson Square, New Orleans City Park, the Audubon Zoo. Theremare plenty of activities as well, including nightlife, cruises, tours, museums, parks, and sightseeing.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '2 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$178,600',
						},
						{
							item: 'Average rent',
							value: '$1,170 per month',
						},
						{
							item: 'Average apartment size',
							value: '897 square feet',
						},
					],
				},
				{
					city: 'Baton Rouge',
					copy: '<p>Baton Rouge, the state capital, is the second-largest city in Louisiana with a population of 225,900. Located on the Mississippi, the city is brimming with culture and history with its Cajun and Creole roots. There\'s a ton to do in the "Red Stick City," including going to parks, museums, sports games, nightlife, shopping, restaurants, tours, casinos, concerts and shows, and various sights and landmarks.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '4 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$163,000',
						},
						{
							item: 'Average rent',
							value: '$1,018 per month',
						},
						{
							item: 'Average apartment size',
							value: '940 square feet',
						},
					],
				},
				{
					city: 'Shreveport',
					copy: '<p>Shreveport is the third-largest city in Louisiana with a population of 188,206 people. The city is a blend of Cajun and Creole traditions with traditional Southern culture thrown into the mix. Located on the banks of the Red River, Shreveport has plenty to do to keep yourself entertained, including parks, museums, zoos, nightlife, shopping, outdoor activities, tours, and concerts and shows.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '9 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$160,000',
						},
						{
							item: 'Average rent',
							value: '$972 per month',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Louisiana are required to transfer their out of state driver's license within 30 days of moving to the state. You'll have to appear in person at your local Office of Motor Vehicles and bring your out of state license, two forms of ID, social security verification, proof of insurance, and proof of residency. Minors require a legal guardian with a picture ID and a completed Certificate of Required School Attendance from their school. For more info, visit:",
				link: 'https://www.expresslane.org/Pages/faqs/dl_q17.aspx',
			},
			{
				title: 'Vehicle registration',
				copy: "Once you transfer your out of state license to Louisiana, you'll have to register your out of state vehicle within 30 days as well. Fill out all required documentation from your local Office of Motor Vehicles. You'll also be required to pay any associated vehicle registration and title fees. Once filled out, submit them to Headquarters. For more info, visit:",
				link: 'https://www.expresslane.org/Pages/faqs/tar_q4.aspx',
			},
			{
				title: 'Voter Registration',
				copy: "To register to vote in Louisiana as a new resident, you'll need a Louisiana state driver's license. You can fill out the application online or download an application, print it out, fill it out, and return it to the Office of Motor Vehicles. There's an audit code on your Louisiana driver's license that you'll need to enter when you apply online. It's a four-digit number labeled AUDIT on the front of your license. For more info, visit:",
				link: 'https://www.sos.la.gov/ElectionsAndVoting/Pages/OnlineVoterRegistration.aspx',
			},
		],
		sources: [
			// static content
			'https://travel.usnews.com/New_Orleans_LA/Things_To_Do/',
			'https://worldpopulationreview.com/states/louisiana-population/',
			'https://pelicaninstitute.org/blog/its-no-secret-why-people-are-leaving-louisiana/',
			'https://www.businessreport.com/article/louisiana-population-decling',
			'https://www.businessinsider.com/the-top-10-states-people-are-moving-out-of-us-2019-5#8-maryland-lost-16438-residents-between-2016-and-2017-3',
			'https://www.bls.gov/eag/eag.la.htm',
			'https://www.statista.com/statistics/1064986/louisiana-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-louisiana/',
			'https://www.lsu.edu/business/newsevents/2019/9-september/2020-21-louisiana-economic-outlook-released.php',
			'https://www.kiplinger.com/slideshow/business/T019-S010-kiplinger-economic-outlook-for-all-50-states-2020/index.html',
			'https://www.bestplaces.net/cost_of_living/state/louisiana',
			'https://www.tripadvisor.com/Attractions-g60864-Activities-New_Orleans_Louisiana.html',
			'https://realestate.usnews.com/places/louisiana/shreveport',
			'https://www.tripadvisor.com/Attractions-g40424-Activities-Shreveport_Louisiana.html',
			'https://www.expresslane.org/Pages/faqs/tar_q4.aspx',
			'https://www.expresslane.org/Pages/faqs/dl_q17.aspx',
			'https://www.sos.la.gov/ElectionsAndVoting/Pages/OnlineVoterRegistration.aspx',
			'https://www.coolkidfacts.com/louisiana-facts/',
			'https://worldpopulationreview.com/states/louisiana-population/cities/',
			'https://livability.com/la/real-estate/8-reasons-to-move-to-louisiana',
			'https://www.allaroundmoving.com/why-move-to-louisiana/',
			'https://www.trustedchoice.com/insurance-articles/moving/moving-to-louisiana',
			'https://www.payscale.com/cost-of-living-calculator/Louisiana-New-Orleans',
			'https://www.zillow.com/new-orleans-la/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/la/new-orleans/',
			'https://www.payscale.com/cost-of-living-calculator/Louisiana-Baton-Rouge',
			'https://www.zillow.com/baton-rouge-la/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/la/east-baton-rouge-county/baton-rouge/',
			'https://www.payscale.com/cost-of-living-calculator/Louisiana-Shreveport',
			'https://www.zillow.com/shreveport-la/home-values/',
		],
	},
	ME: {
		state: 'Maine',
		stateNickname: 'Pine Tree State',
		welcome: `
			<p>As the northernmost state in the New England region, Maine is bordered by New Hampshire, the Atlantic Ocean, and two Canadian provinces (New Brunswick and Quebec). It’s the only U.S. state that is only bound by one other state. The coast of Maine is hauntingly jagged and rocky, which has made it the focus of numerous poems and stories. With a humid continental climate, the summers here are typically warm while the winters are cold and snowy.</p>
			<p>Although Augusta is the state capital, Portland is nearly three times as big and more popular among visitors. Maine is a highly nautical state, having a deeply-rooted history in shipbuilding and fishing. Lighthouses and shipyards line the coast, giving the state it’s picturesque ocean-loving appearance.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Maine has enjoyed some steady population growth recently, and as a result is attracting more self-storage development and investment activity. In fact, a nationwide wave of new self-storage development is leaving just about no part of the country untouched as money pours into the sector. That's led to an uptick in new self-storage facilities in Maine.</p>
			`,
			facts: [
				{
					fact: 'Maine is home to more than 211 self-storage facilities',
					highlight: '211',
				},
				{
					fact: 'Maine facilities offer more than 3,855,227 million square feet of storage space combined.',
					highlight: '3,855,227',
				},
				{
					fact: "Maine has 2.96 square feet of storage space for every man, woman, and child. That's less than the national average of 5.4 square feet per person.",
					highlight: '2.96',
				},
				{
					fact: 'Average price of a self-storage unit in Maine:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Portland',
				price: '0',
			},
			{
				city: 'Augusta',
				price: '0',
			},
			{
				city: 'Bangor',
				price: '0',
			},
			{
				city: 'Lewiston',
				price: '0',
			},
			{
				city: 'Bar Harbor',
				price: '0',
			},
			{
				city: 'South Portland',
				price: '0',
			},
			{
				city: 'Freeport',
				price: '0',
			},
			{
				city: 'Biddeford',
				price: '0',
			},
			{
				city: 'Kittery',
				price: '0',
			},
			{
				city: 'Kennebunkport',
				price: '0',
			},
			{
				city: 'Topsham',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			reasons: [
				'Economic dynamics. Most of Maine’s cities have built their economy on mid-size and private companies, making professionals everyday sort of people. If you want to play a significant part in your area’s finances, Maine is the place to be an economic pillar.',
				'The white pines. Maine is known as “The Pine Tree State” because of its lush inland forests filled with eastern white pine. Although large swaths of these gorgeous woodlands were damaged by heavy logging a few centuries ago, a more serene site than the tall pines of Maine does not exist.',
				'Oceanside lifestyle. Whether it’s hitching a boat ride with a seafaring friend or letting your toes sink into the warm sand on a summer’s day, the Atlantic Ocean offers plenty of satisfaction. In Maine, you can have that sort of lifestyle.',
				'The lobster shacks. Mainers claim that you can have lobster rolls every day for lunch and never grow tired of them. The lobster is that good! Remember, you can’t judge the taste of the food by the shabbiness of the shack, either.',
				'Diverse cuisine. Aside from the lobster, Maine offers plenty of unique eating opportunities. It’s even been said that Portland offers more restaurants per capita than New York City. If you’re a foodie, you won’t be disappointed in The Pine Tree State.',
				'Peaceful country. When you’re not enjoying a seaside shanty or big city conveniences, the countryside in Maine is some of the most beautiful in the U.S. With acres of tranquil forests and a crisp, coastal line; you’re sure to reclaim your calm here.',
				'Acadia National Park. Tucked away near the town of Bar Harbor, this 47,000-acre national park is home to some of the best hiking, kayaking, and adventuring in the country. The views are breathtaking, and the seasons change the scenery so often that it feels like four parks in one.',
				'Backyard Wildlife. When was the last time a moose crossed the highway on your way to work? In Maine, it’s a very likely scenario. The wildlife here includes an array of rare birds, bears, and you can even spot whales off the coast.',
				'The sea glass. Plenty of beaches are optimal for sea glass hunting, but Maine’s coast has a uniqueness to it. Some beaches are several nautical miles offshore, so your treasures can genuinely be kept a secret. Looking in the morning or evening will land you the most sea glass finds.',
				'Festivals and fairs. This likes to celebrate numerous occasions with festivals galore. And local fairs are sure to drum up some excitement for Mainers, too. The best part is that most of its celebrations surround food!',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Maine is the 42nd most populated state in the U.S., with only 1,338,404 individuals calling it home. Maine experienced a slow and steady growth of .28% from 2018 to 2019. These numbers represent about 1,000 new residents per year since the census in 2010. Strangely enough, this state is one of two where deaths outnumbered births in recent years. However, more people are still moving to Maine than leaving, which is offsetting the mortality rate. Cities, such as Portland and the Lewiston-Auburn area, have experienced the most growth.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Much like its population growth, Maine’s economic increase has been on a steady incline, landing its GDP at $66.5 billion. Nicknamed “The Pine Tree State” for its vast forests, the production of paper and wood products remains the most valuable of all manufacturers in Maine. As of September 2019, Maine’s unemployment rate experienced a favorable downtick to 2.9%.</p>
				<p>Since the recession of 2008, Maine’s economy has never looked better. Even though most of the state’s residents would enjoy seeing a quicker and more significant uptick in Maine’s financials, the forecast is more slow and steady. Unlike other states, Maine has very few massive companies with headquarters in the state. Instead, major cities depend on a firm professional culture made up of mid-size and privately owned businesses.</p>
				<p>The natural beauty of Maine’s forests and coastline encourages over 70% of its residents to buy rather than rent. Of course, housing costs vary from city to city, but the overall cost of living score in Maine is 104.7, which is slightly higher than the national average. Utilities, transportation, and healthcare are relatively low, but food prices tend to fall on the top side.</p>
				<p>Below is a breakdown of Maine’s largest sectors by real value added of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$13.9 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$9.3 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$8.6 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$6.6 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$5.3 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'MaineHealth',
					employees: '18,000',
				},
				{
					employer: 'Hannaford Bros Co.',
					employees: '8,500',
				},
				{
					employer: 'WalMart',
					employees: '7,000',
				},
				{
					employer: 'Bath Iron Works Corp.',
					employees: '6,000',
				},
				{
					employer: 'L.L. Bean, Inc.',
					employees: '5,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Of Maine’s 30,865 square miles of breathtaking white pines and jagged coastline, most Mainers choose to abide in Portland. However, several other cities make excellent places to set up camp. Here are three that top the list:</p>
			`,
			cities: [
				{
					city: 'Portland',
					copy: '<p>This city is filled with culinary diversity, lined with historic cobblestone streets, and it features a vibrant ocean setting lifestyle. With a population of 66,417, most individuals claim to enjoy living here for the reasons mentioned above. However, apartment hunting and winter parking bans top the list of disadvantages.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '13% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$310,100',
						},
						{
							item: 'Average rent',
							value: '$1,409/month',
						},
						{
							item: 'Average apartment size',
							value: '703 square feet',
						},
					],
				},
				{
					city: 'Lewiston',
					copy: '<p>Lewiston lies inland from Portland about 30 miles and is well-known for having a low crime rate. The population hovers around 36,000, with living costs being lower than the national average. It boasts of outdoor recreational activities and an attractive setting. Since it’s so intertwined with the nearby city of Auburn, it’s often referred to as the Lewiston-Auburn area.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$152,100',
						},
						{
							item: 'Average rent',
							value: '$780/month',
						},
						{
							item: 'Average apartment size',
							value: '700 square feet',
						},
					],
				},
				{
					city: 'Bangor',
					copy: '<p>With a slightly lower population than Lewiston, 32,695 individuals call Bangor home. The city has a strong sense of community, a quaint downtown, and is home to the University of Maine. Bangor has so much to offer; it’s listed as one of the top 100 best places to live in the U.S.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: 'the same as the national average',
						},
						{
							item: 'Median home price',
							value: '$153,600',
						},
						{
							item: 'Average rent',
							value: '1,042/month',
						},
						{
							item: 'Average apartment size',
							value: '1,087 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'After becoming a resident of Maine, you have 30 days to convert your license by visiting the nearest Bureau of Motor Vehicles office. You’ll need to provide proof of legal presence and Maine residency, surrender your out-of-state license, complete a vision screening, and pay the appropriate fees.',
				link: 'https://www.maine.gov/sos/bmv/licenses/convert.html',
			},
			{
				title: 'Vehicle registration',
				copy: "Again, you have a 30-day grace period to convert your vehicle registrations and titles to Maine. You can complete the conversion by visiting your Maine municipal office. There, you'll need to surrender your out-of-state title and registration and show proof of insurance. In addition to the appropriate fees, you’ll be required to pay an excise tax, which will also be collected annually, too.",
				link: 'https://www.maine.gov/sos/bmv/registration/passenger.html#pconvert',
			},
			{
				title: 'Voter Registration',
				copy: 'Registering to vote in Maine is an in-person versus an online process, although you can mail your registration cards. Otherwise, you can register at your city hall, Motor Vehicle branch office, social services agencies, or at a voter registration drive.',
				link: 'https://www.maine.gov/sos/cec/elec/voter-info/voterguide.html',
			},
		],
		sources: [
			// static content
			'https://en.wikipedia.org/wiki/Maine',
			'https://simple.wikipedia.org/wiki/List_of_U.S._states_by_population',
			'https://worldpopulationreview.com/states/',
			'https://www.newscentermaine.com/article/news/local/maine-census-numbers-show-state-is-growing/97-fa71946a-f6f1-4e31-a796-e113fed7cca3',
			'https://www.usgovernmentspending.com/compare_state_spending_2019bZ0a',
			'https://www.bls.gov/eag/eag.me.htm',
			'https://bangordailynews.com/2019/01/07/business/what-to-expect-from-maines-economy-in-2019/',
			'https://www.mainehomeconnection.com/MaineEconomy',
			'https://www.maine.gov/labor/cwri/publications/pdf/MaineTop50Employers.pdf',
			'https://smartasset.com/mortgage/what-is-the-cost-of-living-in-maine',
			'https://www.bestplaces.net/cost_of_living/state/maine',
			'https://statesymbolsusa.org/symbol-official-item/national-us/uncategorized/states-size',
			'https://wjbq.com/7-reasons-you-shouldnt-move-to-portland-maine-from-someone-who-loves-it-here/',
			'https://www.bestplaces.net/city/maine/lewiston',
			'https://livability.com/best-places/top-100-best-places-to-live/2019/me/bangor',
			'https://www.payscale.com/cost-of-living-calculator/Maine-Portland',
			'https://www.salaryexpert.com/cost-of-living/united-states/maine/lewiston',
			'https://www.bestplaces.net/cost-of-living/bangor-me/portland-me/50000',
			'https://www.zillow.com/portland-me/home-values/',
			'https://www.zillow.com/lewiston-me/home-values/',
			'https://www.zillow.com/bangor-me/home-values/',
			'https://www.areavibes.com/bangor-me/cost-of-living/',
			'https://www.rentjungle.com/average-rent-in-portland-me-rent-trends/',
			'https://www.rentjungle.com/average-rent-in-lewiston-me-rent-trends/',
			'https://www.rentjungle.com/average-rent-in-bangor-me-rent-trends/',
			'https://www.maine.gov/sos/bmv/licenses/convert.html',
			'https://www.maine.gov/sos/bmv/registration/passenger.html#pconvert',
			'https://www.maine.gov/sos/cec/elec/voter-info/voterguide.html',
			'https://integritymovers.com/8-reasons-move-maine-year/',
			'https://statesymbolsusa.org/symbol-official-item/maine/state-tree/white-pine',
			'https://www.onlyinyourstate.com/maine/10-beaches-for-sea-glass-me/',
		],
	},
	MD: {
		state: 'Maryland',
		stateNickname: 'Old Line State',
		welcome: `
			<p>When most people think of Maryland, a few images commonly come to mind: crabs, the Chesapeake Bay, Baltimore’s harbor, and proximity to Washington, D.C. Okay, and probably The Wire, too.</p>
			<p>Maryland is a small Mid-Atlantic state, but it holds a key spot in our nation’s history, The state can technically be considered part of the south, as the Mason-Dixon Line is on the state’s northern border, but its culture is more closely associated with the heart of the nation’s capital. In fact, two of Maryland’s cities — Baltimore and the state capital of Annapolis — served as the nation’s capital at one time. And, the land where Washington, D.C. is located was donated by the state.</p>
			<p>Although it is a small state, it has a wide range of geographical features, from rural areas in the west to beaches on the Atlantic shore. And, there is an equally diverse array of communities, from suburbs and bedroom communities of Washington, D.C. to big city life in Baltimore. The variety of environments have even earned the state its other nickname, Little America.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The self-storage sector has been on a roll in Maryland lately.  In recent years, new investment has poured into the acquisition and development of new facilities across the state as part of a broader nationwide boom. As more people move to the state and the population grows, more self-storage space is needed to serve people who are in the process of relocating. For several years after the recession, new development did not keep up with the natural demand. This led to record-high monthly rental prices in many areas. Rates are now returning to normal here and around the country as more storage inventory becomes available, but Maryland remains a premium market for self-storage.</p>
			`,
			facts: [
				{
					fact: 'Maryland is home to more than 500 self-storage facilities',
					highlight: '500',
				},
				{
					fact: 'Maryland facilities offer more than 24,187,316 million square feet of storage space combined.',
					highlight: '24,187,316',
				},
				{
					fact: "Maryland has 4.08 square feet of storage space for every man, woman, and child. That's less than the national average of 5.4 square feet per person.",
					highlight: '4.08',
				},
				{
					fact: 'Average price of a self-storage unit in Maryland:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Baltimore',
				price: '0',
			},
			{
				city: 'Annapolis',
				price: '0',
			},
			{
				city: 'Bethesda',
				price: '0',
			},
			{
				city: 'Ocean City',
				price: '0',
			},
			{
				city: 'Frederick',
				price: '0',
			},
			{
				city: 'Rockville',
				price: '0',
			},
			{
				city: 'Hagerstown',
				price: '0',
			},
			{
				city: 'Silver Spring',
				price: '0',
			},
			{
				city: 'Gaithersburg',
				price: '0',
			},
			{
				city: 'Salisbury',
				price: '0',
			},
			{
				city: 'Laurel',
				price: '0',
			},
			{
				city: 'Towson',
				price: '0',
			},
			{
				city: 'Cumberland',
				price: '0',
			},
			{
				city: 'Fort Meade',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "If you're thinking about making the move, but aren't sure if Maryland is the right place for you, consider the following:",
			reasons: [
				'The Chesapeake Bay. The Bay is a big deal to almost all Marylanders, simply because of the small size of the state and the enormity of the bay. The Chesapeake is an estuary, meaning it is a place where fresh and saltwater mix. While the Bay is 200 miles long, there are over 11,000 miles of shoreline when you factor in all of the tidal tributaries. That’s more than the entire U.S. west coast.',
				'Maryland is all about the blue crab. Few locations in the United States are as inextricably tied to a single culinary ingredient as Maryland is to the blue crab. Maryland residents put crab in everything, from crab cakes to crab bisque, but the preferred and easiest method to enjoy these crustaceans is steamed with Old Bay and dumped on a paper-lined table.',
				'Maryland food is not limited to the sea. While crab is king, anyone familiar with Baltimore will likely rave about pit beef. These simple sandwiches are kind of like a french dip, featuring thinly sliced roast beef served on a hard roll with zippy horseradish mayo as an optional condiment. But, it’s much more than that. It is Maryland’s barbecue, and the best versions smell just like the fire that slowly roasts the beef to perfection.',
				'The Atlantic shore. For the most part, when talking about the shore in Maryland, you mean Ocean City. Ocean City is a barrier island, on a long north-south sandspit. It is a highly developed tourist destination with a vibrant boardwalk, resorts, shops, and restaurants.',
				'The wild coastline. To the south of Ocean City, Maryland exhibits a different kind of Atlantic ocean setting. The Assateague Island National Seashore area is a barrier island that is populated with wild ponies that travel the beach from Virginia to the northern part of the island — a stone’s throw from Ocean City.',
				'Maryland sports. Even as a small state, Maryland has a strong sports scene. Baltimore is home to the Ravens NFL team and the Orioles MLB team. But, as you travel closer to Washington, D.C., the sports options increase to include the Redskins for football, Nationals for baseball, the Wizards for basketball, and the Capitals for hockey.',
				'The nation’s capital. Of course, there is a lot more to do in the Washington, D.C. area than watch sports. The nation’s capital is full of museums, exhibits, monuments, and a vast urban area that is one of the world’s greatest tourist locations.',
				'A strong military presence. Because of its history, location near the capital, and the accessibility of the Bay, there are many military personnel and veterans in the area. Annapolis is home to the Navy, but the state also hosts Fort Meade, Andrews Air Force Base, and Camp David.',
				'Civil War history.  As a state south of the Mason-Dixon Line, Maryland did not secede during the Civil War but was the setting for one of the bloodiest battles fought in the Civil War. The Battle of Antietam was fought on September 17, 1862, near Sharpsburg in the western area of the state. Today, the battle is commemorated at the Antietam National Battlefield.',
				'Hiking in Appalachia. While Maryland seems to be all about the Bay, and proximity to Washington, D.C., the western part of the state is bisected by the Appalachian trail, offering outstanding hiking and recreation options.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Maryland is the 9th smallest state by size, covering approximately 9,775 square miles. But, it ranks as the 19th largest state by population, with an estimated 6.06 million residents.  This mix of small size and mid-level population means that Maryland can be a vibrant place to live, while not being too densely populated.</p>
				<p>Maryland has shown a 9% population increase over the decade from 2000 to 2010. However, there are signs that this trend may be slowing, with a slight net loss of residents reported recently.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Maryland’s gross domestic product (GDP) is roughly $333 billion, a 5.23% increase over the past five years. That makes it the 15th largest state economy in the nation. The economic outlook in Maryland can be seen as a good news/bad news situation. The Maryland job market is strong, but the state’s relatively high cost of living and a perception that the state is not business-friendly could slow growth.</p>
				<p>Even still, the unemployment rate in the state has been the lowest in the past 11 years, at only 3.7%, a figure less than the nationwide average of 4%. On average, there are 3,100 jobs added to Maryland’s payrolls each month. Recently, jobs in health services, education, transportation and utilities, leisure and hospitality, and financial activities have seen growth.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer:
						'Johns Hopkins Medical Institutions and Johns Hopkins University',
					employees: '37,759',
				},
				{
					employer: 'MedStar Health',
					employees: '22,000',
				},
				{
					employer: 'Black & Decker Corp.',
					employees: '22,000',
				},
				{
					employer: 'Northrup Grumman Corp.',
					employees: '11,000',
				},
				{
					employer: 'McCormick & Co.',
					employees: '8,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>While most of the state’s economic activity is in Baltimore and the cities and towns near Washington, D.C., the state spans wild rural areas that border West Virginia to more than 7,700 miles of coastline.</p>
				<p>Here’s a quick look at the state’s three largest cities:</p>
			`,
			cities: [
				{
					city: 'Baltimore',
					copy: '<p>Baltimore boasts a population of 619,493, which is a huge number compared to other cities in the state. The average salary in the city is $56,522, which is roughly on par with the national average. The cost of living in Baltimore is, however, about 17 percent higher than the national average. The biggest employers in Baltimore include Johns Hopkins University, University of Maryland Medical Center, and Northrop Grumman Corp.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '17 percent above national average.',
						},
						{
							item: 'Median home price',
							value: '$118,800.',
						},
						{
							item: 'Average rent',
							value: '$1,263',
						},
						{
							item: 'Average apartment size',
							value: '818 square feet',
						},
					],
				},
				{
					city: 'Frederick',
					copy: '<p>Located just about 43 miles away from Baltimore is Maryland’s second most populous city, Frederick. The city of slightly more than 70,000 residents is also close to Washington, D.C., an area that attracts many global businesses. Major employers in the Frederick area include military contractors, Leidos Biomed, and Wells Fargo Home Mortgage.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '40.2 percent above national average',
						},
						{
							item: 'Median home price',
							value: '$284,000.',
						},
						{
							item: 'Average rent',
							value: '$1,426',
						},
						{
							item: 'Average apartment size',
							value: '929 square feet',
						},
					],
				},
				{
					city: 'Gaithersburg',
					copy: '<p>Closer to Washington, D.C. still is Gaithersburg. This city, with approximately 68,000 residents has seen the population grow in recent years. It has risen to third in population after being fourth before 2010. This small city is home to several major employers in the Gaithersburg area include the National Institutes of Health, Marriott International, Lockheed Martin, and Adventist Health Care.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '40.2 percent above national average.',
						},
						{
							item: 'Median home price',
							value: '$372,400.',
						},
						{
							item: 'Average rent',
							value: '$1,686',
						},
						{
							item: 'Average apartment size',
							value: '916 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents who possess a driver’s license from another state must obtain a Maryland license within 60 days of establishing residency. If your license is valid in your previous state or expired for less than one year, you will only have to take a vision test.',
				link: 'https://www.mva.maryland.gov/drivers/apply/new-to-maryland.htm',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents of Maryland must register their vehicle within 60 days of moving to Maryland.',
				link: 'https://www.mva.maryland.gov/drivers/apply/new-to-maryland.htm',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Maryland, you must be a citizen of the United States, be 18 years of age or older on or before the date of the next election, and must be a resident of the state.',
				link: 'https://voterservices.elections.maryland.gov/OnlineVoterRegistration/InstructionsStep1',
			},
		],
		sources: [
			// static content
			'https://www.mva.maryland.gov/drivers/apply/new-to-maryland.htm',
			'https://voterservices.elections.maryland.gov/OnlineVoterRegistration/InstructionsStep1',
			'https://www.deptofnumbers.com/gdp/maryland/',
			'https://www.aei.org/carpe-diem/putting-americas-enormous-19-4t-economy-into-perspective-by-comparing-us-state-gdps-to-entire-countries/',
			'https://www.cnbc.com/2018/07/10/top-states-for-business-maryland.html',
			'https://www.baltimoresun.com/business/jobs/bs-hs-january-unemployment-20190311-story.html',
			'https://www.baltimoresun.com/bal-rg-mdbusiness21-story.html',
			'https://baltimorepostexaminer.com/the-top-15-most-in-demand-jobs-in-central-maryland/2019/08/22',
			'https://www.payscale.com/research/US/Location=Baltimore-MD/Salary',
			'https://www.zillow.com/baltimore-md/home-values/',
			'https://commerce.maryland.gov/Documents/ResearchDocument/MajorEmployersInMontgomeryCounty.pdf',
			'https://www.assateagueisland.com/',
			'https://www.washingtonpost.com/goingoutguide/here-are-11-of-the-best-places-to-enjoy-pit-beef--marylands-answer-to-barbecue/2019/09/19/878b965a-d4a0-11e9-86ac-0f250cc91758_story.html',
			'https://www.chesapeakebay.net/discover/facts',
			'https://worldpopulationreview.com/states/maryland-population/',
			'https://www.dllr.state.md.us/lmi/iandoproj/',
		],
	},
	MA: {
		state: 'Massachusetts',
		stateNickname: 'Bay State',
		welcome: `
			<p>Although Massachusetts is the seventh smallest state in the U.S. by area, it’s one of the most populous of the six New England states with nearly seven million people calling it home. It’s bordered by Vermont and New Hampshire on the north, the Atlantic Ocean on the east and southeast, Connecticut and Rhode Island on the south, and New York on the east. Rivers and waterways snake throughout the state, offering unrivaled views of lush trees and foliage. Plenty of wildlife resides in Massachusetts, as well, including deer, beavers, red foxes, blue heron, wild turkeys, and more.</p>
			<p>The glacier-shaped indented coast has left most of the ground rocky, sandy, and non-fertile. Although the western region rolls with gentle hills, the southeastern waters near Cape Cod are some of the most perilous in the U.S. Directly off the fierce coast of Massachusetts, rests famous tourist attractions, such as the islands of Nantucket and Martha’s Vineyard. The state capital of Boston offers Old World history and New World charm, featuring the Boston Symphony Orchestra, Harvard University, and several professional sports teams. Although fishing and shipbuilding were once significant resources for Massachusetts, technological research and development spearhead the state’s economy. However, with a rich history in religion and government, Massachusetts still teems with the early American “Yankee” energy.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>As one of the tiniest states, Massachusetts residents know what it's like to be starved for space. That's true when it comes to self-storage as well. The state has one of the lowest rates of self-storage per capita in the country, compared to the national average. However, developers in Boston and throughout the state are busy developing new sites which should lower rates and lead to more available storage for folks that are moving around the state, as well as those moving in or out. During the recession and immediately after, less self-storage space was built than the market demanded. That has led to the current boom in self-storage building, which also includes converting vacant retail stores into storage facilities. You can spot that trend here in Massachusetts and around the country.</p>
				<p>Below is an overview of the current state of the Massachusetts self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Massachusetts is home to about 537 self-storage facilities.',
					highlight: '537',
				},
				{
					fact: 'Massachusetts self-storage facilities cover 20,971,621 square feet of storage space.',
					highlight: '20,971,621',
				},
				{
					fact: 'Massachusetts storage facilities offer 3.67 square feet of storage per person, which is much lower than the national average of 5.4 square feet per person.',
					highlight: '3.67',
				},
				{
					fact: 'Average price of a self-storage unit in Massachusetts:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Boston',
				price: '0',
			},
			{
				city: 'Cambridge',
				price: '0',
			},
			{
				city: 'Worcester',
				price: '0',
			},
			{
				city: 'Salem',
				price: '0',
			},
			{
				city: 'Plymouth',
				price: '0',
			},
			{
				city: 'Lowell',
				price: '0',
			},
			{
				city: 'Waltham',
				price: '0',
			},
			{
				city: 'Framingham',
				price: '0',
			},
			{
				city: 'Quincy',
				price: '0',
			},
			{
				city: 'New Bedford',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Thinking about moving to the Pelican State, but aren't sure if it would be a good fit for you? Check out our top 10 reasons to move to Louisiana to help you make the right decision.</p>",
			reasons: [
				'Unparalleled seafood. In the Bay State, no shortage of lobster-lovers exists. And for a good reason, too! With fishing still a significant part of the Massachusetts economy, the Atlantic Ocean pours in fresh seafood daily. It’s particularly well-known for its shellfish, harvesting some of the world’s best lobsters for us all to enjoy.',
				'Boston...just Boston. Known as the “Hub of the Universe,” Boston has always played a significant role in U.S. and world history. This city offers an array of cultural happenings, including multiple museums, plenty of theater presentations, and delicious ethnic eateries. The job market is overflowing with opportunity, which is why many professionals flock to Boston. ',
				'Quaint seaside towns. Whether it’s Chatham, Provincetown, Nantucket, or Oak Bluffs, Massachusetts offers some of the best beach towns in the U.S. With classic New England architecture and 19-century lighthouses; it can seem as though time stands still on this coast. ',
				'Forward thinking. As one of America’s original 13 states, Massachusetts continually sets the standard for this country. Unlike other areas in the U.S., the Bay State tends to support outside-of-the-box thinking. With that said, it was the first state to legalize same-sex marriage in 2004. Even with the profound role Massachusetts played in this country’s beginnings, it’s not stuck in the past. ',
				'Diverse economy. From the booming job market to the deeply rooted historical foundation, Massachusetts prides itself on having a healthy economy. Plus, during the Industrial Revolution, it became a national leader and hasn’t ever stopped. Instead of relying solely on whaling and fishing, Massachusetts expanded its revenues by including numerous industries.',
				'Stunning seasons. Winters in Massachusetts can feel brutal, even with the vast amount of wintertime activities. However, most residents claim that the beauty of the other seasons wipes away any winter-induced bitterness. The summers are incredibly pleasant, rarely reaching above 80 ℉ or dipping below 60 ℉. And when fall rolls around, a more naturally colored radiance has never existed. ',
				'Rich history. The landing of the Mayflower, the Boston Tea Party, and the Salem Witch Trials are a few of the famous stories that happened in Massachusetts. The state is overflowing with American history, and its people love it for that very reason. It’s where the first Thanksgiving took place and also the horrendous Boston Massacre that sparked America’s independence. ',
				'Education system. With such rich historical significance, how could Massachusetts have anything but a leading education system? From preschool up to university, the state is renowned for its academics. Not only are there top-ranking elementary schools, but Massachusetts is home to Harvard, Massachusetts Institute of Technology, Boston University, and more.',
				'Top-notch healthcare. It’s not only famous schools that are peppered across the state; Massachusetts has a world-renowned healthcare system, as well. Hospitals such as Brigham and Women’s Hospital, Massachusetts General Hospital, and Boston Children’s Hospital are just a handful of the highly ranked institutions that inhabit the state. In terms of statistics, Massachusetts came in second place for the best overall healthcare system. ',
				'Sports culture. From the Boston Red Sox to the New England Patriots, from the Boston Bruins to the Boston Celtics, the Bay State is nuts about their sports. Hockey, baseball, basketball, and football are all popular, too. Massachusetts residents love them all. ',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Massachusetts is the 15th most populated state, but it’s the 3rd most densely populated area in the U.S. with over 840 people per square mile of land. Although the state’s population has increased steadily in recent years, the rate of growth is under 4 percent, which is well below the national average of 10 percent. From 2017 to 2018, the population bumped from 6.86 million to 6.9 million. Many attribute this growth mainly to foreign immigration. Aside from the high cost of housing, most people are choosing to leave Massachusetts because of a job transfer or a new job, family reasons, relationship status, and climate. Also, the state’s economy is gradually transforming from manufacturing-based to one based on technology, which is shifting the job market significantly. Even with the steady increase, the state’s population isn’t expected to budge much beyond its current numbers by 2020.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Financial and professional services are the most significant industries in Massachusetts, landing its real GDP at $588.2 billion. With a 2.7% growth in 2018, the state ranks 11th in U.S. According to the Bureau of Labor Statistics, employment in Massachusetts has increased from 2018 to 2019, leaving the unemployment rate at 2.9% in August 2019.</p>
				<p>The economic outlook for Massachusetts looks sharp as it’s expected to experience continued job growth in the coming years. Mainly we’ll see the growth in industries, such as health services as well as professional, scientific, and business services. With the booming job industry, Massachusetts has a higher cost of living than most other U.S. states. With a cost of living score of 139, housing is undoubtedly the most expensive part of living in the Bay State. However, many people overlook the higher housing costs to enjoy all that the state has to offer.</p>
				<p>The following are Massachusetts’ top five sectors of real value added by GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Financial, insurance, real estate, rental, and leasing',
					value: '$105,090 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$96,117 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$61,215 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$49,815 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$47,437 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'General Electric',
					employees: '295,000',
				},
				{
					employer: 'The TJX Companies',
					employees: '235,000',
				},
				{
					employer: 'Showcase Cinemas',
					employees: '133.269',
				},
				{
					employer: 'Fresenius Medical Care North America',
					employees: '114,000',
				},
				{
					employer: 'Raytheon',
					employees: '63,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>The Commonwealth of Massachusetts covers 10,565 square miles of land and sea. Residents are officially known as Bay Stater. Move to any of these three major cities, or anywhere else, and that's what you'll be!</p>
			`,
			cities: [
				{
					city: 'Boston',
					copy: '<p>As the capital of Massachusetts and one of the oldest cities in the country, Boston’s 89.63 square miles are spilling over with culture. It’s the most populous city in the New England region, home to 673,184 people. The rich history and ample job opportunities attract plenty of outsiders to Boston, too, despite the high cost of living. It’s the economic and cultural hub of the state, which makes Boston an attractive place to relocate.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '48% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$594,600',
						},
						{
							item: 'Average rent',
							value: '$3,298/month',
						},
						{
							item: 'Average apartment size',
							value: '817 square feet',
						},
					],
				},
				{
					city: 'Worcester',
					copy: '<p>As the second-largest city in Massachusetts, Worcester has a population of 184,508 people. The city is spread across 38.57 square miles and is located in the center of Massachusetts, earning its official heart symbol. Worcester is just west of Boston, and its economy thrives off of education and healthcare industries.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '18% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$245,800',
						},
						{
							item: 'Average rent',
							value: '$1,392/month',
						},
						{
							item: 'Average apartment size',
							value: '786 square feet',
						},
					],
				},
				{
					city: 'Springfield',
					copy: '<p>With 154,074 people calling Springfield home, it’s the third most populated city in Massachusetts. It covers 33.09 square miles and is located on the Connecticut River’s eastern bank. Springfield is commonly dubbed the “Hoop City” as James Naismith invented basketball here in 1891. Springfield has many other firsts, including: the first American dictionary was published here and the first American gas-powered automobile was produced here as well.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '12% below the national average',
						},
						{
							item: 'Median home price',
							value: '$165,400',
						},
						{
							item: 'Average rent',
							value: '$1,168/month',
						},
						{
							item: 'Average apartment size',
							value: '1048 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'Upon becoming a resident of Massachusetts, you must convert your driver’s license to MA. No grace period exists. Two types of driver’s licenses are available: a REAL ID driver’s license (valid for Federal purposes) or a Standard Massachusetts driver’s license (not valid for Federal purposes). You must visit an RMV Service Center with proof of Social Security number and Massachusetts residency. It’s also possible to start your application online, and then finish up in person. The conversion fee is usually $115 but may vary depending on the class. If your driver’s license has been expired for more than a year, you must take a full test and an eye exam. However, if it’s expired under a year, only an eye exam is required.',
				link: 'https://www.mass.gov/how-to/transfer-your-out-of-state-drivers-license-to-massachusetts',
			},
			{
				title: 'Vehicle registration',
				copy: 'As soon as you become a resident of Massachusetts, you must register your vehicle in the state. There is no grace period. Firstly, you must submit proof of Massachusetts insurance through an RMV-1 application with an insurance stamp and signature. Secondly, you’ll need proof of ownership and the correct fee amount. Following registration, you must get a vehicle inspection sticker no later than seven days of the registration date. Massachusetts exercises an excise tax bill, which is generated annually and paid to your residing city.',
				link: 'https://www.mass.gov/how-to/transfer-your-registration-and-title-from-out-of-state',
			},
			{
				title: 'Voter Registration',
				copy: 'Registering to vote as a new resident of Massachusetts is a straightforward process. However, you must register 20 days before an election. You can register to vote in Massachusetts here:',
				link: 'https://www.sec.state.ma.us/ele/eleifv/howreg.htm',
			},
		],
		sources: [
			// static content
			'https://www.britannica.com/place/Massachusetts/Plant-and-animal-life',
			'https://www.usnews.com/news/best-states/rankings/health-care',
			'https://www.wbur.org/cognoscenti/2016/02/24/massachusetts-population-thomas-j-fitzgerald',
			'https://worldpopulationreview.com/states/gdp-by-state/',
			'https://www.mass.gov/news/massachusetts-unemployment-and-job-estimates-for-august-2019',
			'https://www.bls.gov/regions/new-england/news-release/countyemploymentandwages_massachusetts.htm',
			'https://www.statista.com/statistics/551779/massachusetts-real-gdp-by-industry/',
			'https://www.bestplaces.net/cost_of_living/state/massachusetts',
			'https://www.zippia.com/advice/largest-companies-in-massachusetts/',
			'https://www.usgovernmentspending.com/compare_state_spending_2019bZ0a',
			'https://www.payscale.com/cost-of-living-calculator/Massachusetts-Boston',
			'https://www.zillow.com/boston-ma/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ma/boston/',
			'https://www.mass.gov/how-to/transfer-your-out-of-state-drivers-license-to-massachusetts',
			'https://worldpopulationreview.com/states/',
			'https://simple.wikipedia.org/wiki/List_of_U.S._states_by_population',
			'https://www.sec.state.ma.us/ele/eleifv/howreg.htm',
		],
	},
	MI: {
		state: 'Michigan',
		stateNickname: 'Great Lake State',
		welcome: `
			<p>Michigan, also known as "The Wolverine State," or "The Great Lakes State," has a population of 10 million people. The state is also known for its amazing contributions to the auto industry, education, and agriculture. It's the only state that's divided into two peninsulas: the Upper and Lower Peninsulas. The state is bounded on the south by Ohio and Indiana and shares both land and water boundaries with both states. Michigan's northern boundary runs through Lake Superior.</p>
			<p>Michigan's top industries include manufacturing, agriculture, tourism, and alternative energy. The state boasts a cost of living lower than the national average and plenty to do all year long, especially if you love water and winter weather, such as beaches, skiing, amusement parks, casinos, museums, restaurants, nightlife, and more.</p>
			<p>Some of the top attractions are Pictured Rocks National Lakeshore, Mackinac Island, Isle Royale National Park, The Henry Ford Museum, and Tahquamenon Falls.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Michigan self-storage sector has expanded in recent years thanks to unmet demand from consumers and the effect of natural population growth. A huge trend of development is taking place across the nation, including within the state of Michigan. In the wake of the most recent recession, funding for new building self-storage space dried up and existing storage properties reached record levels of occupancy. Recently however, investment and capital has returned to the self-storage industry and has led to a race for developers to find suitable sites for self-storage across the country. Such sites include vacant land, but also empty big box stores that can easily be converted into storage space.
				Below is an overview of the current state of the Michigan self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Michigan is home to about 1,378 self-storage facilities.',
					highlight: '1,378',
				},
				{
					fact: 'Michigan self-storage facilities cover 43,193,325 square feet of storage space.',
					highlight: '43,193,325',
				},
				{
					fact: 'Michigan storage facilities offer 4.38 square feet of storage per person, which is lower than the national average of 5.4 square feet per person.',
					highlight: '4.38',
				},
				{
					fact: 'Average price of a self-storage unit in Michigan:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Detroit',
				price: '0',
			},
			{
				city: 'Flint',
				price: '0',
			},
			{
				city: 'Lansing',
				price: '0',
			},
			{
				city: 'Grand Rapids',
				price: '0',
			},
			{
				city: 'Traverse City',
				price: '0',
			},
			{
				city: 'Kalamazoo',
				price: '0',
			},
			{
				city: 'Saginaw',
				price: '0',
			},
			{
				city: 'Dearborn',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Looking to make a move, but you aren't quite sure Michigan is the place for you? Take a look at our 10 reasons to fall in love with The Great Lakes State.</p>",
			reasons: [
				"Winter wonderland. Are you one of those people who just can't wait until the first snowfall every winter? If so, you'll absolutely love Michigan because the state gets an average of over 200 inches of snow per year. Moving there means stocking up on a few good winter coats and pairs of snow boots because at least six months of the year, you're looking at cold, winter weather.",
				"Perfect for water lovers. Michigan has over 36,000 miles of streams and more than 11,000 inland lakes. So if you're a water lover, Michigan could be the best move you ever made because, in the summertime, you'll be able to enjoy a variety of water-based activities, including water skiing, boating, fishing, swimming, jet-skiing, and more.",
				"Star gazing. If you've ever been stargazing, you'll love Michigan. It has some of the clearest skies at night to make stargazing truly amazing. Taking your spouse out the Headlands International Dark Sky Park in Emmet County for a romantic night of stargazing.",
				"The Coney Dogs. The Coney Dog was invented in Detroit so if you're going to be living in Michigan, you have to try hot dogs Michigan-style. That means a delicious and authentic Coney Dog, topped with chili sauce, mustard, and onions. Adding ketchup could draw some serious stares. Seriously, don't. When in Rome, right?",
				"Affordable homes. If you're looking to buy a home when you eventually move out of state instead of renting, Michigan is a great place to do it because the state is home to some of the most affordable houses in the country, some going for less than $1,000. Of course, those are the ones that'll need some work, but you get the point.",
				"The sports scene. Michiganders are famous for being die-hard sports fans, whether at the professional or college level. Professional teams include the Detroit Tigers and Detroit Lions so if you're a fan, you'll likely find someone to watch the games with every week.",
				"Craft beer game is strong. According to Smart Asset, the craft beer scene in Michigan is a great place to enjoy some of the most well-reviewed craft beers in the country. So if you've got a taste for craft beer, you'll likely share that love with your fellow Michiganders.",
				"You can see the Northern Lights, sometimes. Moving to Michigan means you'll have a chance to see the Northern Lights, which is sometimes visible over Lake Superior on nights when conditions are clear.",
				"Cherry capital of the world.  If you're a fan of this delicious fruit, you'll love cherry season in Michigan because you'll be much closer to the hundreds of cherry orchards sprinkled throughout the state. And you'll spend a lot less than you would in a grocery store.",
				"Middle Eastern cuisine. Are you a sucker for kabobs, hummus, falafel, and shawarma? Michigan's got you covered, particularly in Dearborn, which has become a destination for delectable Middle Eastern cuisine.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Michigan has a population of 10 million people and ranks as the 10th largest state in the country by population. From 2018 to 2019, the population increased by 0.25 percent. The reason people are leaving seems to be new jobs and retirement. About 55 percent of people moved out of Michigan recently, according to the National Movers Study. According to Patch.com, more people are moving out of Michigan than moving into it. But the good news is that housing prices are low, meaning it'll be easier to purchase a new home than it would be in some other states. This creates more demand for self-storage as most people who use storage are doing so as part of a move to a new home.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>The unemployment rate in Michigan is a whopping 9 percent, making it the third-worst in the country. However, on the plus side, the state is creating jobs at a higher rate than the national average. Things are starting to get better throughout the state, but there's still a ways to go. Michigan's GDP is $528 million as of 2018, according to the Federal Reserve Bank of St. Louis.</p>
				<p>Below is a breakdown of the top sectors in Michigan by real value GDP added:</p>
			`,
			breakdown: [
				{
					sector: 'Manufacturing',
					value: '$90.29 billion',
				},
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$75.96 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$65.4 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$47.12 billion',
				},
				{
					sector: 'Educational service, health care, and social assistance',
					value: '$44.14 billion',
				},
			],
			bottomLine: `
				<p>The Michigan economy was estimated to grow by 2 percent in 2019 and is expected to grow by 1.3 percent in 2020 and 1.6 percent in 2021. Wage and salary employment is predicted to continue growing, as it increases by 0.2 percent in 2020 and 0.1 percent in 2021.</p>
				<p>Michigan has a cost of living score of 96.7, meaning it's cheaper than the US average. It also beats out the US average for the cost of groceries, healthcare, and housing, which means you should be able to find affordable housing and more than favorable living conditions.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'General Motors',
					employees: '225,000',
				},
				{
					employer: 'Ford Motor',
					employees: '201,000',
				},
				{
					employer: 'Enstrom Helicopter',
					employees: '174,110',
				},
				{
					employer: 'Lear',
					employees: '148,400',
				},
				{
					employer: 'Whirlpool',
					employees: '93,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Michigan is the largest state east of the Mississippi River at a total of 97,990 square miles. With 3,288 miles, Michigan has the second-longest total shoreline in the country–second only to Alaska.  About 52 percent of Michigan's land area is forested. Moving to Michigan means you'll never be more than six miles from a natural source of water. The three largest cities in the state include Detroit, Grand Rapids, and Warren.</p>
			`,
			cities: [
				{
					city: 'Detroit',
					copy: '<p>Dubbed "Motor City," and named "One of America\'s Most Fun Cities" by Thrillist, Detroit is Michigan\'s largest city, with a population of 695,437 people. Although Detroit gets a bad rap from some folks, the city has more to offer than most people realize, including tons of attractions and activities like amusement parks, casinos, racetracks, water parks, art galleries, museums, theaters, coffee shops, wineries, restaurants, and nightlife. Outdoor activities available throughout the city include boating, fishing, biking, golfing, hunting, ice fishing, snowboarding, and skiing.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$163,200',
						},
						{
							item: 'Average rent',
							value: '$1,068 per month',
						},
						{
							item: 'Average apartment size',
							value: '803 square feet',
						},
					],
				},
				{
					city: 'Grand Rapids',
					copy: '<p>Grand Rapids is the second-largest city in the state, with a population of about 200,000 people. It was rated one of the top 20 places to live in America and has a charming, small-town feel and a somewhat artsy vibe to it. Grand Rapids has tons to offer when it comes to entertainment, including museums, beaches, nightlife, live music, pro sports, historic sites, breweries, shopping, and attractions such as the John Ball Zoo and Beer City USA.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '9 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$163,400',
						},
						{
							item: 'Average rent',
							value: '$1,053 per month',
						},
						{
							item: 'Average apartment size',
							value: '866 square feet',
						},
					],
				},
				{
					city: 'Warren',
					copy: "<p>Located about 15 miles north of Detroit, Warren is Michigan's third-largest city, where more than 135,147 people reside. Warren is located in Macomb County and provides an authentic suburban feel and tons of great public schools, as well as a range of activities and attractions, such as parks, restaurants, shopping, and nightlife. Attractions include Warren Community Centre Indoor Waterpark, Weigand Park, and Dragonmead Microbrewery.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '10 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$140,100',
						},
						{
							item: 'Average rent',
							value: '$821 per month',
						},
						{
							item: 'Average apartment size',
							value: '853 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Michigan have to pass a vision test to convert a valid out-of-state operator's license. You must be a U.S. citizen or resident with a temporary or permanent legal presence to apply for a Michigan driver's license. To get your new license, you'll need to provide proof of identity, a valid Social Security number or letter of ineligibility, proof of U.S. citizenship or legal presence if you're not a citizen, and proof of your Michigan residency. You'll also need to pass the physical standards test and have your picture taken. For more info, visit:",
				link: 'https://www.michigan.gov/sos/0,4670,7-127-1640_50050_50417-171810--,00.html',
			},
			{
				title: 'Vehicle registration',
				copy: "New residents of Michigan have to register their vehicles immediately upon establishing a residence in the state by going to a Secretary of State office and turning in the vehicle title from their previous home state. You'll need to provide proof of Michigan no-fault insurance in order to register your vehicle. The Secretary of State will then issue you a Michigan registration and plate. All listed owners on the title have to be present. For more info, visit:",
				link: 'https://www.michigan.gov/sos/0,4670,7-127-1640_50050_50418-25234--,00.html',
			},
			{
				title: 'Voter Registration',
				copy: "To register to vote in Michigan, you have to be a resident of the state at least 30 days before Election Day. You also must be a citizen of the United States and be at least 18 years old. First, verify that you're eligible to vote. Then, fill out an application and submit it to the City/Township Clerk. For more info, visit:",
				link: 'https://www.michigan.gov/sos/0,4670,7-127-1640_50050_50420-175878--,00.html',
			},
		],
		sources: [
			// static content
			'https://fred.stlouisfed.org/series/MINGSP',
			'https://www.trustedchoice.com/insurance-articles/moving/moving-to-michigan/',
			'https://www.homesnacks.net/moving-to-michigan-1213935/',
			'https://thoughtcatalog.com/koty-neelis/2014/07/59-reasons-you-should-live-in-michigan/',
			'https://www.statista.com/statistics/588974/michigan-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-michigan/',
			'https://www.senate.michigan.gov/sfa/Publications/BudUpdates/EconomicOutlookMay19.pdf',
			'https://www.bestplaces.net/cost_of_living/state/michigan',
			'https://www.michigan.org/things-to-do/index',
			'https://www.michigan.org/city/detroit',
			'https://www.homes.com/f/michigan/homes-for-sale/top-10-most-populated-cities/',
			'https://www.experiencegr.com/things-to-do/attractions/',
			'https://www.michigan.org/city/warren#?c=44.4299:-85.1166:6&tid=1137&page=0&pagesize=20&pagetitle=Warren',
			'https://www.niche.com/places-to-live/warren-macomb-mi/',
			'https://www.tripadvisor.com/Attractions-g42794-Activities-Warren_Michigan.html',
			'https://www.payscale.com/cost-of-living-calculator/Michigan-Detroit',
			'https://www.zillow.com/detroit-warren-dearborn-metro-mi_r394532/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/mi/detroit/',
			'https://www.payscale.com/cost-of-living-calculator/Michigan-Grand-Rapids',
			'https://www.zillow.com/grand-rapids-mi/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/mi/grand-rapids/',
			'https://www.payscale.com/cost-of-living-calculator/Michigan-Warren',
			'https://www.zillow.com/warren-mi/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/mi/warren/',
			'https://www.michigan.gov/sos/0,4670,7-127-1640_50050_50417-171810--,00.html',
			'https://www.michigan.gov/sos/0,4670,7-127-1640_50050---,00.html',
			'https://www.michigan.gov/sos/0,4670,7-127-1640_50050_50418-25234--,00.html',
			'https://www.michigan.gov/sos/0,4670,7-127-1640_50050_50420-175878--,00.html',
			'https://statesymbolsusa.org/symbol-official-item/michigan/state-nickname-state-quarter/great-lakes-state',
			'https://www.newworldencyclopedia.org/entry/Michigan',
			'https://www.coolkidfacts.com/michigan-facts/',
			'https://frankenmuthfestivals.com/frankenmuth-oktoberfest',
			'https://www.estately.com/blog/2013/11/37-things-to-consider-before-moving-to-michigan/',
			'https://smartasset.com/mortgage/15-things-to-know-before-moving-to-michigan',
			'https://worldpopulationreview.com/states/michigan-population/',
			'https://patch.com/michigan/across-mi/study-more-people-are-leaving-michigan-moving-it',
			'https://www.mlive.com/entertainment/2017/03/michigan_is_the_very_best_stat.html',
		],
	},
	MN: {
		state: 'Minnesota',
		stateNickname: 'North Star State',
		welcome: `
			<p>Known as the “Land of 10,000 Lakes,” Minnesota is the second northernmost state in the U.S. after Alaska. Bordering Minnesota are Lake Superior, Wisconsin, Iowa, North and South Dakota, and two Canadian provinces (Ontario and Manitoba). Mostly, the state's geography consists of rolling plains and forests, making it ideal for logging and farming. Like many other middle latitude regions, Minnesota experiences extreme seasons with hot summers and bitter winters.</p>
			<p>The cities of St. Paul and Minneapolis are known as the “Twin Cities” and make up over half of Minnesota’s overall population. Music and the arts have played a significant part in the state’s culture for many years. A long list of notable actors, filmmakers, producers, musicians, etc. hail from Minnesota. Also, with tourism contributing over $15 billion to Minnesota’s economy, many residents regard environmentalism as a top priority.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Minnesota is seeing an increase in the number of new self-storage facilities being built across the state as part of a national trend. Developers have ramped up the construction of self-storage facilities in recent years after a period of inactivity that led to record high rental rates and limited availability. With more self-storage space being built, monthly rental rates are starting to come down. Self-storage developers continue to look for new sites across the country, including vacant retail strip stores that can be easily converted into storage palaces. Minnesota has seen a number of these projects and will continue to be an active market for self-storage for the foreseeable future.</p>
				<p>Read more below about Minnesota's growing self-storage industry.</p>
			`,
			facts: [
				{
					fact: 'Minnesota is home to about 718 self-storage facilities.',
					highlight: '718',
				},
				{
					fact: 'Minnesota self-storage facilities cover 22,403,787 square feet of storage space.',
					highlight: '22,403,787',
				},
				{
					fact: 'Missouri storage facilities offer 4.15 square feet of storage per person, which is less than the national average of 5.4 square feet per person.',
					highlight: '4.15',
				},
				{
					fact: 'Average price of a self-storage unit in Minnesota:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Minneapolis',
				price: '0',
			},
			{
				city: 'St. Paul',
				price: '0',
			},
			{
				city: 'Duluth',
				price: '0',
			},
			{
				city: 'St. Cloud',
				price: '0',
			},
			{
				city: 'Bloomington',
				price: '0',
			},
			{
				city: 'Mankato',
				price: '0',
			},
			{
				city: 'Burnsville',
				price: '0',
			},
			{
				city: 'Eden Prairie',
				price: '0',
			},
			{
				city: 'Minnetonka',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			reasons: [
				'Friendly atmosphere. Rarely do you come across a group of people who genuinely treasure their home state. But, that’s the reputation of Minnesota residents; they love it here! Most people here are typically friendly, reserved, courteous, and mild-mannered.',
				'Small town charm. Although Minnesota has a handful of significant cities, such as St. Paul, Minneapolis, and Duluth, it’s the charming small-town life that sets it apart as a great place to live. For example, Grand Marais was titled America’s Coolest Small Town by Budget Travel in 2015. And that’s just for starters!',
				'Cleanliness. Minnesotans tend to care about their surroundings more than average. This attitude has paid off because they have some of the cleanest cities in the country. Add in the crisp air and green spaces to get some amazingly walkable and enjoyable metropolitan environments.',
				'Education system. Minnesota’s school system is consistently in the top 10th in the nation. Minneapolis is also one of the most educated U.S. cities, making it ideal for teachers and college grads. Minneapolis houses OpenBook as well as dozens of independent presses and bookstores. So, it’s no surprise that it has one of the highest literacy rates in the U.S.',
				'Thriving economy. With nearly 20 Fortune 500 companies in Minnesota, the economy is anything but drab. The education system, social culture, and sustainable work/life balance create an optimal planting ground for success. The median household income is 30% higher than the national average if that tells you anything.',
				'Fairs and festivals. From music festivals to car shows to county fairs, Minnesota has a get-together for plenty of occasions. Whether it’s a classic event or an eccentric festival, this state goes big every time. Even the Minnesota State Fair is world-famous!',
				'The Lakes. Nicknamed the “Land of 10,000 Lakes,” Minnesota truthfully has a total of 11,842 lakes. Many of them, especially near the western side in the “Chain of Lakes” region, are perfect for recreation because each lake is about 3-4 miles around.',
				'Fitness. Minneapolis is considered one of the fittest cities in the U.S. More precisely, it’s one of the top ten best cities for runners and bikers worldwide. Whether you’re trekking around a lake or pedaling down a city street, Minnesota supports it all.',
				'Art and culture. Known as one of the “big five” modern art museums in the U.S., The Walker Art Center resides in Minneapolis as well as the Minneapolis Institute of Art. Don’t forget about the vibrant independent music scene or the many theaters peppered throughout the state.',
				'Food and beer. Lush agricultural land surrounds Minnesota’s major cities, which helps to enrich the local restaurants as well as the farmers’ markets. Local craft beer is also a highlight in Minnesota, boasting dozens of brands.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Minnesota ranks as the 22nd most populous state in the U.S., with 5,655,925 individuals calling it home. According to the U.S. Census Bureau, Minnesota grew by 43,000 people between 2018 to 2019, which is a rate of 0.8%. Unlike other parts of the country, Minnesota is growing at a reasonably natural rate, considering the national average between 0.7% and 0.9%. Mainly this growth is due to state-to-state relocation, foreign migration, and more births than deaths. No mass exodus or influx of young professionals has taken place in Minnesota as it has in other areas. This state has grown steadily throughout the years and is expected to continue that trend.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Even with a slightly slower growing economy in 2019 than in the previous few years, Minnesota’s GDP is still an impressive $381.3 billion. Unemployment rates have ticked down to 3.2% in September 2019, as well. The state’s GDP has climbed steadily for numerous years, and Minnesota is projected to repeat the continual economic incline.</p>
				<p>Below is a breakdown of Minnesota’s largest sectors by real value added of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$58.78 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$49.53 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$46.12 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$35.42 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$31.06 billion',
				},
			],
			bottomLine: `
				<p>Although Minnesota’s economic growth slowed in 2019, its financials remain secure. The “rainy day fund” or otherwise known as the budget reserves of Minnesota are nearly at an optimal level. Should recession impact the rest of the nation, those states with secure reserves tend to bounce back quickly. Minnesota is not only looking forward to continued growth in the future, but it’s safeguarding it, too.</p>
				<p>With a cost of living score a hair over 106, Minnesota is more expensive than the national average. Both housing costs and transportation drive Minnesota's rating up, considering the median home price is $235,600. Otherwise, groceries, health, and utilities all rank lower than the national average. If you can swallow the slightly higher housing costs in Minnesota, the quality of life is worth it, coming in at #3 in the nation for best places to live in the U.S.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Mayo Clinic',
					employees: '43,247',
				},
				{
					employer: 'State of Minnesota',
					employees: '40,906',
				},
				{
					employer: 'U.S. Federal Government',
					employees: '35,114',
				},
				{
					employer: 'Fairview Health Services',
					employees: '34,000',
				},
				{
					employer: 'Allina Health System',
					employees: '29,335',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Within Minnesota’s 86,943 square miles, a significant portion of its 5.66 million residents lives near the following major cities. Affordability varies from city to city, of course. However, overall, Minnesota is only slightly more expensive than the rest of the country. Here’s a look at the top three cities in Minnesota—although St. Paul is the capital, we’ve included it with Minneapolis to stay true to the “Twin Cities” vibe.</p>
			`,
			cities: [
				{
					city: 'St. Paul-Minneapolis',
					copy: '<p>The Twin Cities strike an excellent balance between being eco-friendly and metropolitan-cool. Museums and theaters are peppered throughout the cities, making most areas a great place to land. Also, the shopping here is top-notch, entertaining nearly 18 million visitors annually as well as 733,098 residents. Plus, the culture and cuisine won’t leave you wanting, either.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '5% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$266,400',
						},
						{
							item: 'Average rent',
							value: '$1,589/month',
						},
						{
							item: 'Average apartment size',
							value: '789 square feet',
						},
					],
				},
				{
					city: 'Rochester',
					copy: '<p>This city is ranked in the top 100 best places to live in the nation. Part of the attraction could be its leading universities, the hip music scene, or the uptick in job opportunities. Currently, 116,961 individuals call its 54.75 square miles home. No matter what draws you, Rochester is worth checking out.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '2% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$228,500',
						},
						{
							item: 'Average rent',
							value: '$1,466/month',
						},
						{
							item: 'Average apartment size',
							value: '937 square feet',
						},
					],
				},
				{
					city: 'Duluth',
					copy: '<p>Located on Lake Superior, Duluth is the most affordable city of the three listed here. It’s covered in 23 parks, and this city is the ideal place to reclaim your calm while getting back to nature. It’s home to 85,884 individuals and growing at a steady pace.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '9% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$179,800',
						},
						{
							item: 'Average rent',
							value: '$948/month',
						},
						{
							item: 'Average apartment size',
							value: '1,091 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'After moving to Minnesota, you have 60 days (30 for commercial drivers) to apply for a Minnesota license. This particular state requires you to pass a knowledge test about its laws and regulations. However, if your license has been expired for more than a year or you’re relocated from a different country, you will need to pass the knowledge and skills (driving) test, too. To complete the application, you will need to provide the application form, Social Security number, two forms of identification, old driver’s license from the previous state, proof of passing any required tests (vision included), and the appropriate fees.',
				link: 'https://dps.mn.gov/divisions/dvs/Pages/new-to-minnesota.aspx',
			},
			{
				title: 'Vehicle registration',
				copy: 'When you register a vehicle in Minnesota, one of the most stringent requirements concerns insurance. In this state, you need proof of a no-fault insurance policy for the vehicle you’re attempting to register. Besides insurance, the process is relatively straightforward, requiring the current registration card, lienholder information, odometer reading, and an acceptable form of identification along with appropriate fees.',
				link: 'https://dps.mn.gov/divisions/dvs/Pages/new-to-minnesota.aspx',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Minnesota, you’ll need a Minnesota driver’s license or identification card. The last four digits of your Social Security number will work, too. Register online or on paper any time of the year, even on voting day. To register to vote in Minnesota, visit here:',
				link: 'https://www.sos.state.mn.us/elections-voting/register-to-vote/',
			},
		],
		sources: [
			// static content
			'https://livability.com/mn/real-estate/8-reasons-to-move-to-minnesota',
			'https://www.zumper.com/blog/2018/10/10-reasons-to-move-to-minneapolis/',
			'https://www.mprnews.org/story/2018/12/19/minnesota-population-growth-census-house-congress',
			'https://worldpopulationreview.com/states/minnesota-population/',
			'https://worldpopulationreview.com/countries/united-states-population/',
			'https://www.usgovernmentspending.com/compare_state_spending_2019bZ0a',
			'https://www.americanexperiment.org/2019/05/minnesota-had-the-22nd-fastest-growing-state-economy-in-2018/',
			'https://mn.gov/deed/data/current-econ-highlights/state-national-employment.jsp',
			'https://www.statista.com/statistics/594130/minnesota-real-gdp-by-industry/',
			'https://www.bizjournals.com/twincities/subscriber-only/2019/07/12/largest-employers-in-minnesota-mayo.html',
			"https://www.mnbudgetproject.org/blogdetails/minnesota-budget-bites/2019/11/07/minnesota's-budget-reserve-is-strong-let's-keep-it-strong",
			'https://www.bestplaces.net/cost_of_living/state/minnesota',
			'https://www.bestplaces.net/cost_of_living/state/minnesota',
			'https://www.minnesota-demographics.com/cities_by_population',
			'https://www.payscale.com/cost-of-living-calculator/Minnesota-St.-Paul',
			'https://www.payscale.com/cost-of-living-calculator/Minnesota-Minneapolis',
			'https://www.payscale.com/research/US/Location=Rochester-MN/Salary',
			'https://www.bestplaces.net/cost-of-living/duluth-mn/minneapolis-mn/50000',
			'https://www.zillow.com/minneapolis-mn/home-values/',
			'https://www.zillow.com/duluth-mn/home-values/',
			'https://www.zillow.com/rochester-mn/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/mn/minneapolis/',
			'https://www.rentjungle.com/average-rent-in-rochester-mn-rent-trends/',
			'https://www.rentcafe.com/average-rent-market-trends/us/mn/rochester/',
			'https://www.rentjungle.com/average-rent-in-duluth-rent-trends/',
			'https://www.zillow.com/duluth-mn/apartments/',
			'https://www.midwestliving.com/travel/minnesota/14-top-things-to-do-the-twin-cities/',
			'https://www.midwestliving.com/travel/minnesota/14-top-things-to-do-the-twin-cities/?slide=efd68ab0-58e6-4158-a695-8308f6f1414e#efd68ab0-58e6-4158-a695-8308f6f1414e',
			'https://livability.com/mn/rochester/real-estate/why-rochester-mn-is-a-top-100-best-place-to-live',
			'https://worldpopulationreview.com/us-cities/rochester-mn-population/',
			'https://www.tripadvisor.com/Tourism-g43018-Duluth_Minnesota-Vacations.html',
			'https://worldpopulationreview.com/us-cities/duluth-mn-population/',
			'https://worldpopulationreview.com/us-cities/minneapolis-population/',
			'https://worldpopulationreview.com/us-cities/st-paul-population/',
			'https://dps.mn.gov/divisions/dvs/Pages/new-to-minnesota.aspx',
			'https://www.sos.state.mn.us/elections-voting/register-to-vote/',
		],
	},
	MS: {
		state: 'Mississippi',
		stateNickname: 'Magnolia State',
		welcome: `
			<p>Tall pines, beautiful beaches, plenty of space to explore: These are just a few of the reasons to move to Mississippi. Birthplace of the blues, you can guarantee that culture is a really important aspect of Mississippi, a state that is known for its southern hospitality and delicious southern food.</p>
			<p>Mississippi is perfect for those who want a more laid back lifestyle. Take a stroll along the riverbank under a canopy of Magnolia flowers or go on the free self guided tour on the Mississippi Blues Trail! This southern state is full of some beautiful smaller towns like Cleveland, Oxford, Ocean Springs, or Vicksburg with its Southern Gothic architecture. And if you need a little more hustle to your bustle, there’s Jackson, which is still relatively small and easy going; and just bordering Mississippi’s northern and southern borders are the lively cities of Memphis, TN and New Orleans, LA.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>A nationwide rise in self-storage construction has been ongoing for the last several years. Like most areas of the country, Mississippi is seeing increased levels of self-storage development as investors look to enter new markets. Self-storage is often thought of as a recession-resistant business, so many investors may be hedging that it is a good place to put their money ahead of any future recession. Look for new self-storage developments going into growing parts of the state to accommodate the needs of movers and small businesses.</p>
				<p>Below is an overview of the current state of the Mississippi self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Mississippi is home to about 570 self-storage facilities.',
					highlight: '570',
				},
				{
					fact: 'Mississippi self-storage facilities cover 16,574,257 square feet of storage space.',
					highlight: '16,574,257',
				},
				{
					fact: 'Mississippi storage facilities offer 5.55 square feet of storage per person, which is close to the national average of 5.4 square feet per person.',
					highlight: '5.55',
				},
				{
					fact: 'Average price of a self-storage unit in Mississippi:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Jackson',
				price: '0',
			},
			{
				city: 'Vicksburg',
				price: '0',
			},
			{
				city: 'Tupelo',
				price: '0',
			},
			{
				city: 'Biloxi',
				price: '0',
			},
			{
				city: 'Hattiesburg',
				price: '0',
			},
			{
				city: 'Gulfport',
				price: '0',
			},
			{
				city: 'Oxford',
				price: '0',
			},
			{
				city: 'Meridian',
				price: '0',
			},
			{
				city: 'Southaven',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			reasons: [
				'Easy living. With one of the lowest costs of living and limited job markets, Mississippi is perfect for retirees and those working remotely. It’s hardly every cold so you can enjoy hanging on the porch sipping ice tea most of the year round.',
				'Great food. Mississippi is known for their southern food, especially the BBQ. In Jackson, there are several well loved family-owned restaurants that have been feeding customers for decades.',
				'Civil Rights Museum. Learn about one of the most important movements in American History, highlighting Mississippian’s who changed the course of history and paved the way for activists today.',
				'Beautiful beaches. Located on the Gulf Coast, there are plenty of beaches to enjoy. The beautiful, protected Gulf Island National seashore spans 160 miles from Mississippi into Florida.',
				'Pine forests. Mississippi is home to over 1.2 million acres of national forests. Go camping in the lush piney hills and go canoeing in the lake at the Clear Springs Recreation Center.',
				'Higher education. There are over 50 colleges, universities, and technical skills in Mississippi. That’s a lot for a smaller state!',
				'Historic battlefields. There are several historic sites where Civil War battles took place in Mississippi, the most famous one being the battle of Vicksburg.',
				"Pig ear sliders. Try this local delicacy for only $1.50 at The Big Apple Inn in Jackson. On second thought, don't.",
				'Petrified forest. Open year round, visitors can go on a short and easy walk to view 36 million old petrified fir and maple logs.',
				'Kermit the Frog Museum. The museum in Leland, Mississippi is where Jim Henson was thought to played with his friend “Kermit Scott” amongst the local natural attractions.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Mississippi is the 35th most populous state with 2.98 million residents as of 2019. The current population growth rate is between .05 percent and .30 percent, which is slower than most states. For comparison, Idaho has one of the highest growth rates at 2.05%. Mississippi’s population is expected to grow to about 3.15 million by 2020. It seems while there has been some growth in the last few years, Mississippi’s millennial population has dropped more than any other state, losing 35,013 people from 2010-2016. This is likely due to job opportunities in other states.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Slow and steady, Mississippi has one of the lower GDP annual growth rates at .3%. In 2017, the GDP was $96.8 billion, making it the 15th smallest. Some growth is better than no growth! In August 2019, the unemployment rate was 5.2 percent, slightly higher than August 2018, when the rate was at 4.7 percent.</p>
				<p>Mississippi’s economic growth for 2019 and 2020 is expected to increase by 1.2%. Much like Mississippi’s other stats, change is slow. Cost of living is 10% lower than the national average and the median home price is $187,000, making Mississippi one of the least expensive states to move to.</p>
				<p>Below are a few of Mississippi's top industries by real GDP value added:</p>
			`,
			breakdown: [
				{
					sector: 'Agriculture',
				},
				{
					sector: 'Manufacturing',
				},
				{
					sector: 'Mining',
				},
				{
					sector: 'Fishing',
				},
				{
					sector: 'Services',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'STA-Home Health and Hospice',
					employees: '17,000',
				},
				{
					employer: 'Sanderson Farms',
					employees: '14,000',
				},
				{
					employer: 'Commerce Bancorp',
					employees: '12,700',
				},
				{
					employer: 'Greek Orthodox Church of Holy',
					employees: '7,500',
				},
				{
					employer: 'Island View Casino and Resort',
					employees: '7,300',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Whether you want to enjoy that country living or get a taste of the city life, Mississippi has it all. Nature lovers get ready. Mississippi is home to lush pine forests and 161 miles of preserved national seashore.</p>
			`,
			cities: [
				{
					city: 'Jackson',
					copy: '<p>Jackson, the capital of Mississippi, is home to 170,674 people, and is Mississippi’s only city with a population over 100,000. The city is named after General Andrew Jackson and has a rich, but complicated history. Home to several renowned museums and historic restaurants with deliciously unique dishes, there are plenty of things to do and see in Jackson.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '11% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$123,000',
						},
						{
							item: 'Average rent',
							value: '$793',
						},
						{
							item: 'Average apartment size',
							value: '930 square feet',
						},
					],
				},
				{
					city: 'Gulfport',
					copy: '<p>Gulfport is the second largest city in Mississippi with a population of 71,856 inhabitants. Hit hard by Hurricane Katrina in 2005, the city has since gone through some major reconstruction. Located on the Gulf of Mexico, visitors can enjoy the white sand beaches, stand up paddle-boarding, and sailing, as well as some yummy seafood.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '11% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$178,500',
						},
						{
							item: 'Average rent',
							value: '$823',
						},
						{
							item: 'Average apartment size',
							value: '930 square feet',
						},
					],
				},
				{
					city: 'Southaven',
					copy: '<p>The third largest city in Mississippi is Southaven, with around 52,589 inhabitants. Considered to be part of the greater Memphis area, Southaven is known for its BBQ and outdoor activities.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '17% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$183,000',
						},
						{
							item: 'Average rent',
							value: '$926',
						},
						{
							item: 'Average apartment size',
							value: '984 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New Residents must get a new license within 60 days of moving to Mississippi. After that, they need to go in person to their local DPS and apply for a Mississippi drivers license, in order to continue driving legally. When applying, applicants must surrender their unexpired license from another U.S. state or territory. Applicants with a valid license from another U.S. state or territory are exempt from having to take a written or driving test.',
				link: 'https://www.dmv.org/ms-mississippi/apply-license.php',
			},
			{
				title: 'Vehicle registration',
				copy: "You must register your out-of-state vehicle within 30 days of moving to Mississippi. To register your vehicle, you'll need a vehicle inspection and insurance, and to register at your local county tax-assessor collector office. You’ll need your vehicle title, driver’s license, an odometer reading, your VIN, and payment for your registration fee. For more information check out the Mississippi DMV website:",
				link: 'https://www.dmv.org/ms-mississippi/car-registration.php',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in the 2020 primaries, you must register by February 28th, 2020 by 12:00 p.m.',
				link: 'https://www.rockthevote.org/voting-information/election-dates-deadlines/mississippi/',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/mississippi-population/',
			'https://mississippitoday.org/2018/08/17/key-economic-report-confirms-mississippi-losing-millennials-faster-than-any-other-state/',
			'https://www.wlbt.com/2019/09/20/number-mississippians-working-increased-august/',
			'https://www.usatoday.com/picture-gallery/money/economy/2018/08/23/states-with-the-best-and-worst-economies/37490719/',
			'https://www.mdes.ms.gov/news/2019/09/20/mississippi-s-employment-situation/',
			'https://www.nps.gov/guis/planyourvisit/things2do.htm',
			'https://en.wikipedia.org/wiki/Jackson,_Mississippi#cite_note-6',
			'https://mcrm.mdah.ms.gov/',
			'https://en.wikipedia.org/wiki/LeFleur%27s_Bluff_State_Park',
			'https://www.zillow.com/jackson-ms/home-values/',
			'https://www.zillow.com/gulfport-ms/home-values/',
			'https://www.zillow.com/southhaven-ms/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ms/jackson/',
			'https://www.rentjungle.com/average-rent-in-gulfport-rent-trends/',
			'https://www.payscale.com/cost-of-living-calculator/Mississippi-Gulfport',
			'https://www.payscale.com/cost-of-living-calculator/Tennessee-Memphis',
			'https://www.architecturaldigest.com/story/why-i-moved-to-jackson-mississippi',
			'https://www.mississippi.edu/urc/downloads/outlook/0119mseo.pdf',
			'https://www.onlyinyourstate.com/mississippi/reasons-to-move-to-ms/',
			'https://msbluestrail.org/blues_marker_list',
			'https://theculturetrip.com/north-america/usa/mississippi/articles/the-10-most-beautiful-towns-in-mississippi/',
			'https://www.onlyinyourstate.com/mississippi/best-bbq-joints-in-ms/',
			'https://www.fs.usda.gov/mississippi/',
			'https://www.mspetrifiedforest.com/visitorinfo/',
			'https://traveltips.usatoday.com/major-civil-war-parks-mississippi-60270.html',
			'https://www.dmv.org/ms-mississippi/apply-license.php',
		],
	},
	MO: {
		state: 'Missouri',
		stateNickname: 'Show Me State',
		welcome: `
			<p>There’s a lot to love about Missouri. Although the state is not the location of the geographic center of the lower 48 states — that designation goes to Lebanon, Kansas, about 180 miles west of the state’s border with Kansas — Missouri is a crossroads of our nation. It has a little bit of the south, and a big serving of Midwest charm. The state has some big city features, in Kansas City and St. Louis, vast nature areas, and history at every turn.</p>
			<p>Missouri offers a lot of options to its citizens, including one of the lowest costs of living in the country. Missouri is nicknamed the Show-Me-State — because its locals prefer simple common sense over “frothy eloquence.” From the Ozark Mountains to the Mississippi River, Missouri has a lot to show its visitors and residents. </p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Like the rest of the country, Missouri has seen a surge in self-storage development activity in the recent years. After the recession developers could not finance enough projects to keep up with the natural demand for storage created in markets with growing populations. This led availability of storage to decrease and prices to rise. Lately, construction has returned to the industry and lowering prices for consumers. Buoyed by the growth of its urban centers, Missouri has seen a recent rise in the number of self-storage facilities operating in the state.</p>
				<p>Check out the facts below to learn more about the size of the Missouri self-storage industry:</p>
			`,
			facts: [
				{
					fact: 'Missouri is home to about 1,142 self-storage facilities.',
					highlight: '1,142',
				},
				{
					fact: 'Missouri self-storage facilities cover 30,882,847 square feet of storage space.',
					highlight: '30,882,847',
				},
				{
					fact: 'Missouri storage facilities offer 5.18 square feet of storage per person, which is close to the national average of 5.4 square feet per person.',
					highlight: '5.18',
				},
				{
					fact: 'Average price of a self-storage unit in Missouri:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'St. Louis',
				price: '0',
			},
			{
				city: 'Kansas City',
				price: '0',
			},
			{
				city: 'Springfield',
				price: '0',
			},
			{
				city: 'Joplin',
				price: '0',
			},
			{
				city: 'Columbia',
				price: '0',
			},
			{
				city: 'Branson',
				price: '0',
			},
			{
				city: 'Jefferson City',
				price: '0',
			},
			{
				city: 'Independence',
				price: '0',
			},
			{
				city: 'Hannibal ',
				price: '0',
			},
			{
				city: 'Saint Joseph',
				price: '0',
			},
			{
				city: 'Saint Charles',
				price: '0',
			},
			{
				city: 'Cape Girardeau',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're thinking about making the move, but aren't sure if Missouri is the right place for you, consider the following:</p>",
			reasons: [
				'The Gateway Arch. — more than just a monument. Missouri’s central location where the Midwest and the South converge makes the state a gateway. And, most people will quickly recognize St. Louis’s Gateway Arch as a monument to a national crossroad. The Arch stands 630 feet above the city, and is the tallest man-made monument in the United States.',
				'Branson is the ultimate family vacation destination. An Ozark mountain town, turned live entertainment capital of Missouri, and arguably the Midwest, Branson has attractions for the whole family. The historic downtown area is famously lined with music venues, but the area is also home to amusement parks, shopping, and outdoor activities. ',
				'Lakes and rivers galore. For a landlocked state, Missouri has a lot of water coursing through its cities and towns. The Mississippi River serves as the state’s eastern border, but other major rivers cut across the area, offering fishing, boating, and other water activities. ',
				'Lake of the Ozarks. One of the most popular recreation spots in Missouri, however, is the Lake of the Ozarks. This man-made lake in central Missouri offers 1,150 miles of shoreline and a big focus on boating. Looking for a huge party scene? Check out Party Cove, which the New York Times has noted as the oldest established permanent floating party in the country.',
				'Music is part of Missouri’s history. We know Branson is a music center, but Missouri is also the land of Chuck Berry, one of the architects of rock and roll. Jazz, blues, bluegrass, and ragtime all were partly developed in St. Louis and Kansas City. ',
				'Missouri nature preserves. Looking for outdoor adventures? The state has numerous well-regarded nature preserves including Ha Ha Tonka State Park, Elephant Rocks State Park, Marvel Cave, Smallin Civil War Cave, and many more.',
				'Forest Park. Even the state’s biggest cities have ample outdoor spaces, such as St. Louis’s Forest Park. This urban park contains the St. Louis Zoo and was the site of the 1904 World’s Fair and the 1904 Summer Olympics.',
				'Missouri food delights. Missouri also has a unique cuisine that bridges Midwestern and Southern taste buds. St. Louis style pizza has a cracker-thin crust, provel cheese (a buttery processed cheese), and is usually square-cut. Toasted ravioli is also rumored to have its origins in St. Louis.',
				'Great Kansas City BBQ. But, one cannot talk about Missouri cuisine without mentioning barbecue. In Kansas City, the best can be found at Joe’s. The most famous dish at this venerable BBQ spot is the Z-Man sandwich, featuring sliced smoked brisket, smoked provolone cheese, onion rings, and Kansas City-style barbecue sauce.',
				'Literary history. In many ways, Missouri is a literary hub of the Midwest and the South — at least when it comes to childhood homes of notable authors. Mark Twain’s boyhood home is in Hannibal, and the Mark Twain National Forest occupies 1.5 million acres in the southern part of the state. Missouri is also the hometown of such diverse authors as Kate Chopin, Maya Angelou, and Dale Carnegie.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Missouri has a population of 6.15 million, up from 5.9 million in 2010. The state has a relatively low growth rate of .28%, which is 41st in the country. It is a sparsely populated state, with about 87 people per square mile. A large percentage of the state’s population lives in rural communities, with as many as one-third of the state's residents living in these areas.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Missouri’s gross domestic product at the end of 2018 was $323 billion, which ranks 22nd in the nation. This is up from $316 billion in the prior year. Growth is not the strongest in the Show-Me-State, although the state’s gross domestic product grew 2.3% from 2018 to 2019. While this is positive growth, the state lags behind the national average of 2.9%. Even with less-than-average growth, Missouri has a thriving manufacturing sector, as well as wholesale trade and a growing information services sector.</p>
				<p>Historically, Missouri’s location as a crossroads of the nation, and access to the Mississippi River, has helped propel its economy through the nation’s ups and downs since the area became part of the United States after the Louisiana Purchase in 1803.</p>
				<p>Today, the state’s economy involves all sorts of industries, from manufacturing and technology to greeting cards and retail. Like many states, healthcare is a key driver of economic activity, with the state’s hospitals and clinics adding $27 billion to the economy. These hospitals also account for 310,000 jobs.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Viasystems Group, Inc.',
					employees: '15,000',
				},
				{
					employer: 'Express Scripts Holding Co.',
					employees: '10,000',
				},
				{
					employer: 'Cox Medical Center South ',
					employees: '10,000',
				},
				{
					employer: 'Ford Motor Company',
					employees: '8,000',
				},
				{
					employer: 'Anheuser-Busch Co.',
					employees: '5,000',
				},
				{
					employer: 'General Motors',
					employees: '4,000',
				},
				{
					employer: 'Bayer Crop Science',
					employees: '4,000',
				},
				{
					employer: 'Hallmark Cards',
					employees: '3,700',
				},
				{
					employer: 'Freeman Health System',
					employees: '3,500',
				},
				{
					employer: 'US Air Force 509th Contracting',
					employees: '3,500',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Missouri is a medium-sized state, with about 69,000 square miles. While there is a lot of economic activity in the major metropolitan areas of the state, there is opportunity throughout Missouri for everything from relaxed living to the hustle and bustle of city life.</p>
				<p>Here’s a quick look at the state’s three largest cities:</p>
			`,
			cities: [
				{
					city: 'Kansas City',
					copy: '<p>Yes, it may be confusing, but the largest city in Missouri shares its name with a neighboring state. Kansas City boasts a population of 491,918. The city also borders Kansas City, Kansas, which has a much smaller population of about 145,000. The average salary in the city is $62,000, which is slightly higher than the national average. The cost of living in Kansas City, however, is approximately equal to that of the United States as a whole.The biggest employers in Kansas City include the U.S. Federal Government, Cerner Corporation (health care information services,) University of Missouri-Kansas City, and Hallmark Cards.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: 'Equal to the national cost of living',
						},
						{
							item: 'Median home price',
							value: '$149,000',
						},
						{
							item: 'Average rent',
							value: '$1,004/month',
						},
						{
							item: 'Average apartment size',
							value: '900 square feet',
						},
					],
				},
				{
					city: 'St. Louis',
					copy: '<p>The next largest city in Missouri according to population is St. Louis, with approximately 318,000 residents. This major city embraces its status as gateway to the rest of the United States, no matter what direction you are coming from. Where do all of these residents work? The largest employment areas are in healthcare, but Anheuser Busch, Boeing, and Panera Bread each have many employees in the area.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '6% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$159,000',
						},
						{
							item: 'Average rent',
							value: '$957/month',
						},
						{
							item: 'Average apartment size',
							value: '846 square feet',
						},
					],
				},
				{
					city: 'Springfield',
					copy: '<p>The next largest city in Missouri is Springfield, located in the eastern portion of the state, with 167,000 residents. The average salary in Springfield is lower than most of the state, with an emphasis on skilled nursing and service-industry employment. Big employers in Springfield include Cox Health, Mercy Hospital Springfield, Walmart, Inc., Bass Pro Shops, and O’Reilly Auto Parts. House prices average $147,000, while rents average $799 for an average apartment in the Springfield area.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '12% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$159,000',
						},
						{
							item: 'Average rent',
							value: '$799/month',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents who possess a driver’s license from another state must obtain a Missouri license within 60 days of establishing residency.',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents of Missouri must title their vehicles with the state within 30 days.',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Missouri, you must be a citizen of the United States, be 18 years of age or older on or before the date of the next election, and must be a resident of the state.',
			},
		],
		sources: [
			// static content
			'https://www.gatewayarch.com/plan-your-visit/#frequently-asked-questions',
			'https://www.branson.com/learn/general-branson-info/branson-facts/',
			'https://shsmo.org/research/guides/music/',
			'https://www.joeskc.com/pages/the-legend-of-the-z-man',
			'https://www.sos.mo.gov/archives/history/slogan.asp',
			'https://edckc.com/workforce-talent/major-employers/',
			'https://www.rentcafe.com/average-rent-market-trends/us/mo/saint-louis/',
			'https://www.springfieldregion.com/doing-business/major-employers/',
			'https://dor.mo.gov/new2mo.php',
		],
	},
	MT: {
		state: 'Montana',
		stateNickname: 'Treasure State',
		welcome: `
			<p>Known as “Big Sky Country” for its open and spacious landscape, Montana is the fourth largest state in the U.S. regarding the sheer size. It’s a landlocked state bordered by Idaho, Wyoming, North and Montana, and three Canadian provinces (British Columbia, Alberta, and Saskatchewan). It’s home to numerous parks, including Glacier National Park and Yellowstone National Park, which makes it a destination spot for over 13 million tourists each year. Tourism is a significant source of Montana’s economy, and the residents treasure their naturally awe-inspiring state.</p>
			<p>Although Montana is an official mountain state, over half of it is covered in prairie lands. Badlands and forests cover the rest of the state as rivers and streams snake throughout the area. Because of its fierce, natural beauty, nearly 35% of Montana is protected by the federal and state government. The weather in Big Sky Country typically offers comfortable summers with bitter cold winters. However, the state’s various geography often means Montanans experience vastly different weather conditions from region to region. Despite the weather, tourism and other resources have created a boom in Montana’s economy, making it a popular place to relocate.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>As many households relocate to Montana for jobs, recreation and a more affordable cost of living, the self-storage sector has found opportunity to develop new self-storage properties in recent years. A nationwide trend towards self-storage development over the last few years has resulted in more self-storage investment moving into Montana than usual. That said, Montana already has an abundance of self-storage space relative to the population with 9.87 square feet of storage per capita–almost double the national ratio of 5.4 square foot per person.</p>
			`,
			facts: [
				{
					fact: 'Montana is home to an estimated 370 self-storage facilities.',
					highlight: '370',
				},
				{
					fact: 'Montana self-storage facilities cover 10,096,640 square feet of storage space.',
					highlight: '10,096,640',
				},
				{
					fact: 'Montana storage facilities offer 9.87 square feet of storage per person, which is greater than the national average of 5.4 square feet per capita.',
					highlight: '9.87',
				},
				{
					fact: 'Average price of a self-storage unit in Montana:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Bozeman',
				price: '0',
			},
			{
				city: 'Billings',
				price: '0',
			},
			{
				city: 'Missoula',
				price: '0',
			},
			{
				city: 'Whitefish',
				price: '0',
			},
			{
				city: 'Livingston',
				price: '0',
			},
			{
				city: 'Helena',
				price: '0',
			},
			{
				city: 'Great Falls',
				price: '0',
			},
			{
				city: 'Butte',
				price: '0',
			},
			{
				city: 'Big Sky',
				price: '0',
			},
			{
				city: 'Havre',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>Few states offer such indescribable natural beauty and opportunity as Montana. Here are a few more reasons why this is such a great state to set up camp:</p>',
			reasons: [
				'Outdoor recreation. Nearly 81% of the state’s population take part in outdoor recreational activities. From fly fishing to hunting, from hiking to skiing, there’s never a shortage of things to do outdoors.',
				'Unrivaled scenery. With such an array of unique land formations, bold mountains, and lush rivers, Montana is easy on the eyes. It’s called “Big Sky Country” for a reason, after all! The diverse landscape offers a sense of adventure and wild-heartedness to even the most reserved individuals.',
				'Vibrant cities. Even with the state’s wild outdoors, its cities and towns don’t leave you wanting. Several Montana cities have ranked as the top 100 best places to live time after time.',
				'Top-ranked colleges. With all the outdoor enjoyment to be had, you might think there was no time for education. But think again! Montana houses many of the top-ranked colleges and universities in the country, including the University of Montana and Montana State University. The state even provides several tribal colleges, as well.',
				'Literary hotspot. Authors and poets seem to gravitate toward Montana. Many of the top writers in the country live within 100 miles of Livingston. As a result, the state is a wonderland for all things literary, housing bookstores, workshops, and nonprofit literacy organization galore.',
				'High-tech economy. Gone are the days when mining for gold was the best gig you could get. Instead, Montana has made its mark on the high-tech sector, increasing its annual revenues significantly in recent years.',
				'Low property taxes. Homeownership is a popular way of life in Montana. Mainly because property taxes are lower than the national average, landing it as the 20th least expensive state in the U.S.',
				'Rich history. Epic and violent battles once took place in Montana, and the stories deriving from the land are endless. Native Americans, such as Crow and Cheyenne, first settled here, causing a rift when the area was discovered in the 1800s by the Lewis and Clark Expedition.',
				'Exotic cuisine. As in many other U.S. states, Montana offers unique culinary delights. However, only here will a bison burger or an elk steak work as a go-to meal. Plus, this state is so abundant in wildlife and farms that you can always find plenty of savory and exotic cuisine.',
				'Health and fitness. It’s no surprise that those who live in Montana tend to lead exceptionally healthy lifestyles. The open spaces, outdoor activities, and fresh air all contribute to a deep sense of purpose and a strong sense of community, as well.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Montana is the fourth largest state regarding the total area. However, only 1.07 million individuals call it home, which ranks it 43rd in terms of population. Only two other states in the U.S. have fewer people per square mile—Alaska and Wyoming. Several decades ago, people relocated to Montana for employment. Today, however, they’re moving to the Big Sky Country for outdoor recreation. With a reasonable growth rate of 0.79%, Montana recently ranked as the 26th fastest-growing state in the U.S.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>As tourism and the high-tech industry bolster Montana’s economy, its GDP has grown to $46.6 billion, ranking it 44th in the U.S.</p>
				<p>Big Sky Country continues to experience economic growth, which benefits both businesses and individuals. The stable economic conditions are expected to continue, drawing workers and entrepreneurs to Montana in the future. As mentioned, significant pillars of Montana’s economy are tourism and the high-tech industry. One holdup is that broadband is not readily available in some communities, making it tricky to launch startups. However, Montana’s government has made that issue a new priority.</p>
				<p>Below is a breakdown of Montana’s largest sectors by GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Real estate',
					value: '$5.9 billion',
				},
				{
					sector: 'Trade',
					value: '$5.8 billion',
				},
				{
					sector: 'Healthcare and private education',
					value: '$4.8 billion',
				},
				{
					sector: 'Mining and utilities',
					value: '$3.1 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$3.1 billion',
				},
			],
			bottomLine: `
				<p>The cost of living remains below the national average, though Montanans spend their money on different products than the rest of the country. For example, housing costs tend to fall under the national average, as well. However, with significant distances between cities, Montana residents tend to purchase more gasoline. Thankfully, gas prices have decreased in the past five years. Plus, wages and personal income has also seen an uptick in recent years, making the overall cost of living more manageable, too. The unemployment rates in September 2019 was 3.3%, which is below the national average.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Billings Clinic',
					employees: '4,600',
				},
				{
					employer: 'Aageson Farms',
					employees: '3,000',
				},
				{
					employer: 'State of Montana',
					employees: '2,680',
				},
				{
					employer: 'Glacier Bancorp',
					employees: '2,615',
				},
				{
					employer: 'Bozeman Health',
					employees: '2,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Montana is the fourth largest state in the U.S., encompassing 147,040 square miles. Only Alaska, Texas, and California are bigger. To put it into a more worldwide perspective, Montana is a hair larger than Japan. Although Montana isn’t overflowing with bustling metropolises, here are its biggest cities:</p>
			`,
			cities: [
				{
					city: 'Billings',
					copy: '<p>With a population of 110,263, Billings is the largest city in Montana. It’s characterized by the dramatic landscape, plenty of recreational opportunities, and a Western flavor.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '17% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$209,756',
						},
						{
							item: 'Average rent',
							value: '$1,012/month',
						},
						{
							item: 'Average apartment size',
							value: '1,160 square feet',
						},
					],
				},
				{
					city: 'Missoula',
					copy: '<p>Missoula offers its 71,022 residents a high quality of life, being tucked away in 60,000 acres of breathtaking wilderness. Aside from the outdoor adventuring, however, beer breweries and distinct eateries draw many people to this city.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '10% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$334,164',
						},
						{
							item: 'Average rent',
							value: '$1,035/month',
						},
						{
							item: 'Average apartment size',
							value: '1,030 square feet',
						},
					],
				},
				{
					city: 'Great Falls',
					copy: '<p>This Montana city is located at the foot of the Rocky Mountains, and 59,638 call it home. Although tourism doesn’t bolster its economy like in many other cities, it does offer a small-town vibe that many people desire.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '2.9% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$169,670',
						},
						{
							item: 'Average rent',
							value: '$982/month',
						},
						{
							item: 'Average apartment size',
							value: '1,150 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Louisiana are required to transfer their out of state driver's license within 30 days of moving to the state. You'll have to appear in person at your local Office of Motor Vehicles and bring your out of state license, two forms of ID, social security verification, proof of insurance, and proof of residency. Minors require a legal guardian with a picture ID and a completed Certificate of Required School Attendance from their school. For more info, visit:",
				link: 'https://dojmt.gov/driving/driver-licensing/#DLID10',
			},
			{
				title: 'Vehicle registration',
				copy: 'A 60-day grace period also exists for new Montana residents to register their vehicles. It’s a reasonably straightforward process of applying at your local county treasurer’s office. You must present your out-of-state title, complete an MV100 form, and pay all filing fees.',
				link: 'https://dojmt.gov/driving/vehicle-title-and-registration/',
			},
			{
				title: 'Voter Registration',
				copy: 'Montana requires that you register to vote 30 days before an election, but online applications make the process quicker. You can register to vote in Montana here:',
				link: 'https://sosmt.gov/elections/vote/',
			},
		],
		sources: [
			// static content
			'https://livability.com/mt/real-estate/6-reasons-to-move-to-montana-right-now',
			'https://www.moving.com/tips/10-reasons-to-move-to-montana/',
			'https://worldpopulationreview.com/states/montana-population/',
			'https://www.bestplaces.net/city/montana/billings',
			'https://livability.com/mt/missoula',
			'https://www.bestplaces.net/city/montana/great_falls',
			'https://www.payscale.com/cost-of-living-calculator/Missouri-Billings',
			'https://smartasset.com/mortgage/the-cost-of-living-in-montana',
			'https://en.wikipedia.org/wiki/Montana',
			'https://dojmt.gov/driving/driver-licensing/#DLID10',
			'https://dojmt.gov/driving/vehicle-title-and-registration/',
			'https://sosmt.gov/elections/vote/',
			'https://en.wikipedia.org/wiki/List_of_U.S._states_by_GDP_per_capita',
			'https://www.bls.gov/eag/eag.mt.htm',
			'https://business.mt.gov/Portals/49/MT%20Economic%20Development%20Report_2019.pdf?ver=2019-07-25-144219-790',
			'https://lmi.mt.gov/Portals/193/Publications/LMI-Pubs/Labor%20Market%20Publications/LDR19.pdf',
			'https://livability.com/mt/business/top-employers-in-montana',
			'https://www.zippia.com/billings-clinic-careers-1256153/',
			'https://www.zippia.com/montana-careers-785916/',
			'https://www.zippia.com/glacier-bancorp-careers-4959/',
		],
	},
	NE: {
		state: 'Nebraska',
		stateNickname: 'Cornhusker State',
		welcome: `
			<p>The Cornhusker State rests in the breadbasket of America. Nebraska is known for its agriculture business, which is booming, but there is more to the state than corn and beef. Omaha and Lincoln make up the bulk of the population in Nebraska. Lincoln is home to the University of Nebraska, and the town's nightlife and dining options reflect that. In the more rural areas of the state, you will find friendly folks who are more open minded than you may think. The state’s motto, after all, is “Equality Before the Law”. Cost of living and unemployment are both well below the national average and the job market is flourishing. It’s no wonder that more and more people are moving to the middle of the country to find job opportunities and affordable housing.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Nebraska self-storage industry has been flourishing as of late. A trend of increased self-storage development has been taking place across the nation over the last years, setting all time records for construction dollars spent in the sector. As a result nearly every state is seeing increased levels of self-storage development, including Nebraska. Developers have been pursuing sites in high growth areas where they can buy land or redevelop vacant retail store buildings.</p>
			`,
			facts: [
				{
					fact: 'Nebraska is home to more than 342 self-storage facilities',
					highlight: '342',
				},
				{
					fact: 'Nebraska facilities offer more than 10,404,911 million square feet of storage space combined.',
					highlight: '10,404,911',
				},
				{
					fact: "Nebraska  has 5.56 square feet of storage space for every man, woman, and child. That's comparable to the national average of 5.4 square feet per capita.",
					highlight: '5.56',
				},
				{
					fact: 'Average price of a self-storage unit in Nebraska : ',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Omaha',
				price: '0',
			},
			{
				city: 'Lincoln',
				price: '0',
			},
			{
				city: 'Kearney',
				price: '0',
			},
			{
				city: 'Grand Island',
				price: '0',
			},
			{
				city: 'Norfolk',
				price: '0',
			},
			{
				city: 'Bellevue',
				price: '0',
			},
			{
				city: 'North Platt',
				price: '0',
			},
			{
				city: 'Columbus',
				price: '0',
			},
			{
				city: 'Scottsbluff',
				price: '0',
			},
			{
				city: 'Hastings',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			reasons: [
				'Cornhuskers football. Nebraskans take their football seriously--and they certainly should. The University of Nebraska at Lincoln’s legendary team has earned five National Championships and 46 conference championships. The Cornhuskers play their home games at Memorial Stadium in Lincoln. The stadium, aptly nicknamed “The Sea of Red”,has sold out for every single home game since 1962.',
				'Kool-Aid days. In 1927, a curious minded inventor named Edwin Perkins of Hastings, Nebraska created Kool-Aid in his mother’s kitchen. Kool-Aid is now the official soft-drink of Nebraska, mostly due to the origins of its creator. Every year on the second weekend of August, Hastings hosts a Kool-Aid festival called Kool-Aid Days. If you get lucky, you can catch sight of the clumsy Kool-Aid Man. Oh-Yeah!!',
				'Midwestern hospitality. The Heartland is known for producing some of the most genuine and sincere folks you can meet. The friendly faces and calm demeanor of Nebraskans can offer new residents a nice respite from the turn and burn attitude of the inhabitants of the more ruthless states. I’m foreseeing friendly neighbors offering up steamy pans of corn casserole to you in the future.',
				'Location. The state of Nebraska is surrounded by six states including: South Dakota, Kansas, Colorado, Wyoming, Iowa and Missouri. This gives residents many options for weekend road trips for exploring America’s Great Plains.',
				'Arbor Day. J. Sterling Morton moved to Nebraska in 1854, and although he loved his new home in The Great Plains, he thought it could do with a few more trees. Morton suggested that there be a day in which the folks of Nebraska all plant trees. It is said that Nebraskans plated upwards of one million trees on that first Arbor Day. Nebraskans still embrace the holiday with fervor, and Morton’s birthday is now the nationally recognized date of Arbor Day.',
				'Nebraskan wine. You might not assume it, but Nebraska is making a name for itself as a solid producer of wine in the U.S. Although the state is too cold to grow most traditional European grapes, it does great with cold weather vines. In 2006, the states first riesling was produced by Whisky Run Creek vineyards in Brownsville. The University of Nebraska is in on it to--it now offers a viticulture program.',
				'Room to roam. Nebraska is one of the least densely populated states in the nation. This is great news to people who don’t necessarily like being around a lot of people. And if you do like clusters of humans, populous cities like Omaha and Lincoln will be a great fit for you.',
				'Gateway to the west. There are some great options for nature lovers in Nebraska. Chimney Rock is probably the states most well known natural formation. Toadstool Geological Park, Scotts Bluff and Smith Falls are also popular attractions amongst the outdoor types. ',
				'Runza sammies. The Runza is the National Sandwich of Nebraska. It is a mixture of beef, cabbage, onions, and seasoning surrounded by a yeast bread pillow (YUM). Over 10,000 runza sandwiches are sold during each Cornhuskers game at Memorial Stadium.',
				'Jobs galore. Nebraska has one of the lowest unemployment rates in the nation, recently clocking in at 3.1%. And it’s not just ag jobs that exist, there are plenty of opportunities through the institutions of higher learning and a Nebraskan tech boom in happening via the Silicon Prairie.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>As of 2019, Nebraska is the 38th most populated state in the nation with 1,940,919 residents. The population growth rate from 2017 to 2018 was .61%. Many students from out of state move to Nebraska to take advantage of the states higher education facilities.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Nebraska’s Real Gross Domestic Product reached $112.17 billion in 2018. As of September 2019, Nebraska’s unemployment rate as of September 2019 is 3.1%, up .4% from last year. Since 2011, Nebraska’s Real GDP has increased by $10 billion. The state’s cost of living is 11.5% below the national average and houses are extremely affordable compared to the rest of the nation.</p>
				<p>Below is a list of the top 5 sector’s Real GDP breakdown:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, Insurance and Real Estate',
					value: '$20.6 billion',
				},
				{
					sector: 'Government Enterprise',
					value: '$13.1 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$12.3 billion',
				},
				{
					sector: 'Education, Health Care and Social Assistance',
					value: '$9.3 billion',
				},
				{
					sector: 'Agriculture',
					value: '$8.3 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Billings Clinic',
					employees: '4,600',
				},
				{
					employer: 'Aageson Farms',
					employees: '3,000',
				},
				{
					employer: 'State of Montana',
					employees: '2,680',
				},
				{
					employer: 'Glacier Bancorp',
					employees: '2,615',
				},
				{
					employer: 'Bozeman Health',
					employees: '2,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Nebraska stretches 210 miles wide and 430 miles long. With its 76,874 square mile total area, it is the 16th largest state in the nation. The average elevation is 2,500 feet, and the highest point is 5,424 feet.</p>
			`,
			cities: [
				{
					city: 'Omaha',
					copy: '<p>Omaha is the most populated city in Nebraska. It is the 40th-largest city in the nation with 452,061 residents. Four Fortune 500 companies are headquartered in Omaha.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '8% below the national average',
						},
						{
							item: 'Median home price',
							value: '$179,000',
						},
						{
							item: 'Average rent',
							value: '$929/month',
						},
						{
							item: 'Average apartment size',
							value: '924 square feet',
						},
					],
				},
				{
					city: 'Lincoln',
					copy: '<p>Lincoln is the second most populated city in the state of Nebraska with 291,623 residents. Lincoln is the capital of Nebraska and the home to the University of Nebraska.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '7% below the national average',
						},
						{
							item: 'Median home price',
							value: '$182,800',
						},
						{
							item: 'Average rent',
							value: '$964/month',
						},
						{
							item: 'Average apartment size',
							value: '944 square feet',
						},
					],
				},
				{
					city: 'Bellevue',
					copy: '<p>With 54,582 residents, Bellevue is the third most populated city in Nebraska. Bellevue is recognized as the second-oldest city in the state of Nebraska.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '7% below the national average',
						},
						{
							item: 'Median home price',
							value: '$181,800',
						},
						{
							item: 'Average rent',
							value: '$1,071/month',
						},
						{
							item: 'Average apartment size',
							value: '1050 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'Within 30 days of moving to Nebraska, you will be required to obtain a state issued driver’s license. Stop by your local DMV with proof of citizenship or birth certificate and two documents proving your current Nebraska address. You will also need to surrender your old license and take a vision test before getting your new ID.',
			},
			{
				title: 'Vehicle registration',
				copy: 'You will need to get your vehicle registered by the state of Nebraska within 30 days of moving. To do that, you will need to go to your county’s motor vehicle office with your current certificate of title. Once they approve your title, you will need to show proof of automobile insurance and pay the appropriate fees to obtain your certificate of title. After getting your title certified, you will be able to apply for your Nebraska approved motor vehicle registration.',
			},
			{
				title: 'Voter Registration',
				copy: "After you receive your Nebraska state ID, you're going to want to register to vote. The Nebraska Secretary of State has a portal that will help you go through the motions of getting your voter ID card.",
				link: 'https://www.nebraska.gov/apps-sos-voter-registration/',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/nebraska-population/',
			'https://en.wikipedia.org/wiki/Nebraska',
			'https://worldpopulationreview.com/states/nebraska-population/cities/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ne/lincoln/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ne/bellevue/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ne/omaha/',
			'https://www.zillow.com/lincoln-ne/home-values/',
			'https://www.zillow.com/omaha-ne/home-values/',
			'https://www.zillow.com/bellevue-ne/home-values/',
			'https://www.payscale.com/cost-of-living-calculator/Nebraska-Omaha',
			'https://www.payscale.com/cost-of-living-calculator/Nebraska-Lincoln',
			'https://www.payscale.com/cost-of-living-calculator/Nebraska-Bellevue',
			'https://en.wikipedia.org/wiki/Omaha,_Nebraska',
			'https://en.wikipedia.org/wiki/Lincoln,_Nebraskahttps://en.wikipedia.org/wiki/Bellevue,_Nebraska',
			'https://dmv.nebraska.gov/dl/new-nebraska-resident-drivers-licensing',
			'https://dmv.nebraska.gov/dvr/reg/vehicle-registration',
			'https://dmv.nebraska.gov/dvr/new-nebraskahttps://www.nebraska.gov/apps-sos-voter-registration/',
			'https://www.kansascityfed.org/en/publications/research/ne/articles/2019/3q2019/more-young-out-of-staters-moving-to-nebraska',
			'https://ycharts.com/indicators/nebraska_unemployment_rate',
			'https://united-states.reaproject.org/data-tables/gsp-a900n/tools/310000/',
			'https://www.zippia.com/advice/largest-companies-in-nebraska/',
			'https://www.movoto.com/guide/ne/cost-of-living-in-nebraska-how-does-it-stack-up-against-the-average-salary/',
			'https://www.onlyinyourstate.com/nebraska/living-in-nebraska/',
			'https://www.movoto.com/guide/ne/nebraska-is-underrated/',
			'https://en.wikipedia.org/wiki/Nebraska_Cornhuskers_football',
			'https://en.wikipedia.org/wiki/Edwin_Perkins_(inventor)',
			'https://en.wikipedia.org/wiki/Kool-Aid',
			'https://www.mortonarb.org/visit-explore/about-arboretum/mission-and-history/arbor-day-history',
			'https://en.wikipedia.org/wiki/Nebraska_wine',
			'https://www.onlyinyourstate.com/nebraska/must-see-natural-attractions-ne/',
			'https://en.wikipedia.org/wiki/Runza',
			'https://www.bls.gov/web/laus/laumstrk.htm',
		],
	},
	NV: {
		state: 'Nevada',
		stateNickname: 'Silver State',
		welcome: `
			<p>If you have only visited Las Vegas, you might not understand why the translation of Nevada in spanish in “Snow Covered”. But the state is more than The Strip--Nevada is made of great stretches of arid desert stretching between picturesque snowy mountains and high desert. The Silver State marches to the beat of its own drum, and so do its inhabitants. Nevada gained its popularity as a mining state. Mineral mining is still extremely lucrative in Nevada, and it is the world’s 4th most productive miner of gold. Considering the state's natural beauty and financial possibilities, it’s no surprise that people want to call Nevada home.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Nevada self-storage industry has been on the rebound, with developers actively building new sites throughout the state to meet rising demand. Expansion of the self-storage industry in Nevada stalled for a while in the wake of the last recession. Now as the Nevada housing market has bounced back, the self-storage industry is whizzing along right behind it. There is currently record levels of self-storage development taking place nationwide, and Nevada is not missing out on the action. New storage builds are helping to bring much needed storage units to the market in Nevada, and putting downward pressure on rental rates.</p>
			`,
			facts: [
				{
					fact: 'Nevada is home to about 461 self-storage facilities.',
					highlight: '461',
				},
				{
					fact: 'Nevada self-storage facilities cover 25,206,895 square feet of storage space.',
					highlight: '25,206,895',
				},
				{
					fact: 'Nevada storage facilities offer 8.96 square feet of storage per person, which is much higher than the national average of 5.4 square feet per person.',
					highlight: '8.96',
				},
				{
					fact: 'Average price of a self-storage unit in Nevada:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Las Vegas',
				price: '0',
			},
			{
				city: 'Reno',
				price: '0',
			},
			{
				city: 'Henderson',
				price: '0',
			},
			{
				city: 'Carson City',
				price: '0',
			},
			{
				city: 'Sparks',
				price: '0',
			},
			{
				city: 'Laughlin',
				price: '0',
			},
			{
				city: 'North Las Vegas',
				price: '0',
			},
			{
				city: 'Pahrump ',
				price: '0',
			},
			{
				city: 'Virginia City',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>Few states offer such indescribable natural beauty and opportunity as Montana. Here are a few more reasons why this is such a great state to set up camp:</p>',
			reasons: [
				'Great housing market. It’s a buyers market in Nevada. The value of houses has gone up by 2.7% over the past year and, according to Zillow, they will increase by 1.2% within the year. If you are looking for some good real estate investment with a potential for positive growth, Nevada is a great place to be.',
				'Gambling is welcomed! If you’re feeling lucky, Nevada will be appealing to you. You don’t have to be in Las Vegas or Reno to reap the benefits of a gaming state. Players of poker, blackjack, slots, roulette and craps can find plenty of games across the state. If you have a hunch about who will be victorious in this week’s big game, Las Vegas is home to countless sports books. ',
				'Lake Tahoe. 20 miles west of Carson City is the alpine lake known as Lake Tahoe. Sitting at a 6,225 foot elevation, Lake Tahoe lies on the border of California and Nevada. The lake itself is abuzz in the warm months with jet skis, sport boats, paddle boards and swimmers. In the winter months, the powdery slopes of the surrounding Sierra Nevada Mountains steals all the attention. ',
				'No state taxes. For individuals who are looking to keep the government coffers out of their pocket book, Nevada might be the ideal state. In order to entice more new residents to move to Nevada, the state does not collect personal income tax or corporate income tax. Those savings could add up and help form a nice nest egg for residents in the future.',
				'Hikers dream. For those who love a good, scenic hike, Nevada has some great options. Red Rock Canyon, Mount Charleston and Fire Wave are parks just outside of Las Vegas that have impeccable trails. In the Sierra Nevada range to the west of the state, the panoramic views that can be found on the trails are exceptional. Nevada State Parks offers an annual all access pass on their website.',
				'So much sun. If you are somebody who needs lots of sun to give you energy, Las Vegas has got you covered. Sin City boasts of an average of 310 sunny days per year. People who are looking to escape gloomy clouds will find big bright skies across the state.',
				'Lake fun. Folks who are looking to beat the heat in Nevada’s hot and arid climate can find solstice in the cool lakes that are spread across the state, not just Lake Tahoe. Water skiing, wake-boarding, scuba diving, and fishing are some of the activities lake goers take part in. Many of Nevada’s lakes are surrounded by gorgeous mountains, which makes for some stunning photography. Most lakes offer camping on site, so bring a tent and make a weekend of it!',
				'24 Hour bars. For those who work the graveyard shift and want something to take the edge off once you clock out, you will be happy to know that there is no designated closing time for bars in Nevada. Liquor retailers in Nevada are also able to sell booze 24/7, so you can grab your goods on a Sunday at 9 am if you feel so inclined.',
				'Getting away from people. With the exception of Las Vegas and surrounding areas, Nevada is very sparsely populated. There are only eight other states in the nation that have a lower population density than Nevada. And with a total land area of 110,577 square miles in the state, introverts will have no problem finding space to be alone with their thoughts.',
				"Las Vegas attractions. The Vegas strip is a dream for anyone who is hard up for some entertainment. You could be at the craps table at one moment, and be dining in one of the nation's best restaurants the next. There is a huge variety of concerts, museums, variety shows, comedy acts, shopping and nightlife activities to be enjoyed also. You could never truly be bored in a place with so many entertainment options.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>The population in Nevada as of 2019 is 3,087,025, giving it the population rank of 33rd in the nation. From 2017-2018, the population grew from 2,972,405 to 3,034,392—a 2.09 percent increase. Nevada had population growth of 35 percent between 2000 and 2010. The housing collapse of 2008 sent a portion of those new residents back to their state of origin, but things are on the upswing again. Both Henderson and North Las Vegas are considered to be two of the 20 fastest growing cities in the nation.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>In 2018, Nevada’s Real Gross Domestic Product was $146 billion, ranking it the 33rd best GDP in the nation. As of September 2019, Nevada’s unemployment rate is hovering around 4.1 percent, down 0.4 percent from September 2018.</p>
				<p>Below is a list of Real GDP breakdown by sector:</p>
			`,
			breakdown: [
				{
					sector: 'Real Estate, Rental, Leasing',
					value: '$21.5 billion',
				},
				{
					sector: 'Accommodations',
					value: '$17.4 billion',
				},
				{
					sector: 'Government Industry',
					value: '$15.5 billion',
				},
				{
					sector: 'Retail Trade',
					value: '$10.9 billion',
				},
				{
					sector: 'Health Care',
					value: '$9.5 billion',
				},
			],
			bottomLine: `
				<p>In the past five years Nevada has increased its real GDP by $11 billion and signs for potential economic growth are evident. Although the states overall cost of living is 3 percent higher than the national average, its utility costs are 10 percent below it. The absence of personal income taxes and corporate income taxes are a sweet incentive to anyone looking to create a business or move their already existing business to Nevada.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'MGM Resort International',
					employees: '77,000',
				},
				{
					employer: 'Las Vegas Sands',
					employees: '50.500',
				},
				{
					employer: 'Caesar’s Entertainment',
					employees: '65,000',
				},
				{
					employer: 'Wynn Resorts',
					employees: '25,200',
				},
				{
					employer: 'Amerco/U-Haul',
					employees: '20,376',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>From the Mojave Desert to the south, to the high desert valleys and mountain ranges to the north, Nevada has a wide range of terrain. Nevada’s total land area is 110,577 square miles, ranking 7th in the nation. The average elevation in Nevada is 5,500 feet. Boundary Peak, Nevada’s highest peak, sits at 13,147 feet.</p>
			`,
			cities: [
				{
					city: 'Las Vegas',
					copy: '<p>Las Vegas is a resort city full of frills and thrills including gambling, fine dining, entertainment and shopping. The city claims to have more AAA 5 diamond hotels than anywhere else in the world. It is the 28th most populous city in the nation and is currently home to more than 664,304 people.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3% higher than national average',
						},
						{
							item: 'Median home price',
							value: '$272,800',
						},
						{
							item: 'Average rent',
							value: '$1,104',
						},
						{
							item: 'Average apartment size',
							value: '894 square feet',
						},
					],
				},
				{
					city: 'Henderson',
					copy: '<p>Henderson is the second largest city in Nevada with 317,248 residents. It is part of the Las Vegas metro area and was voted by Forbes magazine as “one of the safest places to live” in the US.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '12% higher than national average',
						},
						{
							item: 'Median home price',
							value: '$326,400',
						},
						{
							item: 'Average rent',
							value: '$1,322',
						},
						{
							item: 'Average apartment size',
							value: '992 square feet',
						},
					],
				},
				{
					city: 'Reno',
					copy: '<p>Reno is known as the “The Biggest Little City in the World”. It has a population of 259,019, and is known for its casinos and hotels. Reno lies 40 miles north of Lake Tahoe.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '7% higher than national average',
						},
						{
							item: 'Median home price',
							value: '$371, 900',
						},
						{
							item: 'Average rent',
							value: '$1,277',
						},
						{
							item: 'Average apartment size',
							value: '857 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'Within 30 days of living in Nevada, you will need to get a state issued driver’s license. You will need to have proof of residency via your old driver’s license or ID card.You will also need to provide proof of residence in Nevada. Two or more bills with your Nevada address and your name on them would be good proof. Take all your paperwork to the DMV and they will get you set up. You can make an appointment at the DMV online here',
			},
			{
				title: 'Vehicle registration',
				copy: 'Before your first 30 days of living in Nevada are up, you will need to obtain registration for your vehicle issued to you by the state. To get this, you will need to have: proof of vehicle insurance, proof of vehicle inspection, current registration and license plate, vehicle title and VIN. Once you present your documents at the DMV and pay the appropriate fees, you will be on your way with your newly registered vehicle.',
			},
			{
				title: 'Voter Registration',
				copy: 'Once you are ready to register to vote in Nevada, you can fill out the online voter registration form. Once all your info is on the form, mail a copy to your local election official. You should get your voter ID in the mail 2-3 weeks later.',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/nevada-population/cities/',
			'https://www.payscale.com/cost-of-living-calculator/Nevada-Las-Vegas',
			'https://www.payscale.com/cost-of-living-calculator/Nevada-Reno',
			'https://www.payscale.com/cost-of-living-calculator/Nevada-Henderson',
			'https://www.zillow.com/las-vegas-nv/home-values/',
			'https://www.zillow.com/henderson-nv/home-values/',
			'https://www.zillow.com/reno-nv/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nv/las-vegas/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nv/clark-county/henderson/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nv/reno/',
			'https://en.wikipedia.org/wiki/Las_Vegashttps://en.wikipedia.org/wiki/Henderson,_Nevada',
			'https://en.wikipedia.org/wiki/Nevada#Future_issueshttps://dmvnv.com/newresident.htm',
			'https://www.nvsos.gov/sosvoterservices/Registration/Step0.aspx',
			'https://united-states.reaproject.org/data-tables/gsp-a900n/reports/320000',
			'https://ycharts.com/indicators/nevada_unemployment_rate',
			'https://www.zippia.com/advice/largest-companies-in-nevada/',
			'https://www.onlineunitedstatescasinos.com/states/nevada-gambling/',
			'https://en.wikipedia.org/wiki/Lake_Tahoe#Winter_sports',
		],
	},
	NH: {
		state: 'New Hampshire',
		stateNickname: 'Granite State',
		welcome: `
			<p>Imagine yourself in picturesque New Hampshire, a land of majestic beauty from the rugged White Mountains to the quaint beach towns on the Atlantic coast. Whether you like an industrial urban vibe, rolling farmland, or just plain wilderness–you'll be sure to find it in the Granite State.</p>
			<p>New Hampshire is known for its status as the first in the nation presidential primary and its "Live Free or Die" political philosophy which doesn't impose a sales or income tax on its residents. The state's staunch resistance to taxation dates all the way back to the American Revolution. New Hampshire was the first colony to create its own government separate from the authority of the British crown. But those aren't the only reasons to move to New Hampshire, as you will soon learn.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>New Hampshire, not unlike the nation at large, has seen a boost in self-storage development activity over the last few years. That's partly due to a lack of new facilities that were built after the recession, and also due to pent up demand created by the natural growth of urban and suburban areas. New Hampshire perhaps has an oversupplied self-storage market with 6.07 square feet per resident. Compare that to the national average of 5.4 square feet and you will see that the state has quite a bit more to offer. Still, storage development continues as entrepreneurial investors seek suitable sites in New Hampshire, including vacant big box stores that can be converted into self-storage facilities.</p>
				<p>Here's some fast facts about the state of the New Hampshire's self-storage industry:</p>
			`,
			facts: [
				{
					fact: 'New Hampshire is home to about 266 self-storage facilities.',
					highlight: '266',
				},
				{
					fact: 'New Hampshire self-storage facilities cover 7,940,210 square feet of storage space.',
					highlight: '7,940,210',
				},
				{
					fact: 'New Hampshire storage facilities offer 6.07 square feet of storage per person, which is more than the national average of 5.4 square feet per person.',
					highlight: '6.07',
				},
				{
					fact: 'Average price of a self-storage unit in New Hampshire:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Manchester',
				price: '0',
			},
			{
				city: 'Nashua',
				price: '0',
			},
			{
				city: 'Concord',
				price: '0',
			},
			{
				city: 'Portsmouth',
				price: '0',
			},
			{
				city: 'Keene',
				price: '0',
			},
			{
				city: 'Derry',
				price: '0',
			},
			{
				city: 'Rochester',
				price: '0',
			},
			{
				city: 'Lebanon',
				price: '0',
			},
			{
				city: 'Merrimack',
				price: '0',
			},
			{
				city: 'Exeter',
				price: '0',
			},
			{
				city: 'Londonberry',
				price: '0',
			},
			{
				city: 'Epping',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>Few states offer such indescribable natural beauty and opportunity as Montana. Here are a few more reasons why this is such a great state to set up camp:</p>',
			reasons: [
				'Live Free or Die. Okay, so the state motto is not the only reason, but it is a pretty big one. No sales taxes or income taxes are a pretty sweet deal. Although New Hampshire does have the third highest property taxes in the country.',
				"You're basically in Boston. The southern portion of New Hampshire borders the Boston suburbs, making Bean Town just a hop, skip and a jump away for most New Hampshirites. Many folks live in Nashua and surrounding towns and commute to their job in Boston.",
				"Waterfront property. You'll delight in your proximity to the pristine Seacoast Region, made up of portions of Rockingham County and Strafford County. Here you can frolic in New Hampshire's coastal hamlets and enjoy bountiful seafood and cultural activities.",
				'Snowmobiling paradise. Through the White Mountains and beyond, New Hampshire maintains more than 6,830 miles of public snowmobile trails–making the state one of the most popular states for zooming through the snow.',
				'Academics on lock. New Hampshire is home to dozens of colleges and universities, including ivy-league member Dartmouth. Dartmouth is the oldest university in the state and founded before the American Revolution.',
				"The laid back lakes region. New Hampshire isn't all beaches and snowy mountains. A big chunk of the state actually lies in the Lakes Region, which is home to more than 30 lakes and plenty of vacation resorts. Wolfeboro, located on Lake Winnipesaukee claims to be the oldest resort town in the nation. ",
				'Holy Mountains! New Hampshire is home to some of the tallest ski slopes in the Northeast, but the state is more than just skiing. The state is also a hot spot for mountain climbers.',
				'Lead the free world. Since 1952 New Hampshire has been home to the first presidential primary in the country. Iowan actually have their say first but they hold a caucus, not a primary. Winners of the New Hampshire primary for their respective party nominating contests have gone on to be the candidate 12 of out 15 times since 1952.',
				'Start your engines. NASCAR isn\'t just for the South. The New Hampshire Motor Speedway in Loudon has hosted several races a year since the 1990s. Nicknamed the "Miracle Mile", the track is also famous for the America\'s longest running motorcycle race dubbed the Loudon Classic.',
				"World's biggest vintage arcade. The American Classic Arcade Museum in Laconia, NH offers visitors a chance to play a revolving selection of more than 200 classic cabinet games.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>With an estimated 1,363,852 residents, New Hampshire is the eighth smallest state in the country by population. But it's getting bigger, growing by 0.55 percent from 2018 to 2019. And while the state is ranked 46th by area, the population is fairly dense with 147 residents per square mile. Many people relocate to New Hampshire as a nice quiet place to retire, for their libertarian brand of politics, and to commute to jobs in Boston.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>For a small state, New Hampshire has a particularly robust economy. The state has an estimated total GDP of $86 billion in 2018. The state has the fourth-highest median income in the country, totaling $74,801 a year in 2017. It also has an extraordinarily low unemployment rate of 2.5 percent.</p>
				<p>Below is a list of New Hampshire's biggest economic sectors by percent share of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Rental, real estate and leasing',
					value: '14 percent',
				},
				{
					sector: 'Manufacturing',
					value: '11 percent',
				},
				{
					sector: 'Government',
					value: '10 percent',
				},
				{
					sector: 'Professional services',
					value: '10 percent',
				},
				{
					sector: 'Healthcare',
					value: '9 percent',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'C&S Wholesale Grocers in Keene',
					employees: '17,000',
				},
				{
					employer: 'Ocean Properties in Portsmouth',
					employees: '5,8003',
				},
				{
					employer: 'Keene State College in Keene',
					employees: '5,7494',
				},
				{
					employer: 'Standex International in Salem',
					employees: '5,5005',
				},
				{
					employer: 'University of New Hampshire in Durham',
					employees: '5,320',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>New Hampshire is one of the smallest states in the country, covering only about  with about 9,349 square miles. The southern half of the state is the most populated, and home to many commuters who work and play in Boston. The northern portion of the state is less populated, and offers a more rural way of living. Wherever you choose to live in New Hampshire you will be in the heart of the Northeast, putting you less than a day's drive to Vermont, Massachusetts, Maine, and even New York City. You also have access to the international border into Canada where you can visit Quebec on a whim.</p>
				<p>If you are planning to move into the state of New Hampshire, consider these primary cities:</p>
			`,
			cities: [
				{
					city: 'Manchester',
					copy: "<p>Manchester is a cosmopolitan city that is the heart of Northern New England; it's the largest city in New Hampshire, Maine or Vermont. Founded in 1751 as Derryfield, the city was reincorporated as Manchester in 1846. With a population of around 112,000, Manchester is frequently named as one of America's most affordable and livable cities. The average salary in Manchester is relatively high at $62,000 per year.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '19 percent higher than national average',
						},
						{
							item: 'Median home price',
							value: '$243,400',
						},
						{
							item: 'Average rent',
							value: '$1,389/month',
						},
						{
							item: 'Average apartment size',
							value: '861 square feet',
						},
					],
				},
				{
					city: 'Nashua',
					copy: "<p>With over 86,000 residents, Nashua is the second biggest city in New Hampshire. Originally built around a long busted textile industry, Nashua today is booming as part of the Greater Boston Metro Area. The downtown area has seen quite a lot of redevelopment in recent years. The median income of $73,000 is a product of the city's recent growth.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '23 percent higher than national average',
						},
						{
							item: 'Median home price',
							value: '$292,400',
						},
						{
							item: 'Average rent',
							value: '$1,491/month',
						},
					],
				},
				{
					city: 'Great Falls',
					copy: "<p>The state's capital and third largest city, Concord is steeped in history and culture. The area was first settled by colonists after 1725 by Ebenezer Eastman and his family moved over from nearby Haverhill, Massachusetts. Concord today has more than 42,000 residents, who make a median income of $61,000 per year.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '20.1 percent higher than national average',
						},
						{
							item: 'Median home price',
							value: '$239,000',
						},
						{
							item: 'Average rent',
							value: '$1,001/month',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents must obtain a New Hampshire driver’s license within 60 days of establishing residency. Drivers over 18 years of age can transfer their out of state license without taking a road test by presenting their valid out-of-state driver's license and proof of residency at any DMV location.",
				link: 'https://www.nh.gov/safety/divisions/dmv/driver-licensing/index.htm',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents of New Hampshire have 60 days to retitle the vehicle in the state.',
				link: 'https://www.nh.gov/safety/divisions/dmv/registration/vehicle.htm',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in New Hampshire, you must be a citizen of the United States aged 18 years or older. New Hampshire residents can register and vote on the same day. The 2020 Primary Election deadline is January 29, 2020 and the General Election deadline is October 21, 2020.',
				link: 'https://sos.nh.gov/HowRegVote.aspx',
			},
		],
		sources: [
			// static content
			'https://www.salary.com/research/cost-of-living/concord-nh',
			'https://www.rentjungle.com/average-rent-in-nashua-rent-trends/',
			'https://www.payscale.com/research/US/Location=Manchester-NH/Salary',
			'https://www.zillow.com/manchester-nh/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nh/manchester/',
			'https://www.zippia.com/advice/largest-companies-in-new-hampshire/',
			'https://smartasset.com/taxes/new-hampshire-property-tax-calculator',
			'https://en.wikipedia.org/wiki/Wolfeboro,_New_Hampshire',
			'https://www.visit-newhampshire.com/state/snowmobiling/winter-activities/',
			'https://www.mountainproject.com/area/105872225/new-hampshire',
			'https://www.atlasobscura.com/places/american-classic-arcade-museum',
			'https://www.nhpr.org/post/you-asked-we-answered-why-do-people-move-nh-join-free-state-project#stream/0',
			'https://www.deptofnumbers.com/gdp/new-hampshire/',
			'https://www.fsp.org/join/',
		],
	},
	NJ: {
		state: 'New Jersey',
		stateNickname: 'Garden State',
		welcome: `
			<p>New Jersey, also known as "The Garden State," has a population of 8.9 million people and is bordered by Pennsylvania, New York, and Delaware, as well as the Delaware Bay, the Atlantic Ocean, and Long Island. The Atlantic Coastal plain is covered in pine forests, salt marshes, and low hills. The New England Upland area contains flat-topped rock ridges and several lakes. New Jersey's natural resources include sand, granite, gravel used for mining.</p>
			<p>The state is a leader in seafood production, specifically clams harvested off the coast. New Jersey's major industries include tourism, transportation, manufacturing, healthcare, and biopharmaceuticals.</p>
			<p>The Garden State has tons to do whether you're planning to visit or stay for good, including historical sites, museums, national parks, and, of course, Atlantic City. Some of the top attractions include Plemont Bay, Elizabeth Castle, The Jersey Zoo, The SandWizard, and St. Brelade's Bay Beach.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Self-storage development has been on the rise in New Jersey, along with the rest of the country as well. The development wave is a result of developers racing to meet pent up demand caused by a lack of storage facility construction after the last recession. New Jersey, especially given its place in the major metro areas of New York City and Philadelphia, has seen an abundance of new development in recent years. Still, New Jersey remains generally undersupplied based on the average amount of self-storage space per resident of the state. People moving to and from New Jersey create demand for self-storage space, as most people who use storage report that they are doing so as part of the relocation process.</p>
				<p>Below is an overview of the current state of the New Jersey self-storage market:</p>
			`,
			facts: [
				{
					fact: 'New Jersey is home to about 588 self-storage facilities.',
					highlight: '588',
				},
				{
					fact: 'New Jersey self-storage facilities cover 32,621,181 square feet of storage space.',
					highlight: '32,621,181',
				},
				{
					fact: 'New Jersey storage facilities offer 3.67 square feet of storage per person, which is much lower than the national average of 5.4 square feet per person.',
					highlight: '3.67',
				},
				{
					fact: 'Average price of a self-storage unit in New Jersey:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Newark',
				price: '0',
			},
			{
				city: 'Jersey City',
				price: '0',
			},
			{
				city: 'Trenton',
				price: '0',
			},
			{
				city: 'Princeton ',
				price: '0',
			},
			{
				city: 'Atlantic City',
				price: '0',
			},
			{
				city: 'Paterson',
				price: '0',
			},
			{
				city: 'Toms River',
				price: '0',
			},
			{
				city: 'Cherry Hill',
				price: '0',
			},
			{
				city: 'Hoboken',
				price: '0',
			},
			{
				city: 'Morristown',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			reasons: [
				"Ideal location. New Jersey is close to NYC and Philadelphia, so if you're considering a move there, you'll always be just a bus ride (or car trip) away from two of the most-visited cities on the East Coast. Central Park or Liberty Bell anyone?",
				'The Jersey Shore. Minus Snooki, J-Wow, and the rest of the crew. The actual Jersey Shore is gorgeous and a great place to unwind after a long day at work. Head to Point Pleasant, Seaside or the Wildwoods beaches for plenty of fun and shopping.',
				"Plenty of shopping. Speaking of shopping, New Jersey is home to a host of malls and no matter where you move in the state, you'll never be more than 15 minutes away from a mall. The major shopping malls include Westfield Garden State Plaza, Tanger Outlets Atlantic City, Willowbrook Mall, Paramus Park, and The Mall at Short Hills.",
				"Outdoor activities. The Garden State has lots to offer in terms of outdoor activities. From hiking through the mountains and hills and walking the nature trails to jet skiing and boating, you'll have tons to do when the weather is nice. Not to mention amusement parks, balloon and helicopter tours, cruises, swimming, sailing and more.",
				"The Greenery. New Jersey is called The Garden State for a reason. And it's because of the seemingly endless amount of green patches, state parks, reserves, and trees. And with that greenery comes a large amount of fresh produce, especially tomatoes, cranberries, asparagus, blueberries, and corn. Find a local farmer's market and enjoy some of the best and freshest fruits and veggies.",
				"Sports stadium. If you're a fan of the New York Jets or the New York Giants, you'll be glad you moved to Jersey when you realize that the MetLife Stadium is located in the Meadowlands of East Rutherford, New Jersey. The New Jersey Devils also have a home in Jersey at the Prudential Center in downtown Newark. ",
				"Atlantic City. Like to hit the slots but don't want to make the trip all the way out to Vegas? Then, you'll love Jersey because Atlantic City (the place where Monopoly was created) is a top gambling destination in the US. And if you don't feel like heading out to the casinos for whatever reason, you can always gamble online since the state legalized online gambling back in 2013.",
				"You'll never have to pump your own gas. True story. In Jersey, it's actually illegal to do it yourself. So every time you go to the pump you can kick back and feel like royalty.",
				"The fall season. Much like Upstate New York, New Jersey boasts a beautiful fall season. With leaves changing to beautiful colors like reds and yellows, browns and oranges, you'll love the gorgeous scenery during the fall months in NJ.",
				'Diversity. Back in 2018, WalletHub named Jersey City as the second-most diverse city in America, meaning there\'s more of a chance you\'ll find your own little tight-knit group of friends that "get you."',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>New Jersey has a population of 8.9 million people. It's the 11th most populous state and is 47th when it comes to size. From 2018 to 2019, the population grew by 0.16 percent. It seems that more people have been moving out of New Jersey than moving into in the last few years. Roughly 225,000 New Jersey residents moved to another state in 2017, but only 152,000 out of state residents moved into the Garden State. Seniors are leaving the state to retire. New Jersey's population of 22- to 34-year-olds is growing somewhat slowly, probably because a decent number of millennials are leaving for job opportunities. However, some well-off millennials are also moving into the state looking for a home close to the city or a train station.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>New Jersey has a GDP of $634 billion as of 2018. If it were a country, its GDP would be similar to the Taiwan Province of China, which has a GDP of $603 billion. New Jersey's unemployment rate is 3.2 percent, as of August 2019, according to the Bureau of Labor Statistics.</p>
				<p>Below is a breakdown of the top five sectors by real value GDP added:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$121.38 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$93.48 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$54.25 billion',
				},
				{
					sector: 'Educational services, healthcare, and social assistance',
					value: '$51.79 billion',
				},
				{
					sector: 'Wholesale trade',
					value: '$47.57 billion',
				},
			],
			bottomLine: `
				<p>New Jersey is looking at an economic growth slower than the national average through 2025. Job growth is expected to improve by 1.1 percent and 0.8 percent through 2045. Information manufacturing will continue to decline as sources of jobs and the trade and public sectors will see an increase in jobs. New Jersey's cost of living is 132.6, meaning it's more expensive to live in New Jersey than the US as a whole. On the plus side, healthcare in New Jersey is lower than the national average.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Cognizant',
					employee: '256,800',
				},
				{
					employer: 'Honeywell',
					employee: '131,000',
				},
				{
					employer: 'Johnson & Johnson',
					employee: '126,400',
				},
				{
					employer: 'Conduent',
					employee: '89,000',
				},
				{
					employer: 'Merck',
					employee: '66,980',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>New Jersey is 8,721 square miles and the 47th biggest state in the country. It has an average of 1,195 people for each square mile and its three largest cities include Newark, Jersey City, and Paterson.</p>
			`,
			cities: [
				{
					city: 'Newark',
					copy: '<p>Newark is the largest city in New Jersey without a population of 283,756. The city gets over 18 million visitors each year thanks to the outlet malls, museums, art exhibits, sporting events, live music events, and assortment of other activities and attractions. Whether you want to learn the art of glass blowing or head to an arena for the next soccer game, Newark has something for everyone.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '22 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$265,000',
						},
						{
							item: 'Average rent',
							value: '$1,198 per month',
						},
						{
							item: 'Average apartment size',
							value: '706 square feet',
						},
					],
				},
				{
					city: 'Jersey City',
					copy: "<p>As the second-largest city in New Jersey, Jersey City has a population of 265,004 people. Often called Wall Street West, Jersey City plays an important role in the banking and finance industry. But it's also got a variety of attractions and activities, including Liberty State Park, the Liberty Science Center, Newport Center (for shopping), White Eagle Hall (where you can go and see a show), parks, boat and water sports, tours of NYC, museums, spas, concerts, and nightlife.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '31 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$487,400',
						},
						{
							item: 'Average rent',
							value: '$2,950 per month',
						},
						{
							item: 'Average apartment size',
							value: '834 square feet',
						},
					],
				},
				{
					city: 'Paterson',
					copy: "<p>Paterson is New Jersey's third-largest city and more than 146,919 people call it home. It has the second-largest Muslim population in the country and a large number of things to do and see, including Garret Mountain Reservation, Lambert Castle Museum, Paterson Great Falls National Historical Park, Passaic Falls, Saddle River County Park, and Fabian 8 Cinema.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '19 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$273,600',
						},
						{
							item: 'Average rent',
							value: '$1,242 per month',
						},
						{
							item: 'Average apartment size',
							value: '738 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "As a new resident of New Jersey, you'll have to transfer your out-of-state driver's license within 60 days of moving to the state or before it expires - whichever happens first. To apply for a New Jersey license, you'll have to go to your local New Jersey MVC office and surrender your out-of-state driver's license, pass a 6 point ID and residency requirement, take a vision screening, pass the written and road tests (if your out-of-state license is expired, provisional, or not issued in the US, the District of Columbia, or a U.S. territory), and pay the new driver's license fee of $24 as well as the $10 transfer permit fee. For more info, visit:",
				link: 'https://www.dmv.org/nj-new-jersey/apply-license.php',
			},
			{
				title: 'Vehicle registration',
				copy: "New Jersey state law says new residents of the state have to transfer their vehicle title and registration (with or without a lien) within 60 days. You'll have to visit a motor vehicle agency with proof of ID, your original title, and insurance information. You'll also have to fill out an Application for Certificate of Ownership form and a Vehicle Registration Application. For more info, visit",
				link: 'https://www.state.nj.us/mvc/drivertopics/movetonj.htm',
			},
			{
				title: 'Voter Registration',
				copy: "To register to vote in New Jersey, you have to be a US citizen and be at least 18 at the time of the election. You also must be a resident in the New Jersey county you live in for at least 30 days before you'll be eligible to vote. To register, complete a Voter Registration Application and/or Party Affiliation form and then mail it to the County Commissioner of Registration or Superintendent of Elections for your county. For more info, visit:",
				link: 'https://www.state.nj.us/state/elections/voter-registration.shtml',
			},
		],
		sources: [
			// static content
			'https://www.northjersey.com/story/life/2019/01/17/nj-reasons-stay-and-not-move-from-state/2539849002/#/gallery',
			'https://www.nj.com/entertainment/2016/06/the_12_best_reasons_to_live_in_new_jersey.html',
			'https://www.njonlinegambling.com/a2578/',
			'https://www.collegehunkshaulingjunk.com/blog/2018/march/12-reasons-to-move-to-new-jersey/',
			'https://www.expataussieinnj.com/reasons-for-moving-to-new-jersey/',
			'https://worldpopulationreview.com/states/new-jersey-population/',
			'https://www.inquirer.com/news/columnists/new-jersey-leaving-state-migration-study-20190114.html',
			'https://www.northjersey.com/story/news/new-jersey/2019/01/05/twice-many-moved-out-new-jersey-2018-than-moved/2463997002/',
			'https://www.cnbc.com/2019/01/11/why-people-are-fleeing-new-jersey-more-than-any-other-state.html',
			'https://howmuch.net/articles/comparing-us-states-to-entire-countries-by-gdp-2019',
			'https://www.bls.gov/cps/cps_htgm.htm',
			'https://www.statista.com/statistics/304942/new-jersey-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-new-jersey/',
			'https://bloustein.rutgers.edu/recon-njs-economy-will-continue-to-lag-the-nations-through-2025-while-undergoing-structural-changes/',
			'https://www.visitnj.org/city/newark',
			'https://www.tripadvisor.com/Attractions-g46531-Activities-Jersey_City_New_Jersey.html',
			'https://www.tripadvisor.com/Attractions-g46718-Activities-Paterson_New_Jersey.html',
			'https://worldpopulationreview.com/states/new-jersey-population/cities/',
			'https://www.payscale.com/cost-of-living-calculator/New-Jersey-Newark',
			'https://www.zillow.com/newark-nj/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nj/essex-county/newark/',
			'https://www.payscale.com/cost-of-living-calculator/New-Jersey-Jersey-City',
			'https://www.zillow.com/jersey-city-nj/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nj/jersey-city/',
			'https://www.payscale.com/cost-of-living-calculator/New-Jersey-Paterson',
			'https://www.zillow.com/paterson-nj/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nj/paterson/',
			'https://www.dmv.org/nj-new-jersey/apply-license.php',
			'https://www.state.nj.us/mvc/drivertopics/movetonj.htm',
		],
	},
	NM: {
		state: 'New Mexico',
		stateNickname: 'Land of Enchantment',
		welcome: `
			<p>New Mexico evokes an image of a drier desert climate, when in fact, a large portion of the state is covered by five different national forests. Some of our country’s most spectacular natural formations exist in New Mexico like Carlsbad Caverns and Chaco Canyon, just to name a couple. New Mexico has a long history marked by Spanish colonization and indigenous roots, which is reflected in the local culture and food. That combination attracts visitors from all over the world to the Land of Enchantment, many of whom become so enchanted they decide to move there for good.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>While self-storage is not a densely populated state over all, it actually has a high ratio of self-storage space to residents. New Mexico has 6.87 square foot of self-storage space person, compared to the national average of 5.4 square feet per person. Yet, there is even more self-storage construction underway in the state. An ongoing wave of self-storage development is taking place all over the country, and New Mexico has attracted its fair share of self-storage investment from developers looking to capitalize on growing demand for storage.</p>
				<p>Below is an overview of the current state of the New Mexico self-storage market:</p>
			`,
			facts: [
				{
					fact: 'New Mexico is home to about 460 self-storage facilities.',
					highlight: '460',
				},
				{
					fact: 'New Mexico self-storage facilities cover 14,174,254 square feet of storage space.',
					highlight: '14,174,254',
				},
				{
					fact: 'New Mexico storage facilities offer 6.87 square feet of storage per person, which is more than the national average of 5.4 square feet per person.',
					highlight: '6.87',
				},
				{
					fact: 'Average price of a self-storage unit in New Mexico:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Albuquerque',
				price: '0',
			},
			{
				city: 'Santa Fe',
				price: '0',
			},
			{
				city: 'Las Cruces',
				price: '0',
			},
			{
				city: 'Roswell',
				price: '0',
			},
			{
				city: 'Farmington',
				price: '0',
			},
			{
				city: 'Taos',
				price: '0',
			},
			{
				city: 'Carlsbad',
				price: '0',
			},
			{
				city: 'Hobbs',
				price: '0',
			},
			{
				city: 'Gallub',
				price: '0',
			},
			{
				city: 'Rio Rancho',
				price: '0',
			},
			{
				city: 'Los Alamos',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			reasons: [
				'Great Weather. You’ve got the best of both worlds. If you hate the cold, Southern New Mexico has mild winters and a generally warmer climate. Northern New Mexico is known for it’s amazing weather, although it gets quite cold in the winter.',
				'Skiing. Known as “The Land of Enchantment,” New Mexico is home to some of the best skiing in the country.',
				'Hot Springs. Go to the affordable but luxurious outdoor hot spring spa, Ojo Caliente, located less than an hour from Santa Fe, or take a hike in nature and discover the lovely Jemez Hot Springs.',
				'Chile Peppers. New Mexico has its own chile, first grown by Pueblo and Hispano communities. You can find delicious mild and spicy dishes using New Mexico chile–also known as Hatch chile–all over the world.',
				'World Heritage Sites. New Mexico has more than any other state. Check out the amazing Chaco Canyon, Taos Pueblo, and Carlsbad Caverns National Park.',
				'Aliens. Do you believe? Roswell, New Mexico is home to the supposed UFO crash of 1947. Check out the International UFO Museum and research center in downtown Roswell. Whether or not you believe in aliens, it’s a fun place to visit. The truth is out there.',
				'Camping and hiking. New Mexico’s extremely diverse terrain offers year round camping. In Northern New Mexico, the Carson National Forest and the Santa Fe National Forest has over 1300 miles of trails and 63 campgrounds.',
				'White Sands National Monument. With 275 miles of white sand, this park is the world’s largest gypsum dune field. Go camping, bicycling, and best of all, sledding down the slippery gypsum hills.',
				'Affordable housing. The cost of living in most New Mexico cities is below the national average.',
				'Hot Air Balloon Festival. A favorite annual festivity! Watch over 500 colorful hot air balloons rise into the air in Albuquerque.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>As of 2019, New Mexico is the 37th most populous state in the country, only a few thousand more than Nebraska. New Mexico is part of the “four corners,” bordering Utah, Colorado, and Arizona, and also shares borders with Oklahoma, Texas, and the Mexican states of Chihuahua and Sonora. New Mexico ranks 45th in population density, meaning there are many vast open spaces. The landscape of New Mexico is diverse with mountain ranges, deserts, and large forests. People from all over the world come to New Mexico to enjoy the culture and the outdoors.</p>
				<p>For years, New Mexico’s economy was stagnant but currently growth is steady, ranking 30th in the country. People move to New Mexico for the culture, landscape, diverse job market, and the many ways to access art.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>In 2017, New Mexico’s GDP was $94.2 billion and ranks 37th in the country. New Mexico has more than 6% of the U.S. crude oil reserves, providing a significant amount of job opportunities. As of September 2019, New Mexico has an unemployment rate of 4.9 percent, which is a bit higher than the national average as of September 2019, which is 3.5 percent.</p>
				<p>Below, you'll find a breakdown of Texas' largest sectors by real value percentage of GDP in 2018:</p>
			`,
			breakdown: [
				{
					sector: 'Government and Government enterprises',
					value: '23%',
				},
				{
					sector: 'Finance, Insurance, Real Estate, Rental, and Leasing',
					value: '16%',
				},
				{
					sector: 'Mining, Quarrying, and Oil and Gas extraction',
					value: '11%',
				},
				{
					sector: 'Professional and Business Services',
					value: '11%',
				},
				{
					sector: 'Educational services, Health Care, and Social Assistance',
					value: '8%',
				},
			],
			bottomLine: `
				<p>The economy of New Mexico is the best it’s been since the recession and the forecast is that it will continue to do well. Incomes are gradually accelerating and there has been a small increase in job opportunities. Tourism is a big part of New Mexico’s economy and there’s no sign of that slowing down. Houses are selling well and the oil and gas industry is also doing well according to recent reports.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Federal Government',
					employees: '21,766',
				},
				{
					employer: 'State of New Mexico',
					employees: '18,359',
				},
				{
					employer: 'Walmart',
					employees: '14,022',
				},
				{
					employer: 'Sandia National Laboratories',
					employees: '12,206',
				},
				{
					employer: 'Presbyterian Healthcare',
					employees: '11,178',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>New Mexico is not a crowded state and has one of the most diverse climates of any state. You can enjoy the desert, mountains, or snow, and if you want to explore even further, New Mexico borders six other states and the nation of Mexico. Whether you want to be in a big city like Albuquerque or visit the small village of Abiquiu, where Georgia O'Keeffe lived the later half of her life, New Mexico has it all.</p>
			`,
			cities: [
				{
					city: 'Albuquerque',
					copy: '<p>Albuquerque is home to 564,764 residents and is the most populous city in New Mexico. Located along Route 66, Interstate 20, and Interstate 40, Albuquerque is a popular stop for anyone on a cross country road trip. Albuquerque gets over six million visitors annually; one million of those go just for the Hot Air Balloon festival.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '5% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$234,900',
						},
						{
							item: 'Average rent',
							value: '$898/month',
						},
						{
							item: 'Average apartment size',
							value: '812 sq. ft.',
						},
					],
				},
				{
					city: 'Las Cruces',
					copy: '<p>The second largest city in New Mexico is Las Cruces, with 102,731 residents. New Mexico University attracts a large student population. Local attractions include the Natural Science Museum and the Dripping Springs Natural Area.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '205,090',
						},
						{
							item: 'Average rent',
							value: '$832/month',
						},
					],
				},
				{
					city: 'Rio Rancho',
					copy: '<p>Rio Rancho has a population of 102,322 residents. It borders Albuquerque, making it a popular place to live. Popular nearby attractions include the Kasha-Katuwe Tent Rocks National Monument, Breaking Bad RV tours, and a really popular children’s park, A Park Above.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '7% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$241,445',
						},
						{
							item: 'Average rent',
							value: '$945/month',
						},
						{
							item: 'Average apartment size',
							value: '872 sq. ft.',
						},
					],
				},
				{
					city: 'Santa Fe',
					copy: '<p>Can’t forget about the capital of New Mexico, Santa Fe, where only 85,642 people reside. Famous for its stunning architecture, rich history, amazing food, and proximity to skiing, hiking, and hot springs. There is so much to enjoy in Santa Fe.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '1% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$499,999',
						},
						{
							item: 'Average rent',
							value: '$1197/month',
						},
						{
							item: 'Average apartment size',
							value: '804 sq. ft.',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents must first establish residency before they can obtain a driver’s license. You will be required to surrender your unexpired license from another U.S. state or territory. You can apply for and obtain your new driver’s license in person at your local MVD Field Office. Applicants with a valid license from another U.S. state or territory are not required to take the written or road test. However, applicants that fail to surrender their current, valid license must take and pass all of the required exams.',
				link: 'https://www.mvd.newmexico.gov/apply-for-new-driver-s-license.aspx',
			},
			{
				title: 'Vehicle registration',
				copy: "To register your vehicle go to your local MVD Field office; you'll need your original Manufacturer’s Certificate of Origin, Purchase Agreement, Odometer Statement, and proof of insurance. For more info, check out the New Mexico's MVD website:",
				link: 'https://www.mvd.newmexico.gov/register-your-vehicle.aspx',
			},
			{
				title: 'Voter Registration',
				copy: 'The deadline to register is May 5, 2020 for the New Mexico 2020 Primary Election. Early voting is May 16th - May 20th. You can register to vote in New Mexico here:',
				link: 'https://portal.sos.state.nm.us/OVR/WebPages/InstructionsStep1.aspx',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/new-mexico-population/',
			'https://www.payscale.com/cost-of-living-calculator/Texas-Santa-Fe',
			'https://www.payscale.com/cost-of-living-calculator/New-Mexico-Rio-Rancho',
			'https://www.payscale.com/cost-of-living-calculator/New-Mexico-Las-Cruces',
			'https://www.payscale.com/cost-of-living-calculator/New-Mexico-Albuquerque',
			'https://www.zillow.com/las-cruces-nm/home-values/',
			'https://www.zillow.com/albuquerque-nm/home-values/',
			'https://www.zillow.com/santa-fe-nm/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nm/bernalillo-county/albuquerque/',
			'https://www.rentjungle.com/average-rent-in-las-cruces-rent-trends/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nm/rio-rancho/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nm/santa-fe/',
			'https://www.onlyinyourstate.com/new-mexico/reasons-to-move-to-nm/',
			'https://www.usnews.com/news/best-states/articles/2017-08-07/why-new-mexicans-are-fleeing-the-state',
			'https://en.wikipedia.org/wiki/New_Mexico',
			'https://en.wikipedia.org/wiki/Albuquerque,_New_Mexico',
			'https://www.abqjournal.com/1267980/tourism-still-a-bright-spot.html',
			'https://www.abqjournal.com/1267980/tourism-still-a-bright-spot.html',
			'https://en.wikipedia.org/wiki/Las_Cruces,_New_Mexico',
			'https://worldpopulationreview.com/us-cities/las-cruces-population/',
			'https://www.rockthevote.org/voting-information/election-dates-deadlines/new-mexico/',
			'https://www.iexplore.com/articles/travel-guides/north-america/united-states/new-mexico/weather',
			'https://www.skicentral.com/newmexico.html',
			'https://traveltips.usatoday.com/skiing-new-mexico-102766.html',
			'https://www.onthesnow.com/new-mexico/red-river/ski-resort.html',
			'https://www.onlyinyourstate.com/new-mexico/hot-springs-nm/',
			'https://en.wikipedia.org/wiki/Roswell_UFO_incident',
			'https://en.wikipedia.org/wiki/International_UFO_Museum_and_Research_Center',
			'https://www.nps.gov/whsa/planyourvisit/things2do.htm',
			'https://www.visitalbuquerque.org/balloon-fiesta/',
			'https://www.tripadvisor.com/Attractions-g47087-Activities-c57-Las_Cruces_New_Mexico.html',
			'https://en.wikipedia.org/wiki/Economy_of_New_Mexico#cite_note-Economic_Statistics-1',
			'https://apps.bea.gov/regional/bearfacts/pdf.cfm?fips=35000&areatype=STATE&geotype=3',
			'https://www.eia.gov/state/?sid=NM',
			'https://www.jobs.state.nm.us/gsipub/index.asp?enc=JdKtFhuODzQ+aO5C6MuCGQ==',
			'https://nmpartnership.com/incentives-data/new-mexico-largest-employers/',
			'https://www.housingnm.org/assets/content/BBER_NMBA_2019.pdf',
			'https://en.wikipedia.org/wiki/Rio_Rancho,_New_Mexico',
			'https://www.yelp.com/biz/a-park-above-rio-rancho?hrid=N7wfVxRXPpxH6Cur3PPkGQ&osq=Things+To+Do',
		],
	},
	NY: {
		state: 'New York',
		stateNickname: 'Empire State',
		welcome: `
			<p>Rich in a vast array of landscapes from its farmlands and valleys to its mountains and forests, New York state is a melting pot of topography. Home to a portion of the Appalachian, the Adirondack, and the Catskill Mountains as well as the Hudson River and the St. Lawrence River, New York has a little something for everyone.</p>
			<p>As the fourth most populous state in the country (after California, Texas and Florida), New York has more than 19 million people (more than 8 million in NYC alone). It's home to the famous Coney Island, the Statue of Liberty, the Empire State Building, and Central Park. But more than that, New York is home to natural wonders, like Niagara Falls, that draw in millions of visitors every year.</p>
			<p>If you're thinking of moving to New York, there's a lot to consider in terms of how you want to live. With big cities and small towns, rural areas, and suburbs for miles, New York is a brilliant blend.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Like the rest of the country, New York has seen a surge in self-storage development over the last few years—and not just in the five boroughs. Long Island and Upstate have all experienced significant levels of self-storage development. That is due in part to a lull in new development that occurred after the last recession. With less projects being built at that time, demand for storage space began to surpass availability. One of the biggest drivers of storage demand is relocation related activity, with 60 percent of storage users reporting that they are currently moving from one place to another.</p>
				<p>Below are some statistics that provide an overview of the self-storage industry in New York:</p>
			`,
			facts: [
				{
					fact: 'New York is home to an estimated 1,395 self-storage facilities.',
					highlight: '1,395',
				},
				{
					fact: 'New York self-storage facilities cover 49,636,761 square feet of storage space.',
					highlight: '49,636,761',
				},
				{
					fact: 'New York storage facilities offer 2.53 square feet of storage per person, which is considered undersupplied by the self-storage industry, The national average is 5.4 square feet per person.',
					highlight: '2.53',
				},
				{
					fact: 'Average price of a self-storage unit in New York: [DATA]',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'New York City (total)',
				price: '0',
			},
			{
				city: 'Brooklyn',
				price: '0',
			},
			{
				city: 'Queens',
				price: '0',
			},
			{
				city: 'Bronx',
				price: '0',
			},
			{
				city: 'Manhattan',
				price: '0',
			},
			{
				city: 'Staten Island',
				price: '0',
			},
			{
				city: 'Buffalo',
				price: '0',
			},
			{
				city: 'Rochester',
				price: '0',
			},
			{
				city: 'Albany',
				price: '0',
			},
			{
				city: 'Hempstead',
				price: '0',
			},
			{
				city: 'Islip',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're considering moving to New York, but you're not quite sure if it's right for you, think about the following facts:</p>",
			reasons: [
				'New York is home to the "City that Never Sleeps" and it\'s called that for a reason. You can literally do anything, at any time of day or night in NYC. The sky\'s the limit.',
				"New York has the 16th highest average income in the country, but also has a pretty high cost of living, so you'll need to manage your money well if you want to make it in good old New York, New York.",
				'Nothing beats autumn in New York when the foliage pops with bright orange and red leaves.',
				'Apple-picking season. Another fall-time favorite for Upstate New Yorkers during the fall is going to an orchard to pick out your very own delectable, in-season apples, perfect for baking up a delicious apple pie.',
				"It’s a hiker's paradise. If you just can't get enough of hitting the trails, you'll love New York because you can always head out to the Adirondack Mountains or the Catskills.",
				"The best hot wings are in Buffalo. If you're looking for the hottest wings on the East Coast, you'll likely find 'em in Buffalo, a city home to the zingiest, spiciest wings your 'buds have ever tasted.",
				"Foodie fetish in full swing? The Empire State has got a wide range of tastes and textures for every palette, from Indian and Asian cuisine to Italian and Mexican cuisine. You'll never get bored with the food in New York (especially NYC).",
				"Halloween is way better in New York. It's got the perfect backdrops for spooky haunted houses and hayrides—especially in Sleepy Hollow where the legend of the Headless Horseman is still going strong.",
				"Fan of the fair? New York's State Fair is one of the biggest and best, drawing visitors from all over the state for the great food, music, and rides.",
				"New York's brews are some of the best in the country. With about 97 craft breweries, you'll find some of the best local and national craft beer you've ever tasted.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>New York is the fourth most populous state in the country (after California, Texas and Florida) with 19.49 million residents as of 2019. Filled with valleys, mountains, suburbs and cities, New York is one of the most diverse states in terms of topography and demographics.</p>
				<p>NYC is a melting pot with more than 80 different languages spoken and numerous different cultural events, foods, and activities. However, many New Yorkers have been moving out of the state (1.3 million in the last 10 years) and the population decreased by 180,360 people from July 2017 to July 2018. Apparently, there are several reasons people want to leave New York, including a lack of jobs within their niche, not wanting to have kids in the city, among other reasons.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>As previously mentioned, New York City is one of the richest cities in the world, with a GDP comparable to South Korea and Canada. If New York state were a country, it would have the 11th biggest economy in the world, according to Markets Insider. NYC's GDP is expected to surpass Tokyo's by 2035. In 2017, it had a GDP of over $1.5 trillion and it's expected to rise to $2.5 trillion in the next 15 to 20 years.</p>
				<p>New York (both the state and the city) have a very healthy job market, not to mention more billionaires than any other city in the world. The state unemployment rate is currently at 4 percent as of July 2019, which is higher than the national average of 3.6 percent. The cost of living is somewhat higher than the national average as well.</p>
				<p>Here, you'll find a recent breakdown of New York's largest sectors by real value added of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate rental and leasing',
					value: '$412.48 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$199.85 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$152.15 billion',
				},
				{
					sector: 'Information',
					value: '$151.33 billion',
				},
				{
					sector: 'Educational services, healthcare, and social assistance',
					value: '$139.9 billion',
				},
				{
					sector: 'Retail trade',
					value: '$72.98 billion',
				},
			],
			bottomLine: `
				<p>The economic outlook for the future of New York may have been on the decline in the past ten years, with 13 million residents moving out of the state. But that just means more room (and more opportunities) for those moving into the state when things finally turn around economically.</p>
				<p>Although the cost of living is significantly higher than the national average, New York makes up for it with its wide array of activities, which include Broadway, the arts, museums, restaurants, special events at Madison Square Garden and other arenas.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Northwell Health',
					employees: '54,000',
				},
				{
					employer: 'Montefiore Health Systems',
					employees: '32,000',
				},
				{
					employer: 'Mount Sinai Health Systems',
					employees: '29,000',
				},
				{
					employer: 'Walmart',
					employees: '28,000',
				},
				{
					employer: 'NYU/NYU Langone Medical Center',
					employees: '27,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>New York is 54,556 square miles covered with more things to do than you can probably even imagine. Not only is it the home of the Statue of Liberty and the Empire State Building, but it boasts plenty of other attractions statewide, including Coney Island, Central Park, the Rockerfeller Center, the Metropolitan Museum of Art, Broadway, the Bronx Zoo, and the American Museum of Natural History. Living in New York means you have access to a never ending list of different activities and national treasures.</p>
			`,
			cities: [
				{
					city: 'New York City',
					copy: '<p>NYC is one of the most diverse and densely populated cities in the world, with a population of 8.55 million as of July 2019.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '129 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: ' $671,000',
						},
						{
							item: 'Average rent',
							value: '$4,222 (Manhattan); $1,708 (Bronx); $2,924 (Brooklyn); $2,579 (Queens); $1,466 (Staten Island)',
						},
						{
							item: 'Average apartment size',
							value: '696 square feet',
						},
					],
				},
				{
					city: 'Buffalo',
					copy: '<p>Buffalo has a cost of living lower than the national average, meaning homeownership is within reach for most who move there. Buffalo was ranked among the most affordable cities in the country. Everyday expenses like healthcare, utilities, and grocery expenses are also below the national average. With warm summers and mild springs, Buffalo is a great place to live if you want to experience all of the seasons.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '4 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$86,000',
						},
						{
							item: 'Average rent',
							value: '$1,067 per month',
						},
						{
							item: 'Average apartment size',
							value: '781 square feet',
						},
					],
				},
				{
					city: 'Rochester',
					copy: "<p>Rochester, New York is known for its natural wonders, like High Falls, a 96-foot tall waterfall, but its also known for its sprawling job market. According to Forbes, Rochester is one of the top cities for finding a job, and it's also one of the most affordable places to live in the country. Moving there can provide you and your family with a great quality of life and plenty of options when it comes to entertainment - both in and outdoors. Getting around Rochester is a breeze. Thanks to its three major highways, you'll enjoy a quick and easy commute from almost anywhere in the city .</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '1 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$79,000',
						},
						{
							item: 'Average rent',
							value: '$1,047 per month',
						},
						{
							item: 'Average apartment size',
							value: '886 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "Once you move to New York, you have to get a state driver's license within 30 days. You're required to exchange your out-of-state driver's license (from another U.S. state or territory, or Canadian province) for a New York state driver's license. To do this, your out-of-state license has to have your picture ID, be valid (or expired less than 24 months), and it has to have been issued at least 6 months before you apply for a New York State license (unless it's a commercial driver's license that's been valid for any amount of time). You won't be able to exchange your out-of-state license if it's lost or stolen, suspended or revoked; if you have a hardship or an \"employment only driver license,\" or if it's marked \"non-renewable\" or \"non-transferrable.\" Once you get your new NYS license, it will be valid for five years.",
				link: 'https://dmv.ny.gov/more-info/moving-new-york',
			},
			{
				title: 'Vehicle registration',
				copy: "If you move to New York permanently, you'll need to register your vehicle in New York state within 30 days of moving. If you're a resident of New York and you got a vehicle from another state that you'll be driving in New York, you still have to register the vehicle within 30 days. To register your out-of-state vehicle, bring a completed Vehicle Registration/Title Application form (MV-82), proof of ownership (original only), proof of NY State liability insurance, proof of age and identity, and proof of payment for sales tax.",
				link: 'https://dmv.ny.gov/registration/register-vehicle-when-you-are-out-state',
			},
			{
				title: 'Voter Registration',
				copy: "In New York, you can register to vote online. To register, you'll need a recent, NYS DMV-issued driver license, permit, or non-driver ID. You'll also need the zip code currently on record with the DMV, and the last four digits of your social security number.",
				link: 'https://voterreg.dmv.ny.gov/MotorVoter/?_ga=2.150642997.240353350.1567464124-1774056322.1567464124',
			},
		],
		sources: [
			// static content
			'https://www.worldatlas.com/articles/the-10-biggest-cities-in-new-york-state.html',
			'https://www.movoto.com/guide/ny/moving-to-new-york-state/',
			'https://smartasset.com/mortgage/15-things-to-know-before-moving-to-new-york-state',
			'https://www.factretriever.com/new-york-facts',
			'https://worldpopulationreview.com/us-cities/new-york-city-population/',
			'https://www.payscale.com/cost-of-living-calculator/New-York-New-York',
			'https://www.zillow.com/new-york-ny/home-values/https://www.rentcafe.com/average-rent-market-trends/us/ny/manhatta',
			'https://realestate.usnews.com/places/new-york/buffalo',
			'https://www.payscale.com/cost-of-living-calculator/New-York-Buffalo',
			'https://www.zillow.com/buffalo-ny/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ny/buffalo/',
			'https://dmv.ny.gov/driver-license/exchange-out-state-driver-license',
			'https://dmv.ny.gov/registration/register-vehicle-when-you-are-out-state',
			'https://www.bls.gov/opub/ted/2019/unemployment-rate-unchanged-at-3-point-6-percent-in-may-2019.htm?view_full',
			'https://nypost.com/2019/04/15/yet-another-study-confirms-it-ny-has-the-worst-economic-prospects/https://www.statista.com/statistics/304883/new-york-real-gdp-by-industry/',
			'https://www.labor.ny.gov/ui/bpta/contribution-rates.shtm',
			'https://realestate.usnews.com/places/new-york/new-york-city/jobs',
			'https://markets.businessinsider.com/news/stocks/11-mind-blowing-facts-about-new-yorks-economy-2019-4-1028134328#see-also-12',
			'https://www.onlyinyourstate.com/new-york/move-to-ny/',
			'https://www.rochesterrealestateblog.com/moving-to-rochester-ny-11-reasons-youll-love-it/',
			'https://www.payscale.com/cost-of-living-calculator/New-York-Rochester',
			'https://www.zillow.com/rochester-ny/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ny/rochester/',
			'https://www.democratandchronicle.com/story/news/politics/albany/2018/09/03/new-york-top-employers/1156576002/',
			'https://libn.com/2018/07/03/health-systems-are-largest-employers-in-ny/',
			'https://worldpopulationreview.com/states/new-york-population/',
			'https://nypost.com/2019/01/19/why-more-people-are-leaving-new-york-than-any-other-state/',
		],
	},
	NC: {
		state: 'North Carolina',
		stateNickname: 'Tar Heel State',
		welcome: `
			<p>North Carolina is the 9th largest state with a population of 10.49 million people and is bordered by Tennessee, Georgia, South Carolina, Virginia, and the Atlantic Ocean. It's the 28th largest state in the nation by total area and has a rich history and several unique regions characterized by a few distinct landscapes, including coastal plains and mountains. North Carolina is filled with rivers, waterfalls, beaches, longleaf pine forests, and even swamps.</p>
			<p>North Carolina's major industries include information and communications technology, automotive equipment, aerospace/defense/aviation, biotechnology and life sciences, and energy. Since forests cover almost 60 percent of North Carolina, timber is an important natural resource for the state, which allowed it to become one of the largest producers of furniture in the US. The Tar Heel State is known for being a major producer of sweet potatoes and Christmas trees, producing about 15 to 20 percent of the country's real Christmas trees.</p>
			<p>Some of the state's top attractions include the Great Smoky Mountains, Chimney Rock State Park, Pisgah National Forest, Outer Banks, Emerald Isle, Blue Ridge Parkway, Whitewater Falls, Mile High Swinging Bridge, and Grandfather Mountain.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The North Carolina self-storage industry has been on a tear recently, with new facilities being built around the state at a rapid clip. Why? Storage developers are racing to build new sites to meet demand. After the recession, enough funding for storage development wasn't available to keep up with the expanding population of the state. Storage rates rose and space became harder to come by for space-strapped residents. With construction financing bouncing back, many new storage facilities have been built to accommodate the growing population of people moving to the state. This trend has been taking place across the country, but Charlotte and the Triangle Region in particular have recently been among the top markets in the country for self-storage development.</p>
				<p>Below is an overview of the current state of the North Carolina self-storage market:</p>
			`,
			facts: [
				{
					fact: 'North Carolina is home to about 1,773 self-storage facilities.',
					highlight: '1,773',
				},
				{
					fact: 'North Carolina self-storage facilities cover 58,519,700 square feet of storage space.',
					highlight: '58,519,700',
				},
				{
					fact: 'Pennsylvania storage facilities offer 5.92 square feet of storage per person, which is higher than the national average of 5.4 square feet per person.',
					highlight: '5.92',
				},
				{
					fact: 'Average price of a self-storage unit in North Carolina:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Charlotte',
				price: '0',
			},
			{
				city: 'Raleigh',
				price: '0',
			},
			{
				city: 'Greensboro',
				price: '0',
			},
			{
				city: 'Asheville',
				price: '0',
			},
			{
				city: 'Wilmington',
				price: '0',
			},
			{
				city: 'Durham',
				price: '0',
			},
			{
				city: 'Fayetteville',
				price: '0',
			},
			{
				city: 'Winston-Salem',
				price: '0',
			},
			{
				city: 'Carey',
				price: '0',
			},
			{
				city: 'Chapel Hill',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>North Carolina has plenty to offer both visitors and residents alike. So if you've been to the Tar Heel State before, but you're not sure if making the move is right for you, consider the following to help you make your final decision.</p>",
			reasons: [
				"Warm weather. If you're looking to move to a state with warmer weather, North Carolina is a great place to consider due to its mild climate. Moving to the Tar Heel state means you get to experience all of the seasons - warm summers and somewhat cold winters mixed with chilly autumns and mild springs.",
				"Authentic BBQ. You haven't had real vinegar-based BBQ until you've had it in North Carolina. It's home to some of the most amazing authentic BBQ you've ever tasted - both Eastern and Lexington style BBQ.",
				"Foodies' paradise. The food scene in North Carolina has been ranked as one of the best and most progressive in the country so if you're a foodie, you'll love North Carolina for its diverse cuisines. You'll be in close proximity to restaurants that serve delectable southern-style food like shrimp and grits, fried green tomatoes, biscuits and gravy, fried catfish, a barbecue tray, macaroni and cheese, fried chicken, and peach cobbler.",
				'Affordable living. North Carolina is one of the most affordable states in the country with a cost of living lower than the national average. Some of the most affordable cities to live in North Carolina include Concord, Cary, Durham, Wilmington, and Chapel Hill.',
				'Southern hospitality. Moving to North Carolina means you get to look forward to getting southern hospitality from just about everyone. North Carolinians are some of the friendliest people in the country.',
				"Birthplace of Krispy Kreme. Got a major sweet tooth? You'll love that North Carolina is the birthplace of Krispy Kreme donuts. Vernon Rudolph opened the first Krispy Kreme in 1937 in Winston-Salem, North Carolina.",
				'Art and culture. North Carolina has tons of art and cultural activities and events to keep you busy all year round, such as the Asheville Art Museum, Thalian Hall, Blue Ridge Music Trails, and the Biltmore Estate.',
				'Gorgeous natural beauty. North Carolina is home to some of the most beautiful natural landscapes, including breathtaking mountains and stunning beaches, which provides ample opportunity for an array of outdoor activities, like rock climbing, swimming, rafting, surfing, or wind-gliding.',
				"Mixed lifestyle. Whether you're looking for big-city living or the laidback country life, North Carolina can offer both. Here, you'll get that small-town charm combined with easy access to the hustle and bustle of the city. You get the best of both worlds. North Carolina has a mix of diverse cities that are perfect for any type of person - beach bum, farmer, business executive. You get the picture.",
				"Breweries. North Carolina has some of the best breweries in the country and is home to about 170, which means you'll be able to enjoy a quality beer with your favorite people anytime you want.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>North Carolina is the 9th most populous state in the country and has a population of 10.49 million people as of 2019. Between 2018 and 2019, the state's population increased by 1.1 percent. U-HAUL reported at the beginning of the year that North Carolina dropped from seventh place in 2017 to 24th in 2018 for net migration. More people moved into North Carolina than left it in recent years and 2018 saw a slight decline in people moving into the state. The most common reasons for people moving into or out of the state include jobs, family, and retirement.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>North Carolina has a GDP of $565 billion as of 2018. North Carolina's economy is the 10th largest in the world. If it were a country, it'd have a similar GDP to Norway's ($513 billion) and it'd have the 28th largest economy in the world.</p>
				<p>Currently, North Carolina's unemployment rate is 4.9 percent as of August 2019, according to the Bureau of Labor Statistics. This is somewhat higher than the US national unemployment rate of 3.9 percent.</p>
				<p>Below is a breakdown of the leading industries in North Carolina by real value GDP added:</p>
			`,
			breakdown: [
				{
					sector: 'Manufacturing',
					value: '$91.33 billion',
				},
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$88.88 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$62.66 billion',
				},
				{
					sector: 'Professional and businesses services',
					value: '$57.11 billion',
				},
				{
					sector: 'Education services, health care, and social assistance',
					value: '$40.95 billion',
				},
			],
			bottomLine: `
				<p>The economy in North Carolina is already strong and it's expected to continue to grow into the two largest metro areas, Charlotte and Raleigh. Both areas are poised for even more growth through 2020. Economists are reporting that North Carolina can expect more jobs and increased pay in the coming years. North Carolina has a cost of living score of 96.2, meaning the state is cheaper than the US average. That means moving to North Carolina could make living more affordable in terms of housing, groceries, utilities, and transportation.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: "Lowe's Companies",
					employees: '290,000',
				},
				{
					employer: 'Bank of America',
					employees: '211,000',
				},
				{
					employer: 'U.S. Trust',
					employees: '209,000',
				},
				{
					employer: 'Compass Group',
					employees: '181,632',
				},
				{
					employer: 'Total',
					employees: '98,280',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>North Carolina is about 53,819 square miles and there are about 2.3 people per square mile. The largest cities in North Carolina include Charlotte, Raleigh, and Greensboro.</p>
			`,
			cities: [
				{
					city: 'Charlotte',
					copy: '<p>Charlotte is the largest city in North Carolina and the 17th largest city in the country. The city was recently named a millennial hub and one of the fastest-growing cities in the country. With a population of about 889,019 people, the city is filled with plenty to do and see, including the NASCAR Hall of Fame, the Discovery Place Science Center, Freedom Park, the Bechtler Museum of Modern Art, and Carowinds.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '5 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$230,300',
						},
						{
							item: 'Average rent',
							value: '$1,243 per month',
						},
						{
							item: 'Average apartment size',
							value: '944 square feet',
						},
					],
				},
				{
					city: 'Raleigh',
					copy: "<p>Raleigh is North Carolina's second-largest city with a population of 464,758 and boasts 16.8 million visitors each year. The city has a distinct art scene, which includes Broadway shows and original plays performed in outdoor theaters. Raleigh also has more than 9,000 acres of parkland, a nationally-acclaimed greenway spanning more than 180 miles, and almost 1,300 acres of water, which means ample opportunity for outdoor recreation, such as hiking, walking, swimming, fishing, jet-skiing, boating, and more.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '5 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$280,300',
						},
						{
							item: 'Average rent',
							value: '$1,208 per month',
						},
						{
							item: 'Average apartment size',
							value: '958 square feet',
						},
					],
				},
				{
					city: 'Greensboro',
					copy: "<p>Greensboro is North Carolina's third-largest city, with a population of 284,816 people. Located in Guilford County, Greensboro was rated the 10th best place to live in the US by Niche.com because if its diversity and its suburban feel, but also because of the great weather and the numerous activities available, including parks, museums, art galleries, kayaking, and canoeing and attractions like the Carolina Film and Video Festival, the Greensboro Children's Museum, and Wet'n Wild Emerald Pointe.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '10 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$148,700',
						},
						{
							item: 'Average rent',
							value: '$908 per month',
						},
						{
							item: 'Average apartment size',
							value: '937 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of North Carolina are required to get a new driver's license within 60 days of establishing a permanent residence in the state at the North Carolina Division of Motor Vehicles. Before applying, you should familiarize yourself with the North Carolina Driver's Handbook, as each state has different rules of the road.  Bring the following with you when you go to the NCDMV: out-of-state-license, social security card, proof of address, and proof of insurance. For more info, visit:",
				link: 'https://www.ncdot.gov/dmv/help/moving/Pages/new-residents.aspx',
			},
			{
				title: 'Vehicle registration',
				copy: "After you get your North Carolina driver's license, you'll have to register your vehicle once you gain new employment or at the expiration of the time established by North Carolina and your previous state of residence, which is typically 30 days. To register your vehicle, you'll need the vehicle title from the previous state, a filled out MVR-1 Title application, a filled out MVR-180 form (if your vehicle is less than 10 years old), a North Carolina driver's license, and insurance issued in North Carolina. For more info, visit:",
				link: 'https://www.ncdot.gov/dmv/help/moving/Pages/new-residents.aspx',
			},
			{
				title: 'Voter Registration',
				copy: "In order to register to vote in North Carolina, you'll have to complete a voter registration application and provide information such as your full name, date of birth, residential address, and citizenship status. Residents are required to sign the hard copy of their application as electronic signatures are not accepted. For more info, visit:",
				link: 'https://www.ncsbe.gov/voters/registering-to-vote',
			},
		],
		sources: [
			// static content
			'https://www.statista.com/statistics/304960/north-carolina-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-north-carolina/',
			'https://livability.com/nc/real-estate/8-reasons-to-move-to-north-carolina',
			'https://www.wendellfalls.com/whats-happening/blog/posts-by-date/2016/october/10-reasons-to-move-to-north-carolina/',
			'https://www.onlyinyourstate.com/north-carolina/20-reasons-to-move-to-nc/',
			'https://www.trustedchoice.com/insurance-articles/moving/moving-to-north-carolina',
			'https://fred.stlouisfed.org/series/NCNGSP',
			'https://www.nccommerce.com/blog/2017/01/18/north-carolina%E2%80%99s-gross-domestic-product',
			'https://www.ncdemography.org/2015/01/20/if-us-states-were-countries-nc-would-be-the-worlds-35th-largest-economy/',
			'https://www.bls.gov/cps/cps_htgm.htm',
			'https://worldpopulationreview.com/states/north-carolina-population/cities/',
			'https://www.ncdot.gov/dmv/help/moving/Pages/new-residents.aspx',
			'https://www.ncsbe.gov/voters/registering-to-vote',
			'https://kids.nationalgeographic.com/explore/states/north-carolina',
			'https://www.coolkidfacts.com/north-carolina-facts/',
			'https://worldpopulationreview.com/states/north-carolina-population/cities/',
			'https://worldpopulationreview.com/states/north-carolina-population/',
			'https://www.journalnow.com/news/local/fewer-people-moved-into-north-carolina-in-than-previous-years/article_b3a223f4-e361-564e-8f3f-076737064ae5.html',
			'https://www.bestplaces.net/cost_of_living/state/north_carolina',
			'https://www08.wellsfargomedia.com/assets/pdf/commercial/insights/economics/regional-reports/nc-economic-outlook-20190716.pdf',
			'https://www.wraltechwire.com/2019/08/30/nc-economy-remains-strong-with-more-jobs-increases-in-pay-economist-reports/',
			'https://www.visitraleigh.com/plan-a-trip/fast-facts/',
			'https://uspopulation2019.com/population-of-north-carolina-2019.html',
			'https://www.payscale.com/cost-of-living-calculator/North-Carolina-Charlotte',
			'https://www.zillow.com/charlotte-nc/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nc/charlotte/',
			'https://www.payscale.com/cost-of-living-calculator/North-Carolina-Raleigh',
			'https://www.zillow.com/raleigh-nc/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nc/raleigh/',
			'https://www.areavibes.com/greensboro-nc/cost-of-living/',
			'https://www.zillow.com/greensboro-nc/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/nc/greensboro/',
			'https://www.visitnc.com/story/baVq/cradle-of-cue-stops-on-north-carolina-s-historic-barbecue-trail',
			'https://www.tripadvisor.com/Attractions-g60845-Activities-Greensboro_North_Carolina.html',
			'https://www.niche.com/places-to-live/greensboro-guilford-nc/',
			'https://livability.com/nc/affordable-places-to-live/the-5-most-affordable-cities-in-north-carolina',
		],
	},
	ND: {
		state: 'North Dakota',
		stateNickname: 'Peace Garden State',
		welcome: `
			<p>North Dakota, also known as the Peace Garden State, is the 47th largest country in the US with a population of 760,900 people. Known as the happiest state in the country, North Dakota is known for its friendly residents, scenic landscapes, and Native American culture.</p>
			<p>North Dakota's largest industries include tourism, manufacturing, agriculture, renewable energy, and coal gasification. The state's natural resources include lignite, gas, oil, and petroleum.</p>
			<p>The Peace Garden State has plenty to attract visitors and residents alike, including Theodore Roosevelt National Park, the Enchanted Highway, Fort Abraham Lincoln State Park, Lake Metigoshe State Park, and Knife River Indian Villages National Historic Site.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>As more folks continue to move into North Dakota than move out, the self-storage sector has found opportunities to build new storage space or convert vacant retail stores into storage facilities in growing markets. But North Dakota has a good amount of self-storage currently with a total of 4,429,617 square feet in existence. That's 6.03 square feet per person, an amount greater than the nationwide average of 5.4 square feet per head. With an oversupply of storage, monthly rental prices in North Dakota are more affordable for consumers compared to the rest of the country.</p>
			`,
			facts: [
				{
					fact: 'North Dakota is home to an estimated 161 self-storage facilities.',
					highlight: '161',
				},
				{
					fact: 'North Dakota self-storage facilities cover 4,429,617 square feet of storage space.',
					highlight: '4,429,617',
				},
				{
					fact: 'North Dakota storage facilities offer 6.03 square feet of storage per person, which is lower than the national average of 5.4 square feet per person.',
					highlight: '6.03',
				},
				{
					fact: 'Average price of a self-storage unit in North Dakota:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Fargo',
				price: '0',
			},
			{
				city: 'Bismarck',
				price: '0',
			},
			{
				city: 'Minot',
				price: '0',
			},
			{
				city: 'Grand Forks',
				price: '0',
			},
			{
				city: 'Williston',
				price: '0',
			},
			{
				city: 'Dickinson',
				price: '0',
			},
			{
				city: 'Mandan',
				price: '0',
			},
			{
				city: 'West Fargo',
				price: '0',
			},
			{
				city: 'Devils Lake',
				price: '0',
			},
			{
				city: 'Valley City',
				price: '0',
			},
			{
				city: 'New Town',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Thinking about making the move to North Dakota for good? Here are 10 reasons you'll love the Peace Garden State.</p>",
			reasons: [
				'Perfect for pasta lovers. The majority of the pasta made in America is from North Dakota durum wheat. The city Grand Forks holds a huge pasta party every year to honor the crop.',
				'Easy to find employment. North Dakota has one of the lowest unemployment rates in the country, meaning you should have no trouble finding a job if you make the move.',
				"The World's Largest French Fry Feed. Every year in Grand Forks, residents host the world's largest French fry feed during Potato Bowl USA. In 2015, 5,220 pounds of fries were served.",
				'Get Your snow angel on. North Dakota holds the Guinness World Record for the most snow angels made at the same time in the same place. Join in on the fun if you make the move.',
				'The world\'s largest (fake) buffalo. In Jamestown, North Dakota, you can stand beside the world\'s largest fake buffalo called "Dakota Thunder," which is 26 feet tall!',
				"Quirky names for cities and places. North Dakota has some quirky and oddly named cities and places so if you'd get a kick out of living in a place called Buttzville or On-a-Slant village and bragging to your friends back home about it, North Dakota might be for you.",
				'Lawn mower racing. Ever wanted to race your friends on a riding lawn mower without being harshly judged by onlookers? Well you can if you move to North Dakota where mowers are customized to reach speeds of 60mph for competitive races.',
				'A whole lot of pancakes. Much like the French fry feed, the largest pancake feed is held in Fargo, North Dakota and it served up 34,818 pancakes back in 2008.',
				"Great for snow bunnies. If you just can't get enough of cold weather and the snow, you'll love North Dakota because it's got really long winters and short (but hot) summers.",
				"Melting pot of food. North Dakota cuisine can offer several different kinds of cuisine from Norwegian to Native American to German. In North Dakota, you'll be able to enjoy dishes like Fleischkuekle (a German meat-filled pastry), hotdish (a casserole topped with tater tots), and Knoephla (a German potato dumpling soup).",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>North Dakota has a population of roughly 760,900 people. Between 2018 and 2019, the population increased by 0.11 percent. In recent years, people moved both into and out of North Dakota, but more people are moving in than out. The main reason for moving either into or out of the state was employment. Other reasons for moving included family reasons and retirement.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>North Dakota's GDP for 2018 was approximately $51.16 billion, according to Statista. The state's unemployment rate is 2.5 percent as of September 2019, which is lower than the national unemployment rate (3.6 percent as of October 2019).</p>
				<p>North Dakota is expected to see a 0.4 percent job growth rate through 2020, adding approximately 2,200 new jobs. One piece of good news is that the energy sector slowly revitalized after a three-year slump. The state's population and the labor force are starting to grow thanks to the oil sector drawing migrants again. North Dakota's other major industries, wind farms and agriculture, are subject to volatile economic conditions, according to Kiplinger.</p>
				<p>North Dakota has a cost of living score of 89.9, meaning it's cheaper to live there than the US as a whole.</p>
				<p>Below is a break down of North Dakota's largest sectors by GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$7.61 billion',
				},
				{
					sector: 'Mining, quarrying, and oil and gas extraction',
					value: '$7.1 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$5.28 billion',
				},
				{
					sector: 'Wholesale Trade',
					value: '$4.57 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$4.05 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Scheels',
					employees: '6,000',
				},
				{
					employer: 'TMI Hospitality',
					employees: '4,000',
				},
				{
					employer: 'Altru Health System',
					employees: '3,800',
				},
				{
					employer: 'North Dakota State University',
					employees: '3,410',
				},
				{
					employer: 'ICS',
					employees: '3,250',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>North Dakota covers approximately 71,432 square miles and is home to 53 counties. The three largest cities include Fargo, Bismarck, and Grand Forks.</p>
			`,
			cities: [
				{
					city: 'Fargo',
					copy: "<p>Fargo is North Dakota's largest city with a population of 127,422. Over 15 percent of the state's entire population lives in Fargo and it's probably because of the city's variety of entertainment and activities, which includes art galleries, museums, and outdoor activities like golf, biking, running, curling, fishing, swimming, and more.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '6 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$225,600',
						},
						{
							item: 'Average rent',
							value: '$843 per month',
						},
					],
				},
				{
					city: 'Bismarck',
					copy: "<p>Bismarck is the second-largest city in North Dakota and has a population of roughly 75,858 residents. It's also the capital city of North Dakota and provides tons to do on your days off, such as hiking, golf courses, restaurants, shops, and cafes.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '3 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$267,600',
						},
						{
							item: 'Average rent',
							value: '$958 per month',
						},
					],
				},
				{
					city: 'Grand Forks',
					copy: '<p>Grand Forks is the third-largest city in North Dakota with a population of 58,500 people. Nestled on the western banks of the Red River of the North in Red River Valley, Grand Forks is full of small-town charm and an array of things to do to keep yourself entertained, including North Dakota Museum of Art, Splashers of the South Seas (indoor water park), and the Greenway.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$209,300',
						},
						{
							item: 'Average rent',
							value: '$834 per month',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of North Dakota have 60 days to transfer their out-of-state driver's license to a new one. You'll have to go to your local NDDOT office in person and provide several documents, your out-of-state driver's license, and you'll have to pay the required fees. You might also have to take the written and driving exams. For more info, visit:",
				link: 'https://www.dmv.org/nd-north-dakota/car-registration.php',
			},
			{
				title: 'Vehicle registration',
				copy: "Once you get your new North Dakota license, you'll have to register your out-of-state vehicle with the DOT unless you're a full-time non-resident student or active-duty military personnel. You'll have to register your vehicle at a local North Dakota DMV office. For more info, visit:",
				link: 'https://www.dmv.org/nd-north-dakota/car-registration.php',
			},
			{
				title: 'Voter Registration',
				copy: 'North Dakota is the only state without voter registration, however, you can still register to vote in city elections. You must be a legal resident of North Dakota and a resident in the precinct at least 30 days before any election. To vote, complete the online application using the link below. For more info, visit:',
				link: 'https://votesmart.org/elections/voter-registration/ND#.XdAVNTJKho4',
			},
		],
		sources: [
			// static content
			'https://www.zippia.com/advice/largest-companies-in-north-dakota/',
			'https://www.statista.com/statistics/1065144/north-dakota-real-gdp-by-industry/',
			'https://www.statista.com/statistics/188099/gdp-of-the-us-federal-state-of-north-dakota-since-1997/',
			'https://www.bls.gov/eag/eag.nd.htm',
			'https://worldpopulationreview.com/states/north-dakota-population/',
			'https://bismarcktribune.com/news/state-and-regional/study-jobs-top-reason-for-moving-to-or-out-of/article_8efa5833-5eba-5a53-ab8d-707b3ebc4dc8.html',
			'https://www.kiplinger.com/slideshow/business/T019-S010-kiplinger-economic-outlook-for-all-50-states-2020/index.html',
			'https://www.bestplaces.net/cost_of_living/state/north_dakota',
			'https://worldpopulationreview.com/states/north-dakota-population/cities/',
			'https://livability.com/nd/fargo/things-to-do/activities-in-fargo-nd-biking-running-and-golf',
			'https://livability.com/nd/bismarck',
			'https://www.forbes.com/places/nd/grand-forks/',
			'https://www.google.com/travel/things-to-do?g2lb=2502405%2C2502548%2C4208993%2C4254308%2C4258168%2C4260007%2C4270442%2C4274032%2C4285990%2C4288513%2C4289525%2C4291318%2C4296668%2C4301054%2C4305595%2C4308216%2C4313006%2C4315873%2C4317816%2C4317909%2C4322341%2C4324289%2C4329288%2C4270859%2C4284970%2C4291517%2C4292955%2C4307997&hl=en&gl=us&un=1&otf=1&dest_mid=%2Fm%2F0yp21&dest_src=ts&dest_state_type=main&sa=X&ved=2ahUKEwj0zdXqg-_lAhWQct8KHaKbBnQQ6tEBKAQwAHoECAwQCw#ttdm=47.900367_-97.057258_12',
			'https://www.dmv.org/nd-north-dakota/new-to-north-dakota.php',
			'https://www.dmv.org/nd-north-dakota/car-registration.php',
			'https://votesmart.org/elections/voter-registration/ND#.XdAVNTJKho4',
			'https://www.payscale.com/cost-of-living-calculator/North-Dakota-Fargo',
			'https://www.zillow.com/fargo-nd/home-values/',
			'https://www.rentjungle.com/average-rent-in-fargo-rent-trends/',
			'https://www.payscale.com/cost-of-living-calculator/North-Dakota-Bismarck',
			'https://www.zillow.com/bismarck-nd/home-values/',
			'https://www.rentjungle.com/average-rent-in-bismarck-rent-trends/',
			'https://www.payscale.com/cost-of-living-calculator/North-Dakota-Grand-Forks',
			'https://www.zillow.com/grand-forks-nd/home-values/',
			'https://www.rentjungle.com/average-rent-in-grand-forks-rent-trends/',
			'https://kids.nationalgeographic.com/explore/states/north-dakota/',
			'https://www.coolkidfacts.com/north-dakota-facts/',
			'https://www.ndtourism.com/articles/north-dakota-facts',
			'https://livability.com/nd/real-estate/8-reasons-to-move-to-north-dakota',
			'https://www.midwestliving.com/travel/north-dakota/7-reasons-i-love-living-north-dakota/',
			'https://www.factretriever.com/north-dakota-facts',
		],
	},
	OH: {
		state: 'Ohio',
		stateNickname: 'Buckeye State',
		welcome: `
			<p>With a population of 11.7 million people, Ohio is the 7th largest state by population and the 34th largest by size. Ohio is a state rich in natural resources, cheap energy, and productive soils. Local industries take full advantage of Ohio's oil, salt, coal, limestone, sandstone, natural gas, and other resources. Heavily engulfed in agriculture and mineral production, those are two of the state's greatest sources of income. However, manufacturing is still one of Ohio's most important economic activities.</p>
			<p>Ohio's major industries include aerospace, advanced energy, agriculture and food processing, motor vehicle and parts manufacturing, and professional and financial services. North Ohio's major industries include fuel cells, liquid crystal displays, polymers, bioscience, chemicals, logistics, and distribution.</p>
			<p>While Cleveland may be more expensive than the US as a whole when it comes to the cost of living, Columbus and Cincinnati both have a cost of living lower than the national average. Let's not forget that there's tons to do across the state all year long, including beaches, museums, casinos, and skiing, to name a few.</p>
			<p>Top attractions include Kings Island Amusement Park, Hocking Hills State Park, Cedar Point, Cuyahoga Valley National Park, Cincinnati Zoo & Botanical Garden, and The Cleveland Museum of Art.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Ohio self-storage industry has grown in recent years with a market driven by pent up demand and population growth. A recent wave of development has taken over the country and the Buckeye State is no exception. Following the last recession, the development of new self-storage space slowed to a halt. Banks were no longer lending to speculative commercial development. But demand for facilities did not go away as population centers in cities like Columbus and Cleveland continue to grow. With financing now available for the self-storage industry, many facilities are being built currently to meet the demand in urban centers as well as in secondary and tertiary markets across the United States. The good news is for consumers is that the expansion of new self-storage facilities has led to lower rates as operators compete to fill empty space.</p>
				<p>Below is an overview of the current state of the Ohio self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Ohio is home to about 1,748 self-storage facilities.',
					highlight: '1,748',
				},
				{
					fact: 'Ohio self-storage facilities cover 53,926,296 square feet of storage space.',
					highlight: '53,926,296',
				},
				{
					fact: 'Ohio storage facilities offer 4.67 square feet of storage per person, which is lower than the national average of 5.4 square feet per person.',
					highlight: '4.67',
				},
				{
					fact: 'Average price of a self-storage unit in Ohio:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Cleveland',
				price: '0',
			},
			{
				city: 'Columbus',
				price: '0',
			},
			{
				city: 'Cincinatti',
				price: '0',
			},
			{
				city: 'Akron',
				price: '0',
			},
			{
				city: 'Youngstown',
				price: '0',
			},
			{
				city: 'Dayton',
				price: '0',
			},
			{
				city: 'Toledo',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you've been considering moving to Ohio, but you're not exactly sure what it is you have to look forward to, take a look at the top 10 reasons you might want to make the move. They may just convince you to make your next visit permanent.</p>",
			reasons: [
				"Wine lovers' paradise. Some people call Ohio the Napa Valley of the Midwest, so if you're a wine connoisseur or you just like to sip on your favorite red in the evenings, Ohio is a great place to be.",
				"The rollercoasters. If you make the move to Ohio, you'll never be more than a few hours from some of the best roller coasters in the world. Ohioans love themselves a good rollercoaster, you'll learn.",
				"Hot dogs everywhere. Ohio is home to large populations of German, Hungarian, and Polish residents and because of that, you'll likely find a hot dog place in close proximity no matter where you are in the state. If you're a fan of hot dogs and sausages, you won't be disappointed living in Ohio.",
				'Other culinary delights. Ohio is a great place to find a variety of different kinds of foods (other than hot dogs) with playful menus and state-of-the-art chefs, including Ricotta dumplings in Columbus and sushi in Toledo.',
				"Experience all four seasons. Moving to Ohio means you'll get to experience all four of the seasons, which means you get to periodically update your wardrobe every three months. Win-win!",
				"Great flights. If you're looking to escape the cold weather the winter brings in Ohio, escaping to Florida is easy. There are tons of flights that leave directly out of Ohio.",
				"Home of the Rock & Roll Hall of Fame. Cleveland is home to the largest house of rock n' roll in the entire country. Moving to Cleveland gives you bragging rights few others have.",
				'Top shelf beer. Ohio has plenty of dive bars and sports bars and they often have the top-shelf brands of craft beer, so bottoms up!',
				"The Greatest Free Show on Earth. Every fall, at the Circleville Pumpkin Show, you'll get to experience one of the coolest fall festivals in the state to what locals call The Greatest Free Show on Earth.",
				"Proximity to major cities. If you move to Ohio, you'll be halfway between New York City and Chicago, meaning you can take a quick trip to either city any time you want. Road trip anyone?",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>With a population of approximately 11.7 million people, Ohio is the 7th most populous and 10th most densely populated state in the country. The state has one of the slowest lowest growth rates in the US. Between 2018 and 2019, the population grew by 0.25 percent. Ohio was ranked number six on the list of most moved-from states in 2018. The reason for the decline appears to be new employment. People are flocking to other states for new jobs. More than 60 percent of outgoing migrants said that was their main reason for leaving Ohio. Other reasons include Ohio not having full worker freedom, like the majority of its neighbors. Ohio also has a complex local government structure, local income taxes, as well as a high occupational licensing burden.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Ohio's economic outlook is strong because of the fact that the state still has impressive comparative advantages, including having a location that puts businesses in favorable locations - within 600 miles of 59 percent of the population of the US and Canada. Not to mention, the goods produced or making their way through Ohio can contribute to the state's economy in the coming years, according to the Carnegie Endowment for International Peace and the Ohio Development Services Agency.</p>
				<p>The state GDP is about $676 billion as of 2018 and the current unemployment rate in Ohio is 4.2 percent (September 2019), which is higher than the US average of 3.5 percent. While unemployment rates are rising, the state appears to be recovering with a 0.4 percent increase in the job market over the last year. Over the next 10 years, job growth is expected to increase by 26.9 percent, which is somewhat lower than the US average of 33.5 percent. However, plenty of cities in Ohio boast a lower cost of living than the national average, such as Columbus, which has a cost of living 10 percent lower than the national average.</p>
				<p>Below is a breakdown of Ohio's largest sector by real GDP added:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$110.72 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$101.8 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$72.11 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$62.23 billion',
				},
				{
					sector: 'Educational services, healthcare, and social assistance',
					value: '$58.32 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Wal-Mart Stores, Inc.',
					employees: '50,200',
				},
				{
					employer: 'Cleveland Clinic Foundation',
					employees: '49,800',
				},
				{
					employer: 'Kroger Co.',
					employees: '45,150',
				},
				{
					employer: 'Ohio State University',
					employees: '33,300',
				},
				{
					employer: 'Mercy Health',
					employees: '32,200',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Ohio is 44,825 square miles with a population density of 282 people per square mile. Known to some as The Heart of It All due to its close proximity to both Chicago and NYC, Ohio is a state filled with opportunity. From amusement and state parks to dozens of outdoor events and restaurants, there's no shortage of things to do and see in Ohio.</p>
			`,
			cities: [
				{
					city: 'Columbus',
					copy: "<p>Columbus, which is also the state's capital, is the most populous city in Ohio with a population of roughly 890,228 people. Located in Central Ohio, Columbus has plenty to offer whether you're there to visit or stay, including museums, escape rooms, wineries, vineyards, restaurants, sports games, and more.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '10 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$158,700',
						},
						{
							item: 'Average rent',
							value: '$947 per month',
						},
						{
							item: 'Average apartment size',
							value: '885 square feet',
						},
					],
				},
				{
					city: 'Cleveland',
					copy: "<p>Cleveland is Ohio's second-largest city and has a population of about 379,800 people, according to World Population Review. Located in Northeast Ohio, Cleveland boasts casinos, museums, golf clubs, zoos, parks, theaters, and antique shops.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '1 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: "$5Cincinnati, Ohio's third-largest city, has more than 299,238 residents that live within the city limits. Home to two professional sports teams, the Bengals and the Reds, Cincinnati is a city brimming with excitement. Located in Southwest Ohio, there's more than enough to do in this exciting city, including distilleries, state parks, conservatories, museums, botanical gardens, zoos, art centers, and theaters.",
						},
						{
							item: 'Average rent',
							value: "$1,097 per Cincinnati, Ohio's third-largest city, has more than 299,238 residents that live within the city limits. Home to two professional sports teams, the Bengals and the Reds, Cincinnati is a city brimming with excitement. Located in Southwest Ohio, there's more than enough to do in this exciting city, including distilleries, state parks, conservatories, museums, botanical gardens, zoos, art centers, and theaters.",
						},
						{
							item: 'Average apartment size',
							value: "801 squareCincinnati, Ohio's third-largest city, has more than 299,238 residents that live within the city limits. Home to two professional sports teams, the Bengals and the Reds, Cincinnati is a city brimming with excitement. Located in Southwest Ohio, there's more than enough to do in this exciting city, including distilleries, state parks, conservatories, museums, botanical gardens, zoos, art centers, and theaters.",
						},
					],
				},
				{
					city: 'Cincinnati',
					copy: "<p>Cincinnati, Ohio's third-largest city, has more than 299,238 residents that live within the city limits. Home to two professional sports teams, the Bengals and the Reds, Cincinnati is a city brimming with excitement. Located in Southwest Ohio, there's more than enough to do in this exciting city, including distilleries, state parks, conservatories, museums, botanical gardens, zoos, art centers, and theaters.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '8 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$147,100',
						},
						{
							item: 'Average rent',
							value: '$996 per month',
						},
						{
							item: 'Average apartment size',
							value: '870 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "To obtain a new Ohio driver's license, you'll have to visit your local deputy registrar license agency. You also need to bring proof of your full legal name, date of birth, social security number, citizenship, and Ohio street address. For more info, visit:",
				link: 'https://www.dmv.org/nd-north-dakota/car-registration.php',
			},
			{
				title: 'Vehicle registration',
				copy: "To register your vehicle in the state of Ohio, you have to go to a deputy registrar license agency and show them your Ohio Certificate of Title or Memorandum of Title, lease agreement and power of attorney documents, E-Check certificate (if applicable) and your Ohio driver's license, state ID or social security number. For more info, visit:",
				link: 'https://ohio.gov/wps/portal/gov/site/residents/resources/bmv-new-residents-guide',
			},
			{
				title: 'Voter Registration',
				copy: "Registering to vote in Ohio requires that you be a United States citizen, you're at least 18 years old, and that you've been a resident of Ohio for 30 days minimum before the election. To register to vote, you have to fill out the National Voter Registration Form, sign it, and mail it to the address provided on the BMV website. For more information, visit:",
				link: 'https://www.vote.org/register-to-vote/ohio/',
			},
		],
		sources: [
			// static content
			'https://www.homesnacks.net/moving-to-ohio-1213939/',
			'https://livability.com/oh/make-your-move/10-surprising-things-about-living-in-ohio',
			'https://www.onlyinyourstate.com/ohio/reasons-you-should-move-to-oh/',
			'https://www.trustedchoice.com/insurance-articles/moving/moving-to-ohio/',
			'https://worldpopulationreview.com/states/ohio-population/',
			'https://www.statista.com/statistics/304935/ohio-real-gdp-by-industry/',
			'https://www.cincinnati.com/story/money/business/2018/06/13/see-ohios-largest-employers/697287002/',
			'https://www.vote.org/register-to-vote/ohio/',
			'https://ohio.gov/wps/portal/gov/site/residents/resources/bmv-new-residents-guide',
			'https://www.payscale.com/cost-of-living-calculator/Ohio-Columbus',
			'https://www.payscale.com/cost-of-living-calculator/Ohio-Cincinnati',
			'https://www.payscale.com/cost-of-living-calculator/Ohio-Cleveland',
			'https://www.zillow.com/columbus-oh/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/oh/columbus/',
			'https://www.zillow.com/cleveland-oh/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/oh/cleveland/',
			'https://www.zillow.com/cincinnati-oh/home-values/',
			'https://www.bestplaces.net/economy/state/ohio',
			'https://www.neotec.org/site.cfm/About-NE-Ohio/Industry-Profiles.cfm',
			'https://www.thecentersquare.com/ohio/study-ohio-ranked-th-in-people-leaving-state/article_246743ee-0fa7-11e9-8420-8f5aff60d600.html',
			'https://ohio.org/regions/ohio-cities/',
			'https://fred.stlouisfed.org/series/OHNGSP',
			'https://carnegieendowment.org/2018/12/10/diverging-economic-realities-for-ohioans-today-pub-77795',
			'https://www.britannica.com/place/Ohio-state/Economy#ref78872',
			'https://carnegieendowment.org/2018/12/10/diverging-economic-realities-for-ohioans-today-pub-77795',
		],
	},
	OK: {
		state: 'Oklahoma',
		stateNickname: 'Sooner State',
		welcome: `
			<p>Oklahoma is where the wind comes sweeping down the plain — at least, that is, according to musical theater fans. This sweeping wind can take the form of tornadoes, with 83 recorded events in 2018, much more than Oklahoma’s annual average of 56. While the tornado season and its associated risks are important considerations for those looking to move to Oklahoma, there is a lot more to the Sooner State than twisters.
			<p>The state has recently become a popular destination for relocating households, likely because of its low cost of living, fast-growing economy, and a population noted for kindness and laid-back way of life. Some know of Oklahoma as the site of the tragic Oklahoma City bombing of 1995. In many ways, that sad event has brought Oklahomans together in an infectious unity that creates a sense of community. In many ways, Oklahoma has almost everything one would want: beautiful natural areas, a bustling and diverse metropolis in Oklahoma City, southern hospitality, and a touch of Midwestern charm, too.
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>For a state with so much wide open space, you might be surprised to learn just how big the self-storage industry in Oklahoma is. There are about 937 self-storage facilities in the state, which together provide 7.88 square feet per capita! That's much higher than the national average of 5.4 square feet per person. Oklahoma has seen the number of self-storage facilities grow in recent years thanks to a nationwide expansion of self-storage that has taken place over the last several years. With Oklahoma's population increasing more than 5 percent since 2010, it has made it a prime target for self-storage developers who seek areas that are growing in population.</p>
			`,
			facts: [
				{
					fact: 'Oklahoma is home to more than 937 self-storage facilities',
					highlight: '937',
				},
				{
					fact: 'Oklahoma facilities offer more than 30.4 million square feet of storage space combined.',
					highlight: '30,400,000',
				},
				{
					fact: 'Oklahoma has 7.88 square feet of storage space for every man, woman, and child.',
					highlight: '7.88',
				},
				{
					fact: 'Average price of a self-storage unit in Oklahoma: ',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Oklahoma City',
				price: '0',
			},
			{
				city: 'Norman',
				price: '0',
			},
			{
				city: 'Tulsa',
				price: '0',
			},
			{
				city: 'Edmond',
				price: '0',
			},
			{
				city: 'Enid',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're thinking about making the move, but aren't sure if Oklahoma is the right place for you, consider the following:</p>",
			reasons: [
				'Sooner cuisine. Some of the best-kept culinary secrets in the country are cooked up in Oklahoma. Chicken fried steak, grits, black-eyed peas, okra, and cornbread are all just part of the state’s official meal according to a 1988 state resolution. But there is much more on the Oklahoma menu, such as fried onion burgers and barbecue. And Oklahoma City is home to a sizeable Vietnamese-American population, which makes it an epicenter for traditional Banh Mi sandwiches. ',
				'OU. The University of Oklahoma is a significant public research institution with a reputation for both academic excellence and college athletics dominance. The main campus is in Norman, which is a close neighbor to the south of Oklahoma City.  OU is also home to the National Weather Center.  ',
				'Oklahoma!  Sooner culture hit the Great White Way with the Rodgers and Hammerstein Broadway masterpiece, Oklahoma!  The hit show debuted in 1943 and is credited with creating modern musical theater. The play has been performed thousands of times on Broadway, became a hit film, and continues today in both professional and in countless high school musical productions. ',
				'Rodeo and bull riding. With ample plains and ranchland, it’s no wonder that Oklahoma is home to professional rodeo and bull riding. Major events are held all year long, and the sports have been popular since 1880.',
				'Country music. Oklahoma might not spring to mind as a hub for burgeoning musical talent, but the state is the hometown of numerous country music stars. Reba McIntyre, Carrie Underwood, Garth Brooks, and Toby Keith all have ties to the Sooner State. The state, along with Texas, even has its own sub-genre of country called Red Dirt.',
				'Tornado Alley. This roughly defined area of the Midwest spans northern Texas to South Dakota, covering nearly the entire state of Oklahoma along the way.  While 2019 saw elevated tornado activity in the state, 2018 saw a near-record low.',
				'Native-American culture. 39 Native American tribes call Oklahoma home. Their stories are complex and deep, emanating from national policies of relocation and reservation building. Today, Native American culture is revered and celebrated all across the state, with events such as the Red Earth Festival, the largest powwow in the world.',
				'Oil and gas. Oil is a big part of Oklahoma’s economy.  The first well was discovered and drilled in 1897, and ever since then, the industry has proliferated. The state is ranked third in the nation for natural gas production, and fourth in crude oil production.  Oil accounts for $35 billion of Oklahoma’s $175 billion GDP.',
				'Oklahoma’s manmade lakes. There are lots of lakes in Oklahoma, and they are all man-made reservoirs.  The only natural lakes in the state are either oxbows (river sections naturally cut-off) or playas (dry lake beds). Oklahoma has 200 manmade ones — more than anywhere else in the country.',
				'The OKC Thunder.  Sports in Oklahoma go beyond Sooner pride. The Oklahoma City Thunder NBA team, which were the Seattle Supersonics until 2008,  has one of the most devoted followings in NBA.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Oklahoma is the 20th largest state by size, covering approximately 69,000 square miles. It is the 28th largest state by population, with an estimated 3.9 million residents.  With an average of 55 people per square mile, the state is the 15th least densely populated state. There are only four cities with a population of over 100,000.</p>
				<p>Oklahoma has shown an 8.7% population increase over the decade from 2000 to 2010.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Oklahoma’s gross domestic product (GDP) is roughly $175 billion. The past two decades saw sustained growth, with the last few years showing a slight slowdown and dip in GDP growth. Overall, however, the economy is strong, which some analysts link to the oil industry’s prominence in the state and a 15.72% compound annual growth rate. Another reason for Oklahoma’s economic strength is its low unemployment rate of 3.2%, versus the national average of 3.6%. This rate has been steadily declining over the last decade, following national trends. On average, there are 167,000 jobs added to Oklahoma’s payrolls each month. These include positions in food service, social assistance, finance.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Express Employment Professionals',
				},
				{
					employer: 'Hobby Lobby',
				},
				{
					employer: 'University of Oklahoma',
				},
				{
					employer: 'Saint Francis Health System',
				},
				{
					employer: 'Love’s Travel Stops & Country Stores',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Most of the state’s economic activity is in Oklahoma City and the areas involved in the oil and gas industry, located in the central and eastern sections of the state. Oklahoma stretches along the top of Texas, from Arkansas and Missouri to Colorado and New Mexico. The state offers a variety of places to live, from rural to urban.</p>
				<p>Here’s a quick look at the state’s three largest cities:</p>
			`,
			cities: [
				{
					city: 'Oklahoma City',
					copy: '<p>Oklahoma City boasts a population of 649,021, making it the 29th largest city by population in the United States. The average salary in the city is $58,000, which is slightly higher than the national average of $56,516. The cost of living in Oklahoma City is, however, about 15 percent less than the national average. The biggest employers in Oklahoma City include BancFirst, Chesapeake Energy, Continental Resources, and Paycom. Here are some housing figures for Oklahoma City:</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '15 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$134,100',
						},
						{
							item: 'Average rent',
							value: '$774',
						},
						{
							item: 'Average apartment size',
							value: '848 square feet',
						},
					],
				},
				{
					city: 'Tulsa',
					copy: '<p>Located just about 120 miles away from Oklahoma City is Oklahoma’s second most populous city, Tulsa. The city of slightly more than 400,000 residents is large and diverse without being too big. Significant employers in the Tulsa area include AT&T, AAON, American Airlines, CenturyLink, and Enterprise Holdings, Inc. Here are some housing figures for Tulsa:</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '8 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$122,100',
						},
						{
							item: 'Average rent',
							value: '$698',
						},
						{
							item: 'Average apartment size',
							value: '822 square feet',
						},
					],
				},
				{
					city: 'Norman',
					copy: '<p>Home to the Oklahoma University, Norman has an estimated 123,000 residents. The population here has steadily grown, thanks to its proximity to Oklahoma City and the economic opportunities that accompany OU. Since Norman and OKC are only 20 miles apart, when measured from their respective city centers, both cities comprise a single Oklahoma City metropolitan area. Major employers in addition to OU include Johnson Controls, Hitachi, and Astellas Pharma. Here are some housing figures for Norman:</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '9 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$168,100',
						},
						{
							item: 'Average rent',
							value: '$883',
						},
						{
							item: 'Average apartment size',
							value: '923 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents who possess a driver’s license from another state must obtain an Oklahoma license within 30 days of establishing residency. If your license is valid in your previous state or expired for less than one year, you will only have to take a vision test.',
				link: 'https://www.ok.gov/dps/Obtain_an_Oklahoma_Driver_License_ID_Card/Transfer_a_Driver_License_from_Another_State/Transfer_a_Driver_License_from_Another_State_(Over_the_Age_of_18)/',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents of Oklahoma must register their vehicles within 30 days of moving to Oklahoma.',
				link: 'https://www.ok.gov/tax/Individuals/Motor_Vehicle/',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Oklahoma, you must be a citizen of the United States, be 18 years of age or older on or before the date of the next election, and must be a resident of the state.',
				link: 'https://www.ok.gov/elections/Voter_Info/Register_to_Vote/',
			},
		],
		sources: [
			// static content
			'https://www.foodnetwork.com/restaurants/packages/best-food-in-america/photos/what-to-eat-oklahoma',
			'https://oklahoman.com/special/article/5505468/oklahoma-citys-growth-a-path-thats-unsustainable',
			'https://www.ereferencedesk.com/resources/state-geography/oklahoma.html',
			'https://www.mentalfloss.com/article/59115/15-things-you-might-not-know-about-oklahoma',
			'https://www.usnews.com/best-colleges/university-of-oklahoma-3184',
			'https://www.udiscovermusic.com/stories/how-oklahoma-birthed-the-modern-musical/',
			'https://www.okhistory.org/publications/enc/entry.php?entry=RO014',
			'https://oklahoman.com/article/1914848/39-tribes-call-state-home',
			'https://aoghs.org/oil-almanac/oklahoma-oil-history/',
			'https://www.oerb.com/industry/impact/stats',
			'https://grantland.com/features/thunder-family-values/',
			'https://worldpopulationreview.com/states/oklahoma-population/',
			'https://oklahoman.com/article/5602487/oklahomas-first-quarter-gdp-growth-ranks-no.-22-in-nation',
			'https://www.bls.gov/eag/eag.ok.htm',
			'https://www.ok.gov/oesc/documents/lmiEconIndPub.pdf',
			'https://www.zippia.com/advice/largest-companies-in-oklahoma/',
			'https://www.kansascityfed.org/publications/research/oke/articles/2016/comparing-oklahomas-economy',
			'https://www.zillow.com/oklahoma-city-ok/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ok/oklahoma-city/',
			'https://www.growmetrotulsa.com/business-attraction/relocation-data/largest-employers',
		],
	},
	OR: {
		state: 'Oregon',
		stateNickname: 'Beaver State',
		welcome: `
			<p>Oregon, in the country’s Pacific Northwest, is a land of green forests,  rugged mountains, quiet seashores, hipster culture, excellent wineries, and plenty of year-round opportunities for outdoor activities. Portland has its bicycles, coffee, farm-to-table restaurants, and microbreweries, but much of the state is covered in National Forests and Parks. For many Oregonians, the outdoors and outdoor activities are central parts of life.</p>
			<p>In between the urban and the less-populated areas, there are vibrant communities — a balance of metropolitan cities, small towns, rural farming villages, and some of the best places to live in the country. Logging, fishing, and agriculture ones ruled the Beaver State economy, but today, Oregon’s manufacturing, service, and technology industries are leading the way. Job growth in Oregon is among the nation’s highest; however wage growth is below average.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Oregon in many ways has been at ground zero for the latest wave of self-storage construction taking place across the country. Portland has at times lead the nation in numbers of new self-storage projects as self-storage operators have sought to capitalize on the high amount of population growth in the metro region in recent years. A lack of development immediately after the last recession led to a shortage of self-storage units needed to serve the growing population. New development has led to lower rental rates for consumers, and more modern self-storage options with better amenities.</p>
			`,
			facts: [
				{
					fact: 'Oregon is home to more than 810 self-storage facilities',
					highlight: '810',
				},
				{
					fact: 'Oregon facilities offer more than 28.7 million square feet of storage space combined.',
					highlight: '28,700,000',
				},
				{
					fact: "Oregon has 7.22 square feet of storage space for every man, woman, and child. That's more than the national average of 5.4 square feet per capita.",
					highlight: '7.22',
				},
				{
					fact: 'Average price of a self-storage unit: ',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Portland',
				price: '0',
			},
			{
				city: 'Eugene',
				price: '0',
			},
			{
				city: 'Medford',
				price: '0',
			},
			{
				city: 'Salem',
				price: '0',
			},
			{
				city: 'Bend',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're thinking about making the move, but aren't sure if Oregon is the right place for you, consider the following:</p>",
			reasons: [
				'Coffee culture is everywhere. Coffee is a big deal in Oregon, with noted purveyors and cafes, including Stumptown, Oblique Coffee Roasters, Oui Presse, and others dot the Portland area. While the city is known as the birthplace of the “third wave” of coffee, it is also home to unique offerings that suggest the evolution of coffee consumption in the United States is still moving. Coffee lovers can experience unique Egyptian-style coffee at Tōv or what has been referred to as coffee with a “casually threatening atmosphere” in the allegedly-haunted Rimsky-Korsakoffee House.',
				'Oregon is all about bicycling.  Portland is one of the most bicycle-friendly cities in the country, but the entire state is seemingly obsessed with cycling culture. With cities that embrace the outdoors, people all over the more populated areas of the state are likely to ride to work. And opportunities for longer treks in the picturesque Oregon countryside and forests abound.',
				'Living in Oregon means loving the outdoors. In Oregon, the outdoors are enjoyed by more than just cyclists. Surfing is popular all along the Pacific coastline. Strong waves and Oregon’s unique weather combine for some of the best windsurfing opportunities in the world, too. The state’s five national parks offer history, activities, and nature appreciation.',
				'Oregon is a breadbasket state. Some people mistake Oregon for a state filled with nothing but forests. It also has vast amounts of farming land. Its more than 35,00 farms produce a diverse range of products, including dairy, hops, potatoes, eggs, wine grapes, cherries, sweet corn, and more. Oregon is second only to California in agricultural production. Little-known fact: Oregon is the number one U.S. producer of Christmas trees, blackberries, hazelnuts, peppermint, and cranberries.',
				'No state sales tax helps a slightly high cost of living. Oregon is sometimes referred to as a tax-unfriendly state, especially for retirees. The cost of living is also higher than the U.S. average. However, the state has no sales tax, which offers some financial relief. It can be a source of increased retail activity along the border with Washington, which has one of the highest sales taxes in the nation, and California.',
				'Oregon’s Wine Country excels. Several areas of the Pacific Coast are noted for wine production, such as California’s Napa Valley and Washington’s Columbia Valley.  Oregon has six wine-producing regions that are uniquely its own, including North and South Willamette Valley and Rogue Valley. It shares three regions with Washington, and one with Idaho.',
				'Oregon cuisine is hip, fresh, and funky. Oregon’s status as the number two agricultural producer in the country has given rise to a vibrant farm-to-table movement in food.  But, there is a unique spin on everything in Oregon. This is, after all, the birthplace of Voodoo Donuts with its delectable bacon-maple bars, and Pine State Biscuits’ famous monster chicken and biscuits.',
				'Crater Lake is a collapsed volcano. In the south-central region of the state, Crater Lake is the deepest lake in the United States. This breathtaking lake was formed 7,700 years ago after a volcano erupted and collapsed. Today this area is a National Park, and the volcano is “just resting.”',
				'Portlandia.  Today, you cannot mention Oregon without discussing the hipster culture of Portland, as satirized in Portlandia, a critically-acclaimed comedy show that aired on the IFC channel from 2011 to 2018. Portland in real life may be a little less extreme, but fans of the show can see famous landmarks from the show like Burnside Skatepark and the In Other Words bookshop.',
				"All the beaches in Oregon are public. We mentioned the outdoors and surfing, but if you want to see the devotion to public outdoor enjoyment, note that all beaches in Oregon are public land. While that might be a loss to wealthy residents looking for a seaside home, it's a huge plus for beachcombers and adventurers.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Oregon is the 9th largest state by size, covering approximately 98,466 square miles. It’s slightly larger than the United Kingdom and features a diverse landscape from the Pacific Coast in the west to the Columbia Plateau that borders Washington, Idaho, and Nevada.</p>
				<p>Although the land is diverse, the bulk of Oregon’s population is near its three largest cities in the central and northwest sections of the state, Portland, Salem, and Eugene. Oregon has a total population of 4.2 million. The combination of vast size and relatively small community means that Oregonians have a lot of room to move about, but population growth has been high over the past decade.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Oregon’s gross domestic product (GDP) is roughly $213.7 billion, a 3.4% increase over the past year. This growth is higher than the national average of 2.9% but is slightly less than the numbers generated by California and Washington. The economic outlook in Oregon is positive overall, with a rolling economy. The only concerns are that the growth will eventually plateau after running its course.</p>
				<p>Unemployment in the Beaver State is low — with some predicting “full employment” soon —  and wage growth was up 5% in 2018. And it’s no wonder, as numerous significant employers have set up shop in Oregon.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Nike',
				},
				{
					employer: 'Intel',
				},
				{
					employer: 'Precision Castparts',
				},
				{
					employer: 'Daimler Trucks North America',
				},
				{
					employer: 'Banfield Pet Hospital',
				},
				{
					employer: 'Oregon Health & Science University',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Most of the state’s economic activity is in Portland and nearby cities to the south of it. Here’s a quick look at the state’s three largest cities:</p>
			`,
			cities: [
				{
					city: 'Portland',
					copy: '<p>Portland boasts a population of 653,155, but the greater Portland metropolitan area has a population of nearly 2.8 million. This metro area straddles the border with Washington to a degree, including those in Clark and Skamania Counties in Washington. The average salary in the city is $66,000, which is roughly on par with the national average. The cost of living in Portland is, however, 29% higher than the national average. The biggest employers in Portland include Nike, Intel, Oregon Health and Science University, Daimler Trucks North America, LLC, and Kaiser Permanente.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '29 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$416,400.',
						},
						{
							item: 'Average rent',
							value: '$1,522',
						},
						{
							item: 'Average apartment size',
							value: '765 square feet',
						},
					],
				},
				{
					city: 'Salem',
					copy: '<p>Located just about 45 miles away from Portland is Oregon’s second most populous city, Salem. The city of slightly more than 177,000 residents is also in Oregon’s Willamette Valley region. Major employers in the Salem area include T-Mobile US, Inc., Wells Fargo, Garmin AT, and Truitt Bros., Inc.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3.8 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$287,600.',
						},
						{
							item: 'Average rent',
							value: '$1,051',
						},
						{
							item: 'Average apartment size',
							value: '887 square feet',
						},
					],
				},
				{
					city: 'Eugene',
					copy: '<p>Further down south in a direct line from Portland and Salem lies Eugene, a city with approximately 175,000 residents. The city is home to the University of Oregon, PeaceHealth Medical Group, and a large lumber industry.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '10.8 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$318,300.',
						},
						{
							item: 'Average rent',
							value: '$1,366',
						},
						{
							item: 'Average apartment size',
							value: '894 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents who possess a driver’s license from another state must obtain an Oregon license within 30 days of establishing residency. If your license is valid in your previous state or expired for less than one year, you will only have to take a vision test.',
				link: 'https://www.oregon.gov/ODOT/DMV/Pages/New2or/moving.aspx',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents of Oregon must register their vehicles within 30 days of moving to Oregon.',
				link: 'https://www.oregon.gov/ODOT/DMV/Pages/New2or/moving.aspx',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Oregon, you must be a citizen of the United States, be 18 years of age or older on or before the date of the next election, and must be a resident of the state.',
				link: 'https://sos.oregon.gov/voting/Pages/registration.aspx',
			},
		],
		sources: [
			// static content
			'https://sos.oregon.gov/blue-book/Pages/facts-economy.aspx',
			'https://www.cntraveler.com/gallery/best-coffee-shops-in-portland-oregon',
			'https://www.oregonlive.com/tv/2018/03/a_portlandia_tour_guide_21_ore.html',
			'https://www.nps.gov/crla/index.htm',
			'https://www.nwpb.org/2015/05/01/northwest-classical-music-destination-rimsky-korsakoffee-house/',
			'https://oregonfresh.net/education/ag-facts-figures/oregon-facts-figures/',
			'https://www.columbian.com/news/2019/sep/01/will-sales-tax-exemption-changes-spook-oregon-shoppers/',
			'https://www.pinestatebiscuits.com/',
			'https://www.winesnw.com/orhome.html',
			'https://worldpopulationreview.com/states/oregon-population/',
			'https://www.bizjournals.com/portland/news/2019/06/13/oregon-gdp-growth-continued-to-outpace-nation-in.html',
			'https://www.oregonbusiness.com/article/economy/item/18771-ten-takeaways-from-the-northwest-economic-research-center-s-economic-forecast',
			'https://www.rentcafe.com/average-rent-market-trends/us/or/eugene/',
			'https://www.zillow.com/eugene-or/home-values/',
			'https://www.payscale.com/research/US/Location=Portland-OR/Salary',
			'https://www.cityofsalem.net/Pages/economic-data.aspx',
			'https://web.eugenechamber.com/news/newsarticledisplay.aspx?ArticleID=206',
			'https://www.oregon.gov/ODOT/DMV/Pages/New2or/moving.aspx',
			'https://www.salary.com/research/cost-of-living/salem-or',
		],
	},
	PA: {
		state: 'Pennsylvania',
		stateNickname: 'Keystone State',
		welcome: `
			<p>Known as the Keystone State, Pennsylvania is home to more than 12.8 million people. Bordered by New York, Delaware, Maryland, West Virginia, and Ohio, the state is if filled with flat plains and narrow valleys cut by streams and rolling hills, caves, and low ridges created by glaciers. It's also home to part of the Appalachian Mountains and half of the state is engulfed in lush forests and millions of acres of farmland. Plenty of wildlife species call Pennsylvania home, including red foxes, black bears, white-tailed deer, golden eagles, softshell turtles, peregrine falcons, and rattlesnakes.</p>
			<p>Several large corporations, such as Auntie Anne's, Hershey's, Utz, Comcast, Rite Aid, Kraft Heinz, and The Crayola Factory, Dick's Sporting Goods are headquartered in Pennsylvania. The state is home to a variety of companies, such as meat-packing plants, potato chip production factories, healthcare corporations, technology companies, and retail stores. Some of its major attractions include Independence National Park, the Liberty Bell, Hershey Park, Philadelphia Museum of Art, and Presque Isle State Park. It's also got casinos, bowling alleys, racetracks, escape rooms, magic shows, theaters, sports complexes, mini-golf, playgrounds, and more. So if you're considering moving to Pennsylvania, this guide can help you make the decision and start planning properly.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Like other states across the nation, Pennsylvania has seen a significant uptick in self-storage development activity over the last few years. Developers eased off of building new facilities in the wake of the last recession. That led to the existing supply of storage to become mostly occupied and prices for units rose for consumers. Thanks to a recent building boom, there is more storage space available and average rates have started to come down gradually.</p>
				<p>Below are some statistics that provide an overview of the self-storage industry in Pennsylvania:</p>
			`,
			facts: [
				{
					fact: 'Pennsylvania is home to an estimated 1,583 self-storage facilities.',
					highlight: '1,583',
				},
				{
					fact: 'Pennsylvania self-storage facilities cover 44,495,071 square feet of storage space.',
					highlight: '44,495,071',
				},
				{
					fact: 'Pennsylvania storage facilities offer 3.49 square feet of storage per person, which is lower than the national average of 5.4 square feet per person.',
					highlight: '3.49',
				},
				{
					fact: 'Average price of a self-storage unit in Pennsylvania:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Philadelphia',
				price: '0',
			},
			{
				city: 'Pittsburgh',
				price: '0',
			},
			{
				city: 'Harrisonburg',
				price: '0',
			},
			{
				city: 'Scranton',
				price: '0',
			},
			{
				city: 'Eerie',
				price: '0',
			},
			{
				city: 'Allentown',
				price: '0',
			},
			{
				city: 'Lancaster',
				price: '0',
			},
			{
				city: 'Bethlehem',
				price: '0',
			},
			{
				city: 'King of Prussia',
				price: '0',
			},
			{
				city: 'West Chester',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're thinking of making the move to Pennsylvania, but you haven't exactly made up your mind, the following are a few reasons you might want to consider it.</p>",
			reasons: [
				"Philly cheesesteaks. You can't mention Pennsylvania without mentioning what the state is arguably most famous for: Philly cheesesteaks! If you're planning on moving to Philly, you can grab an authentic Philly cheesesteak from just about anywhere in the city.",
				"Chocolate-lover's dream. If you've got a major sweet tooth and chocolate is the only cure, Pennsylvania might just be the place for you. Not only is Hershey Park located in Pennsylvania, but the Hershey's headquarters is located there, too, meaning you'll have plenty of chances to satisfy that sweet tooth.",
				"Striking natural beauty. If you're a fan of the outdoors and all that it's got to offer, you'll love Pennsylvania's strikingly beautiful landscapes. It's a great state for hiking and biking and other outdoor activities when the weather permits.",
				"Home of handmade pretzels. If you just can't get enough of those soft, buttered, salted, pretzels, you'll love Pennsylvania because they're known for their handmade pretzels. Auntie Anne's anyone?",
				"The Liberty Bell. Pennsylvania is also home to the Liberty Bell, one of many national treasures found in the Keystone State. Living in PA, you'll be able to visit it almost anytime and take your out-of-town guests when they come to visit.",
				"No traffic lights. That's right! If you live in Forest County or Perry County, you won't have to worry about sitting at a red light for what seems like an eternity. Apparently, there aren't any traffic lights in either county.",
				"The changing seasons. Much like New York, moving to Pennsylvania will afford you the opportunity to experience the changing seasons. Autumn in Pennsylvania is a great chance to watch the leaves change colors and it's the ideal time for apple picking and outdoor activities like hiking and biking.",
				'Great job market. Thanks to the many, many large corporations and Fortune 500 Companies maintaining their headquarters in the Keystone State, such as Comcast and Hershey, Pennsylvania has a booming job market.',
				"Great sports teams. Pennsylvania has six major sports franchises, including the Philadelphia Eagles and six-time champs, the Pittsburgh Steelers. Not to mention the NCAA champs, the Villanova Wildcats. Living in PA, you'll have a chance to see them play not too far from home.",
				'Great for star gazing. Pennsylvania has some of the best skies for stargazing. Coudersport, PA ranked #1 for one of the best cities in the country for viewing meteor showers. Cherry Springs State Park is another great area for stargazing.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>With a population of 12.8 million people, Pennsylvania is the fifth-largest state in the country. Filled with a vast array of landscapes, it's one of the most diverse states when it comes to topography, much like New York. However, as many as 300,000 people are leaving the northeast each year, many relocating for new jobs or a change of climate, while others are leaving in search of new or better housing. According to the U.S. Census Bureau, 55 percent of the state's 67 counties have been losing residents from year to year. However, from 2017 to 2018, the population increased by 0.13 percent for the state as a whole. Pennsylvania continues to grow in some areas while losing residents in others. The state's population is expected to surpass 13 million by 2020.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Pennsylvania's major industries include electronics, pharmaceuticals, mining, and farming. With a high rate of Fortune 500 companies, the state has a strong job market. In 2018, the real GDP of Pennsylvania was $712 billion, similar to that of countries like Saudi Arabia, which has a GDP of $684 billion as of 2017. The unemployment rate is currently 3.9 percent as of July 2019 according to the Bureau of Labor Statistics.</p>
				<p>Here's a breakdown of Pennsylvania's largest sectors by GDP of real value added.</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, renal, and leasing',
					value: '$122.78 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$95 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$84.97 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$83.93 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$64.7 billion',
				},
			],
			bottomLine:
				'<p>The economic outlook for Pennsylvania is promising because of its steady economy and 1.2 percent expected job growth. Pennsylvania is also projected to have a positive annual job growth rate and household income growth. While the overall cost of living in some areas is quite high throughout the state, there are plenty of cities that offer affordable living. Pennsylvania has a cost of living score of 88.7, which means the state is cheaper than the U.S. average.</p>',
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Aramark',
					employees: '217,250',
				},
				{
					employer: 'Comcast',
					employees: '159,000',
				},
				{
					employer: 'Keystone Foods',
					employees: '110,000',
				},
				{
					employer: 'Ricoh',
					employees: '97,880',
				},
				{
					employer: 'Genesis Healthcare',
					employees: '82,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Pennsylvania is roughly 45,888 square miles and runs 310 miles east to west and 180 miles north to south. The state has more than 50 natural lakes and about 2,500 man-made lakes. It has 45,000 miles of rivers and streams and tons to do outdoors, including target shooting, biking, backpacking, wildlife viewing, fishing, rock climbing, camping, and more.</p>
			`,
			cities: [
				{
					city: 'Philadelphia',
					copy: '<p>Philadelphia is the biggest city in Pennsylvania with a population of about 1.5 million people. As the sixth-largest city in the country, Pennsylvania boasts a mix of people and serves as a hub of culture and economy in the Delaware Valley, according to World Atlas. Philadelphia is a major tourist destination and gets millions of visitors each year.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '17 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$157,500',
						},
						{
							item: 'Average rent',
							value: '$1,625 per month',
						},
						{
							item: 'Average apartment size',
							value: '800 square feet',
						},
					],
				},
				{
					city: 'Pittsburgh',
					copy: '<p>Pittsburgh is the second-most populous city in the state of Pennsylvania with more than 302,407 people calling it home. Located in the seat of Allegheny County and nicknamed the "Steel City," Pittsburgh is home to more than 300 steel-related businesses. Pittsburgh is a beautiful city and a center for education, healthcare, technology, financial services, and robotics.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '1 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$146,600',
						},
						{
							item: 'Average rent',
							value: '1,248 per month',
						},
						{
							item: 'Average apartment size',
							value: '814 square feet',
						},
					],
				},
				{
					city: 'Allentown',
					copy: '<p>Allentown, the third most populous city in the state of Pennsylvania, has more than 121,000 people living there. Located on the Lehigh River, Allentown is full of small-town charm due to its wide collection of historic homes and buildings, century-old industrial buildings, and commercial structures. The business district is full of restaurants, an art school, a museum, and a civic theater. Allentown also offers easy access to trails for skiers and hikers.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '6 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$137,100',
						},
						{
							item: 'Average rent',
							value: '$1,121 per month',
						},
						{
							item: 'Average apartment size',
							value: '855 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents are required to get a Pennsylvania driver's license within 60 days of moving to Pennsylvania permanently. To apply for a Pennsylvania state license, you have to appear in person at a Driver License Center. Prior to getting your license, you'll need to take a vision screening test and complete Form DL-180R (the application). You'll also need to show proof of ID and residency, as well as your social security card. All of your documents have to show the same name and date of birth or an association between the information in the documents. Out-of-state learner's permits can't be transferred to Pennsylvania.",
				link: 'https://www.dmv.pa.gov/Driver-Services/New-Resident-Relocation-Information/New%20Residents/Pages/Info-For-New-Residents.aspx',
			},
			{
				title: 'Vehicle registration',
				copy: "New residents of Pennsylvania have to apply for a Pennsylvania title and vehicle registration within 20 days of moving to Pennsylvania permanently. You're required to have a valid form of Pennsylvania identification in order to apply for a title and registration. Title procedures in Pennsylvania required that any out-of-state titles be surrendered to the Bureau of Motor Vehicles at the time of your application for the title and registration. A title will only be issued to you once the out-of-state title is submitted with a completed application. In order to register your vehicle, you'll need: a valid title for all of your vehicles, issued in your name, from your previous state; proof of insurance; a tracing of the VIN number or the verification of the VIN by an inspection mechanic or notary public at a dealership or issuing agent; and the appropriate fees. For more info:",
				link: 'https://www.dmv.pa.gov/Driver-Services/New-Resident-Relocation-Information/New%20Residents/Pages/Motor-Vehicle-Information-for-New-Residents.aspx',
			},
			{
				title: 'Voter Registration',
				copy: "Once you get a permanent address in Pennsylvania, you have to register to vote at the address you live. Owning a business or a property in the state of Pennsylvania doesn't mean you're legally a resident. To register to vote, fill out a voter registration application form online or fill out and mail the paper application. You can also register to vote in person at your county voter registration office or at PennDOT and several other government agencies. For more info:",
				link: 'https://www.votespa.com/Register-to-Vote/Pages/How-to-Register-to-Vote.aspx',
			},
		],
		sources: [
			// static content
			'https://www.statista.com/statistics/188122/gdp-of-the-us-federal-state-of-pennsylvania-since-1997/',
			'https://www.worldatlas.com/articles/the-10-biggest-cities-in-pennsylvania.html',
			'https://www.payscale.com/cost-of-living-calculator/Pennsylvania-Pittsburgh',
			'https://www.zillow.com/pittsburgh-pa/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/pa/pittsburgh/',
			'https://www.rentcafe.com/average-rent-market-trends/us/pa/lehigh-county/allentown/',
			'https://www.zillow.com/allentown-pa/home-values/',
			'https://www.payscale.com/cost-of-living-calculator/Pennsylvania-Allentown',
			'https://www.payscale.com/cost-of-living-calculator/Pennsylvania-Philadelphia',
			'https://www.zillow.com/philadelphia-pa/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/pa/philadelphia/',
			'https://www.dmv.pa.gov/Driver-Services/New-Resident-Relocation-Information/New%20Residents/Pages/Info-For-New-Residents.aspx',
			'https://www.dmv.pa.gov/Driver-Services/New-Resident-Relocation-Information/New%20Residents/Pages/Motor-Vehicle-Information-for-New-Residents.aspx',
			'https://kids.nationalgeographic.com/explore/states/pennsylvania/',
			'https://www.providentmetals.com/pennsylvania/pennsylvania-facts.html',
			'https://patch.com/pennsylvania/pittsburgh/fortune-500-2019-20-pennsylvania-companies-make-list',
			'https://www.movoto.com/guide/pa/pennsylvania-facts/',
			'https://www.mcall.com/news/pennsylvania/mc-nws-pa-population-estimates-2018-20190418-nbmmuz3dyvh5rgmeqblla5p43y-story.html',
			'https://worldpopulationreview.com/states/pennsylvania-population/',
			'https://www.usatoday.com/story/money/2019/04/17/how-gdp-of-us-states-compares-to-countries-around-the-world/39295197/',
			'https://www.bestplaces.net/cost_of_living/state/pennsylvania',
			'https://matadornetwork.com/read/8-reasons-move-pennsylvania/',
			'https://livability.com/pa/real-estate/8-reasons-to-move-to-pennsylvania',
			'https://www.forbes.com/places/pa/',
			'https://getoutdoorspa.org/explore/',
			'https://www.votespa.com/Register-to-Vote/Pages/How-to-Register-to-Vote.aspx',
			'https://www.zippia.com/advice/largest-companies-in-pennsylvania/',
			'https://www.azquotes.com/quote/1154426?ref=pennsylvania',
			'https://realestate.usnews.com/places/pennsylvania/allentown',
			'https://www.tripadvisor.com/Attractions-g28959-Activities-c56-Pennsylvania.html',
			'https://www.planetware.com/tourist-attractions/pennsylvania-uspa.htm',
			'https://www.governing.com/topics/urban/gov-migration-northeast-population-trend.html',
			'https://www.tripsavvy.com/pennsylvania-facts-and-firsts-2707223',
			'https://www.worldatlas.com/articles/the-10-biggest-cities-in-pennsylvania.html',
		],
	},
	RI: {
		state: 'Rhode Island',
		stateNickname: 'Peace Garden State',
		welcome: `
			<p>When it comes to square feet, Rhode Island is the smallest state in the U.S. But this tiny state, also known as “Little Rhody,” has a lot going on.  It’s also known as the “The Ocean State,” because of its large bays and inlets. And if you need a break from the sea, go play in the woods; over 50% of the state is covered in forests. Founded in 1636, Rhode Island is rich in the history of our nation’s beginnings, and there are plenty of museums and historic sites to learn and explore.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Rhode Island isn't necessarily the biggest market for the self-storage industry, which is home to just 84 out of 45,547 self-storage facilities in the United States. This makes sense given the state's relatively flat population growth, as self-storage facilities tend to cater towards people that are in the midst of some sort of move from one home to another. However a recent surge in self-storage development nationwide has led to some additional self-storage development in the state of Rhode Island where residents are moving around the most. The state has a remarkably low square footage of self-storage per capita at 3.2 square feet of self-storage space per person. Compare that to the national average of self-storage space per person: 5.4 square feet per capita.</p>
				<p>Below are some figures that provide a snapshot of the self-storage industry in Rhode Island:</p>
			`,
			facts: [
				{
					fact: 'Rhode Island is home to an estimated 84 self-storage facilities.',
					highlight: '84',
				},
				{
					fact: 'Rhode Island self-storage facilities cover 3,376,255 square feet of storage space.',
					highlight: '3,376,255',
				},
				{
					fact: 'Rhode Island storage facilities offer 3.2 square feet of storage per person, which is lower than the national average of 5.4 square feet per person.',
					highlight: '3.2',
				},
				{
					fact: 'Average price of a self-storage unit in Rhode Island:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Providence',
				price: '0',
			},
			{
				city: 'Newport',
				price: '0',
			},
			{
				city: 'Warwick',
				price: '0',
			},
			{
				city: 'Cranston',
				price: '0',
			},
			{
				city: 'Pawtucket',
				price: '0',
			},
			{
				city: 'Westerly',
				price: '0',
			},
			{
				city: 'Woonsocket',
				price: '0',
			},
			{
				city: 'Narragansett',
				price: '0',
			},
			{
				city: 'Middletown',
				price: '0',
			},
			{
				city: 'Coventry',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Thinking about making the move to North Dakota for good? Here are 10 reasons you'll love the Peace Garden State.</p>",
			reasons: [
				'Lighthouses. Rhode Island is home to nearly 20 different lighthouses that have been keeping ships safe for centuries. And if you want to be the lighthouse keeper for a night or two, check out Rose Island Lighthouse in Newport.',
				'Bird watching. In the fall at Block Island, over 70 rare species of birds stop during their southern migration. But if you can’t make it off shore, there are plenty of beautiful birds all over the state.',
				'Bike friendly. Rhode Island has several bike paths 10-30 miles long that are removed from cars, so you can safely bike your heart out.',
				'Family friendly farms. Pet some alpacas, pick some apples, or go on a winter-land hayride full of twinkly lights. Whatever strikes your fancy, Rhode Island’s farms provide lots of fun activities.',
				'The Ocean State. The name doesn’t lie. Rhode Island has over 400 miles of coastline and is a really popular spot for surfing and sailing.',
				'Great universities. Little Rhody is home to the famous Brown University and one of the best art schools in the country, RISD (Rhode Island School of Design).',
				'Historic sites. Rhode Island is one of the original 13 colonies, founded in 1636. Many of the structures are still standing and open to the public.',
				'Location. If you’re feeling cooped up, don’t worry. Rhode Island is close to major cities, including Boston and NYC.',
				'Great seafood. Of course this New England state has delicious seafood, it’s coastal! No matter your budget, you have your choice of inexpensive quick window service or sit down water view spots, and some of the best oysters in the world!',
				'Coffee and donuts. Providence, Rhode Island has more coffee and donut shops per capita of any city in the nation. Come get some!',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Rhode Island has a population of 1.06 million residents, making it the 44th most populated state and the second most densely populated state in the country. There has been a slight decrease in population in the last few years, mostly because of the aging population. The state’s dense population also slows down growth, due to the limited capacity for newcomers. It’s projected that the population will continue to decrease before it increases. People move to Rhode Island because it’s easy to get around and there are many activities to engage in, making it a great place to retire. One possible reason people are leaving is to find new jobs, but this is also a reason people are moving there.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>In 2018, Rhode Island’s Real Gross Domestic Product was $53.6 billion, ranking it the 46th best GDP in the nation. As of September 2019, Rhode Island’s unemployment rate is at 3.6%, on par with the national average. Rhode Island’s economic growth has outpaced the nation’s economic growth over the past 40 years. A sudden drop in available jobs caused analysts to forecast a downward trend, but the data shows that Rhode Island’s employment is predicted to rise 5.9% to 550,700 jobs within the next seven years.</p>
				<p>Below is a breakdown of Rhode Island’s Real GDP by sector:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, Insurance and Real Estate',
					value: '$12 billion',
				},
				{
					sector: 'Professional and Business Services',
					value: '$7.3 billion',
				},
				{
					sector: 'Education',
					value: '$7.1 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$4.7 billion',
				},
				{
					sector: 'Wholesale Trade',
					value: '$3.3 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'CVS Health',
					employees: '204,000',
				},
				{
					employer: 'Textron',
					employees: '36,000',
				},
				{
					employer: 'Citizens Bank',
					employees: '17,300',
				},
				{
					employer: 'APC by Schneider Electric',
					employees: '12,000',
				},
				{
					employer: 'Nortek',
					employees: '11,400',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Rhode Island’s total land area adds up to 1,045 square miles, making it the smallest state in the nation. Little Rhody is only 37 miles wide and 48 miles long. The state’s average elevation is 200 feet. Jerimoth Hill is the state’s highest natural point, sitting at 812 feet in height. Rhode island’s neighbors include Massachusetts to the northeast, Connecticut to the west, and the Atlantic Ocean to the south.</p>
			`,
			cities: [
				{
					city: 'Providence',
					copy: '<p>Rhode Island’s capital city was founded in 1636, and it is the most populated city in the state with 179,335 residents.. The city is one of the largest centers for jewelry and silverware design manufacturing.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '22% higher than national average',
						},
						{
							item: 'Median home price',
							value: '$215,100',
						},
						{
							item: 'Average rent',
							value: '$1,942',
						},
						{
							item: 'Average apartment size',
							value: '817 square feet',
						},
					],
				},
				{
					city: 'Cranston',
					copy: '<p>Cranston is the second largest city in Rhode Island with a population of 81,274 residents. Money Magazine named Cranston of the “100 Best Places to Live” in 2006.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '27% higher than national average',
						},
						{
							item: 'Median home price',
							value: '$254,300',
						},
						{
							item: 'Average rent',
							value: '$1,942',
						},
					],
				},
				{
					city: 'Warwick',
					copy: '<p>Warwick is the third largest city in the state of Rhode Island with 80,847 residents. The city has a rich history and claims to be the location of the first act of armed aggression towards the British before the American Revolution began.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '28% higher than national average',
						},
						{
							item: 'Median home price',
							value: '$233,300',
						},
						{
							item: 'Average rent',
							value: '$1,349',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'Within 30 days of making Rhode Island your new home, you will need to get your state issued driver’s license. The Rhode Island DMV’s website can guide you through the application process. After filling out the ID application, go to your local dmv office with proof of identity and two proofs of current Rhode Island residency. Once you pay the appropriate fees, you will be able to get your new Rhode Island driver’s license.',
			},
			{
				title: 'Vehicle registration',
				copy: 'Within 30 days of moving to Rhode Island you will need to get your vehicle registered by the state. The DMV’s website has a link for the application for registration. Bring the application, proof of insurance, vehicle title, and Rhode Island license to you local DMV. After you present your documents and pay the appropriate fees, you will be able to get your vehicle registered.',
			},
			{
				title: 'Voter Registration',
				copy: 'Once you have your Rhode Island driver’s license or state issued ID, you will be eligible to register to vote.  Print and fill out the voter registration form on the state’s website. Once all your information is on the form, you can mail it in to the board of canvassers. You will receive your voter ID card in the mail 2-4 weeks later.',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/rhode-island-population/cities/',
			'https://www.payscale.com/cost-of-living-calculator/Rhode-Island-Providence',
			'https://www.payscale.com/cost-of-living-calculator/Rhode-Island-Warwick',
			'https://www.payscale.com/cost-of-living-calculator/Rhode-Island-Cranston',
			'https://www.zillow.com/providence-ri/home-values/',
			'https://www.zillow.com/warwick-ri/home-values/',
			'https://www.zillow.com/cranston-ri/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ri/providence/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ri/cranston/',
			'https://united-states.reaproject.org/data-tables/gsp-a900n/tools/440000/',
			'https://en.wikipedia.org/wiki/List_of_U.S._states_and_territories_by_GDP',
			'https://www.dlt.ri.gov/News/2019/NR030719.htm',
			'https://www.zippia.com/advice/largest-companies-in-rhode-island/',
			'https://worldpopulationreview.com/states/rhode-island-population/',
			'https://www.visitrhodeisland.com/things-to-do/attractions/lighthouses/',
			'https://www.dlt.ri.gov/lmi/proj/indoutlook.htm',
			'https://www.visitrhodeisland.com/things-to-do/super-cool-bike-friendly-cities/',
			'https://en.wikipedia.org/wiki/Cranston,_Rhode_Island',
			'https://en.wikipedia.org/wiki/Rhode_Island#Geography_and_climate',
			'https://www.visitrhodeisland.com/things-to-do/colleges-universities/',
			'https://www.visitrhodeisland.com/things-to-do/history/historic-sites/',
			'https://www.rentjungle.com/average-rent-in-warwick-rent-trends/',
			'https://en.wikipedia.org/wiki/Providence,_Rhode_Island',
			'https://www.dmv.ri.gov/licenses/oosTransfer/',
			'https://www.dmv.ri.gov/registrations/transfer/index.php',
			'https://en.wikipedia.org/wiki/Providence,_Rhode_Island',
			'https://patch.com/rhode-island/newport/people-are-fleeing-rhode-island-heres-why',
			'https://www.onlyinyourstate.com/rhode-island/best-seafood-ri/',
			'https://worldpopulationreview.com/us-cities/providence-population/',
			'https://worldpopulationreview.com/us-cities/warwick-ri-population/',
			'https://www.providencejournal.com/news/20191031/analysts-give-ri-leaders-rosier-forecast-for-state-economy',
			'https://www.providencejournal.com/news/20190503/ri-job-losses-in-winter-cast-pall-over-economic-forecast',
			'https://www.usnews.com/news/best-states/rhode-island/articles/2019-10-06/report-rhode-island-economic-growth-outpaced-us-growth',
		],
	},
	SC: {
		state: 'South Carolina',
		stateNickname: 'Palmetto State',
		welcome: `
			<p>South Carolina is often referred to as the Palmetto State and its bordered by North Carolina, Georgia, and the Atlantic Ocean. As the 40th largest state in size and the 23rd largest by population, South Carolina has plenty to offer both visitors and residents alike. The state is home to the Blue Ridge Mountain Province, which stretches across northwestern South Carolina and it's known for its historic districts, golf courses, and its beaches.</p>
			<p>South Carolina's major industries include biotechnology and life sciences, aerospace and aviation, recycling, transportation, and automotive manufacturing. Since forests cover more than 67 percent of the state, South Carolina's top natural resource is loblolly pine. The state is one of the US's top producers of mica, kaolin (natural clay), and vermiculite (a mineral that's typically used for growing plants or for insulation).</p>
			<p>Some of the top attractions in the Palmetto State include The Center for Birds of Prey, the Myrtle Beach Pinball Museum, Falls Park on the Reedy, Lulu's Beach Arcade and Ropes Course, Hilton Head Island Bike Trails, and the Dark Corner Distillery.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The South Carolina self-storage industry has been thriving in recent years, thanks in part to a wave of storage facility construction that has swept the nation over the last few years. Record levels of self-storage facilities are being built, which means developers and operators are seeking sites wherever they can. This includes even vacant big box stores that are frequently being converted to self-storage facilities. In South Carolina, the increase in the number of new storage units is good news for space-starved consumers as it is leading to lower monthly rental rates for self-storage.</p>
			`,
			facts: [
				{
					fact: 'South Carolina is home to more than 902 self-storage facilities',
					highlight: '902',
				},
				{
					fact: 'South Carolina facilities offer more than 28,931,143 million square feet of storage space combined.',
					highlight: '28,931,143',
				},
				{
					fact: 'South Carolina has 6.02 square feet of storage space for every man, woman, and child–much more than the national average of 5.4 square feet per person.',
					highlight: '6.02',
				},
				{
					fact: 'Average price of a self-storage unit in South Carolina:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Charleston',
				price: '0',
			},
			{
				city: 'Columbia',
				price: '0',
			},
			{
				city: 'Myrtle Beach',
				price: '0',
			},
			{
				city: 'Greenville',
				price: '0',
			},
			{
				city: 'Spartanburg',
				price: '0',
			},
			{
				city: 'Florence',
				price: '0',
			},
			{
				city: 'Rock Hill',
				price: '0',
			},
			{
				city: 'Mount Pleasant',
				price: '0',
			},
			{
				city: 'Sumter',
				price: '0',
			},
			{
				city: 'Clemson',
				price: '0',
			},
			{
				city: 'Aiken',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're already leaning towards making the move to South Carolina, check out our top 10 reasons to move to the Palmetto State to sway you in the right direction.</p>",
			reasons: [
				'Great weather. One of the reasons people move to South Carolina is for the great year-round weather. The average temperature in South Carolina is approximately 64 degrees and annual lows are typically in the 50s. That means more time in the sun enjoying the outdoor activities you love.',
				'Slower pace. If the idea of a slower pace sounds appealing to you, South Carolina might be a good place to settle. You can look forward to less road rage from your fellow drivers and more casual conversations at the grocery store while waiting in line.',
				'No traffic jams. Because there are no major metropolitan areas in South Carolina, traffic jams are pretty much nonexistent. The average commutes in the biggest cities in South Carolina generally only last between 17 and 21 minutes.',
				"The beaches. Get some silky white sand between your toes because the state is known for its amazing beaches because of its miles of seashore, nautical activities, and luxury resorts. South Carolina's beaches include Hilton Head, Isle of Palms, Folly Beach, and more.",
				"Great job growth. South Carolina is expected to see continued job growth in the coming years. In the past few years, economists have said that there aren't enough people for all the jobs. So if you're looking for a new job and to start over someplace nice, South Carolina might just be the right place for you.",
				"Southern hospitality. Everyone loves a little southern hospitality and you'll get plenty of it if you move to South Carolina. Just like surrounding southern states, you can expect a full range of kindness from your fellow residents.",
				'The state parks and greenery. South Carolina houses more than 47 state parks and those parks cover more than 80,000 acres of land. Some of your options include Hunting Island State Park, Swan Lake Iris Gardens, Caesars Head State Park or Congaree National Park.',
				"The delectable dishes. South Carolina has several great restaurants in its coastal towns, some featuring some of the best seafood you'll come across. But it's also got great barbecue, specifically the Gullah cuisine, which is akin to Caribbean cooking. For a blend of exotic and homegrown cuisine, South Carolina is where you need to be.",
				"Affordability. South Carolina has a remarkably low cost of living - one that's 13 percent lower than the national average. The state is cheaper than most places in the country so your wallets should stay fuller longer.",
				'Rich history and culture. South Carolina is rich with history and culture, featuring plenty of historic sites, museums, plantations, and Fort Sumter. Historic Charleston (founded in 1670) is known for its cobblestone streets and antebellum homes.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>South Carolina has a population of 5.1 million people, according to World Population Review and roughly 28.5 million people visit the state every year. Between 2018 and 2019, the state's population increased by 1.24 percent. In the last few years, only five states have gained more new residents due to relocation than South Carolina. Several things are attracting people to the state, including the beautiful weather, retirement, a lack of state taxes on social security benefits, and low property taxes.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>South Carolina's GDP was $202.77 billion as of 2018, according to Statista. The unemployment rate was 2.9 percent as of September 2019, according to the Bureau of Labor Statistics.</p>
				<p>Top 5 Sectors by GDP of Real Value Added</p>
			`,
			breakdown: [
				{
					sector: 'Manufacturing',
					value: '$34.09 billion',
				},
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$33.18 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$30.34 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$22.85 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$15.38 billion',
				},
			],
			bottomLine: `
				<p>South Carolina added 32,500 new jobs (a 1.5 percent job growth rate from the previous year). Job growth for 2020 is expected to be slow, at a rate of 0.9 percent (which equals 19,600 new jobs). Due to trade tensions with both China and Europe, the state's export-driven economy will take a hit. However, according to Kiplinger, the economy will remain strong. South Carolina is expecting Google to expand its Berkeley County data center and new facilities are being built by DHL, Fuyao, and Valantic.</p>
				<p>South Carolina has a cost of living score of 94.1, meaning it's cheaper to live in the Palmetto state than the US as a whole. Not to mention, the cost of groceries and housing are also below the national average.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Cryovan Inc.',
					employees: '23,000',
				},
				{
					employer: 'Michelin',
					employees: '23,000',
				},
				{
					employer: 'Sonoco',
					employees: '20,000',
				},
				{
					employer: 'Intertech Group',
					employees: '15,832',
				},
				{
					employer: 'KEMET Electronics',
					employees: '15,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>South Carolina is roughly 32,020 square miles, meaning it's the 40th largest state in the US by size. For every square mile of the state's territory, there's an average of 153 people, making it the 23rd most densely populated state in the country. The largest cities include Columbia, Charleston, and North Charleston.</p>
			`,
			cities: [
				{
					city: 'Columbia',
					copy: '<p>Columbia is the largest city in South Carolina and has a population of 135,299 people. As the capital of South Carolina, Columbia is affectionately known as "Soda City" by the locals thanks to an old abbreviation of Columbia to "Cola." Columbia has tons to do and see, including the Congaree National Park, Riverbanks Zoo, The Columbia Marionette Theater, EdVenture Children\'s Museum, the South Carolina State Museum, and more.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$138,100',
						},
						{
							item: 'Average rent',
							value: '$1,076 per month',
						},
						{
							item: 'Average apartment size',
							value: '1,005 square feet',
						},
					],
				},
				{
					city: 'Charleston',
					copy: "<p>Charleston is the second-largest city in South Carolina and boasts a population of 140,178 people. It's also the oldest city in the Palmetto State and it's filled with rich history and culture. It's known for its amazing architecture and the array of activities available, including live music, great restaurants, amazing art and culture, and shopping.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '4 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$317,500',
						},
						{
							item: 'Average rent',
							value: '$1,364 per month',
						},
						{
							item: 'Average apartment size',
							value: '967 square feet',
						},
					],
				},
				{
					city: 'North Charleston',
					copy: "<p>North Charleston is the third-largest city in South Carolina with a population of 111,593 people. The city is seen as the main industrial center for retail sales in the state. North Charleston is an exciting city filled with plenty to keep you entertained, including shopping, nightlife, restaurants, golf, historic sites, and attractions like Riverfront Park, Whirlin' Waters Adventure Park, Holy City Brewing, and Wannamaker County Park.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '10 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$175,800',
						},
						{
							item: 'Average rent',
							value: '$1,121 per month',
						},
						{
							item: 'Average apartment size',
							value: '972 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of South Carolina have 45 days to transfer an out-of-state license and vehicle registration. To get a South Carolina driver's license, you'll need proof of your identity, proof of social security number, two proofs of your current physical address, proof of your legal name (if applicable), and the appropriate forms filled out. You'll also be required to take a vision test at the South Carolina DMV and pay any associated fees. For more info, visit:",
				link: 'https://scdmvonline.com/Driver-Services/Moving-To-SC',
			},
			{
				title: 'Vehicle registration',
				copy: "Once you get your new South Carolina license, you'll need to register your vehicle with the South Carolina DMV. Before you transfer your title and registration, you have to pay any property taxes with your county treasurer. You'll receive your new title in the mail once your out-of-state title is cleared through the National Motor Vehicle Title Information System. If you're titling and registering your vehicle in South Carolina for the first time, you have to update your vehicle insurance company with your new address and bring the appropriate documentation to the SCDMV. For more info, visit:",
				link: 'https://scdmvonline.com/Vehicle-Owners/Moving-To-SC',
			},
			{
				title: 'Voter Registration',
				copy: "To register to vote in South Carolina, you'll need a South Carolina driver's license or DMV ID. You can register by mail, email, fax, or online. You can download a voter registration form and return it to your local county board of voter registration. For more info, visit:",
				link: 'https://www.scvotes.org/south-carolina-voter-registration-information',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/south-carolina-population/',
			'https://www.statista.com/statistics/188127/gdp-of-the-us-federal-state-of-south-carolina-since-1997/',
			'https://www.bls.gov/eag/eag.sc.htm',
			'https://www.statista.com/statistics/1065201/south-carolina-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-south-carolina/',
			'https://www.kiplinger.com/slideshow/business/T019-S010-kiplinger-economic-outlook-for-all-50-states-2020/index.html',
			'https://www.bestplaces.net/cost_of_living/state/south_carolina',
			'https://scdmvonline.com/Driver-Services/Moving-To-SC',
			"https://scdmvonline.com/Vehicle-Owners/Moving-To-SC'https://www.scvotes.org/south-carolina-voter-registration-information",
			'https://kids.nationalgeographic.com/explore/states/south-carolina/',
			'https://www.coolkidfacts.com/south-carolina-facts/',
			'https://www.tripadvisor.com/Attractions-g28961-Activities-South_Carolina.html#ATTRACTION_SORT_WRAPPER',
			'https://livability.com/sc/things-to-do/8-reasons-to-move-to-south-carolina',
			'https://www.builderpeople.com/blog/2018/06/14/guide-to-moving-to-south-carolina-plus-fun-facts',
			'https://discoversouthcarolina.com/articles/10-things-you-might-not-know-about-columbia-sc',
			'https://www.charlestoncvb.com/itineraries/north-charleston-guide/',
			'https://www.tripadvisor.com/Attractions-g54370-Activities-North_Charleston_South_Carolina.html',
			'https://www.payscale.com/cost-of-living-calculator/South-Carolina-Columbia',
			'https://www.zillow.com/columbia-sc/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/sc/columbia/',
			'https://www.payscale.com/cost-of-living-calculator/South-Carolina-Charleston',
			'https://www.zillow.com/charleston-sc/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/sc/charleston/',
			'https://www.payscale.com/cost-of-living-calculator/South-Carolina-North-Charleston',
			'https://www.zillow.com/north-charleston-sc/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/sc/charleston-county/north-charleston/',
		],
	},
	SD: {
		state: 'South Dakota',
		stateNickname: 'Mount Rushmore State',
		welcome: `
			<p>South Dakota is nicknamed The Mount Rushmore State and has a population of roughly 892,631 people, making it the 46th largest state in the county. Located in the Midwest, South Dakota is mostly filled with plains and its home to the Black Hills National Forest, the site of Mount Rushmore (hence the nickname).</p>
			<p>South Dakota's major industries include manufacturing, agriculture, mining, and tourism. The state's number one industry is agriculture, however, due to its fertile soil. Some of the most common crops include soybeans, corn, sunflowers, and wheat. Some of the top attractions include Mount Rushmore, Crazy Horse Memorial, Custer State Park, Badlands National Park, Wind Cave National Park, and Dignity.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>As many people continue to move to South Dakota for jobs and a more affordable cost of living, the self-storage industry has found reason to grow and expand in the state in recent years. However, South Dakota has a great deal of storage with a current inventory of 5,935,227 square feet. That's 6.97 square feet per person, much more than the national average of 5.4 square feet per capita. </p>
			`,
			facts: [
				{
					fact: 'South Dakota is home to an estimated 227 self-storage facilities.',
					highlight: '227',
				},
				{
					fact: 'South Dakota self-storage facilities cover 5,935,227 square feet of storage space.',
					highlight: '5,935,227',
				},
				{
					fact: 'South Dakota storage facilities offer 6.97 square feet of storage per person, which is lower than the national average of 5.4 square feet per person.',
					highlight: '6.97',
				},
				{
					fact: 'Average price of a self-storage unit in South Dakota:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Sioux Falls',
				price: '0',
			},
			{
				city: 'Rapid City',
				price: '0',
			},
			{
				city: 'Pierre',
				price: '0',
			},
			{
				city: 'Aberdeen',
				price: '0',
			},
			{
				city: 'Brookings',
				price: '0',
			},
			{
				city: 'Yankton',
				price: '0',
			},
			{
				city: 'Watertown',
				price: '0',
			},
			{
				city: 'Spearfish',
				price: '0',
			},
			{
				city: 'Sturgis',
				price: '0',
			},
			{
				city: 'Deadwood',
				price: '0',
			},
			{
				city: 'Mitchell',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>Considering South Dakota as your new home? Check out our top 10 reasons to love the Mount Rushmore state.</p>',
			reasons: [
				'Minimal traffic. We all hate sitting in bumper-to-bumper traffic on the way to or from work, but in South Dakota, traffic is significantly less congested.',
				'Great for aspiring business owners. South Dakota was named the best state for starting a business by CNN and it was also rated the number one business climate in the country for entrepreneurs.',
				'Tax-advantaged. Moving to South Dakota means no personal income tax, inheritance tax, or property tax, meaning more of your money stays in your wallet.',
				'Affordable. South Dakota has a cost of living 20 percent lower than the national average when it comes to housing, health, transportation, and utilities.',
				'Great quality of life. South Dakota was named the second-best state for overall well being and happiness and also the second-best state for quality of life.',
				"Small town life. If you're into small-town living, you'll love South Dakota for that reason. Get used to strangers saying hello to you everywhere and making small talk about just about anything.",
				"Great universities. Moving to South Dakota means you'll be closer to great universities like Northern State University and Dakota State University.",
				'Beautiful sunrises and sunsets. South Dakota is pretty well known for its amazing sunrises and sunsets and moving there means you can enjoy them in person with your special someone.',
				'Great for nature lovers. South Dakota has plenty to offer nature lovers thanks to its iconic attractions and natural beauty, such as Mount Rushmore, the Missouri River, and dozens of state parks, trails, lakes and more.',
				'Friendly people. Much like southern states in the US, South Dakota is a state filled with its share of friendly people so get used to smiling and waving no matter where you are.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>South Dakota's population is roughly 892,631 and it's one of few states that has under a million residents. Between 2017 and 2018, South Dakota's population increased by 1.02 percent. More people are moving into South Dakota than leaving it and the reasons appear to be employment opportunities and visitors who end up coming back to live in the Mount Rushmore State.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>South Dakota's GDP for 2018 was $45.87 billion and the state has an unemployment rate of 3 percent as of September 2019. South Dakota's job growth rate for 2020 is about 1 percent, which is somewhat lower than in 2019. More than 4,500 jobs will be added in 2020. South Dakota has a cost of living score of 95, meaning it's cheaper to live there than in the US as a whole.</p>
				<p>Below are the top five sectors by GDP of real value added</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$9.86 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$4.97 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$4.78 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$4.67 billion',
				},
				{
					sector: 'Agriculture, forestry, fishing, and hunting',
					value: '$4.27 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Highmark',
					employees: '35,000',
				},
				{
					employer: 'Sanford Health ',
					employees: '28,400',
				},
				{
					employer: 'The Good Samaritan Society',
					employees: '24,000',
				},
				{
					employer: 'Rapid City Regional Hospital ',
					employees: '4,200',
				},
				{
					employer: 'Black Hills',
					employees: '2,834',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>South Dakota spans roughly 78,116 square miles and has a total of 66 counties. The three largest cities in South Dakota are Sioux Falls, Rapid City, and Aberdeen.</p>
			`,
			cities: [
				{
					city: 'Sioux Falls',
					copy: '<p>Sioux Falls is the largest city in South Dakota with a population of 182,574 residents. As one of the fastest growing cities in the country, Sioux Falls has tons to offer when it comes to entertainment, including Wild Water West Waterpark, Butterfly House & Aquarium, Great Plains Zoo & Delbridge Museum, Falls Park, to name a few.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '6 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$193,000',
						},
						{
							item: 'Average rent',
							value: '$825 per month',
						},
						{
							item: 'Average apartment size',
							value: '967 square feet',
						},
					],
				},
				{
					city: 'Rapid City',
					copy: "<p>Rapid City is the second-largest city in South Dakota with a population of 76,007 people. The city is located east of Black Hills National Forest and there's plenty to do and see there, including Custer State Park, Dinosaur Park, Mount Rushmore National Memorial, and Reptile Gardens.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '5 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$216,000',
						},
						{
							item: 'Average rent',
							value: '$883 per month',
						},
						{
							item: 'Average apartment size',
							value: '967 square feet',
						},
					],
				},
				{
					city: 'Aberdeen',
					copy: '<p>Aberdeen, the third-largest city in South Dakota, has a modest population of just 29,516 people. Despite its somewhat small population, Aberdeen has a few places that just might appeal to you, including Wylie Park, Dacotah Prairie Museum, Richmond Lake Recreation Area, Slackers, and Skate Away.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '12 percent lower the national average',
						},
						{
							item: 'Median home price',
							value: '$165,900',
						},
						{
							item: 'Average rent',
							value: '$1,446 per month',
						},
						{
							item: 'Average apartment size',
							value: '967 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of South Dakota can apply for a license at any South Dakota Driver Exam location throughout the state. To get your South Dakota license, you'll need a completed license application form, proof of your lawful status in the US via a birth certificate, a valid, non-expired U.S. passport, or a permanent resident card. You'll also be required to pay the $28 application fee, pass a vision test, pass a knowledge test with a score of 80 percent or more, and pass a driving test with a score of 80 percent or higher. For more info, visit:",
				link: 'https://dps.sd.gov/driver-licensing/south-dakota-licensing-information/faqs',
			},
			{
				title: 'Vehicle registration',
				copy: "Once you obtain your new South Dakota driver's license, you'll be allowed to register and title your vehicle in the state. You can use the online Vehicle Registration & Plates portal and your South Dakota driver's license to register your vehicle. For more info:",
				link: 'https://dor.sd.gov/individuals/motor-vehicle/all-vehicles-title-fees-registration/',
			},
			{
				title: 'Voter Registration',
				copy: 'To register to vote in South Dakota, print out the voter registration form, fill it out, sign it, and then submit it to your County Auditor. Your voter registration application has to be received by the auditor at least 15 days before any election you want to vote in. For more info, visit:',
				link: 'https://sdsos.gov/elections-voting/voting/register-to-vote/default.aspx',
			},
		],
		sources: [
			// static content
			'https://www.advancedmovingsd.com/blog/2018/10/5/9-great-reasons-to-move-to-south-dakota',
			'https://www.dakotaroots.com/why-south-dakota',
			'https://www.onlyinyourstate.com/south-dakota/never-move-here-sd/',
			'https://worldpopulationreview.com/states/south-dakota-population/',
			'https://rapidcityjournal.com/news/local/south-dakota-a-top-state-in-net-migration/article_aad75104-029c-56d6-ae44-cab973235d39.html',
			'https://www.statista.com/statistics/188129/gdp-of-the-us-federal-state-of-south-dakota-since-1997/',
			'https://www.statista.com/statistics/1065207/south-dakota-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-south-dakota/',
			'https://www.bestplaces.net/cost_of_living/state/south_dakota',
			'https://www.kiplinger.com/slideshow/business/T019-S010-kiplinger-economic-outlook-for-all-50-states-2020/index.html',
			'https://dor.sd.gov/individuals/motor-vehicle/all-vehicles-title-fees-registration/',
			'https://dps.sd.gov/driver-licensing/south-dakota-licensing-information/faqs',
			'https://sdsos.gov/elections-voting/voting/register-to-vote/default.aspx',
			'https://www.tripadvisor.com/Attractions-g54805-Activities-Sioux_Falls_South_Dakota.html',
			'https://www.tripadvisor.com/Attractions-g54774-Activities-Rapid_City_South_Dakota.html',
			'https://www.tripadvisor.com/Attractions-g30095-Activities-Aberdeen_South_Dakota.html',
			'https://www.payscale.com/cost-of-living-calculator/South-Dakota-Sioux-Falls',
			'https://www.zillow.com/sioux-falls-sd/home-values/',
			'https://www.rentjungle.com/average-rent-in-sioux-falls-rent-trends/',
			'https://www.payscale.com/cost-of-living-calculator/South-Dakota-Rapid-City',
			'https://www.zillow.com/rapid-city-sd/home-values/',
			'https://www.rentjungle.com/average-rent-in-rapid-city-rent-trends/',
			'https://www.areavibes.com/aberdeen-sd/cost-of-living/',
			'https://www.zillow.com/aberdeen-sd/home-values/',
			'https://www.coolkidfacts.com/south-dakota-facts/',
			'https://kids.nationalgeographic.com/explore/states/south-dakota/',
			'https://www.tripadvisor.com/Attractions-g28962-Activities-South_Dakota.html',
			'https://www.bestplaces.net/cost_of_living/state/south_dakota',
		],
	},
	TN: {
		state: 'Tennessee',
		stateNickname: 'Volunteer State',
		welcome: `
			<p>It’s hard to talk about Tennessee without mentioning music, as the state is home to the birth of country music, and the foundations of rock and roll, blues, and jazz. Stretching from the Midwest to the southeast, Tennessee is a crossroads of American culture that offers everything from small-town charm to big city excitement.</p>
			<p>Tennessee is home to gorgeous landscapes, cuisine that blends the south with the heartland, two large metropolitan areas that retain a small-town way of living, and a history of technological innovation that continues to drive its economy today. Nicknamed “The Volunteer State” as it saw more of its citizens enlist for the War of 1812 than any other state, Tennessee is as American as it gets. </p>
			<p>From its famed music roots of the past and status as a current hotbed of popular music across several genres today, to its national parks, many colleges, Jack Daniel’s whiskey, and sweet tea, Tennessee is a land filled with equal parts southern hospitality and Midwestern work ethic. It makes sense, then, that many are moving to this state, including businesses and accompanying opportunities.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>A wave of self-storage development has swept across the country over the last several years, including in major metro areas in Tennessee. Nashville, in fact, has been one of the most active markets for self-storage construction, as developers raced to meet the unmet demand created by the growing population. Most storage rentals are part of a relocation in or out of a home. To meet the demand, self-storage developers are seizing the opportunity to build new facilities, or convert shuttered retail stores into storage spaces. The boom in self-storage has proven to be good news for consumers–the increase in available storage units has led to lower rates and more promotions. </p>
				<p>Below is an overview of the current state of the Tennessee self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Tennessee is home to about 1,232 self-storage facilities.',
					highlight: '1,232',
				},
				{
					fact: 'Tennessee self-storage facilities cover 36,948,539 square feet of storage space.',
					highlight: '36,948,539',
				},
				{
					fact: 'Tennessee storage facilities offer 5.68 square feet of storage per person, which is close to the national average of 5.4 square feet per person.',
					highlight: '5.68',
				},
				{
					fact: 'Average price of a self-storage unit in Tennessee:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Nashville',
				price: '0',
			},
			{
				city: 'Memphis',
				price: '0',
			},
			{
				city: 'Knoxville',
				price: '0',
			},
			{
				city: 'Franklin',
				price: '0',
			},
			{
				city: 'Gatlinburg',
				price: '0',
			},
			{
				city: 'Franklin',
				price: '0',
			},
			{
				city: 'Murfreesboro',
				price: '0',
			},
			{
				city: 'Chattanooga',
				price: '0',
			},
			{
				city: 'Clarksville',
				price: '0',
			},
			{
				city: 'Johnson City',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're thinking about making the move, but aren't sure if Tennessee is the right place for you, consider the following:</p>",
			reasons: [
				'Music is everywhere. The affinity between Tennessee and music is well-known, with over 15 million visitors flocking to Nashville and its country music scene each year. But, Tennessee has more to offer than country. Memphis is home to Elvis Presley’s mansion Graceland, which serves as a museum to the King of Rock and Roll, and Beale Street, the eye of the storm for American blues. And Nashville is now a national center for all genres, from bluegrass to hip hop and beyond.',
				'Tennessee cuisine will keep you cozy. The state is home to a biscuit festival — and you know any state that loves biscuits that much has some great food to accompany. From traditional country-style cooking such as fried chicken and stellar Memphis-style barbecue to unique modern cooking emanating from destination restaurants across the state, Tennessee is a foodie’s playground.',
				'Tourist attractions galore. Nashville has Music City and the nearby Grand Ole’ Opry (the longest continuously running live radio program), but it also has a full-size replica of the Parthenon. And while many visit Memphis to revel in all things Elvis, a visit to the city isn’t complete without seeing the mighty Mississippi River slowly rolling along the city skyline.',
				'Smoky Mountains National Park. The country’s most visited natural park, the Smoky Mountains straddle the border of Tennessee and North Carolina. With 522,419 acres of protected land, the park is vast and beautiful. It received its name from the blue hazy smoke-like fog that often lingers on the mountain peaks. Gatlinburg in the eastern part of the state serves as the gateway to the Great Smoky Mountains National Park.',
				'Tennessee caves. On the flip side of mountain exploration, the state is home to numerous caverns and caves, offering chances to explore what lies beneath the surface.',
				'The Lost Sea of Tennessee. One of these caves includes the country’s largest underground lake, The Lost Sea. Located between Sweetwater and Madisonville, the underwater lake features a waterfall, abundant crystal clusters, and explorable caves. Tour boats even operate in the subterranean depths.',
				'Reelfoot Lake State Park. Topside, and in the northwest corner of the state, is a 15,000-acre lake that is only 200 years old. Reelfoot Lake sprung into existence after a series of earthquakes in 1811 and 1812 — some of the most violent seismic activity ever witnessed in the United States. Today, it remains a flooded forest, with adapted plant life, and a large population of American bald eagles.',
				'Skiing in the South. Back in Gatlinburg, visitors to the Great Smoky Mountains can also experience skiing, a relatively rare pastime in this part of the country. Ober Gatlinburg, the area’s ski resort, is a 5-acre artificial ski surface that permits skiing typically from mid-December to mid-March, comparable to the skiing seasons in the Northeast United States.',
				'Tennessee is college football country. With several large public and private universities, such as the University of Tennessee, University of Memphis, and Vanderbilt University, sports fans have many opportunities to enjoy college football.',
				'Tennessee is a growing sports center. Besides traditionally popular college athletics, Tennessee is home to the Memphis Grizzlies (basketball), Nashville Predators (hockey) and Tennessee Titans (football).',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Thanks in great part to the growing popularity of Nashville as a metropolitan center for entertainment, culture, business, and education, Tennessee has seen consistent population growth. It is only the 36th largest state by area, however, it is the 16th most populated with an estimated 6.8 million residents. On average, there are roughly 153 people per square mile in the Volunteer State. The population figure is up from 6.3 million in 2010, making Tennessee the state with the 23rd highest growth rate in the country. It’s projected that this number will reach 7 million by 2020, and approach 7.5 million by 2025.</p>
				<p>Why the steady growth in Tennessee? Much of the population growth in the state is evident in the middle of the state, including smaller cities of Murfreesboro, Clarksville, and the large metropolitan statistical area of Nashville-Davidson. You might call it the “Nashville Effect” as the area is accustomed to steady growth due to its popularity as a cosmopolitan city and for its burgeoning tech industry.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Tennessee’s gross domestic product (GDP) is roughly $287 billion, making it the 19th largest state economy in the nation. This figure represents a huge jump over the past decade, with a 43% increase. Its growth is the seventh fastest in the nation. Tennessee employment numbers are on the rise, too, with its payroll growth ranking 13th in the country.</p>
				<p>Studies point to a low overall tax rate as a major reason for the growth. Tennessee has no personal state income tax, and is in the process of phasing out inheritance taxes. The state does have a relatively high sales tax, ranked as the ninth highest in the country, but its property tax rates are the fifth-lowest.</p>
				<p>Some of the biggest economic activity comes from Nashville’s health care companies, with an estimated $84 billion each year in global revenue. Over 50 years of health care innovation and growth, Nashville has become not only a music epicenter, but it is also a health-tech hotbed.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Eastman Chemical',
					employees: '10,000',
				},
				{
					employer: 'Southern Tennessee Medical Center',
					employees: '9,300',
				},
				{
					employer: 'Nissan North America',
					employees: '4,400',
				},
				{
					employer: 'Lockheed Martin Energy Research',
					employees: '4,000',
				},
				{
					employer: 'Federal Express Corp.',
					employees: '3,000',
				},
				{
					employer: 'McKee Foods Corp.',
					employees: '3,795',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Tennessee is a medium-sized state, that covers a total area of about 42,000 square miles. While there is a lot of economic activity in the central area of the state, there is opportunity throughout the state for everything from relaxed living to the hustle and bustle of city life.</p>
				<p>Here’s a quick look at the state’s three largest cities:</p>
			`,
			cities: [
				{
					city: 'Memphis',
					copy: '<p>Memphis boasts a population of 655,000 and compared to other cities in the state, this makes it just barely the largest. The average salary in the city is $59,000, which is roughly on par with the national average. The biggest employers in Memphis include FedEx and St. Jude Children’s Hospital.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '17 percent lower than the national average.',
						},
						{
							item: 'Median home price',
							value: '$110,000',
						},
						{
							item: 'Average rent',
							value: '$811/month',
						},
						{
							item: 'Average apartment size',
							value: '909 square feet.',
						},
					],
				},
				{
					city: 'Nashville',
					copy: '<p>While Music City is just below Memphis in population at 654,000 residents, the greater Nashville-Davidson area has a much larger population, approaching 2 million. Where do all of these residents work? Most likely not in the music industry, although many pursue this dream. The largest employment areas are in healthcare, retail, manufacturing, and professional, scientific and technical services. The area boasts a median household income of $63,939 and a median property value of $242,900.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$272,000',
						},
						{
							item: 'Average rent',
							value: '$1,405/month',
						},
						{
							item: 'Average apartment size',
							value: '889 square feet.',
						},
					],
				},
				{
					city: 'Knoxville',
					copy: '<p>The next largest city in Tennessee is Knoxville, located in the eastern portion of the state, with 189,000 residents. The average salary in Knoxville is $56,000, which is on par with the rest of the state. Wage trends in Knoxville are slightly on the rise. Big employers in Knoxville include the University of Tennessee and the Oak Ridge National Laboratory.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '18 percent lower than the national average.',
						},
						{
							item: 'Median home price',
							value: '$184,000',
						},
						{
							item: 'Average rent',
							value: ' $1,062/month',
						},
						{
							item: 'Average apartment size',
							value: '969 square foot apartment in Knoxville.',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents who possess a driver’s license from another state must obtain a Tennessee license within 30 days of establishing residency.',
				link: 'https://www.tn.gov/safety/driver-services/classd/dlnew.html',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents of Tennessee can obtain a vehicle title from their local county clerk, but must first obtain an emissions test if required by the county.',
				link: 'https://www.tn.gov/revenue/title-and-registration/vehicle-titling---registration/vehicle-registration/titling-a-vehicle--new-residents-or-those-relocating-to-tennessee-.html',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Tennessee, you must be a citizen of the United States, be 18 years of age or older on or before the date of the next election, and must be a resident of the state.',
				link: 'https://sos.tn.gov/products/elections/register-vote',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/tennessee-population/cities/',
			'https://livability.com/tn/business/top-employers-in-tennessee',
			'https://www.payscale.com/research/US/Location=Knoxville-TN/Salary',
			'https://www.zillow.com/knoxville-tn/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/tn/knoxville/',
			'https://datausa.io/profile/geo/nashville-davidson-murfreesboro-franklin-tn-metro-area?compare=knoxville-tn-metro-area',
			'https://sos.tn.gov/products/elections/guidelines-determining-residency',
		],
	},
	TX: {
		state: 'Texas',
		stateNickname: 'Lone Star State',
		welcome: `
			<p>From the hottest desert towns and the highest mountains to the most gorgeous ranchlands and dense natural forests, Texas boasts a wide array of landscapes and cities both big and small. With a mix of residents and a rich culture and history, you'll never be bored in Texas.</p>
			<p>Some come to the Lone Star state to start a new life away from the hustle and bustle, while others relocate to the cosmopolitan big cities of Houston, Dallas, Austin and San Antonio. Texas is home to some of the best live music, sports teams, and restaurants in the country. It's also the second-largest state, not just in terms of land area but also when it comes to GDP and total population. It's no wonder people are flocking to live in Texas!</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Everything is bigger in Texas, and self-storage is no exception. In fact, the modern self-storage industry got its start in West Texas and has been going strong ever since. As more and more people have moved to Texas over the last decade, that has created a tremendous demand for self-storage facilities. Our internal research has found that about 60 percent of self-storage users are in the midst of some kind of relocation activity, which means that self-storage is a critical service for those moving into the state.</p>
				<p>Here's some data points that illustrate just how big self-storage is in Texas:</p>
			`,
			facts: [
				{
					fact: 'Texas is home to more than 4,900 self-storage facilities, more than any other state in the country!',
					highlight: '4,900',
				},
				{
					fact: 'Texas self-storage facilities provide more than 207,000,000 square feet of storage space.',
					highlight: '207,000,000',
				},
				{
					fact: "Texas has 7.74 square feet of self-storage space for every person in the state. That's more than the national average of 5.4 square feet per capita.",
					highlight: '7.74',
				},
				{
					fact: 'Average price of a self-storage unit in Texas:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Houston',
				price: '0',
			},
			{
				city: 'Dallas',
				price: '0',
			},
			{
				city: 'Austin',
				price: '0',
			},
			{
				city: 'San Antonio',
				price: '0',
			},
			{
				city: 'El Paso',
				price: '0',
			},
			{
				city: 'Ft. Worth',
				price: '0',
			},
			{
				city: 'Amarillo',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're thinking about making the move, but aren't sure if Texas is the right place, consider the following:</p>",
			reasons: [
				"Better livin'. The average cost of living in Texas is lower than the national average and best of all, there's no personal income tax and no corporate income tax. The unemployment rate is also lower than the national average meaning it'll be easier for you to get a job once you move there.",
				'The great food. Texas is known for its delicious BBQ and there are tons of restaurants offering up a thick, juicy slab of meat drizzled with the most delectable BBQ sauces in the country.',
				'Great weather. Texas is a beautiful (and warm) place to live with temperatures ranging from 80 to 100 degrees in the summer. But the rest of the year, the temperature is mild with very little (if any) snow and plenty of sunshine.',
				"Southern hospitality. If you've never been to the south, you'll love the Southern hospitality most northerners will never know. If you're looking for a state to welcome you with open arms and tons of smiles, Texas is the place to go. Texans are well known for their pleasant attitudes and politeness to neighbors and strangers. Get ready to hear \"Hi, y'all\" or \"Howdy, ma'am\" throughout your daily travels if you're going to come to the Lone Star State.",
				'Great sports teams. Texas is home to a few winning national sports league franchises, including Houston Rockets, Dallas Mavericks, San Antonio Spurs, Houston Texans, Dallas Cowboys, Texas Rangers, Houston Astros, Dallas Stars and the Houston Livestock Show and Rodeo.',
				"Higher education institutions. With more than 200 colleges and universities, you'll be sure to find what you're looking for when it comes time to go to school (or back to school). Some of the best colleges in Texas include Texas A&M University, Texas Tech University, Rice University, and the University of Texas at Austin.",
				'Fast-Growing cities. Of any state, Texas has the most cities with the fastest growth due to a boom in industries like energy, agriculture, healthcare, and defense.',
				"Got a sweet tooth? Dr. Pepper was invented in Waco in 1885 so if you're a fan of Dr. Pepper --and real sugar! - you can enjoy Dr. Pepper with real sugar if you ever move near Waco, Texas.",
				'Got a love of wine? Texas produces more than $13 billion worth of wine every year.',
				'Are you a woman who owns a business? Texas is a great state for female entrepreneurs with nearly one million women-owned businesses registered in the state.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Texas is the second-most populous state in the country, second only to California, with 29 million residents as of 2019. Texas borders New Mexico, Oklahoma, Arkansas, and Louisiana. Filled with deserts, forest, mountains, and ranches, Texas offers a diverse range of landscapes, which is one reason Texas's population continues to grow as more people flock to the south and the west from the east. Texas continues to see growth due in part to its rich culture and history, job opportunities and word class entertainment, which is why so many young people across the country are heading to Texas cities like Dallas and Austin.</p>
				<p>Another reason? In 2017, Texas accounted for 37 percent of America's crude oil production, based on information from the US Energy Information Administration, which is another reason for the explosive growth in major cities throughout the state.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>As mentioned above, Texas has the second-largest economy of all the states in the country. If Texas were a country, it would have the 10th largest GDP on earth with an approximate economic output of $1.7 trillion, according to Markets Insider. It's home to more than 254 of counties and a very healthy job market. As of September 2019, Texas has an unemployment rate of 3.4 percent, which is a bit lower than the national average of 3.5 percent.</p>
				<p>The economic outlook for the future of Texas looks positive. Texas gained 391,000 jobs in 2018. Employment growth exceeded expectations and unemployment rates dropped to historic lows. Housing sales declined and interest rates dropped. Overall, Texas has a healthy economic outlook and it's expected to continue on that path, which is great news for those planning a move there.</p>
				<p>Although its the second largest state in the country, the overall cost of living is lower than the national average, making Texas one of the most affordable places to live in the country, according to The Balance Small Business, with an overall cost of living index of 90.7.</p>
				<p>Below, you'll find a breakdown of Texas' largest sectors by real value added of GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate rental and leasing',
					value: '$226.52 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$217.93 billion',
				},
				{
					sector: 'Mining, quarrying, and oil and gas extraction',
					value: '$207.19 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$194.32 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$159.73 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Texas A&M University',
					employees: 'more than 50,000',
				},
				{
					employer: 'MD Anderson Cancer Center',
					employees: 'more than 22,000',
				},
				{
					employer: 'Dell',
					employees: '22,000',
				},
				{
					employer: 'Shell Deepwater Development',
					employees: '44,000',
				},
				{
					employer: 'The University of Texas at Austin',
					employees: 'nearly 21,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Whether you're looking for big-city or small-town living, Texas has got you covered. If you're looking to change careers or you simply just want to get out of where you currently reside, Texas has plenty to offer in terms of great education institutions and top employers. Here is a quick look at the state's three largest cities:</p>
			`,
			cities: [
				{
					city: 'San Antonio',
					copy: '<p>San Antonio is home to 1.5 million people as of 2017 and is the most visited city in Texas (and the 17th most visited in the country) thanks to attractions like Six Flags Fiesta, the historic Alamo site, and The River Walk. The thriving cultural and entertainment scenes make it an attractive option for those considering moving there any time soon.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '14 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$211,800',
						},
						{
							item: 'Average rent',
							value: '$949/month',
						},
						{
							item: 'Average apartment size',
							value: '853 square feet',
						},
					],
				},
				{
					city: 'Dallas',
					copy: '<p>Dallas is the 9th largest city in the U.S. and the third-largest in Texas with a population of 1.2 million people. Every year, almost 25 million people visit the City of Dallas. Commonly referred to as the Triple D by its residents, Dallas boasts great attractions like the Dallas Arboretum & Botanical Gardens and White Rock Lake Park.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '2 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$248,375',
						},
						{
							item: 'Average rent',
							value: '$1,022/month',
						},
						{
							item: 'Average apartment size',
							value: '845 square feet',
						},
					],
				},
				{
					city: 'Houston',
					copy: "<p>As the fourth largest city in the country, Houston's metro area is larger than some states. With a population of more than 2 million people, Houston is one of the most diverse major cities in the United States. Housing more than 11,000 restaurants, the Space Center, and its famous Texas-shaped lazy river, Houston has plenty to offer in terms of dining and entertainment options.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '2 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$223,875',
						},
						{
							item: 'Average rent',
							value: '$995/month',
						},
						{
							item: 'Average apartment size',
							value: '879 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Texas must get a new license within 90 days of moving to Texas. Then, they have to apply for a Texas driver's license in person at any driver's license office (usually your local tax-assessor collector office) in order to continue driving legally. When applying, applicants must surrender their unexpired license from another U.S. state or territory or a Canadian province. Applicants with a valid license from another U.S. state or territory, or Canada are not required to take the knowledge skills exams. However, applicants that fail to surrender their current, valid license must take and pass all of the required exams.",
				link: 'https://www.dps.texas.gov/driverlicense/movingtotexas.htm',
			},
			{
				title: 'Vehicle registration',
				copy: "You must register your out-of-state vehicle within 30 days of moving to Texas. To register your vehicle, you'll need a vehicle inspection and insurance, and to register at your local county tax-assessor collector office. You'll need your insurance card, proof of vehicle inspection (like the registration from your previous state, country, or province), and Form 130-U. For more info, check out the Texas DMV's website:",
				link: 'https://www.txdmv.gov/motorists/new-to-texas',
			},
			{
				title: 'Voter Registration',
				copy: 'The deadline to register to vote in Texas is October 7, 2019, for the November 5, 2019 election. You can register to vote in Texas here:',
				link: 'https://webservices.sos.state.tx.us/vrapp/index.asp',
			},
		],
		sources: [
			// static content
			'https://www.ncsl.org/research/labor-and-employment/national-employment-monthly-update.aspx',
			'https://www.statista.com/statistics/304890/texas-real-gdp-by-industry/',
			'https://www.dallasnews.com/business/jobs/2019/01/18/texas-record-unemployment-remains-historic-low-third-month-row',
			'https://livability.com/tx/business/texas-top-employers',
			'https://thefactfile.org/texas-facts/',
			'https://www.worldatlas.com/articles/what-is-texas-known-for.html',
			'https://theculturetrip.com/north-america/usa/texas/articles/10-unique-facts-about-san-antonio-you-didnt-know/',
			'https://www.dps.texas.gov/driverlicense/movingtotexas.htm',
			'https://www.votetexas.gov/register-to-vote/where-to-get-an-application-2.html',
			'https://www.rentcafe.com/average-rent-market-trends/us/tx/bexar-county/san-antonio/',
			'https://realestate.usnews.com/places/texas/san-antonio',
			'https://www.rentcafe.com/average-rent-market-trends/us/tx/bexar-county/san-antonio/',
			'https://www.rentcafe.com/average-rent-market-trends/us/tx/dallas/',
			'https://www.payscale.com/cost-of-living-calculator/Texas-Dallas',
			'https://realestate.usnews.com/places/texas/houston',
			'https://www.rentcafe.com/average-rent-market-trends/us/tx/houston/',
			'https://www.texastribune.org/2018/05/24/texas-census-san-antonio-tops-national-list-population-houston-growth/',
			'https://www.payscale.com/cost-of-living-calculator/Texas-Houston',
			'https://www.thebalancesmb.com/states-with-lowest-cost-of-living-4137935',
			'https://www.recenter.tamu.edu/articles/technical-report/outlook-for-the-texas-economy',
			'https://www.dallasfed.org/research/update/reg',
			'https://www.rentcafe.com/blog/apartment-search-2/moving-resources-apartment-search-2/10-things-to-know-before-moving-to-texas/',
			'https://smartasset.com/mortgage/15-things-to-know-before-moving-to-texas',
			'https://livability.com/tx/real-estate/8-reasons-to-move-to-texas',
			'https://markets.businessinsider.com/commodities/news/texas-economy-facts-2019-4-1028127171#if-texas-were-an-independent-nation-it-would-have-the-10th-largest-gdp-on-earth2',
		],
	},
	UT: {
		state: 'Utah',
		stateNickname: 'Beehive State',
		welcome: `
			<p>Most people who have never spent time in Utah probably know little about the state, except for its association with Mormons — the religious and cultural group that originated in upstate New York before relocating to the pre-statehood Utah Territory. Mormon culture is a significant part of the state’s history, exemplified by the Salt Lake Temple in the center of downtown Salt Lake. But, rich history is throughout the state, and Utah has become an epicenter for outdoor sports, such as hiking, rock climbing, skiing, and mountain biking.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Utah self-storage industry is expanding as part of a nationwide increase in self-storage construction. Utah in particular is benefitting thanks to the desire from self-storage developers to target high growth areas. The Utah population has grown more than 16 percent since 2010, giving self-storage developers plenty of opportunity to develop new sites and convert vacant big box stores in need of revitalization. Retirees, seasonal residents and tourists also benefit the Utah self-storage industry. Utah is also home to Salt Lake City-based Extra Space Storage, one of the largest self-storage operators in the country.</p>
				<p>Here are some more facts about the Utah self-storage industry you should know:</p>
			`,
			facts: [
				{
					fact: 'Utah is home to more than 574 self-storage facilities',
					highlight: '574',
				},
				{
					fact: 'Utah facilities offer more than 25.5 million square feet of storage space combined.',
					highlight: '25,500,000',
				},
				{
					fact: "Utah has 8.71 square feet of storage space for every man, woman, and child. That's greater than the national average of 5.4 square feet per person.",
					highlight: '8.71',
				},
				{
					fact: 'Average price of a self-storage unit in Utah:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Salt Lake City',
				price: '0',
			},
			{
				city: 'St. George',
				price: '0',
			},
			{
				city: 'Ogden',
				price: '0',
			},
			{
				city: 'Provo',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>If you're thinking about making the move, but aren't sure if Utah is the right place for you, consider the following:</p>",
			reasons: [
				'Utah has five National Parks. Visitors and residents have many choices for outdoor exploration, thanks to five large and notable National Parks, including Zion, Bryce Canyon, Arches, Canyonlands, and Capitol Reef. The surreal landscapes in these parks are otherworldly, with jagged red cliffs, water-worn massive boulders, and vast canyons.',
				'It’s the Beehive State, but not because of bees. Utah’s nickname has nothing to do with honeybees, but rather is a reference to the hardworking nature of early residents. Beehive imagery is all over the state.',
				'You can find the largest open-pit mine in Utah. The Bingham Copper Mine, also known as the Kennecott Mine, southwest of South Lake City in the Oquirrh Mountains, is 0.6 miles deep and 2.5 miles wide, covering an area of three square miles.',
				'Utah has a lot of familiar Wild West settings. Other than Hollywood, more Western movies and television shows have been filmed in Utah. Next time you watch a cowboy flick, take a good look — you are most likely viewing the natural scenery of Utah. And, the film industry in Utah is not limited to Westerns. The state has its own film tour, which features filming locations for “Back to the Future III,” “Independence Day,” “Pirates of the Caribbean,” and two installments of the “Halloween” franchise.',
				'Sundance is an international film showcase. When it comes to movies, Utah is probably most famous for its Sundance Film Festival, held at the end of January each year in Park City and Salt Lake City.  Actor Robert Redford’s film production company began the festival in 1978. At first, it was an initiative to spotlight American filmmaking, and encourage filming in Utah, but has grown to be a showcase for international film.',
				'Utah food is rich, diverse, and unique. For those unfamiliar with the state, Utah probably doesn’t jump to mind as a culinary destination. But, it’s thick shakes, funeral potatoes (sort of like mega-sized super flavorful tater tots) Navajo tacos (like the Tex-Mex classic, but with fry-bread instead of a tortilla.) make Utah a unique culinary environment worth exploring. Also, Jello is popular to the point of parody.',
				'Crown Burger. Many regions in the United States have their favorite burger joints, and in the Salt Lake City area, the king of ground beef on a bun is Crown Burger. These aren’t just your regular hamburgers, with a famed pastrami burger and a menu full of Greek food alongside classic American fare.',
				'Winter sports abound. Even with vast deserts, the mountain areas of Utah are famed for skiing, with annual snowfall reaching ridiculous levels. During the 2018-2019 skiing season, Alta Ski Area alone received 626 inches of snow, with fresh powder on 91 separate days. Winter sports are so popular in the state that it hosted the 2002 Winter Olympics.',
				'Utah sports. While outdoor sports such as hiking and skiing are popular state-wide, so too are the Utah Jazz basketball and Utes college football. Other popular sports include minor teams such as Grizzlies hockey and the Salt Lake Bees baseball teams.',
				'The Great Salt Lake. Of course, Utah is also well-known for the Great Salt Lake, the largest lake west of the Mississippi, and the largest saltwater lake in the Western Hemisphere. While lake dimension change due to water flows and evaporation, the lake is typically larger than Rhode Island and Delaware. However, the lake is not especially deep, with an average depth of 14 feet.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Utah is the 11th largest state by size, covering approximately 85,000 square miles. It is around 350 miles by 270 miles. The population is relatively small, with just 3.2 million residents. Utah is spacious, but it also provides more than just open areas.</p>
				<p>Utah has shown a significant 16 percent population increase over the decade since 2010. It is one of the fastest growing states, but it has some catching up to do as the 30th most populous state in the country.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Utah has a growing economy. Its gross domestic product (GDP) grew 4.3% — the second most of all states in 2018. This follows an overall trend of growth for the past few years, boosted by strong professional, scientific, technical, information, and retail sectors. Utah has a long history as a software development center, and its growth in this area has ramped up again in recent years. Some of the tech companies in Utah include Adobe, eBay, IM Flash Technologies, EMC Corporation, and others.</p>
				<p>The unemployment rate in the state has been the lowest in recent history, at only 2.7% as of September 2019, a figure less than the nationwide average of 3.5%. Unemployment is even lower in some metropolitan areas: 2.7% in Provo-Orem and 2.5% in Logan.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Brigham Young University',
				},
				{
					employer: 'Vivint Solar',
				},
				{
					employer: 'Utah Valley University and Hospital',
				},
				{
					employer: 'Alpine School District',
				},
				{
					employer: 'Intermountain Healthcare',
				},
				{
					employer: 'Walmart',
				},
				{
					employer: 'Zions Bank Management Services',
				},
				{
					employer: 'L3 Communications Corporation',
				},
				{
					employer: 'Delta Airlines',
				},
				{
					employer: 'Convergys',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Most Utahns — yes, that’s the official name for residents of Utah — live in the Salt Lake City area. The state’s three largest cities are all within 45 miles of each other in a small belt south of the Great Salt Lake.</p>
				<p>Here’s a quick look at the state’s three largest cities:</p>
			`,
			cities: [
				{
					city: 'Salt Lake City',
					copy: '<p>Salt Lake City boasts a population of 200,000, which is pretty small for the largest city in a state. It is the 127th largest city in the United States. The Salt Lake City-Ogden metro area has a population of 1.34 million. Significant employers include Intermountain Healthcare Medical Center, Salt Lake County, University of Utah, L3 Communications, and ARUP Laboratories.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '6% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$415,000',
						},
						{
							item: 'Average rent',
							value: '$1,233',
						},
						{
							item: 'Average apartment size',
							value: '828 square feet',
						},
					],
				},
				{
					city: 'West Valley City',
					copy: '<p>Right next to Salt Lake City, West Valley City has a population of approximately 138,000. It is not known for hosting large employers, as most of the larger businesses in the area are located in SLC. Some of the notable employers in West Valley City include Harmons, Backcountry, Discover Financial Services, and Intermountain Healthcare.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '$327,400',
						},
						{
							item: 'Median home price',
							value: '$1,100',
						},
						{
							item: 'Average rent',
							value: '872 square feet',
						},
					],
				},
				{
					city: 'Provo',
					copy: '<p>Further south from Salt Lake City is Provo. The area is combined as the Provo-Orem region and sprawls across the eastern shore of Utah Lake, a smaller, freshwater lake. There are approximately 122,000 residents in Provo, and major employers include Brigham Young University, Utah Valley University, and Vivint. Here are some housing figures for Provo:</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '2% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$310,900',
						},
						{
							item: 'Average rent',
							value: '$1,383',
						},
						{
							item: 'Average apartment size',
							value: '924 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'Drivers license info for new residents: New residents who possess a driver’s license from another state must obtain a Utah license within 60 days of establishing residency. If your license is valid in your previous state or expired for less than one year, you will only have to take a vision test.',
				link: 'https://dld.utah.gov/i-am-new-to-utah/',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents of Utah must register their vehicles within 60 days of moving to Utah.',
				link: 'https://tax.utah.gov/forms/current/tc-656.pdf',
			},
			{
				title: 'Voter Registration',
				copy: 'To vote in Utah, you must be a citizen of the United States, be 18 years of age or older on or before the date of the next election, and must be a resident of the state.',
				link: 'https://secure.utah.gov/voterreg/index.html;jsessionid=52094c6f52fe1646fb1dfb20b9e2',
			},
		],
		sources: [
			// static content
			'https://www.sltrib.com/news/politics/2019/05/01/utah-ranked-no-last-year/',
			'https://www.visitutah.com/things-to-do/film-tourism/',
			'https://www.sundance.org/festivals/sundance-film-festival',
			'https://www.saltlakemagazine.com/behind-the-beehive',
			'https://www.visitutah.com/places-to-go/parks-outdoors/the-mighty-5/',
			'https://utah.com/kennecotthttps://www.utah.gov/about/quickfacts.html',
			'https://www.thebeehive.com/crown-burger-and-the-case-for-kitsch/',
			'https://www.skiutah.com/blog/authors/yeti/2018-19-one-of-utah-s-snowiest',
			'https://worldpopulationreview.com/states/utah-population/',
			'https://jobs.utah.gov/wi/pubs/em/pastreports/15annual/lrgstemp.pdf',
			'https://business.utah.gov/news/revised-revenue-numbers-show-utahs-economic-growth/',
			'https://edcutah.org/industries/information-technology',
			'https://www.heraldextra.com/business/local/the-largest-employers-in-utah-county/collection_5aa456f4-b63f-586b-a2f1-e865e1474994.html',
			'https://www.rentcafe.com/average-rent-market-trends/us/ut/salt-lake-county/west-valley-city/',
			'https://www.rentcafe.com/average-rent-market-trends/us/ut/utah-county/provo/',
			'https://dld.utah.gov/i-am-new-to-utah/',
		],
	},
	VT: {
		state: 'Vermont',
		stateNickname: 'Green Mountain State',
		welcome: `
			<p>Vermont, also known as The Green Mountain State is the 49th most populated state in the country, with just about 627,180 residents. The state is known for its maple syrup, covered bridges, forested landscape, and ski slopes.</p>
			<p>Vermont's major industries include agriculture, manufacturing, technology, service industry, and energy. It's the largest producer of maple syrup in the country and produces over 500,000 gallons a year. Some of the top attractions in the state include Lake Champlain, Green Mountain National Forest, Shelburne Museum, Mount Mansfield, Killington Ski Resort, and more.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Vermont self-storage industry might not be the biggest, but it is lucrative for those who own and operate self-storage facilities thanks to limited competition. Vermont has just 3.85 square feet of storage space per person, whereas the national average is 5.4 square feet per person. While Vermont is one of the least populated states in the country, tourism and seasonal workers help fuel demand for storage. A nationwide trend of increased storage development has taken place over the last half a decade, with Vermont getting its fair share of new self-storage development.</p>
			`,
			facts: [
				{
					fact: 'Vermont is home to more than 138 self-storage facilities',
					highlight: '138',
				},
				{
					fact: 'Vermont facilities offer more than 2,390,915 million square feet of storage space combined.',
					highlight: '2,390,915',
				},
				{
					fact: "Vermont has 3.85 square feet of storage space for every man, woman, and child. That's less than the national average of 5.4 square feet per person.",
					highlight: '3.85',
				},
				{
					fact: 'Average price of a self-storage unit in Vermont:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
				{
					fact: 'Most popular unit type:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Burlington',
				price: '0',
			},
			{
				city: 'Montpelier',
				price: '0',
			},
			{
				city: 'Stowe',
				price: '0',
			},
			{
				city: 'Rutland',
				price: '0',
			},
			{
				city: 'Brattleboro',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Been considering a move to Vermont, but haven't been fully convinced yet? Take a look at our top 10 reasons to move to the Green Mountain State.</p>",
			reasons: [
				"Great of outdoor enthusiasts. Moving to Vermont means you'll have all kinds of places to be active in your leisure time, such as state and national forests, parks, and campgrounds.",
				"Fall foliage. Vermont is famous for its amazing fall foliage so if you're planning a move there, you can enjoy the beautiful autumns that people travel to the state for.",
				"Close to Canada. Vermont is partially bordered by Canada so if you ever want to make a quick trip to the Great White North, you'll be in the prime spot.",
				"Lowest crime rate. Vermont has the lowest crime rate in America, so moving to the Green Mountain State means you won't have to worry much about safety.",
				"It's good for you to live here. Vermont was rated the third-healthiest state in America by CBS News in 2017.",
				'Maple syrup from the source. Ever heard that Vermonters are maple syrup snobs? Well, they are and for good reason - Vermont is famous for its delicious and authentic maple syrup, as well as sauces, cookies, and jellies made from it.',
				"Beautiful scenery. Driving around Vermont means you'll catch glimpses of beautiful scenery like gorgeous pink-leafed trees and impressive, historic covered bridges.",
				"Lake towns. If you've ever wanted to live in a place with a seaside feel, Burlington, Vermont might just surprise you.",
				'Lots of beer. Vermont was also rated the number one state with the greatest number of breweries per capita by the Brewers Association in 2016.',
				"Ben & Jerry's. The Ben & Jerry's factory is located in Vermont and you'll also find the brand's ice cream stores scattered throughout the state.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Vermont has a population of about 627,180 people and ranks as the 49th largest state by population. Between 2018 and 2019, the population increased by 0.14 percent. In 2018, Vermont was the most popular state to move to, according to United Van Lines. The top reason for migration was a career change. The second most compelling reason for moving to Vermont was retirement, followed by wanting to be closer to family, lifestyle, and health, according to CNBC.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Vermont's 2018 GDP was $33 billion and the unemployment rate is 2.2 percent as of September 2019, which is well below the national unemployment rate of 3.6 percent (October 2019).</p>
				<p>Below is a breakdown of Vermont's economic sectors by GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$5.64 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$4.17 billion',
				},
				{
					sector: 'Education services, health care, and social assistance',
					value: '$4.12 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$3.19 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$2.9 billion',
				},
			],
			bottomLine: `
				<p>Vermont is expected to see a job growth rate of 0.5 percent, adding an estimated 1,600 jobs through 2020. Tourism and business services are doing well, but manufacturing is showing signs of slowing. GE Aviation has plans to make helicopter engines in its Rutland plant, which means even more jobs. Vermont has a cost of living score of 95.2, meaning it's cheaper to live there than in the US as a whole.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'University of Vermont',
					employees: '5,380',
				},
				{
					employer: 'State of Vermont',
					employees: '3,670',
				},
				{
					employer: "Bruegger's",
					employees: '2,400',
				},
				{
					employer: 'Casella Waste Systems',
					employees: '2,000',
				},
				{
					employer: 'Killington Resort',
					employees: '1,500',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Vermont spans roughly 9,616 square miles and is home to 14 counties. The three biggest cities are Burlington, South Burlington, and Rutland.</p>
			`,
			cities: [
				{
					city: 'Burlington',
					copy: '<p>Burlington is the largest city in Vermont, with a population of 41,609 people. It was the first city to fully operate on renewable energy in the US. The city has tons to offer in terms of entertainment, including Waterfront Park, Burlington Bike Path, Church Street Marketplace, Foam Brewers, and the Lake Champlain Ferries.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '21 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$332,000',
						},
						{
							item: 'Average rent',
							value: '$2,038 per month',
						},
					],
				},
				{
					city: 'South Burlington',
					copy: "<p>South Burlington is the second-largest city in Vermont, with a modest population of just 19,472 people. South Burlington is home to the state's largest mall, University Mall, among other attractions and activities, such as Magic Hat Brewing Company, Red Rocks Park, Whales Tails, and Overlook Park.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '21 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$312,600',
						},
						{
							item: 'Average rent',
							value: '$2,044 per month',
						},
					],
				},
				{
					city: 'Rutland',
					copy: "<p>Rutland is Vermont's third-largest city and about 15,136 people call it home. Downtown Rutland is on the National Register of Historic Places and offers a variety of entertainment options, including Green Mountain National Forest, Pico Mountain, Paramount Theater, Deer Leap Trail, and Giorgetti Park.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '2 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$147,800',
						},
						{
							item: 'Average rent',
							value: '$850 per month',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Vermont have to apply for a new driver's license and have an eye exam. You'll have to bring proof of identity, date of birth, legal status in the US, social security number, and your current residential address. For more info, visit:",
				link: 'https://dmv.vermont.gov/licenses/new',
			},
			{
				title: 'Vehicle registration',
				copy: "Once you get your Vermont driver's license, you'll have to register your out-of-state vehicle online using the Registration Required Documents Wizard to determine what kind of documentation you'll need and which forms you need for registration. You'll need the Manufacturer's Certificate of Origin (MCO) or the title and the Bill of Sale & Odometer Disclosure Statement. For more info, visit:",
				link: 'https://dmv.vermont.gov/registrations/new',
			},
			{
				title: 'Voter Registration',
				copy: "In Vermont, you can register to vote online. If you're registering to vote for the first time in the state, you'll need a valid photo ID (driver's license or passport), a current utility bill, a current bank statement, and another government document. Submit your application to the town or city clerk's office on days preceding the election and during polling hours on Election Day. For more info, visit:",
				link: 'https://www.sec.state.vt.us/elections/voters/registration.aspx',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/vermont-population/',
			'https://www.cnbc.com/2019/02/05/vermont-was-the-most-popular-state-to-move-to-last-year-says-uvl.html',
			'https://fred.stlouisfed.org/series/VTNGSP',
			'https://labor.vermont.gov/press-release/press-release-vt-department-labor-september-2019-unemployment-and-jobs-report',
			'https://www.zippia.com/advice/largest-companies-in-vermont/',
			'https://www.statista.com/statistics/1065238/vermont-real-gdp-by-industry/',
			'https://www.kiplinger.com/slideshow/business/T019-S010-kiplinger-economic-outlook-for-all-50-states-2020/index.html',
			'https://www.bestplaces.net/cost_of_living/state/vermont',
			'https://dmv.vermont.gov/licenses/new',
			'https://dmv.vermont.gov/registrations/new',
			'https://www.sec.state.vt.us/elections/voters/registration.aspx',
			'https://worldpopulationreview.com/states/vermont-population/cities/',
			'https://worldpopulationreview.com/states/vermont-population/',
			'https://www.onlyinyourstate.com/vermont/living-best-vt/',
			'https://www.vermont.org/move-to-vermont/why-vermont',
			'https://blog.unpakt.com/5-reasons-move-vermont/',
			'https://www.payscale.com/cost-of-living-calculator/Vermont-Burlington',
			'https://www.zillow.com/burlington-vt/home-values/',
			'https://www.rentjungle.com/average-rent-in-burlington-vt-rent-trends/',
			'https://www.payscale.com/cost-of-living-calculator/Vermont-South-Burlington',
			'https://www.zillow.com/south-burlington-vt/home-values/',
			'https://www.rentjungle.com/average-rent-in-south-burlington-vt-rent-trends/',
			'https://www.areavibes.com/rutland-vt/cost-of-living/',
			'https://www.zillow.com/rutland-vt/home-values/',
			'https://www.tripadvisor.com/Attractions-g57201-Activities-Burlington_Vermont.html',
			'https://www.tripadvisor.com/Attractions-g57402-Activities-South_Burlington_Vermont.html',
			'https://www.tripadvisor.com/Attractions-g57383-Activities-Rutland_Vermont.html',
			'https://kids.nationalgeographic.com/explore/states/vermont/',
			'https://www.coolkidfacts.com/vermont-facts/',
		],
	},
	VA: {
		state: 'Virginia',
		stateNickname: 'Cavalier State',
		welcome: `
			<p>Virginia is the 12th largest state in the country with a population of 8.57 million people. It's the 35th biggest by size. Nicknamed the Old Dominion and located along the central-eastern tip of the country, Virginia stretches from the Chesapeake Bay to the Appalachian Mountains. The state is bordered by West Virginia, Maryland, Washington D.C., North Carolina, Tennessee, Kentucky, and West Virginia. Virginia is known for its gorgeous beaches and mountains and other natural wonders.</p>
			<p>Virginia's major industries include mining, aerospace, technology, agriculture, and the military. One of Virginia's top natural resources is forests, which it uses to sell timber, generating roughly $17 billion every year. The state has more than 27 military bases and produces tons of livestock, soybeans, tomatoes, potatoes, snap beans, cucumbers, and sweet corn. However, apples and grapes are the leading fruits grown in Virginia.</p>
			<p>Some of the state's major attractions include Shenandoah National Park, Skyline Drive, Virginia Beach, Colonial Williamsburg, the Virginia Museum of Fine Arts in Richmond, the Military Aviation Museum, and the American Shakespeare Center. There are also tons of other things to do, including water and amusement parks, zoos, aquariums, and tons of outdoor activities like canoeing, kayaking, swimming, jet skiing, and more.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The Virginia self-storage industry has been booming in recent years, part of a larger trend of self-storage development expanding nationwide. After the last recession, developers weren't able to build as many new facilities as was needed to meet the demand generated by natural population growth. That led to record high occupancy rates and rental rates at self-storage facilities across the country. Over the last five years or so, financing has returned to the self-storage industry, spurning a gold rush of sorts to develop new self-storage sites. Development has surged nationwide, and the Old Dominion has seen its fair share of new self-storage construction as a part of the trend.</p>
				<p>Below is an overview of the current state of the Virginia self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Virginia is home to about 926 self-storage facilities.',
					highlight: '926',
				},
				{
					fact: 'Virginia self-storage facilities cover 43,017,469 square feet of storage space.',
					highlight: '43,017,469',
				},
				{
					fact: 'Virginia storage facilities offer 5.18 square feet of storage per person, which is close to the national average of 5.4 square feet per person.',
					highlight: '5.18',
				},
				{
					fact: 'Average price of a self-storage unit in Virginia:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Richmond',
				price: '0',
			},
			{
				city: 'Virginia Beach',
				price: '0',
			},
			{
				city: 'Charlottesville',
				price: '0',
			},
			{
				city: 'Chesapeake',
				price: '0',
			},
			{
				city: 'Roanoke',
				price: '0',
			},
			{
				city: 'Fairfax',
				price: '0',
			},
			{
				city: 'Alexandria',
				price: '0',
			},
			{
				city: 'Arlington',
				price: '0',
			},
			{
				city: 'Norfolk',
				price: '0',
			},
			{
				city: 'Hampton',
				price: '0',
			},
			{
				city: 'Winchester',
				price: '0',
			},
			{
				city: 'Lynchburg',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: '<p>Moving to Virginia might not be a sure thing just yet, but wait till you hear our top 10 reasons why moving to Virginia could be the best move you ever made.</p>',
			reasons: [
				"Wine country. Award-winning wines and more than 230+ vineyards combined with beautiful countryside should be reason enough for any wine-lover to make the move to Virginia. It's not California wine country, but it's the next best thing.",
				'Virginia Beach. Located on the coast where the Chesapeake Bay meets the Atlantic, Virginia Beach has over 38 miles of coastline, most of which is covered in immaculate beaches. The city offers plenty to do including boat tours, kayaking, walking trails, golf, and more.',
				"Best of both worlds. If you're looking for big-city living, but you also want to be able to head out to the country every now and then, Virginia might be the place for you. In Virginia, you can have your cake and eat it too.",
				'Arts and culture abound. Virginia is rich in arts and culture, offering several publicly funded museums, tons of theaters, and several performing arts centers. The Wolf Trap National Park for the Performing Arts in Vienna is a national park that was actually designed to be used as a performing arts center, and the VMFA in Richmond is one of the top ten most comprehensive art museums in the country.',
				"Great education. If you're looking to go back to school or your children are going off to college soon, Virginia is a the perfect place to get a great education. The Old Dominion State has three of the top 40 public colleges and universities in the country, University of Virginia (#2), the College of William and Mary (#6), and Virginia Tech (#27).",
				"Experience all four seasons. Virginia is another state where you can experience every season in its splendor. From chilly autumns and ice-cold winters to mild springs and warm summers, you'll get it all right here in Virginia.",
				"Top rated healthcare. Moving to Virginia means you're never too far from a top hospital. Some of the top hospitals in the country are located in Virginia, which includes Inova Fairfax Hospital and the University of Virginia Medical Center.",
				'Natural beauty. One of the many things Virginia can boast about is the natural beauty you can find almost anywhere in the state. From beaches and mountains to forests and state parks, Virginia truly has it all.',
				"Shopaholic's delight. If you're a shopaholic, you'll love Virginia. In Fairfax County, you'll have access to Tysons Corner, a huge retail space that has more than 300 stores and a variety of restaurants. But don't go too crazy. You'll certainly be tempted.",
				"Foamhenge. One of the coolest things you'll find in Virginia is Foamhenge, an exact replica of England's Stonehenge, but...made entirely out of Styrofoam. You can't go to Virginia and not see it. You just can't.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Virginia has a population of 8.5 million people and ranks as the 12th largest state by population. From 2018 to 2019, the population increased by 0.64 percent, according to World Population Review. In general, people seem to be moving out of Virginia more than they're moving in and the reasons appear to be job changes, retirement, or moving closer to family. Most Virginia residents moved out of the state in recent years for a job according to the 42nd annual "National Movers Study" conducted by United Van Lines.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Virginia had a GDP of $476.39 billion as of 2018, according to Statista. If Virginia were a country, its GDP would be similar to that of Nigeria, which has a GDP of $460 billion. The unemployment rate as of August 2019 is 2.8 percent, which is lower than the national unemployment rate of 3.6 percent.</p>
				<p>Below is a breakdown of the top sectors by GDP of real value added:</p>
			`,
			breakdown: [
				{
					sector: 'Professional and business services',
					value: '$97.56 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$85.17 billion',
				},
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$84.79 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$41.97 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$35.47 billion',
				},
			],
			bottomLine: `
				<p>Job growth for 2020 is expected to increase by 0.8 percent (an increase of 32,100 jobs). Since Amazon is establishing a campus in Arlington, VA, residents can expect that to bring in at least 25,000 well-paying jobs to the state. The state capital, Richmond, is expected to see good growth as well and Hershey Candy announced that it would expand in Virginia. Microsoft is also investing about $350 billion to expand its cloud data center operations in Southern Virginia and Google is also hiring tech workers throughout the state, according to Kiplinger.</p>
				<p>Virginia has a cost of living score of 113.8, meaning its more expensive to live there than the US as a whole. However, Virginian cities like Pulaski and Big Stone Gap have a lower cost of living than larger cities like Virginia Beach, meaning you should have no trouble finding someplace affordable to call your new home.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'US Army',
					employees: '500,000',
				},
				{
					employer: 'Hilton Hotels & Resorts',
					employees: '169,000',
				},
				{
					employer: 'Dollar Tree',
					employees: '116,050',
				},
				{
					employer: 'General Dynamics',
					employees: '98,800',
				},
				{
					employer: 'Northrop Grumman',
					employees: '67,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Virginia is 42,775 square miles and has so much to offer both visitors and residents, including beaches, mountains, parks, and museums. Its three largest cities include Virginia Beach, Norfolk, and Chesapeake, which are all part of the state's greater Hampton Roads region.</p>
			`,
			cities: [
				{
					city: 'Virginia Beach',
					copy: '<p>Virginia Beach is the largest city in Virginia with a population of 454,846 people and is popular among tourists because of its gorgeous state parks, beautiful beaches, hotels, and restaurants. Some of the best activities and attractions include kayaking, canoeing, Virginia Beach Boardwalk, First Landing State Park, the Military Aviation Museum, and the Virginia Aquarium & Marine Science Center.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '5.3 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$270,600',
						},
						{
							item: 'Average rent',
							value: '$1,206 per month',
						},
						{
							item: 'Average apartment size',
							value: '971 square feet',
						},
					],
				},
				{
					city: 'Norfolk',
					copy: "<p>Norfolk, Virginia's second-largest city has a population of 242,070 people. It's one of the oldest cities in the state and offers tons to do and see, such as museums, restaurants, shopping centers, parks, zoos, aquariums, spas, fishing charters, bike trails, boat tours, botanical gardens, and more.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '4.7 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$191,400',
						},
						{
							item: 'Average rent',
							value: '$1,081 per month',
						},
						{
							item: 'Average apartment size',
							value: '881 square feet',
						},
					],
				},
				{
					city: 'Chesapeake',
					copy: "<p>Chesapeake is the third-largest city in Virginia with a population of 245,467 people. It's also the second-largest by area in the state, offering plenty to do whether you're with the family or out with your friends, including the Chilled Ponds Ice Sports Complex, Chesapeake Arboretum, Northwest River Park, Chesapeake Planetarium, and Fun Forest.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '4.7 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$267,500',
						},
						{
							item: 'Average rent',
							value: '$1,235 per month',
						},
						{
							item: 'Average apartment size',
							value: '980 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Virginia are required to get a Virginia driver's license within 60 days of moving to the state. If you have a valid driver's license from a U.S. state or territory, a Canadian province, France, Germany, or South Korea, you'll have to pass a vision screening test. If you have one issued by Taiwan, you'll have to pass a vision screening and a knowledge exam. If you have a license from any other country or territory, you'll have to pass the two-part knowledge exam, a road skills test, and a vision screening. For more info, visit:",
				link: 'https://www.dmv.virginia.gov/drivers/#eligibility.asp',
			},
			{
				title: 'Vehicle registration',
				copy: "To register your vehicle as a new resident of Virginia, you'll have to go to any DMV customer service center within 30 days of moving to the state. Once you complete the application and pay the fees, you'll be issued a two-year registration and a title, unless you have a vehicle that weighs more than 55,000 pounds or more or it's registered under the International Registration Plan or uninsured vehicles. For more info, visit:",
				link: 'https://www.dmv.virginia.gov/moving/#newva.asp',
			},
			{
				title: 'Voter Registration',
				copy: 'To register to vote in Virginia, you have to be a permanent resident of Virginia and be at least 18 years old at the time of the election. Registering is as easy as completing an online voter registration application or filling out a paper one and returning it to your local voter registration office. For more info, visit:',
				link: 'https://www.elections.virginia.gov/registration/how-to-register/',
			},
		],
		sources: [
			// static content
			'https://livability.com/va/real-estate/8-reasons-to-move-to-virginia',
			'https://www.baconsrebellion.com/wp/more-people-still-moving-out-of-virginia-than-moving-in/',
			'https://www.dailyprogress.com/news/local/virginia-sees-population-booms-and-big-declines/article_26e7cd04-2d80-11e9-9651-5f67a16c834a.html',
			'https://patch.com/virginia/across-va/people-are-moving-virginia-heres-whyhttps://www.statista.com/statistics/188142/gdp-of-the-us-federal-state-of-virginia-since-1997/',
			'https://www.usatoday.com/story/money/2019/04/17/how-gdp-of-us-states-compares-to-countries-around-the-world/39295197/',
			'https://worldpopulationreview.com/states/virginia-population/',
			'https://www.statista.com/statistics/588161/virginia-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-virginia/',
			'https://www.kiplinger.com/slideshow/business/T019-S010-kiplinger-economic-outlook-for-all-50-states-2020/index.html',
			'https://www.bestplaces.net/cost_of_living/state/virginia',
			'https://www.tripadvisor.com/Attractions-g58277-Activities-Virginia_Beach_Virginia.html',
			'https://www.tripadvisor.com/Attractions-g58026-Activities-c61-Norfolk_Virginia.html',
			'https://www.thecrazytourist.com/15-best-things-chesapeake-va/6/',
			'https://worldpopulationreview.com/states/virginia-population/cities/',
			'https://www.zillow.com/virginia-beach-va/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/va/virginia-beach/',
			'https://www.salary.com/research/cost-of-living/norfolk-va',
			'https://www.salary.com/research/cost-of-living/chesapeake-va',
			'https://www.salary.com/research/cost-of-living/va',
			'https://www.zillow.com/norfolk-va/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/va/norfolk/',
			'https://www.zillow.com/chesapeake-va/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/va/chesapeake/',
			'https://www.elections.virginia.gov/registration/how-to-register/',
			'https://www.dmv.virginia.gov/drivers/#eligibility.asp',
			'https://www.dmv.virginia.gov/moving/#newva.asp',
			'https://www.netstate.com/economy/va_economy.htm',
			'https://www.coolkidfacts.com/virginia-facts/',
			'https://augustafreepress.com/5-reasons-why-moving-to-virginia-may-just-be-the-best-option-for-you/',
			'https://www.trustedchoice.com/insurance-articles/moving/moving-to-virginia',
			'https://www.homesnacks.net/most-affordable-places-in-virginia-126841/',
			'https://www.onlyinyourstate.com/virginia/20-reasons-to-live-in-va/',
			'https://livability.com/va/real-estate/8-reasons-to-move-to-virginia',
			'https://kids.nationalgeographic.com/explore/states/virginia/',
		],
	},
	WA: {
		state: 'Washington',
		stateNickname: 'Evergreen State',
		welcome: `
			<p>Washington, also known as The Evergreen State, is the 18th largest state in the country by total area and has a population of about 7.6 million people. It's known for its snow-capped mountains and enormous evergreens, but it's most famous for its coffee houses (like Starbucks) and museums.</p>
			<p>Washington's major industries include agriculture food manufacturing, forest products, aerospace, and technology. And since half of the state is covered in forests, it only makes sense that the state produces the most lumber and plywood in the country. Washington is also known for mining valuable metals, like aluminum, lead, and gold. The Evergreen State also produces more pears, cherries, red raspberries, and apples than any other state in the US. </p>
			<p>Some of the top attractions in the state include the Space Needle, Mount St. Helens, Olympic National Park, Mount Rainier, and the Hoh Rain Forest.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>The self-storage industry has greatly expanding in the State of Washington over the last several years. That's because financing for self-storage development recently became widely available after being harder to access in the years immediately following the Great Recession. The lack of development during that period led to pent up demand and rising rental rates, especially in the country's major population centers and surrounding areas as well. Seattle and other popular cities are seeing their fair share of new development as a part of the trend. Developers continue to seek new opportunities to serve the growing population of the state, however some submarkets may been overdeveloped resulting in low occupancies and increased promotions for consumers.</p>
				<p>Below is an overview of the current state of the Washington self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Washington is home to about 1,244 self-storage facilities.',
					highlight: '1,244',
				},
				{
					fact: 'Washington self-storage facilities cover 46,464,276 square feet of storage space.',
					highlight: '46,464,276',
				},
				{
					fact: 'Washington storage facilities offer 6.61 square feet of storage per person, which is greater than the national average of 5.4 square feet per person.',
					highlight: '6.61',
				},
				{
					fact: 'Average price of a self-storage unit in Washington:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Seattle',
				price: '0',
			},
			{
				city: 'Spokane',
				price: '0',
			},
			{
				city: 'Tacoma',
				price: '0',
			},
			{
				city: 'Everett',
				price: '0',
			},
			{
				city: 'Olympia',
				price: '0',
			},
			{
				city: 'Redmond',
				price: '0',
			},
			{
				city: 'Bellevue',
				price: '0',
			},
			{
				city: 'Yakima',
				price: '0',
			},
			{
				city: 'Bellingham',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Considering a move to the Evergreen State, but aren't sure if it's the right place? Check out our top 10 reasons to move to Washington to help you decide whether it's right for you.</p>",
			reasons: [
				"Environmentally friendly. Washington is one of the top five most environmentally friendly states in the country. It's also been named the country's most bike-friendly state by the League of American Bicyclists.",
				'No state income tax. Washington is one of only seven states with no personal state income tax. However, it has a 6.5 percent sales tax and an optional local sales tax of up to 3.1 percent.',
				"Diverse weather. Washington gets a bad rap for being a rainy state, but it actually gets pretty decent weather - Miami gets more rain. Moving to Washington means you'll get 80 degree summer days and 45 degree winter days.",
				"State parks. If you're a nature lover or you just like being outdoors, you'll love Washington for its variety of state parks. You'll find Olympic National Park, North Cascades National Park, and Mount Rainier National Park to name a the most prominent.",
				"Home of Bill Gates. Ever wanted to live close to the richest man in the world? If you move to Washington, you'll be that much closer to realizing your dream because Bill Gates lives in Washington. Maybe you'll end up neighbors, who knows?",
				"Bottoms up. Washington produces more hops than any other state in the US and more than any country other than Germany. So if you're a beer guzzler, you'll love Washington because it's got the second most permitted breweries in the country, second only to California.",
				'Plenty of outdoor activities. Known for its national parks and floating bridges, Washington offers plenty of outdoor activities, including whale watching, boating, fishing, sailing, kayaking, and snow skiing.',
				"Jobs for everyone. Washington is one of few states that has an abundance of great jobs for everyone, whether you're looking for minimum wage jobs or jobs that require more skills. The minimum wage in Washington is higher than in most other states. And you'll have the opportunity to work for giant companies like Google, Amazon, and Microsoft.",
				"Laid back vibe. Washington's west coast, laid-back vibe is yet another reason to consider moving to the Evergreen State. If you're looking for friendly, helpful folks to call your neighbors, you'll find them in Washington.",
				"Home to Starbucks. Gourmet coffee anyone? If you're the type who has to get their daily dose of gourmet coffee before you're actually fully awake, moving closer to the home of Starbucks can only help at this point, right?",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Washington is the 13th largest state by population, with more than 7.6 million people as of 2019, according to World Population Review. Between 2018 and 2019, the population increased by 1.74 percent.</p>
				<p>Recently, more people have been moving out of Washington state than into the state. There were 9,169 fewer people that moved into Washington in the first two months of 2019 compared to 2016. While home prices have dropped, the Washington economy is still performing quite well. People seem to be leaving due to the high cost of living and a lack of affordable housing. However, Seattle is still seeing an increase in residents despite other cities losing them.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Washington's state GDP was $563 billion as of 2019, according to the Federal Reserve Bank of St. Louis. The state has an unemployment rate of 4.6 percent as of August 2019, according to the Bureau of Labor Statistics.</p>
				<p>Below is a break down of the biggest sectors in Washington by real value GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Finance, insurance, real estate, rental, and leasing',
					value: '$77.09 billion',
				},
				{
					sector: 'Information',
					value: '$75.48 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$61.68 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$57.19 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$55.11 billion',
				},
			],
			bottomLine: `
				<p>The labor market remains strong throughout the state as the economy continues to grow slowly. Employment growth is also solid and roughly 200,000 jobs have been added every month throughout 2019. In 2020, job growth is expected to continue growing at 1.7 percent, which means 60,000 new jobs. Construction, hospitality, health care, and manufacturing are growing sectors and could potentially provide even more jobs. However, there are some possible vulnerabilities, such as the worsening trade war between China and the US, which could adversely affect trade.</p>
				<p>Washington has a cost of living score of 131.1, meaning it's more expensive than the US as a whole. On the plus side, cities like Spokane provide a cost of living lower than the national average.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'Amazon',
					employees: '600,000',
				},
				{
					employer: 'Starbucks',
					employees: '254,000',
				},
				{
					employer: 'Costco Wholesale',
					employees: '172,000',
				},
				{
					employer: 'Boeing',
					employees: '150,500',
				},
				{
					employer: 'Microsoft',
					employees: '124,000',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Washington is approximately 71,363 square miles and has a range of activities and events for everyone to enjoy. That includes museums, parks, shopping, art galleries, cruises, concerts, restaurants, water sports, spas, and nightlife.</p>
			`,
			cities: [
				{
					city: 'Seattle',
					copy: '<p>Seattle is the largest city in Washington and more than 766,893 people call it home. It was the fastest-growing city in the country in 2016 probably because it boasts tons of things to do and see, including the Pacific Science Center, the Seattle Center, the Space Needle, the Olympic Sculpture Park, Chihuly Garden and Glass, the Museum of Pop Culture, and the Seattle Art Museum.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '49 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$714,800',
						},
						{
							item: 'Average rent',
							value: '$2,122 per month',
						},
						{
							item: 'Average apartment size',
							value: '696 square feet',
						},
					],
				},
				{
					city: 'Spokane',
					copy: '<p>Spokane is the second-largest city in Washington with a population of 224,652 people. Known as the Lilac City, Spokane is a city brimming with excitement, offering plenty to keep you and your family entertained. Some of the top activities and attractions in Spokane include museums, parks, gardens, skiing, snowboarding, hiking, rock climbing, live music, Broadway shows, bars and clubs, shopping, casinos, sports, spas, and more.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '4 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$221,600',
						},
						{
							item: 'Average rent',
							value: '$1,023 per month',
						},
						{
							item: 'Average apartment size',
							value: '891 square feet',
						},
					],
				},
				{
					city: 'Tacoma',
					copy: "<p>Tacoma is the third-largest city in Washington and there are more than 222,128 people living inside the city limits. Tacoma was named after Mount Rainier and was named one of the most livable cities in the U.S. most likely due to the city's numerous activities and attractions, including Foss Waterway Seaport, Wright Park, the Museum of Glass, Fort Nisqually Living History Museum, the Washington State History Museum, the Children's Museum of Tacoma, and Point Defiance Zoo and Aquarium.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '8 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$318,900',
						},
						{
							item: 'Average rent',
							value: '$1,323 per month',
						},
						{
							item: 'Average apartment size',
							value: '834 square feet',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Washington have 30 days to obtain a state-issued driver's license and you'll need to get one before you'll be allowed to register any vehicles in the state. Once you establish residency in Washington, visit a driver licensing office to apply for your new driver's license. You might be able to pre-apply online to save time in an office. You'll need proof of identity, proof of address, and you'll have to pay any associated fees. For more info, visit:",
				link: 'https://www.dol.wa.gov/driverslicense/moving.html',
			},
			{
				title: 'Vehicle registration',
				copy: "Once you have your Washington state-issued driver's license, you'll be permitted to register your vehicle and get your new title. To do that, you'll need to call a vehicle licensing office to find out what your fees will be and what your next steps are. Fill out the required forms (like the Vehicle Title Application) and pay the required fees. For more info, visit:",
				link: 'https://www.dol.wa.gov/vehicleregistration/moving.html',
			},
			{
				title: 'Voter Registration',
				copy: "To register to vote in Washington state, you'll need to fill out an online voter registration application on the Secretary of State website. To vote, you must be at least 18 years old by the day of the election and you must be a US citizen. You also must have been a resident of Washington state and lived at your address for at least 30 days prior to the election. For more info, visit:",
				link: 'https://www.dol.wa.gov/driverslicense/voter.html  ',
			},
		],
		sources: [
			// static content
			'https://www.leisurecare.com/resources/reasons-to-retire-in-washington/',
			'https://livability.com/wa/where-to-live-now/8-reasons-to-move-to-washington-state',
			'https://www.themadronagroup.com/top-10-reasons-to-relocate-to-the-state-of-washington/',
			'https://www.estately.com/blog/2015/03/35-things-you-should-know-before-moving-to-washington-state/',
			'https://inspectorchecklist.com/moving-washington-state-10-reasons/',
			'https://worldpopulationreview.com/states/washington-population/',
			'https://www.seattlepi.com/news/article/Thinking-about-leaving-Washington-These-are-the-14499108.php',
			'https://fred.stlouisfed.org/series/WANGSP',
			'https://www.bls.gov/cps/cps_htgm.htm',
			'https://www.statista.com/statistics/304966/washington-real-gdp-by-industry/',
			'https://www.zippia.com/advice/largest-companies-in-washington/',
			'https://www.kiplinger.com/slideshow/business/T019-S010-kiplinger-economic-outlook-for-all-50-states-2020/index.html',
			'https://kids.nationalgeographic.com/explore/states/washington/',
			'https://www.dol.wa.gov/driverslicense/moving.html',
			'https://www.dol.wa.gov/vehicleregistration/moving.html',
			'https://www.dol.wa.gov/driverslicense/voter.html',
			'https://www.bestplaces.net/cost_of_living/state/washington',
			'https://worldpopulationreview.com/states/washington-population/cities/',
			'https://q13fox.com/2019/03/14/despite-fewer-people-moving-to-washington-state-and-a-dip-in-home-prices-experts-say-economic-boom-not-over/',
			'https://www.tripadvisor.com/Attractions-g28970-Activities-Washington_DC_District_of_Columbia.html',
			'https://www.thecrazytourist.com/25-best-things-seattle-washington/',
			'https://www.visitspokane.com/things-to-do/',
			'https://www.thecrazytourist.com/15-best-things-tacoma-wa/9/',
			'https://www.payscale.com/cost-of-living-calculator/Washington-Seattle',
			'https://www.zillow.com/seattle-wa/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/wa/seattle/',
			'https://www.payscale.com/cost-of-living-calculator/Washington-Tacoma',
			'https://www.zillow.com/tacoma-wa/home-values/',
			'https://www.payscale.com/cost-of-living-calculator/Washington-Spokane',
			'https://www.zillow.com/spokane-wa/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/wa/spokane/',
		],
	},
	WV: {
		state: 'West Virginia',
		stateNickname: 'Mountain State',
		welcome: `
			<p>It’s beautiful here! West Virginia is home to some spectacular scenery and outdoor adventures, including rock climbing, mountain biking, hiking, fishing, and whitewater rafting. And if you need a quick change of scenery, West Virginia is close to several other states and even Washington D.C. West Virginia is considered a Southern state but is also close to the northeastern part of the country, providing a diverse mix of culture, food, and history. </p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>A nationwide trend of self-storage development has swept across the nation over the last five years or so, increasing the amount of available self-storage space in major markets from coast-to-coast. For the most part West Virginia hasn't seen a huge surge in development per se, which has resulted in an undersupplied market relative to the rest of the country. West Virginia offers just 3.03 square feet of self-storage space per capita. Compare that to the national average of 5.4 square feet per resident. The result is higher monthly pricing for self-storage units relative to market supply. Still, you can expect to see some new storage development in West Virginia which may increase as developers seek opportunities in underserved markets.</p>
			`,
			facts: [
				{
					fact: 'West Virginia is home to an estimated 327 self-storage facilities.',
					highlight: '327',
				},
				{
					fact: 'West Virginia self-storage facilities cover 5,548,377 square feet of storage space.',
					highlight: '5,548,377',
				},
				{
					fact: 'West Virginia storage facilities offer 3.03 square feet of storage per person, less than the national average of 5.4 square feet per person.',
					highlight: '3.03',
				},
				{
					fact: 'Average price of a self-storage unit in West Virginia:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Charleston',
				price: '0',
			},
			{
				city: 'Huntington',
				price: '0',
			},
			{
				city: 'Morgantown',
				price: '0',
			},
			{
				city: 'Wheeling',
				price: '0',
			},
			{
				city: 'Beckley',
				price: '0',
			},
			{
				city: 'Martinsburg',
				price: '0',
			},
			{
				city: 'Parkersburg',
				price: '0',
			},
			{
				city: 'Clarksburg',
				price: '0',
			},
			{
				city: 'Fairmont',
				price: '0',
			},
			{
				city: 'Bluefield',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			reasons: [
				'Great music. Feast your ears on some authentic Appalachian sound, whether it’s folk, bluegrass, or the blues. ',
				'Low cost of living. West Virginia’s cost of living is 22% below the national average! ',
				'Affordable houses. The median home price in West Virginia is $149,500, making it $88,000 lower than the national average.',
				'Location. West Virginia is in close proximity to so many places! Not too far away are larger cities like Philadelphia, Washington D.C., Columbus, or Cincinnati. ',
				'Skiing. Being so mountainous and all, there are at least three major ski resorts with activities for the whole family.',
				"Great produce. West Virginia has the highest percentage of family-owned farms in the nation, with some great farmers' markets to show it off. ",
				'Fine dining. You might not think you could find world class food here, but there are some real gems to be found.',
				'Cute small towns. Even the capital city has less than 100,000 people. West Virginia is home to some precious smaller towns with all the historic architecture that will make you swoon. ',
				'Romantic getaways. West Virginia has some beautiful remote attractions like Davis, a tiny mountain town on the edge of the Monongahela National Forest, or Berkeley Springs with its healing thermal waters.',
				'It’s the Mountain State! West Virginia is the only state that is entirely in the Appalachian Mountains, so get on those hiking boots!',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>As of 2019, the population of West Virginia was 1.79 million residents, making it the 39th most populous in the country, just slightly more populated than Idaho by 1,900 residents. West Virginia borders Pennsylvania, Maryland, Virginia, Kentucky, and Ohio. Dubbed “The Mountain State,” the entire state is located within the Appalachian Region. For the last few decades, growth in West Virginia has been very slow. The two main reasons for this are: the death rate is higher than the birth rate and young West Virginians are moving out of state for better job opportunities.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>In 2018, West Virginia’s GDP was $77.48 billion and ranked 39th in the country. In the first quarter of 2019, West Virginia actually led the nation in GDP growth. The mining industry has been the biggest contribution to the state’s growth. However, the mining sector is unpredictable and has a tendency to taper off. As of August of 2019, West Virginia had an unemployment rate of 4.6 percent, which is higher than the national average.</p>
				<p>West Virginia’s economy is much better than it was a few years ago and much of this is attributed to the mining of coal and natural gas by private companies. The economic forecast for West Virginia is currently dependent on coal and natural gas. The growth of other industries could secure a more steady economy, but only time will tell if other industries like biotech will gain traction. The overall cost of living in West Virginia is 22 percent below the national average, making it one of the cheapest places to live in the country.</p>
			`,
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'WVU Medicine',
					employees: '7,000',
				},
				{
					employer: 'CAMC Health System Jobs',
					employees: '6,858',
				},
				{
					employer: 'Urgent Care MSO',
					employees: '4,794',
				},
				{
					employer: 'ESMARK',
					employees: '3,740',
				},
				{
					employer: 'Ogden Newspapers',
					employees: '3,500',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Whether it's the metropolitan area of Charleston, the tiny mountain town of Davis, or back-country camping, West Virginia can please all who move there. Not to mention, West Virginia has all four seasons, and breathtaking views year round.</p>
			`,
			cities: [
				{
					city: 'Charleston',
					copy: '<p>The capital of West Virginia, Charleston, is also the state’s most populous city, with 47,293 residents, as of 2019. You can walk along the Kanawha River and get some goodies at Capitol Market–two great attractions for locals and visitors. Also nearby is the Kanawha State Forest with 9,300 acres of diverse wildflower, tree, and bird populations.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '6% below the national average',
						},
						{
							item: 'Median home price',
							value: '$144,800',
						},
						{
							item: 'Average rent',
							value: '$1,364',
						},
						{
							item: 'Average apartment size',
							value: '967 sq. ft.',
						},
					],
				},
				{
					city: 'Huntington',
					copy: '<p>Huntington is the second largest city in West Virginia, with 46,811 residents. One of the main attractions is the Huntington Museum of Art, the largest art museum in West Virginia. Huntington is on the Ohio River and is the home of the Port of Huntington Tri-State, the second busiest inland port in the United States.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '11% below the national average',
						},
						{
							item: 'Median home price',
							value: '$112,000',
						},
						{
							item: 'Average rent',
							value: '$709',
						},
					],
				},
				{
					city: 'Parkersburg',
					copy: '<p>Parkersburg is the third largest city in West Virginia with a population of 29,689. Parkersburg host several annual festivals including the MId-Ohio Valley Multicultural Festival, featuring an international marketplace. Visitors and locals can also enjoy the many outdoor activities like mountain biking, hiking, or horseback riding.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '16.6% below the national average',
						},
						{
							item: 'Median home price',
							value: '$97,600',
						},
						{
							item: 'Average rent',
							value: '$618',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'New residents can transfer their out-of-state license if it is unexpired. If your out-of-state license is expired, you must take all written and road test examinations. You will also be required to surrender your unexpired license from another U.S. state or territory. You can apply for and obtain your new driver’s license in person at your local DMV. For more information, check out West Virginia’s DMV website.',
				link: 'https://transportation.wv.gov/DMV/Drivers/Pages/Drivers-Licenses.aspx',
			},
			{
				title: 'Vehicle registration',
				copy: 'New residents need to title and register their vehicles within 30 days of establishing residency. To register your vehicle go to your local DMV office. You will also need to submit an odometer disclosure and provide proof of insurance.',
				link: 'https://transportation.wv.gov/DMV/Vehicle-Services/Pages/New-Residents.aspx',
			},
			{
				title: 'Voter Registration',
				copy: 'The deadline to register is April 21, 2020 for the West Virginia 2020 Primary Election. Early voting is April 29th - May 9th. You can register to vote in West Virginia here:',
				link: 'https://ovr.sos.wv.gov/Register/Landing',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/west-virginia-population/',
			'https://en.wikipedia.org/wiki/West_Virginia',
			'https://worldpopulationreview.com/states/west-virginia-population/cities/',
			'https://theculturetrip.com/north-america/usa/west-virginia/articles/7-best-things-charleston-west-virginia/',
			'https://wvstateparks.com/park/kanawha-state-forest/',
			'https://en.wikipedia.org/wiki/Huntington,_West_Virginia',
			'https://www.hmoa.org/art/current/',
			'https://en.wikipedia.org/wiki/Parkersburg,_West_Virginia',
			'https://www.greaterparkersburg.com/things-to-do/outdoor-recreation/',
			'https://wvmetronews.com/2019/07/25/west-virginia-leads-nation-in-gdp-growth-for-most-recent-period/',
			'https://wvmetronews.com/2019/09/19/w-va-unemployment-rate-hits-lowest-in-a-decade-but-still-behind-national-average/',
			'https://www.newsmax.com/fastfeatures/industries-in-west-virginia-economy/2015/04/03/id/636341/',
			'https://www.bestplaces.net/cost_of_living/state/west-virginia',
			'https://www.areavibes.com/charleston-wv/cost-of-living/',
			'https://www.salary.com/research/cost-of-living/huntington-wv',
			'https://www.salary.com/research/cost-of-living/parkersburg-wv',
			'https://www.zillow.com/charleston-wv/home-values/',
			'https://www.zillow.com/huntington-wv/home-values/',
			'https://www.zillow.com/parkersburg-wv/home-values/',
			'https://www.rentcafe.com/average-rent-market-trends/us/sc/charleston/',
			'https://www.rentjungle.com/average-rent-in-huntington-wv-rent-trends/',
			'https://www.rentjungle.com/average-rent-in-parkersburg-wv-rent-trends/',
			'https://wvtourism.com/things-to-do/?gclid=Cj0KCQiAtrnuBRDXARIsABiN-7CVhHAUkw6E74PdiNiIlqd9LqEoKuEYnQ4uyxHDTC3wE2jSv2mUAWgaAucrEALw_wcB',
			'https://www.zillow.com/wv/home-values/',
			'https://www.zillow.com/home-values/',
		],
	},
	WI: {
		state: 'Wisconsin',
		stateNickname: 'Badger State',
		welcome: `
			<p>From the Great Lakes coastline to the rolling hills of the Northern Highland to the bluffs of the Driftless Area, Wisconsin has diverse geography. The state is bordered by Minnesota, Iowa, Illinois, Michigan, Lake Michigan, and Lake Superior. With 65,497.82 square miles of total area, Wisconsin is the 23rd largest state by total area, but the 20th most populous. Although Milwaukee is the largest city, the state capital finds its home in Madison.	</p>
			<p>Known as America’s Dairyland, Wisconsin is well-known for its cheese and dairy products, producing a quarter of America’s cheese. Aside from dairy, however, Wisconsin is rich in history, too. The Little White Schoolhouse in Ripon was the first meeting place of the Republican Party and still stands to this day.	</p>
			<p>Tourism drives much of Wisconsin’s economy with destinations, such as The Dells of the Wisconsin Rivers, the House on the Rock, the Milwaukee Art Museum, and more. Nicknamed “cheeseheads,” Wisconsinites are known to be a friendly bunch and welcome visitors. It’s not hard to see why some visitors make their stay more permanent.	</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Wisconsin's self-storage industry has seen a steady expansion over the last several years as self-storage operators seek secondary and tertiary markets for building new locations. Nationwide levels of self-storage development are in the midst of record setting heights, but activity is expected to moderate in the coming years. For now it means self-storage renters in Wisconsin can expect competitive monthly rates and a better selection of high-end self-storage options near them.</p>
				<p>Below is an overview of the current state of the Wisconsin self-storage market:</p>
			`,
			facts: [
				{
					fact: 'Wisconsin is home to about 1,203 self-storage facilities.',
					highlight: '1,203',
				},
				{
					fact: 'Wisconsin self-storage facilities cover 32,849,560 square feet of storage space.',
					highlight: '32,849,560',
				},
				{
					fact: 'Wisconsin storage facilities offer 5.72 square feet of storage per person, which is slightly higher than the national average of 5.4 square feet per person.',
					highlight: '5.72',
				},
				{
					fact: 'Average price of a self-storage unit in Wisconsin:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Milwaukee',
				price: '0',
			},
			{
				city: 'Madison',
				price: '0',
			},
			{
				city: 'Green Bay',
				price: '0',
			},
			{
				city: 'Appleton',
				price: '0',
			},
			{
				city: 'Kenosha',
				price: '0',
			},
			{
				city: 'La Crosse',
				price: '0',
			},
			{
				city: 'Sheboygan',
				price: '0',
			},
			{
				city: 'Wisconsin Dells',
				price: '0',
			},
			{
				city: 'Eau Claire',
				price: '0',
			},
			{
				city: 'Oshkosh',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			reasons: [
				'The cheese. With over 600 varieties, Wisconsin produces three million pounds of cheese every year. It’s  no surprise that its the only state to have a licensed Master Cheesemaker program like those in Europe. Cheese curds are a standard at nearly every Wisconsin restaurant, and they don’t disappoint!',
				'Fresh farm-to-table food. Wisconsin eateries bring a new meaning to the idea of homegrown, farm-fresh food. Farm-to-table restaurants are sprouting up all over the state, setting up camp in both big cities and small towns. Whether it’s fresh dairy, fish, beef, or pork, Wisconsin is a foodie’s treasure trove.',
				'Affordability. With housing costs well below the national average, Wisconsin is an incredibly affordable place to live. Larger cities, such as Madison and Milwaukee, drive the average cost of living up. However, it’s 20% cheaper to live in many Wisconsin communities than it is anywhere else in the country.',
				'Summertime festivals. Despite the harsh winters, summertime in Wisconsin is a never-ending party where hundreds of big-label music acts serve as entertainment. From Milwaukee’s Summerfest to Oshkosh’s five-day Country USA, major music festivals abound in America’s Dairyland.',
				'Waterpark capital. Wisconsin seems to subscribe to the mindset that we’re all still kids on the inside. With indoor and outdoor waterparks designed for the entire family, the state has been dubbed as “The Waterpark Capital of the World.” Mainly it’s The Dells that won this particular title, but you can be sure there will be no shortage of waterpark fun when visiting Wisconsin.',
				'Madison. Few cities are coveted as much as the state capital, Madison. This city consistently makes “best places to live” lists and is considered one of the best college towns in the U.S. Surrounded by numerous state parks and two lakes; Madison is easy on the eyes, as well.',
				"The love of sports. For Wisconsinites, “tailgating season” doesn’t exist—it’s always a good time to tailgate! On the flip side, the streets turn hauntingly desolate when a Packers away-game is on TV. The bottom line is that Wisconsin loves its sports and the Greenbay Packers are at the top of most cheeseheads' list. Mainly, to live in Wisconsin, you must be comfortable wearing a hat that looks like cheese.",
				'Outdoor adventures. What greets you on the other side of a bitter Wisconsin winter is a multitude of outdoor adventures. Comfortable summertime nights create the perfect atmosphere for sleeping under the stars or gathering around a warm fire to drink a cold brew. Plus, with 47 state parks and 15,000 lakes, the fun you can have in the sun is a fair trade-off for the bleak Wisconsin winters.',
				'Freshwater fun. Wisconsin leads the way in freshwater technology, supplying 21% of the world’s freshwater. Many graduate school programs are dedicated to the study of freshwater. With over 150 water-related companies, Wisconsin takes its freshwater serious. But it’s not all business; you can surf in Sheboygan and never have to wash any salt off of your skin.',
				'Architecture. Whether you’re admiring Santiago Calatrava’s “wings” on the Milwaukee Art Museum or Frank Lloyd Wright’s Taliesin, Wisconsin doesn’t fail in delivering stunning architecture. Wright grew up in Wisconsin, so it’s not uncommon to see his handiwork peppered across the state. Aside from Wright, many opera houses and churches offer turn-of-the-century ornate interiors, as well.',
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>According to an estimate by the U.S. Census Bureau, the population of Wisconsin is 5.83 million in 2019, landing it as the 20th most populous state. For every square mile, there are 105 people. With a growth rate of .33%, Wisconsin continues a steady increase in population. It may even exceed its next population milestone of six million people by 2020. People are steadily moving into the state for many reasons, such as employment, family, and culture. However, Wisconsin prides itself on being immigrant-friendly, so it serves as a haven for plenty of foreigners and refugees. Many semiskilled people tend to find work quicker in Wisconsin than in any other region.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Wisconsin has a GDP of nearly $350 billion with a healthy and diverse job market supporting its steady success. Whether it’s innovative advancements in agriculture or world-class life sciences, America’s Dairyland leads the way in several industries. According to the Bureau of Labor Statistics, the unemployment rate as of September 2019 was 3.2% and has risen slightly since the first quarter.</p>
				<p>The economic outlook for Wisconsin is promising as the state plays in various sectors continually, which diversifies the professional outlook more than some states. Hospitals and universities naturally dominate the business landscape in the state with the University of Wisconsin leading the way. The forecast is that the GDP will continue to grow at a steady rate of 1.8%, experiencing sustained growth in the process.</p>
				<p>Overall, the cost of living in Wisconsin is 2% lower than the national average. However, in some cities, it’s even more economical. Groceries and the internet cost less in Wisconsin versus the rest of the country, as well, making Wisconsin an ideal state in which to relocate. The trend is that most families and individuals seem to make enough money to live a decent lifestyle in America’s Dairyland.</p>
				<p>The following outlines Wisconsin’s top five sectors of real value added by GDP:</p>
			`,
			breakdown: [
				{
					sector: 'Financial, insurance, real estate, rental, and leasing',
					value: '$56.3 billion',
				},
				{
					sector: 'Manufacturing',
					value: '$56.04 billion',
				},
				{
					sector: 'Professional and business services',
					value: '$30.76 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$30.04 billion',
				},
				{
					sector: 'Educational services, health care, and social assistance',
					value: '$29.64 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'University of Wisconsin',
					employees: '39,000',
				},
				{
					employer: 'Menard Inc',
					employees: '10,000',
				},
				{
					employer: 'University-Wi Hosp-Clinics',
					employees: '10,000',
				},
				{
					employer: 'Epic',
					employees: '9,700',
				},
				{
					employer: 'UW University Hospital',
					employees: '7,447',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>With 65,497.82 square miles to explore, Wisconsin offers a pleasant place to call home for those who need room to breathe. Mid-sized cities, such as Kenosha and Racine, are well-known for their family-friendly approach to living. However, the following three major cities offer unique outlooks, too.</p>
			`,
			cities: [
				{
					city: 'Milwaukee',
					copy: '<p>As a hip millennial city, Milwaukee doesn’t disappoint when it comes to things to do. Hosting several music festivals each year, its 1,575,101 residents are passionate about having a good time. The city is filled with award-winning restaurants, a vibrant music and arts scene, and dozens of lakefront museums. Milwaukee embraces history and tradition but has an up-and-coming vibe to it.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '3% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$123,600',
						},
						{
							item: 'Average rent',
							value: '$1,199/month',
						},
						{
							item: 'Average apartment size',
							value: '852 square feet',
						},
					],
				},
				{
					city: 'Madison',
					copy: '<p>As the state capital, Madison is also known as one of the best college towns in which to reside. The Dane County Farmers’ Market offers some of the best fresh food in the state, and they set up every Wednesday near the Capitol Square. Aside from the brilliant views of the nearby lakes, Madison also teems with culture, too. The Madison Public Library has nine branches, offering everything from educational programs to hands-on workshops to a vast amount of quality books.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '7% higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$256, 600',
						},
						{
							item: 'Average rent',
							value: '$1,250/month',
						},
						{
							item: 'Average apartment size',
							value: '845 square feet',
						},
					],
				},
				{
					city: 'Green Bay',
					copy: '<p>More than a sports-crazy city, Green Bay is known as one of the oldest settlements in Wisconsin. Its residents enjoy a lifestyle centered around nature with hiking, skiing, and snowshoeing all popular activities in the area. Although the Green Bay Packers football team is frequently the main focus, this city offers far more than brats and beer.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '9% lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$146,600',
						},
						{
							item: 'Average rent',
							value: '$754/month',
						},
						{
							item: 'Average apartment size',
							value: '867',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: 'Within 60 days of moving to Wisconsin, you must apply for a Wisconsin driver’s license. The grace period shortens to 30 days if you have a Class A, B, or CDL. The State of Wisconsin Department of Transportation (WisDOT) features an interactive driver licensing guide with information on specific requirements. You can also use this guide to submit your application and schedule an appointment with the DMV to speed up the process. Like many other states, Wisconsin offers both REAL ID-compliant and non-compliant driver’s licenses and ID cards. Documentation that you will need to bring to the DMV will include proof of insurance, your name, identify, U.S. citizenship, Social Security number, and Wisconsin residency.',
				link: 'https://wisconsindot.gov/Pages/dmv/license-drvs/how-to-apply/ooslicense.aspx',
			},
			{
				title: 'Vehicle registration',
				copy: 'The state of Wisconsin requires you to obtain Wisconsin registration for your vehicle with you become a resident. The DMV will need the title from the previous state, proof of identity, title fee, registration fee, verification of sales tax, and an MV1 application. For more information, visit the WisDOT website:',
				link: 'https://wisconsindot.gov/Pages/dmv/vehicles/title-plates/new-apply.aspx',
			},
			{
				title: 'Voter Registration',
				copy: 'After verifying that you’re not already in the Wisconsin system, you can register to vote online or by mailing or delivering your information to your Municipal clerk. However, mailing your application is no longer an option if its less than 20 days before an election. You can register to vote in Wisconsin here:',
				link: 'https://myvote.wi.gov/en-US/VoterRegistration',
			},
		],
		sources: [
			// static content
			'https://livability.com/wi/real-estate/10-reasons-to-move-to-wisconsin',
			'https://www.travelwisconsin.com/article/things-to-do/article/top-music-festivals-in-wisconsin',
			'https://matadornetwork.com/read/9-reasons-move-wisconsin/',
			'https://livability.com/wi/real-estate/10-reasons-to-move-to-wisconsin',
			'https://www.familyvacationcritic.com/water-park-capital-of-the-world/art/',
			'https://www.payscale.com/cost-of-living-calculator/Wisconsin-Green-Bay',
			'https://www.zillow.com/green-bay-wi/home-values/',
			'https://www.rentjungle.com/average-rent-in-green-bay-rent-trends/',
			'https://www.rentcafe.com/average-rent-market-trends/us/wi/green-bay/',
			'https://www.movoto.com/guide/madison-wi/move-to-madison/',
			'https://www.thecrazytourist.com/15-best-things-green-bay-wi/',
			'https://www.careerinfonet.org/oview6.asp?stfips=55&Level=State1',
			'https://247wallst.com/special-report/2018/04/18/largest-employer-in-every-state-2/11/',
			'https://crowe.wisc.edu/an-outlook-for-the-wisconsin-economy-in-2018/',
			'https://www.movoto.com/guide/wi/cost-of-living-in-wisconsin-how-does-it-stack-up-against-the-average-salary/',
			'https://www.usgovernmentspending.com/compare_state_spending_2019bZ0a',
			'https://madisonregion.org/industry-and-innovation/global-industry-leadership/',
			'https://www.bls.gov/eag/eag.wi.htm',
			'https://www.statista.com/statistics/595185/wisconsin-real-gdp-by-industry/',
			'https://app.wi.gov/DLGuides/',
			'https://wisconsindot.gov/Pages/dmv/license-drvs/how-to-apply/ooslicense.aspx',
			'https://wisconsindot.gov/Pages/dmv/vehicles/title-plates/new-resident.aspx',
			'https://myvote.wi.gov/en-US/VoterRegistration',
		],
	},
	WY: {
		state: 'Wyoming',
		stateNickname: 'Cowboy State',
		welcome: `
			<p>You're in the Cowboy State now. Wyoming is home to mountains, plains, National Parks, and you guessed it...cowboys. But it's also home to highly respected institutions of higher learning, strategic mineral and energy operations, and lot's of breathing room. Wyoming is the 10th largest state, but it is the least populated state with just about 572,380 residents. That makes Wyoming the least densely populated state after Alaska.</p>
			<p>That also makes Wyoming the perfect place for anyone sick and tired of the urban lifestyle and anyone who wants to get away from it all and live amongst some of the most spectacular natural formations our nation has to offer. Outdoor recreation and wildlife appreciation alone make Wyoming an amazing place to live for the few hundred thousands folks who call it home.</p>
			<p>Are you ready to join them? Keep reading and you'll find out soon enough.</p>
		`,
		selfStorageFacts: {
			// dynamic content WIP
			copy: `
				<p>Because it is the least populated state in the country and self-storage is an industry that thrives on population growth, the Wyoming self-storage industry is not all that large. But its bigger than you might think with an estimated 174 self-storage facilities. That is enough space to provide 7.56 square feet of self-storage space per person, a big jump over the national average of 5.4 square feet per person. That might suggest an oversupplied market in the state. A nationwide expansion of self-storage development has taken place over the last few years, leading developers to seek new opportunities wherever they can–even in Wyoming where students, tourism and retirees help fuel demand.</p>
				<p>Below are some statistics that provide an overview of the self-storage industry in Wyoming:</p>
			`,
			facts: [
				{
					fact: 'Wyoming is home to an estimated 174 self-storage facilities.',
					highlight: '174',
				},
				{
					fact: 'Wyoming self-storage facilities cover 4,407,893 square feet of storage space.',
					highlight: '4,407,893',
				},
				{
					fact: 'Wyoming storage facilities offer 7.56 square feet of storage per person, which is higher than the national average of 5.4 square feet per person.',
					highlight: '7.56',
				},
				{
					fact: 'Average price of a self-storage unit in Wyoming:',
					highlight: 'X',
				},
				{
					fact: 'Percent change over previous year:',
					highlight: 'X',
				},
				{
					fact: 'Average price per square foot:',
					highlight: 'X',
				},
			],
		},
		cityPriceList: [
			// dynamic content WIP
			{
				city: 'Cheyenne',
				price: '0',
			},
			{
				city: 'Casper',
				price: '0',
			},
			{
				city: 'Jackson',
				price: '0',
			},
			{
				city: 'Laramie',
				price: '0',
			},
			{
				city: 'Gillette',
				price: '0',
			},
			{
				city: 'Cody',
				price: '0',
			},
			{
				city: 'Sheridan',
				price: '0',
			},
			{
				city: 'Rock Springs',
				price: '0',
			},
			{
				city: 'Riverton',
				price: '0',
			},
		],
		reasonsToMove: {
			// static content
			copy: "<p>Wyoming isn't for everybody, but for those that love it you couldn't pry them away if they tried. See if you are ready to become Wyomingite if any of the following reasons to move appeal to you.</p>",
			reasons: [
				'Yellowstone National Park. One of the most visited National Parks in the country will be in your own backyard. Witness the Old Faithful geyser, incredible wild life and breathtaking vistas whenever you want.',
				"Small town feel. If you aren't alone in the wilderness, you're most definitely in a small town.",
				"Low population. Wyoming is the state with the lowest population, which means if you really want to be alone you can. Remote living is big draw for many of the state's residents who just want to be left alone by everyone else.",
				"You won't believe the stars. Due to its low population, Wyoming has barely any light pollution. That makes it one of the best destinations for stargazing in the United States.",
				'Keep up with Kanye. Speaking of stars, you might know that rapper and mogul Kanye West recently bought a massive ranch outside of Cody where he has brought his entourage and spouse Kim Kardashian along with him to record music and enjoy the serenity that only Wyoming can provide.',
				"Weekends in Denver. As a Wyomingite you'll have to cross state lines into Denver to experience big city life. Thankfully the Mile High City is less than two hours from Cheyenne.",
				'Rocky Mountain high. More than two-thirds of the state is in the Rocky Mountain Range, providing ample opportunities to camp, hike and fish.',
				"Your vote actually counts more. Because all states get three electoral votes when choosing the president regardless of population, Wyomingites have a disproportionate number of electors per capita. For example, each of California's 55 electors represent more than 700,000 people each while Wyoming's three electors represent 192,000 people each.",
				'Ranch life. Wyoming is full of working ranches. If you truly want to live the cowboy way of life, there is no better place to do it.',
				"Higher education. An affordable education is in your grasp when you attended one of the state's dozen or so colleges and universities. The University of Wyoming in Cheyenne is the biggest with more than 12,800 students.",
			],
		},
		movingTo: {
			// static content
			copy: `
				<p>Wyoming has grown slowly over the last several years, with population growth of 1.4 percent from 2010 to 2018. From 2018 to 2019 the population actually fell 0.93 percent. Wyoming is the most sparsely populated state in the lower 48, with just 5.85 people every square mile. Wyoming has seen the most growth in areas that attract tourists, such as Teton County. Wyoming experiences boom and bust cycles in the energy sector, but a growing emphasis on wind power projects could provide more stability in the future as Wyoming has among the highest wind power generation potential in the U.S.</p>
			`,
		},
		economicOutlook: {
			// static content
			copy: `
				<p>Wyoming has a GDP of $39.7 billion, making it not too surprisingly the smallest state economy in the country. But Wyoming residents don't have too bad with a household median income of $60,434–slightly more than the national average. The state has a disproportionate number of high net worth individuals such as Dick Cheney and Walmart founding family member Christy Walton. The state has a low unemployment rate at 3.8 percent as of September 2019.</p>
				<p>Below is a breakdown of the largest sectors of the Wyoming economy by real added GDP</p>
			`,
			breakdown: [
				{
					sector: 'Mining, quarrying, and oil and gas extraction',
					value: '$6.9 billion',
				},
				{
					sector: 'Government and government enterprises',
					value: '$6.4 billion',
				},
				{
					sector: 'Real estate and rental and leasing',
					value: '$4.5 billion',
				},
				{
					sector: 'Transportation and warehousing',
					value: '$3.4 billion',
				},
				{
					sector: 'Construction',
					value: '$2.3 billion',
				},
			],
		},
		largestEmployers: {
			// static content
			employers: [
				{
					employer: 'University of Wyoming in Laramie',
					employees: '3,720',
				},
				{
					employer: 'Omega Probe Inc in Cheyenne',
					employees: '2,200',
				},
				{
					employer: 'Sheridan College in Gillette',
					employees: '2,000',
				},
				{
					employer: 'Jackson Hole in Wilson',
					employees: '1,400',
				},
				{
					employer: 'Cloud Peak Energy in Gillette',
					employees: '1,300',
				},
			],
		},
		placesToLive: {
			// static content
			copy: `
				<p>Wyoming spreads across 97,914 square miles, the 10th largest state in the country. Wyoming is split between the Great Plains and the Rocky Mountains. The state actually lies on what is a great plateau that is broken up by a smattering of various mountain ranges such as the Wind River Mountain Range, the Tetons, the Big Horn Mountains and others. The Continental Divide cuts a line through the state that runs north to south. More than 48 percent of the state is located on federal land. The Wind River Indian Reservation is shared by the Eastern Shoshone and Northern Arapaho who combined number around 7,500.</p>
			`,
			cities: [
				{
					city: 'Cheyenne',
					copy: '<p>Cheyenne is Wyoming\'s biggest city with nearly 64,000 inhabitants. The city continues to grow steadily each year as part of the expanding Front Range Urban Corridor that stretches from Cheyenne to Pueblo, CO south of Denver. The so-called "Magic City of the Plains" offers higher learning, incredible parks, and modern amenities. Cheyenne is the state capital of Wyoming.</p>',
					facts: [
						{
							item: 'Cost of living',
							value: '5 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$295,000',
						},
						{
							item: 'Average rent',
							value: '$794 per month',
						},
					],
				},
				{
					city: 'Casper',
					copy: "<p>With a population just over 57,000, Casper is Wyoming's second largest city by population. The city was originally founded as Fort Caspar, a military outpost established to protect settlers immigrating from other parts of America. Casper is a regional hub for banking and business as well as the the center of the state's oil industry. The median household income in Casper is $57,511.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '4.5 percent lower than the national average',
						},
						{
							item: 'Median home price',
							value: '$216,000',
						},
						{
							item: 'Average rent',
							value: '$867 per month',
						},
					],
				},
				{
					city: 'Jackson',
					copy: "<p>Jackson has more than 10,500 permanent residents, but as the center of the state's tourism industry Jackson plays host to many more. The city is close to three major ski resorts, and it is also close to Grand Teton and Yellowstone National Parks. Arts and entertainment flourish here like no where else in the state where wealthy patrons and donors abound. The city is a playground of sorts for the rich and powerful, so living here is not cheap.</p>",
					facts: [
						{
							item: 'Cost of living',
							value: '77.8 percent higher than the national average',
						},
						{
							item: 'Median home price',
							value: '$1.6 million',
						},
						{
							item: 'Average rent',
							value: '$1,933 per month',
						},
					],
				},
			],
		},
		movingToResources: [
			// static content
			{
				title: 'Drivers License Info for New Residents',
				copy: "New residents of Wyoming must obtain a valid Wyoming driver's license within one year of establishing residency in the state. If your license is from Georgia, Massachusetts, Michigan Tennessee, Wisconsin or is a CDL, you must obtain a Wyoming license as soon as you establish residency in the state. To get a license you must appear in person and surrender your out-of-state license.",
				link: 'https://www.dot.state.wy.us/home/driver_license_records/driver-license.html',
			},
			{
				title: 'Vehicle registration',
				copy: "New Wyoming residents must register their vehicle within 30 days of moving. To register you must get your vehicle inspected at a local sheriff's station.",
				link: 'https://www.tetonwyo.org/317/Transferring-Your-Out-of-State-Vehicle-t',
			},
			{
				title: 'Voter Registration',
				copy: 'In Wyoming, the deadline to register to vote is 14 days before an election. However, you can register to vote and cast a ballot on Election Day. You can register to vote in Wyoming here:',
				link: 'https://votesmart.org/elections/voter-registration/WY#.XdHheDJKiuU',
			},
		],
		sources: [
			// static content
			'https://worldpopulationreview.com/states/',
			'https://en.wikipedia.org/wiki/Wyoming',
			'https://hiphopwired.com/828985/kanye-west-building-amphitheater-on-his-wyoming-ranch/',
			'https://en.wikipedia.org/wiki/United_States_Electoral_College',
			'https://www.rentjungle.com/average-rent-in-jackson-wy-wy-rent-trends/',
			'https://www.rentjungle.com/average-rent-in-casper-rent-trends/',
			'https://www.zillow.com/casper-wy/home-values/',
			'https://www.bestplaces.net/cost_of_living/city/wyoming/casper',
			'https://www.payscale.com/cost-of-living-calculator/Wyoming-Cheyenne',
			'https://www.zippia.com/advice/largest-companies-in-wyoming/',
			'https://apps.bea.gov/itable/iTable.cfm?ReqID=70&step=1#reqid=70&step=1&isuri=1',
			'https://en.wikipedia.org/wiki/Casper,_Wyoming',
			'https://en.wikipedia.org/wiki/Jackson,_Wyoming',
			'https://en.wikipedia.org/wiki/Cheyenne,_Wyoming',
		],
	},
};
